import { makeStyles, createStyles, createTheme, MuiThemeProvider, withStyles as withStyles$1 } from '@material-ui/core/styles';
import React, { createContext, useState, useEffect, useRef, createRef, useLayoutEffect, useCallback, useMemo, forwardRef, useContext } from 'react';
import { CardMedia, Typography, Grid, Collapse, ButtonBase, Link, Paper, withStyles, Toolbar, Button, IconButton as IconButton$1, Modal, Backdrop, Card, CardContent, Divider, Tooltip, List, ListItem, ListItemIcon, ListItemText, TextField, InputAdornment, Checkbox, LinearProgress, SvgIcon, Dialog, DialogTitle, DialogContent, useTheme, useMediaQuery } from '@material-ui/core';
import ArrowRightAltOutlinedIcon from '@material-ui/icons/ArrowRightAltOutlined';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import NoSimOutlinedIcon from '@material-ui/icons/NoSimOutlined';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import IconButton from '@material-ui/core/IconButton';
import withWidth from '@material-ui/core/withWidth';
import Link$1 from '@material-ui/core/Link';
import Typography$1 from '@material-ui/core/Typography';
import Grid$1 from '@material-ui/core/Grid';
import { gql, ApolloClient, InMemoryCache } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';
import 'graphql/language/visitor';
import { print } from 'graphql/language/printer';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import AppBar from '@material-ui/core/AppBar';
import DehazeIcon from '@material-ui/icons/Dehaze';
import Menu from '@material-ui/core/Menu';
import Drawer from '@material-ui/core/Drawer';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { useHistory, useLocation, Link as Link$2 } from 'react-router-dom';
import { useZoom, useOpenSeadragon, ViewerProvider } from 'use-open-seadragon';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import reactDom from 'react-dom';
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import ButtonBase$1 from '@material-ui/core/ButtonBase';
import CardMedia$1 from '@material-ui/core/CardMedia';
import CardContent$1 from '@material-ui/core/CardContent';
import SaveAltOutlinedIcon from '@material-ui/icons/SaveAltOutlined';
import ZoomInOutlinedIcon from '@material-ui/icons/ZoomInOutlined';
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import FullscreenOutlinedIcon from '@material-ui/icons/FullscreenOutlined';
import FullscreenExitOutlinedIcon from '@material-ui/icons/FullscreenExitOutlined';
import Card$1 from '@material-ui/core/Card';
import CloseIcon from '@material-ui/icons/Close';
import LanguageOutlined from '@material-ui/icons/LanguageOutlined';
import gql$1 from 'graphql-tag';
import axios from 'axios';
import { GraphQLClient } from 'graphql-request';

var e=[],t=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t[u]={}),a=t[u]&&t[u][s]?t[u][s]:t[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

var css = "/**\n * Swiper 6.8.4\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2021 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: August 23, 2021\n */\n\n@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA') format('woff');font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-container-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}.swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-container-pointer-events{touch-action:pan-y}.swiper-container-pointer-events.swiper-container-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-container-3d{perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;text-transform:none;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-container-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-container-rtl .swiper-button-next:after{content:'prev'}.swiper-button-next,.swiper-container-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-container-rtl .swiper-button-prev:after{content:'next'}.swiper-button-next.swiper-button-white,.swiper-button-prev.swiper-button-white{--swiper-navigation-color:#ffffff}.swiper-button-next.swiper-button-black,.swiper-button-prev.swiper-button-black{--swiper-navigation-color:#000000}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:50%;background:#000;opacity:.2}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:1;background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px,-50%,0)}.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;display:block}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-container-horizontal>.swiper-pagination-progressbar,.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-container-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-white{--swiper-pagination-color:#ffffff}.swiper-pagination-black{--swiper-pagination-color:#000000}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-container-horizontal>.swiper-scrollbar{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-container-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;animation:swiper-preloader-spin 1s infinite linear;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{100%{transform:rotate(360deg)}}.swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-container-fade.swiper-container-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-container-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-container-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube{overflow:visible}.swiper-container-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-container-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-cube.swiper-container-rtl .swiper-slide{transform-origin:100% 0}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-container-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-container-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-container-flip{overflow:visible}.swiper-container-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-container-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}\n/**\n * Swiper 6.8.4\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2021 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: August 23, 2021\n */\n@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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') format('woff');font-weight:400;font-style:normal}\n:root{--swiper-theme-color:#007aff}\n.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}\n.swiper-container-vertical>.swiper-wrapper{flex-direction:column}\n.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}\n.swiper-container-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}\n.swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}\n.swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}\n.swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}\n.swiper-container-pointer-events{touch-action:pan-y}\n.swiper-container-pointer-events.swiper-container-vertical{touch-action:pan-x}\n.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}\n.swiper-slide-invisible-blank{visibility:hidden}\n.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}\n.swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}\n.swiper-container-3d{perspective:1200px}\n.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}\n.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}\n.swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}\n.swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}\n.swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}\n.swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}\n.swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}\n.swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}\n.swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}\n.swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}\n.swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}\n* {\n  margin: 0;\n  box-sizing: border-box !important;\n}\n\nhtml {\n  font-size: 16px;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1 !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.button-reset {\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n}\n\n.swiper-button-next,\n.swiper-button-prev {\n  color: #0f0900 !important;\n}\n.swiper-button-next::after,\n.swiper-button-prev::after {\n  content: \"\";\n}\n.swiper-button-next:hover,\n.swiper-button-prev:hover {\n  opacity: 0.5;\n}\n.swiper-button-next.swiper-button-disabled,\n.swiper-button-prev.swiper-button-disabled {\n  visibility: hidden;\n}\n.swiper-button-next svg,\n.swiper-button-prev svg {\n  height: 2rem;\n}\n@media (min-width: 1024px) {\n  .swiper-button-next svg,\n.swiper-button-prev svg {\n    height: initial;\n  }\n}\n\n.swiper-button-next {\n  right: -0.875rem !important;\n}\n@media (min-width: 678px) {\n  .swiper-button-next {\n    right: -1.875rem !important;\n  }\n}\n@media (min-width: 1024px) {\n  .swiper-button-next {\n    right: -2.5rem !important;\n  }\n}\n\n.swiper-button-prev {\n  left: -0.875rem !important;\n}\n@media (min-width: 678px) {\n  .swiper-button-prev {\n    left: -1.875rem !important;\n  }\n}\n@media (min-width: 1024px) {\n  .swiper-button-prev {\n    left: -2.5rem !important;\n  }\n}\n\n@media (min-width: 500px) {\n  .swiper-slide-auto .swiper-slide {\n    width: auto !important;\n  }\n}\n\n.swiper-slide {\n  height: auto !important;\n}\n\n.swiper-wrapper {\n  padding: 0.5rem 0 !important;\n}\n\n.link-animation {\n  display: block;\n  width: 1rem;\n  height: 0.625rem;\n  background: currentColor;\n  transition: all 0.3s ease-in-out;\n}\n\n.swiper-outter-conatiner {\n  display: flex;\n  position: relative;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n@media (min-width: 678px) {\n  .swiper-outter-conatiner {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n.swiper-outter-conatiner--hero {\n  color: white;\n  width: 100%;\n  max-width: unset !important;\n  padding-left: 0;\n  padding-right: 0;\n}\n.swiper-outter-conatiner--hero .swiper-container {\n  height: 100% !important;\n  width: 100% !important;\n}\n.swiper-outter-conatiner--hero .swiper-wrapper {\n  padding: 0 !important;\n}\n.swiper-outter-conatiner--hero .swiper-button-next,\n.swiper-outter-conatiner--hero .swiper-button-prev {\n  color: white !important;\n  position: absolute !important;\n}\n.swiper-outter-conatiner--hero .swiper-button-next::after,\n.swiper-outter-conatiner--hero .swiper-button-prev::after {\n  content: \"\";\n}\n.swiper-outter-conatiner--hero .swiper-button-next svg,\n.swiper-outter-conatiner--hero .swiper-button-prev svg {\n  height: initial;\n}\n.swiper-outter-conatiner--hero .swiper-button-prev {\n  left: 1rem !important;\n  top: calc(100% - 100px) !important;\n}\n@media (min-width: 500px) {\n  .swiper-outter-conatiner--hero .swiper-button-prev {\n    top: 50% !important;\n  }\n}\n@media (min-width: 1350px) {\n  .swiper-outter-conatiner--hero .swiper-button-prev {\n    left: -2rem !important;\n  }\n}\n.swiper-outter-conatiner--hero .swiper-button-next {\n  right: 1rem !important;\n  top: calc(100% - 100px) !important;\n}\n@media (min-width: 500px) {\n  .swiper-outter-conatiner--hero .swiper-button-next {\n    top: 50% !important;\n  }\n}\n@media (min-width: 1350px) {\n  .swiper-outter-conatiner--hero .swiper-button-next {\n    right: -2rem !important;\n  }\n}";
n(css,{});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

// const opacity = '98';
var navHeightMob = 106;
var navHeightTabSmall = 112;
var navHeightTabMid = 128;
var navHeightTabLarge = 170;
var navHeightTabMidLarge = 154;
var navHeight = 128;
var useStyles = function (props) {
    return makeStyles(function (theme) {
        var _a, _b;
        return createStyles({
            navigation: (_a = {
                    height: navHeightMob,
                    flexShrink: 0
                },
                _a[theme.breakpoints.up(375)] = {
                    height: navHeightTabSmall,
                },
                _a[theme.breakpoints.up(500)] = {
                    height: navHeightTabMid,
                },
                _a[theme.breakpoints.up(600)] = {
                    height: navHeightTabMidLarge,
                },
                _a[theme.breakpoints.up(678)] = {
                    height: navHeightTabLarge,
                },
                _a[theme.breakpoints.up(900)] = {
                    height: navHeight,
                },
                _a),
            drawerPaper: (_b = {
                    minHeight: '60vh',
                    backgroundColor: props.backgroundColor,
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    overflowX: 'hidden',
                    paddingTop: '1rem'
                },
                _b[theme.breakpoints.up(500)] = {
                    paddingLeft: '1.5rem',
                    paddingRight: '1.5rem',
                    paddingTop: '1.5rem',
                },
                _b[theme.breakpoints.up(678)] = {
                    paddingLeft: '2rem',
                    paddingRight: '2rem',
                    paddingTop: '2rem',
                },
                _b[theme.breakpoints.up(1024)] = {
                    paddingLeft: '3rem',
                    paddingRight: '3rem',
                },
                _b[theme.breakpoints.up('lg')] = {
                    paddingLeft: '4rem',
                    paddingRight: '4rem',
                },
                // MUI overrides transition for drawer, so we have take care of transform prop, add background-color and
                // add the needed !important statement.
                _b.transition = theme.transitions
                    .create(['background-color', 'transform'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                })
                    .concat(' !important'),
                _b),
            drawerHeader: __assign(__assign({ display: 'flex', 
                // height: navHeightMob,
                padding: theme.spacing(0, 1) }, theme.mixins.toolbar), { justifyContent: 'flex-start' }),
            content: {
                outline: 0,
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                alignItems: 'flex-end',
                width: '100%',
                maxWidth: 1280,
                // margin: '0.625rem 0 0',
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
        });
    });
};

var CollectionsContext = createContext({
    collections: [],
});

var css$1 = ".collectionCard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 400px;\n  height: 100%;\n  text-decoration: none;\n}\n@media (min-width: 900px) {\n  .collectionCard {\n    flex-direction: row-reverse;\n  }\n}\n.collectionCard__content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 2.5rem 1rem;\n  flex: 1;\n}\n.collectionCard__content__subtitle {\n  font-weight: 700 !important;\n  margin-bottom: 1.5rem !important;\n  color: inherit !important;\n}\n.collectionCard__content__title {\n  color: inherit !important;\n}\n.collectionCard__content__inner {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  max-height: 100%;\n  overflow: hidden;\n}\n.collectionCard__content__button {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  flex: 1;\n  margin-top: 1rem;\n}\n.collectionCard__content__button__text {\n  font-weight: 800;\n  text-transform: uppercase;\n  color: inherit !important;\n}\n@media (min-width: 900px) {\n  .collectionCard__content {\n    width: 50%;\n  }\n}\n.collectionCard__image-wrapper {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%;\n}\n@media (min-width: 900px) {\n  .collectionCard__image-wrapper {\n    padding-bottom: unset;\n    width: 50%;\n  }\n}\n.collectionCard__image-wrapper__image {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n.collectionCard__image-wrapper__no-image {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #73717133;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n.collectionCard--guide {\n  background: #0f0900;\n  color: #ff5252;\n}\n.collectionCard--topics {\n  background: #0f0900;\n  color: #f9ff4b;\n}\n.collectionCard--research {\n  background: #0f0900;\n  color: #79a9f5;\n}\n.collectionCard:hover .link-animation {\n  width: 100%;\n}";
n(css$1,{});

/* eslint-disable @typescript-eslint/no-unused-vars */
var CollectionCardComponent = function (props) {
    var t = useTranslation().t;
    var image = props.image, section = props.section, title = props.title, subtitle = props.subtitle, href = props.href, _a = props.target, target = _a === void 0 ? '' : _a, _b = props.actionText, actionText = _b === void 0 ? '' : _b;
    return (React.createElement("a", { href: href, target: target, className: "collectionCard collectionCard--" + section, "aria-label": "Link zu " + title },
        React.createElement("div", { className: "collectionCard__image-wrapper", "aria-label": "Abbildung von " + title },
            React.createElement("div", { className: "collectionCard__image-wrapper__no-image" },
                React.createElement(NoSimOutlinedIcon, { fontSize: "large" })),
            React.createElement(CardMedia, { className: "collectionCard__image-wrapper__image", image: image })),
        React.createElement("div", { className: "collectionCard__content" },
            React.createElement("div", { className: "collectionCard__content__inner" },
                React.createElement(Typography, { variant: "overline", className: "collectionCard__content__subtitle" }, subtitle),
                React.createElement(Typography, { variant: "h3", component: 'h4', className: "collectionCard__content__title" }, title)),
            actionText && (React.createElement("div", { className: "collectionCard__content__button" },
                React.createElement(Typography, { variant: "h4", component: 'span', className: "collectionCard__content__button__text" }, t(actionText)),
                React.createElement("span", { className: "link-animation" }))))));
};
var CollectionCard = CollectionCardComponent;

var ConfigLoader = /** @class */ (function () {
    function ConfigLoader() {
    }
    ConfigLoader.Running = false;
    ConfigLoader.FetchedReactAppStage = false;
    return ConfigLoader;
}());
function useConfigLoader() {
    // used states and useEffect to keep care of possible side-effects
    var _a = useState(ConfigLoader.CurrentConfig), config = _a[0], setConfig = _a[1];
    var _b = useState(ConfigLoader.FetchedReactAppStage), fetchedReactAppStage = _b[0], setFetchedReactAppStage = _b[1];
    var _c = useState(AppStage.LOCAL), appStage = _c[0], setAppStage = _c[1];
    useEffect(function () {
        var publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
        !fetchedReactAppStage &&
            fetch(publicUrl.href, { method: 'HEAD' }).then(function (response) {
                var _a;
                var REACT_APP_STAGE = (_a = process.env.REACT_APP_STAGE) !== null && _a !== void 0 ? _a : response.headers.get('X-React-App-Stage');
                switch (REACT_APP_STAGE === null || REACT_APP_STAGE === void 0 ? void 0 : REACT_APP_STAGE.toLowerCase()) {
                    case AppStage.PRODUCTION:
                        ConfigLoader.CurrentConfig = loadConfig(AppStage.PRODUCTION);
                        break;
                    case AppStage.STAGE:
                        ConfigLoader.CurrentConfig = loadConfig(AppStage.STAGE);
                        break;
                    case AppStage.DEV:
                        ConfigLoader.CurrentConfig = loadConfig(AppStage.DEV);
                        break;
                    case AppStage.LOCAL:
                        ConfigLoader.CurrentConfig = loadConfig(AppStage.LOCAL);
                        break;
                }
                setConfig(ConfigLoader.CurrentConfig);
                if (REACT_APP_STAGE !== null) {
                    setAppStage(REACT_APP_STAGE.toLowerCase());
                }
                ConfigLoader.FetchedReactAppStage = true;
                ConfigLoader.Running = false;
                setFetchedReactAppStage(true);
            });
    }, [config, fetchedReactAppStage, appStage]);
    return { loadingConfig: !fetchedReactAppStage, appStage: appStage, config: config };
}

var createSlug = function (text) {
    var _a, _b;
    var slug = (_b = (_a = text === null || text === void 0 ? void 0 : text.replace(/[ /.+]/g, '-')) === null || _a === void 0 ? void 0 : _a.replace(/['"()?!:,]/g, '')) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    return slug ? encodeURIComponent(slug) : '';
};
var goTo = function (link) {
    window.location.href = link;
};
var LinkBuilder = /** @class */ (function () {
    function LinkBuilder() {
        this.config = ConfigLoader.CurrentConfig;
    }
    LinkBuilder.prototype.getPermalinkHref = function (id, title) {
        return "https://id.smb.museum/object/" + id + "/" + createSlug(title);
    };
    LinkBuilder.prototype.getShareButtonHref = function (id) {
        return "https://id.smb.museum/object/" + id;
    };
    LinkBuilder.prototype.getDetailsLink = function (id, title, fullUrl) {
        if (fullUrl === void 0) { fullUrl = false; }
        var link = "/detail/" + id + "/" + createSlug(title);
        return fullUrl ? "" + this.config.RESEARCH_DOMAIN + link : link;
    };
    // TODO wrong link
    LinkBuilder.prototype.toTopics = function (id, platform) {
        var link = this.config.TOPICS_DOMAIN + "/collections/" + platform + "/" + id;
        goTo(link);
    };
    LinkBuilder.prototype.getTopicsHref = function (id, platform, currentLocale) {
        var link = "" + this.config.TOPICS_DOMAIN + currentLocale + "/category/" + platform + "/" + id;
        return link;
    };
    LinkBuilder.prototype.toTopicsHashed = function (hash) {
        var link = this.config.TOPICS_DOMAIN + hash;
        goTo(link);
    };
    LinkBuilder.prototype.toGuide = function (id, title) {
        goTo(this.getGuideHref(id, title));
    };
    LinkBuilder.prototype.getGuideHref = function (id, title) {
        var link = this.config.GUIDE_DOMAIN + "/tour/" + id + "/" + createSlug(title);
        return link;
    };
    LinkBuilder.prototype.toResearch = function () {
        goTo(this.config.RESEARCH_DOMAIN);
    };
    LinkBuilder.prototype.goToLink = function (link) {
        goTo(link);
    };
    LinkBuilder.prototype.getDownloadHref = function (id, format) {
        if (format === void 0) { format = 'csv'; }
        var link = this.config.ELASTIC_API_URL + "/" + id + "/export?format=" + format;
        return link;
    };
    return LinkBuilder;
}());

var useStyles$1 = makeStyles(function (theme) {
    var _a;
    return createStyles({
        container: (_a = {
                transition: theme.transitions.create(['height'], {
                    easing: theme.transitions.easing.easeInOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                maxWidth: 1280,
                // padding: '2rem',
                margin: 'auto'
            },
            // backgroundColor: theme.palette.secondary.main,
            _a[theme.breakpoints.up('sm')] = {
            // padding: '25px',
            },
            _a[theme.breakpoints.up('lg')] = {
            // padding: '2rem',
            },
            _a),
        titleGridItem: {
            display: 'grid',
            alignItems: 'center',
            justifyContent: 'center',
        },
        titleArrowButton: {
            transform: 'rotate(-90deg)',
            color: theme.palette.secondary.contrastText,
        },
        buttonTitle: {
            marginTop: '1rem',
            '&:focus-visible': {
                outline: "4px solid " + theme.palette.primary.main,
            },
            '&:hover span h3': {
                textDecoration: 'underline',
            },
        },
        sortCollectionsButton: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'baseline',
        },
        sortCollectionsButtonTypo: {
            color: theme.palette.primary.main,
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '2px',
        },
        showAllButtonTypo: {
            color: theme.palette.primary.main,
            paddingTop: '1rem',
        },
        endArrowButton: {
            transform: 'rotate(90deg)',
            color: theme.palette.secondary.contrastText,
        },
    });
});

/* eslint-disable react/jsx-key */
/**
 * CollectionsModule is a wrapper component to display cards of different collections.
 * @constructor
 */
function CollectionsModule(_a) {
    var _b = _a.collectionModuleClasses, collectionModuleClasses = _b === void 0 ? '' : _b, _c = _a.section, section = _c === void 0 ? '' : _c, _d = _a.initialCards, initialCards = _d === void 0 ? 4 : _d;
    // const [isOpen, setOpen] = useState(false);
    var _e = useState(false), expanded = _e[0], setExpanded = _e[1];
    var classes = useStyles$1();
    var t = useTranslation().t;
    var link = new LinkBuilder();
    var handleExpandClick = function () {
        setExpanded(!expanded);
    };
    var getCardHref = function (id, title, platform) {
        return section === 'guide'
            ? link.getGuideHref(id, title)
            : link.getTopicsHref(id, platform);
    };
    return (React.createElement(CollectionsContext.Consumer, null, function (collectionsContext) { return (React.createElement("div", { id: 'CollectionsModule', className: clsx(classes.container, collectionModuleClasses) },
        React.createElement(Grid, { container: true, spacing: 4, direction: 'row', alignItems: 'center' }, collectionsContext.collections
            .slice(0, initialCards)
            .map(function (_a, index) {
            var id = _a.id, previewImageCard = _a.previewImageCard, title = _a.title, subtitle = _a.subtitle, platform = _a.platform;
            return (React.createElement(Grid, { item: true, key: index, xs: 12, sm: 6, md: 6 },
                React.createElement(CollectionCard, { title: title, subtitle: subtitle, section: section, image: previewImageCard, actionText: t('collections module discover button'), href: getCardHref(id, title, platform) })));
        })),
        React.createElement(Collapse, { in: expanded, timeout: "auto", unmountOnExit: true, style: { marginTop: '1rem' } },
            React.createElement(Grid, { style: {
                    paddingTop: '1rem',
                    transition: 'all 1s',
                    overflow: 'hidden',
                }, container: true, spacing: 4, direction: 'row', justifyContent: 'flex-start', alignItems: 'center' }, collectionsContext.collections
                .slice(initialCards)
                .map(function (_a, index) {
                var id = _a.id, previewImageCard = _a.previewImageCard, title = _a.title, subtitle = _a.subtitle, platform = _a.platform;
                return (React.createElement(Grid, { item: true, key: index, xs: 12, sm: 6, md: 6 },
                    React.createElement(CollectionCard, { title: title, subtitle: subtitle, section: section, image: previewImageCard, actionText: t('collections module discover button'), href: getCardHref(id, title, platform) })));
            }))),
        React.createElement(Collapse, { in: !expanded && collectionsContext.collections.length > initialCards, timeout: "auto", unmountOnExit: true },
            React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12, className: classes.titleGridItem },
                React.createElement(ButtonBase, { onClick: handleExpandClick, className: classes.buttonTitle },
                    React.createElement("span", null,
                        React.createElement(Typography, { variant: 'h3', className: classes.showAllButtonTypo }, t('collections module show all button')),
                        React.createElement(ArrowRightAltOutlinedIcon, { className: classes.endArrowButton, fontSize: 'large' }))))))); }));
}

var copyToClipboard = function (text) {
    navigator.clipboard.writeText(text);
};
var shortenPermalink = function (link) {
    var lastSegmentIdx = link.lastIndexOf('/');
    return link.substring(0, lastSegmentIdx);
};

var FALLBACK_IMAGE_TYPE = 'webp';
var ImageUrlBuilder = /** @class */ (function () {
    function ImageUrlBuilder(config) {
        this.config = config || ConfigLoader.CurrentConfig;
    }
    ImageUrlBuilder.prototype.splitImageIdAndType = function (filename, fallbackType) {
        if (fallbackType === void 0) { fallbackType = FALLBACK_IMAGE_TYPE; }
        var parts = filename.split(/\.([^\\.]{3,})$/);
        if (parts.length !== 3) {
            return [parts.join('.'), fallbackType];
        }
        return [parts[0], parts[1]];
    };
    ImageUrlBuilder.prototype.buildUrl = function (filename, width, height) {
        // if full url is given, we cannot resize the image
        if (filename.startsWith('http://') || filename.startsWith('https://')) {
            return filename;
        }
        // we have an image that is supposed to be served by our image-provider which supports serverside resizing
        // -> https://recherche.smb.museum/images/{fileid}_{width}x{height}.{imageType}
        var _a = this.splitImageIdAndType(filename), imageId = _a[0], imageType = _a[1];
        return new URL(this.config.IMAGE_PROVIDER_ENDPOINT.concat('/', imageId, '_', width.toString(), 'x', height.toString(), '.', imageType)).toString();
    };
    return ImageUrlBuilder;
}());

var defaultLanguage = 'de';
var LanguageService = /** @class */ (function () {
    function LanguageService() {
    }
    LanguageService.getDefaultLanguage = function () {
        return defaultLanguage;
    };
    LanguageService.getCurrentStrapiLanguage = function () {
        return i18next.language || defaultLanguage;
    };
    LanguageService.getCurrentLanguage = function () {
        var _a;
        var searchLang = (_a = i18next.language) === null || _a === void 0 ? void 0 : _a.split('-')[0];
        return searchLang || defaultLanguage;
    };
    return LanguageService;
}());

var languageOptionsOrder = ['de', 'de-ls', 'de-dgs', 'en', 'en-sl', 'en-asl'];
var languageOptionsData = {
    de: {
        map: { en: 'en' },
        icon: 'language',
    },
    en: {
        map: { de: 'de' },
        icon: 'language',
    },
    'de-ls': {
        map: { en: 'en-SL' },
        icon: 'simple_language',
    },
    'de-dgs': {
        map: { en: 'en-ASL' },
        icon: 'sign_language',
    },
    'en-sl': {
        map: { de: 'de-LS' },
        icon: 'simple_language',
    },
    'en-asl': {
        map: { de: 'de-DGS' },
        icon: 'sign_language',
    },
};
var LANGUAGE_ICONS = {
    language: "<g\n          id=\"Gruppe_318\"\n          data-name=\"Gruppe 318\"\n          transform=\"translate(-19.998 217)\"\n        >\n          <path\n            id=\"Icon_material-chat-bubble\"\n            data-name=\"Icon material-chat-bubble\"\n            d=\"M28.2,3H5.8A2.808,2.808,0,0,0,3,5.8V31l5.6-5.6H28.2A2.808,2.808,0,0,0,31,22.6V5.8A2.808,2.808,0,0,0,28.2,3Z\"\n            transform=\"translate(16.998 -220)\"\n            fill=\"currentColor\"\n          />\n          <text\n            id=\"DE\"\n            transform=\"translate(43.091 -201)\"\n            fill=\"#fff\"\n            fontSize=\"14\"\n            fontFamily=\"GTWalsheimPro-Black, GT Walsheim\"\n            letterSpacing=\"0.027em\"\n          >\n            <tspan x=\"-16\" y=\"0\">\n              ...\n            </tspan>\n          </text>\n        </g>",
    simple_language: "<path\n          id=\"Icon_awesome-book-reader\"\n          data-name=\"Icon awesome-book-reader\"\n          d=\"M19.25,5.25A5.25,5.25,0,1,0,14,10.5,5.25,5.25,0,0,0,19.25,5.25Zm-6.475,7.935C9.53,11.2,4.274,10.653,1.63,10.5A1.513,1.513,0,0,0,0,11.984V24.168a1.5,1.5,0,0,0,1.449,1.479c2.388.125,7.218.584,10.557,2.266a.761.761,0,0,0,1.12-.649V13.812a.728.728,0,0,0-.351-.627ZM26.37,10.5c-2.644.15-7.9.7-11.144,2.682a.741.741,0,0,0-.351.636V27.262A.763.763,0,0,0,16,27.913c3.338-1.68,8.166-2.139,10.553-2.264A1.5,1.5,0,0,0,28,24.169V11.984A1.514,1.514,0,0,0,26.37,10.5Z\"\n          fill=\"currentColor\"\n        />",
    sign_language: "<g\n          id=\"dtloFO_00000018926322535516363510000012078273516230456243_\"\n          transform=\"translate(-12.375 -7.776)\"\n        >\n          <g\n            id=\"Gruppe_390\"\n            data-name=\"Gruppe 390\"\n            transform=\"translate(12.375 7.776)\"\n          >\n            <path\n              id=\"Pfad_150\"\n              data-name=\"Pfad 150\"\n              d=\"M22.037,23.545c.379-.467.758-.817,1.021-1.225a27.429,27.429,0,0,0,2.013-3.15,1.717,1.717,0,0,0-.613-1.954c-.642-.379-1.138.087-1.633.379l-.35.263c-2.129,1.808-4.288,3.588-6.388,5.454a10.546,10.546,0,0,0-3.179,4.054c-.817,2.129-.5,4.375-.321,6.533.233,2.625,2.654,4.4,5.629,4.433,5.221.029,10.413,0,15.633.029,1.021,0,1.633-.525,1.633-1.4s-.613-1.4-1.633-1.4c-2.363,0-4.7-.029-7.058,0-.642,0-.438-.379-.467-.7-.029-.35.058-.5.438-.5,3.5.029,7,0,10.5,0,1.021,0,1.633-.554,1.633-1.4,0-.875-.642-1.4-1.633-1.4-2.742,0-5.483-.029-8.225,0-.583,0-.438-.35-.438-.642-.029-.35,0-.554.467-.554,2.975.029,5.95,0,8.954,0a5.973,5.973,0,0,0,1.021-.029,1.41,1.41,0,0,0-.467-2.771c-3.558,0-7.117-.029-10.675,0-.467,0-.438-.233-.438-.554,0-.292-.146-.642.438-.642,2.771.029,5.513,0,8.283,0a1.385,1.385,0,0,0,1.575-1.4,1.421,1.421,0,0,0-1.575-1.429H22.037ZM16.7,18.762c-.087-.788-.117-1.488-.263-2.188a24.492,24.492,0,0,0-.7-2.888,1.755,1.755,0,0,0-1.925-1.079c-.788.2-.788.9-.875,1.517-.087.642-.087,1.283-.117,1.925-.117,2.6-.233,5.163-.35,7.758a13.7,13.7,0,0,0,.117,1.808,37.894,37.894,0,0,1,7.175-6.854c1.079-.875,2.275-1.663,3.267-2.625,1.925-1.9,3.763-3.908,5.6-5.863a1.386,1.386,0,0,0-.058-2.042,1.409,1.409,0,0,0-2.013.146c-2.188,2.275-4.375,4.608-6.563,6.913C18.916,16.429,17.837,17.537,16.7,18.762Zm7.992,3.675h3.063a.761.761,0,0,0,.5-.2c2.333-2.421,4.638-4.871,6.942-7.321a1.641,1.641,0,0,0,.408-.846,1.3,1.3,0,0,0-.817-1.429,1.339,1.339,0,0,0-1.6.321c-1.867,1.954-3.7,3.908-5.542,5.863-.292.321-.613.554-.992.2-.379-.379-.146-.7.146-.992,2.1-2.246,4.2-4.463,6.271-6.708A1.405,1.405,0,1,0,31.02,9.4l-2.567,2.742c-1.225,1.313-2.479,2.6-3.7,3.908a2.705,2.705,0,0,1,1.429,3.121A22,22,0,0,1,24.691,22.437Zm4.958,0h3.792a.223.223,0,0,0,.146-.058c.788-.817,1.575-1.633,2.3-2.479a1.39,1.39,0,0,0-2.013-1.867C32.449,19.462,31.107,20.92,29.649,22.437Z\"\n              transform=\"translate(-12.375 -7.847)\"\n              fill=\"#fff\"\n            />\n            <path\n              id=\"Pfad_151\"\n              data-name=\"Pfad 151\"\n              d=\"M22.151,45.813H36.385a1.423,1.423,0,1,1,0,2.829c-2.771,0-5.513.029-8.283,0-.554,0-.408.35-.438.642,0,.292-.058.554.438.554,3.558-.029,7.117,0,10.675,0a1.408,1.408,0,0,1,1.517,1.254,1.342,1.342,0,0,1-1.05,1.517,5.887,5.887,0,0,1-1.021.029H29.268c-.467,0-.5.2-.467.554.029.292-.146.642.438.642,2.742-.029,5.483,0,8.225,0,.992,0,1.633.554,1.633,1.4s-.642,1.4-1.633,1.4h-10.5c-.408,0-.5.146-.438.5.029.321-.175.7.467.7,2.363-.029,4.7-.029,7.058,0,1.021,0,1.633.554,1.633,1.4,0,.875-.613,1.4-1.633,1.4-5.221,0-10.413,0-15.633-.029-3-.058-5.425-1.838-5.658-4.463-.2-2.158-.5-4.4.321-6.533A10.767,10.767,0,0,1,16.26,45.55c2.1-1.838,4.258-3.646,6.388-5.454a3.644,3.644,0,0,1,.35-.263c.5-.292.992-.758,1.633-.379a1.717,1.717,0,0,1,.613,1.954,32.054,32.054,0,0,1-2.013,3.15C22.91,45,22.531,45.346,22.151,45.813Z\"\n              transform=\"translate(-12.49 -30.114)\"\n              fill=\"currentColor\"\n            />\n            <path\n              id=\"Pfad_152\"\n              data-name=\"Pfad 152\"\n              d=\"M17,18.691c1.138-1.2,2.217-2.333,3.3-3.442,2.188-2.333,4.375-4.667,6.592-6.971A1.409,1.409,0,0,1,28.9,8.133a1.386,1.386,0,0,1,.058,2.042c-1.867,1.983-3.675,3.967-5.6,5.863a40.192,40.192,0,0,1-3.267,2.625,37.894,37.894,0,0,0-7.175,6.854c-.058-.671-.117-1.254-.117-1.808.088-2.6.233-5.163.35-7.758.029-.642.029-1.283.117-1.925.087-.613.087-1.313.875-1.517a1.722,1.722,0,0,1,1.925,1.079,19.83,19.83,0,0,1,.7,2.888C16.883,17.175,16.913,17.875,17,18.691Z\"\n              transform=\"translate(-12.676 -7.776)\"\n              fill=\"currentColor\"\n            />\n            <path\n              id=\"Pfad_153\"\n              data-name=\"Pfad 153\"\n              d=\"M54.6,24.916a23.445,23.445,0,0,0,1.488-3.267,2.793,2.793,0,0,0-1.429-3.121c1.254-1.313,2.479-2.6,3.7-3.908l2.567-2.742A1.405,1.405,0,1,1,62.971,13.8c-2.071,2.246-4.171,4.463-6.3,6.679-.292.321-.525.642-.146.992s.7.117.992-.2c1.838-1.954,3.675-3.908,5.542-5.863a1.347,1.347,0,0,1,1.6-.321,1.3,1.3,0,0,1,.817,1.429,1.54,1.54,0,0,1-.408.846c-2.3,2.45-4.608,4.9-6.942,7.321a.761.761,0,0,1-.5.2C56.583,24.945,55.5,24.916,54.6,24.916Z\"\n              transform=\"translate(-42.284 -10.326)\"\n              fill=\"currentColor\"\n            />\n            <path\n              id=\"Pfad_154\"\n              data-name=\"Pfad 154\"\n              d=\"M71.6,46.322c1.458-1.517,2.829-2.975,4.229-4.4a1.307,1.307,0,0,1,1.779.058,1.332,1.332,0,0,1,.233,1.808c-.729.875-1.517,1.663-2.3,2.479a.223.223,0,0,1-.146.058Z\"\n              transform=\"translate(-54.326 -31.731)\"\n              fill=\"currentColor\"\n            />\n          </g>\n        </g>",
};
var getLanguageIndex = function (locale) {
    return languageOptionsOrder.indexOf(locale);
};
var getLanguageMap = function () {
    return languageOptionsData;
};
var getLanguageValue = function (value) {
    if (value.includes('-')) {
        var lang = value.split('-');
        lang.splice(1, 1, lang[1].toLocaleUpperCase());
        return lang.join('-');
    }
    return value;
};
var getLanguageIcon = function (locale) {
    return languageOptionsData[locale].icon;
};
var getLegalPagesMap = function (currentLegalPages, localeLegalPages) {
    var legalPagesMap = {};
    currentLegalPages.forEach(function (page, index) {
        var _a;
        legalPagesMap[page.slug] = '';
        if (localeLegalPages[index]) {
            legalPagesMap[page.slug] = (_a = localeLegalPages[index]) === null || _a === void 0 ? void 0 : _a.slug;
        }
    });
    return legalPagesMap;
};
var getLanguageRoute = function (option, availableLanguages, main) {
    var strapiLanguage = LanguageService.getCurrentStrapiLanguage();
    if (main && strapiLanguage.includes(option.value))
        return '';
    var regex = new RegExp(/^\/[\w-]+\/|^\//g);
    var path = [window.location.origin];
    var pathname = window.location.pathname;
    if (regex.test(pathname)) {
        pathname = main
            ? getPathname(pathname, option, availableLanguages, main)
            : getPathname(pathname, option);
        path.push(pathname);
    }
    return path.filter(function (item) { return item; }).join('/');
};
var getLanguageOptionIcon = function (icon) {
    return icon && LANGUAGE_ICONS[icon];
};
var getLanguage = function (localeOption, strapiLanguage, availableLanguages) {
    if (!strapiLanguage.includes(localeOption.value)) {
        var lang = localeOption.map[strapiLanguage.toLocaleLowerCase()].map[localeOption.value];
        return availableLanguages && availableLanguages.includes(lang)
            ? lang
            : localeOption.value;
    }
    return localeOption.value;
};
var getPathname = function (pathname, localeOption, availableLanguages, main) {
    var strapiLanguage = LanguageService.getCurrentStrapiLanguage();
    var language = main
        ? getLanguage(localeOption, strapiLanguage, availableLanguages)
        : localeOption.value;
    var legalPagePathname = pathname.split('/');
    if (legalPagePathname.indexOf(strapiLanguage) !== -1) {
        if (main && language !== 'de') {
            legalPagePathname.splice(1, 1, language);
        }
        else {
            localeOption.value !== 'de'
                ? legalPagePathname.splice(1, 1, language)
                : legalPagePathname.splice(1, 1, '');
        }
        legalPagePathname.splice(2, 1, localeOption.legalPages[legalPagePathname[2]]);
    }
    else {
        localeOption.value !== 'de' && legalPagePathname.splice(1, 0, language);
        legalPagePathname.splice(2, 1, localeOption.legalPages[legalPagePathname[2]]);
    }
    return legalPagePathname.filter(function (item) { return item; }).join('/');
};

var CollectionContext = createContext({
    id: 0,
    previewImageSlider: '',
    previewImageCard: '',
    previewImageMediaPlayer: '',
    title: '',
    subtitle: '',
    collectionObjects: [],
    interval: 8000,
});

var EFooterLinkType;
(function (EFooterLinkType) {
    EFooterLinkType[EFooterLinkType["internal"] = 0] = "internal";
    EFooterLinkType[EFooterLinkType["external"] = 1] = "external";
})(EFooterLinkType || (EFooterLinkType = {}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This work is licensed under the W3C Software and Document License
 * (http://www.w3.org/Consortium/Legal/2015/copyright-software-and-document).
 */

(function () {
  // Return early if we're not running inside of the browser.
  if (typeof window === 'undefined') {
    return;
  }

  // Convenience function for converting NodeLists.
  /** @type {typeof Array.prototype.slice} */
  var slice = Array.prototype.slice;

  /**
   * IE has a non-standard name for "matches".
   * @type {typeof Element.prototype.matches}
   */
  var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;

  /** @type {string} */
  var _focusableElementsString = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'details', 'summary', 'iframe', 'object', 'embed', '[contenteditable]'].join(',');

  /**
   * `InertRoot` manages a single inert subtree, i.e. a DOM subtree whose root element has an `inert`
   * attribute.
   *
   * Its main functions are:
   *
   * - to create and maintain a set of managed `InertNode`s, including when mutations occur in the
   *   subtree. The `makeSubtreeUnfocusable()` method handles collecting `InertNode`s via registering
   *   each focusable node in the subtree with the singleton `InertManager` which manages all known
   *   focusable nodes within inert subtrees. `InertManager` ensures that a single `InertNode`
   *   instance exists for each focusable node which has at least one inert root as an ancestor.
   *
   * - to notify all managed `InertNode`s when this subtree stops being inert (i.e. when the `inert`
   *   attribute is removed from the root node). This is handled in the destructor, which calls the
   *   `deregister` method on `InertManager` for each managed inert node.
   */

  var InertRoot = function () {
    /**
     * @param {!Element} rootElement The Element at the root of the inert subtree.
     * @param {!InertManager} inertManager The global singleton InertManager object.
     */
    function InertRoot(rootElement, inertManager) {
      _classCallCheck(this, InertRoot);

      /** @type {!InertManager} */
      this._inertManager = inertManager;

      /** @type {!Element} */
      this._rootElement = rootElement;

      /**
       * @type {!Set<!InertNode>}
       * All managed focusable nodes in this InertRoot's subtree.
       */
      this._managedNodes = new Set();

      // Make the subtree hidden from assistive technology
      if (this._rootElement.hasAttribute('aria-hidden')) {
        /** @type {?string} */
        this._savedAriaHidden = this._rootElement.getAttribute('aria-hidden');
      } else {
        this._savedAriaHidden = null;
      }
      this._rootElement.setAttribute('aria-hidden', 'true');

      // Make all focusable elements in the subtree unfocusable and add them to _managedNodes
      this._makeSubtreeUnfocusable(this._rootElement);

      // Watch for:
      // - any additions in the subtree: make them unfocusable too
      // - any removals from the subtree: remove them from this inert root's managed nodes
      // - attribute changes: if `tabindex` is added, or removed from an intrinsically focusable
      //   element, make that node a managed node.
      this._observer = new MutationObserver(this._onMutation.bind(this));
      this._observer.observe(this._rootElement, { attributes: true, childList: true, subtree: true });
    }

    /**
     * Call this whenever this object is about to become obsolete.  This unwinds all of the state
     * stored in this object and updates the state of all of the managed nodes.
     */


    _createClass(InertRoot, [{
      key: 'destructor',
      value: function destructor() {
        this._observer.disconnect();

        if (this._rootElement) {
          if (this._savedAriaHidden !== null) {
            this._rootElement.setAttribute('aria-hidden', this._savedAriaHidden);
          } else {
            this._rootElement.removeAttribute('aria-hidden');
          }
        }

        this._managedNodes.forEach(function (inertNode) {
          this._unmanageNode(inertNode.node);
        }, this);

        // Note we cast the nulls to the ANY type here because:
        // 1) We want the class properties to be declared as non-null, or else we
        //    need even more casts throughout this code. All bets are off if an
        //    instance has been destroyed and a method is called.
        // 2) We don't want to cast "this", because we want type-aware optimizations
        //    to know which properties we're setting.
        this._observer = /** @type {?} */null;
        this._rootElement = /** @type {?} */null;
        this._managedNodes = /** @type {?} */null;
        this._inertManager = /** @type {?} */null;
      }

      /**
       * @return {!Set<!InertNode>} A copy of this InertRoot's managed nodes set.
       */

    }, {
      key: '_makeSubtreeUnfocusable',


      /**
       * @param {!Node} startNode
       */
      value: function _makeSubtreeUnfocusable(startNode) {
        var _this2 = this;

        composedTreeWalk(startNode, function (node) {
          return _this2._visitNode(node);
        });

        var activeElement = document.activeElement;

        if (!document.body.contains(startNode)) {
          // startNode may be in shadow DOM, so find its nearest shadowRoot to get the activeElement.
          var node = startNode;
          /** @type {!ShadowRoot|undefined} */
          var root = undefined;
          while (node) {
            if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
              root = /** @type {!ShadowRoot} */node;
              break;
            }
            node = node.parentNode;
          }
          if (root) {
            activeElement = root.activeElement;
          }
        }
        if (startNode.contains(activeElement)) {
          activeElement.blur();
          // In IE11, if an element is already focused, and then set to tabindex=-1
          // calling blur() will not actually move the focus.
          // To work around this we call focus() on the body instead.
          if (activeElement === document.activeElement) {
            document.body.focus();
          }
        }
      }

      /**
       * @param {!Node} node
       */

    }, {
      key: '_visitNode',
      value: function _visitNode(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }
        var element = /** @type {!Element} */node;

        // If a descendant inert root becomes un-inert, its descendants will still be inert because of
        // this inert root, so all of its managed nodes need to be adopted by this InertRoot.
        if (element !== this._rootElement && element.hasAttribute('inert')) {
          this._adoptInertRoot(element);
        }

        if (matches.call(element, _focusableElementsString) || element.hasAttribute('tabindex')) {
          this._manageNode(element);
        }
      }

      /**
       * Register the given node with this InertRoot and with InertManager.
       * @param {!Node} node
       */

    }, {
      key: '_manageNode',
      value: function _manageNode(node) {
        var inertNode = this._inertManager.register(node, this);
        this._managedNodes.add(inertNode);
      }

      /**
       * Unregister the given node with this InertRoot and with InertManager.
       * @param {!Node} node
       */

    }, {
      key: '_unmanageNode',
      value: function _unmanageNode(node) {
        var inertNode = this._inertManager.deregister(node, this);
        if (inertNode) {
          this._managedNodes['delete'](inertNode);
        }
      }

      /**
       * Unregister the entire subtree starting at `startNode`.
       * @param {!Node} startNode
       */

    }, {
      key: '_unmanageSubtree',
      value: function _unmanageSubtree(startNode) {
        var _this3 = this;

        composedTreeWalk(startNode, function (node) {
          return _this3._unmanageNode(node);
        });
      }

      /**
       * If a descendant node is found with an `inert` attribute, adopt its managed nodes.
       * @param {!Element} node
       */

    }, {
      key: '_adoptInertRoot',
      value: function _adoptInertRoot(node) {
        var inertSubroot = this._inertManager.getInertRoot(node);

        // During initialisation this inert root may not have been registered yet,
        // so register it now if need be.
        if (!inertSubroot) {
          this._inertManager.setInert(node, true);
          inertSubroot = this._inertManager.getInertRoot(node);
        }

        inertSubroot.managedNodes.forEach(function (savedInertNode) {
          this._manageNode(savedInertNode.node);
        }, this);
      }

      /**
       * Callback used when mutation observer detects subtree additions, removals, or attribute changes.
       * @param {!Array<!MutationRecord>} records
       * @param {!MutationObserver} self
       */

    }, {
      key: '_onMutation',
      value: function _onMutation(records, self) {
        records.forEach(function (record) {
          var target = /** @type {!Element} */record.target;
          if (record.type === 'childList') {
            // Manage added nodes
            slice.call(record.addedNodes).forEach(function (node) {
              this._makeSubtreeUnfocusable(node);
            }, this);

            // Un-manage removed nodes
            slice.call(record.removedNodes).forEach(function (node) {
              this._unmanageSubtree(node);
            }, this);
          } else if (record.type === 'attributes') {
            if (record.attributeName === 'tabindex') {
              // Re-initialise inert node if tabindex changes
              this._manageNode(target);
            } else if (target !== this._rootElement && record.attributeName === 'inert' && target.hasAttribute('inert')) {
              // If a new inert root is added, adopt its managed nodes and make sure it knows about the
              // already managed nodes from this inert subroot.
              this._adoptInertRoot(target);
              var inertSubroot = this._inertManager.getInertRoot(target);
              this._managedNodes.forEach(function (managedNode) {
                if (target.contains(managedNode.node)) {
                  inertSubroot._manageNode(managedNode.node);
                }
              });
            }
          }
        }, this);
      }
    }, {
      key: 'managedNodes',
      get: function get() {
        return new Set(this._managedNodes);
      }

      /** @return {boolean} */

    }, {
      key: 'hasSavedAriaHidden',
      get: function get() {
        return this._savedAriaHidden !== null;
      }

      /** @param {?string} ariaHidden */

    }, {
      key: 'savedAriaHidden',
      set: function set(ariaHidden) {
        this._savedAriaHidden = ariaHidden;
      }

      /** @return {?string} */
      ,
      get: function get() {
        return this._savedAriaHidden;
      }
    }]);

    return InertRoot;
  }();

  /**
   * `InertNode` initialises and manages a single inert node.
   * A node is inert if it is a descendant of one or more inert root elements.
   *
   * On construction, `InertNode` saves the existing `tabindex` value for the node, if any, and
   * either removes the `tabindex` attribute or sets it to `-1`, depending on whether the element
   * is intrinsically focusable or not.
   *
   * `InertNode` maintains a set of `InertRoot`s which are descendants of this `InertNode`. When an
   * `InertRoot` is destroyed, and calls `InertManager.deregister()`, the `InertManager` notifies the
   * `InertNode` via `removeInertRoot()`, which in turn destroys the `InertNode` if no `InertRoot`s
   * remain in the set. On destruction, `InertNode` reinstates the stored `tabindex` if one exists,
   * or removes the `tabindex` attribute if the element is intrinsically focusable.
   */


  var InertNode = function () {
    /**
     * @param {!Node} node A focusable element to be made inert.
     * @param {!InertRoot} inertRoot The inert root element associated with this inert node.
     */
    function InertNode(node, inertRoot) {
      _classCallCheck(this, InertNode);

      /** @type {!Node} */
      this._node = node;

      /** @type {boolean} */
      this._overrodeFocusMethod = false;

      /**
       * @type {!Set<!InertRoot>} The set of descendant inert roots.
       *    If and only if this set becomes empty, this node is no longer inert.
       */
      this._inertRoots = new Set([inertRoot]);

      /** @type {?number} */
      this._savedTabIndex = null;

      /** @type {boolean} */
      this._destroyed = false;

      // Save any prior tabindex info and make this node untabbable
      this.ensureUntabbable();
    }

    /**
     * Call this whenever this object is about to become obsolete.
     * This makes the managed node focusable again and deletes all of the previously stored state.
     */


    _createClass(InertNode, [{
      key: 'destructor',
      value: function destructor() {
        this._throwIfDestroyed();

        if (this._node && this._node.nodeType === Node.ELEMENT_NODE) {
          var element = /** @type {!Element} */this._node;
          if (this._savedTabIndex !== null) {
            element.setAttribute('tabindex', this._savedTabIndex);
          } else {
            element.removeAttribute('tabindex');
          }

          // Use `delete` to restore native focus method.
          if (this._overrodeFocusMethod) {
            delete element.focus;
          }
        }

        // See note in InertRoot.destructor for why we cast these nulls to ANY.
        this._node = /** @type {?} */null;
        this._inertRoots = /** @type {?} */null;
        this._destroyed = true;
      }

      /**
       * @type {boolean} Whether this object is obsolete because the managed node is no longer inert.
       * If the object has been destroyed, any attempt to access it will cause an exception.
       */

    }, {
      key: '_throwIfDestroyed',


      /**
       * Throw if user tries to access destroyed InertNode.
       */
      value: function _throwIfDestroyed() {
        if (this.destroyed) {
          throw new Error('Trying to access destroyed InertNode');
        }
      }

      /** @return {boolean} */

    }, {
      key: 'ensureUntabbable',


      /** Save the existing tabindex value and make the node untabbable and unfocusable */
      value: function ensureUntabbable() {
        if (this.node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }
        var element = /** @type {!Element} */this.node;
        if (matches.call(element, _focusableElementsString)) {
          if ( /** @type {!HTMLElement} */element.tabIndex === -1 && this.hasSavedTabIndex) {
            return;
          }

          if (element.hasAttribute('tabindex')) {
            this._savedTabIndex = /** @type {!HTMLElement} */element.tabIndex;
          }
          element.setAttribute('tabindex', '-1');
          if (element.nodeType === Node.ELEMENT_NODE) {
            element.focus = function () {};
            this._overrodeFocusMethod = true;
          }
        } else if (element.hasAttribute('tabindex')) {
          this._savedTabIndex = /** @type {!HTMLElement} */element.tabIndex;
          element.removeAttribute('tabindex');
        }
      }

      /**
       * Add another inert root to this inert node's set of managing inert roots.
       * @param {!InertRoot} inertRoot
       */

    }, {
      key: 'addInertRoot',
      value: function addInertRoot(inertRoot) {
        this._throwIfDestroyed();
        this._inertRoots.add(inertRoot);
      }

      /**
       * Remove the given inert root from this inert node's set of managing inert roots.
       * If the set of managing inert roots becomes empty, this node is no longer inert,
       * so the object should be destroyed.
       * @param {!InertRoot} inertRoot
       */

    }, {
      key: 'removeInertRoot',
      value: function removeInertRoot(inertRoot) {
        this._throwIfDestroyed();
        this._inertRoots['delete'](inertRoot);
        if (this._inertRoots.size === 0) {
          this.destructor();
        }
      }
    }, {
      key: 'destroyed',
      get: function get() {
        return (/** @type {!InertNode} */this._destroyed
        );
      }
    }, {
      key: 'hasSavedTabIndex',
      get: function get() {
        return this._savedTabIndex !== null;
      }

      /** @return {!Node} */

    }, {
      key: 'node',
      get: function get() {
        this._throwIfDestroyed();
        return this._node;
      }

      /** @param {?number} tabIndex */

    }, {
      key: 'savedTabIndex',
      set: function set(tabIndex) {
        this._throwIfDestroyed();
        this._savedTabIndex = tabIndex;
      }

      /** @return {?number} */
      ,
      get: function get() {
        this._throwIfDestroyed();
        return this._savedTabIndex;
      }
    }]);

    return InertNode;
  }();

  /**
   * InertManager is a per-document singleton object which manages all inert roots and nodes.
   *
   * When an element becomes an inert root by having an `inert` attribute set and/or its `inert`
   * property set to `true`, the `setInert` method creates an `InertRoot` object for the element.
   * The `InertRoot` in turn registers itself as managing all of the element's focusable descendant
   * nodes via the `register()` method. The `InertManager` ensures that a single `InertNode` instance
   * is created for each such node, via the `_managedNodes` map.
   */


  var InertManager = function () {
    /**
     * @param {!Document} document
     */
    function InertManager(document) {
      _classCallCheck(this, InertManager);

      if (!document) {
        throw new Error('Missing required argument; InertManager needs to wrap a document.');
      }

      /** @type {!Document} */
      this._document = document;

      /**
       * All managed nodes known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertNode>}
       */
      this._managedNodes = new Map();

      /**
       * All inert roots known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertRoot>}
       */
      this._inertRoots = new Map();

      /**
       * Observer for mutations on `document.body`.
       * @type {!MutationObserver}
       */
      this._observer = new MutationObserver(this._watchForInert.bind(this));

      // Add inert style.
      addInertStyle(document.head || document.body || document.documentElement);

      // Wait for document to be loaded.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this._onDocumentLoaded.bind(this));
      } else {
        this._onDocumentLoaded();
      }
    }

    /**
     * Set whether the given element should be an inert root or not.
     * @param {!Element} root
     * @param {boolean} inert
     */


    _createClass(InertManager, [{
      key: 'setInert',
      value: function setInert(root, inert) {
        if (inert) {
          if (this._inertRoots.has(root)) {
            // element is already inert
            return;
          }

          var inertRoot = new InertRoot(root, this);
          root.setAttribute('inert', '');
          this._inertRoots.set(root, inertRoot);
          // If not contained in the document, it must be in a shadowRoot.
          // Ensure inert styles are added there.
          if (!this._document.body.contains(root)) {
            var parent = root.parentNode;
            while (parent) {
              if (parent.nodeType === 11) {
                addInertStyle(parent);
              }
              parent = parent.parentNode;
            }
          }
        } else {
          if (!this._inertRoots.has(root)) {
            // element is already non-inert
            return;
          }

          var _inertRoot = this._inertRoots.get(root);
          _inertRoot.destructor();
          this._inertRoots['delete'](root);
          root.removeAttribute('inert');
        }
      }

      /**
       * Get the InertRoot object corresponding to the given inert root element, if any.
       * @param {!Node} element
       * @return {!InertRoot|undefined}
       */

    }, {
      key: 'getInertRoot',
      value: function getInertRoot(element) {
        return this._inertRoots.get(element);
      }

      /**
       * Register the given InertRoot as managing the given node.
       * In the case where the node has a previously existing inert root, this inert root will
       * be added to its set of inert roots.
       * @param {!Node} node
       * @param {!InertRoot} inertRoot
       * @return {!InertNode} inertNode
       */

    }, {
      key: 'register',
      value: function register(node, inertRoot) {
        var inertNode = this._managedNodes.get(node);
        if (inertNode !== undefined) {
          // node was already in an inert subtree
          inertNode.addInertRoot(inertRoot);
        } else {
          inertNode = new InertNode(node, inertRoot);
        }

        this._managedNodes.set(node, inertNode);

        return inertNode;
      }

      /**
       * De-register the given InertRoot as managing the given inert node.
       * Removes the inert root from the InertNode's set of managing inert roots, and remove the inert
       * node from the InertManager's set of managed nodes if it is destroyed.
       * If the node is not currently managed, this is essentially a no-op.
       * @param {!Node} node
       * @param {!InertRoot} inertRoot
       * @return {?InertNode} The potentially destroyed InertNode associated with this node, if any.
       */

    }, {
      key: 'deregister',
      value: function deregister(node, inertRoot) {
        var inertNode = this._managedNodes.get(node);
        if (!inertNode) {
          return null;
        }

        inertNode.removeInertRoot(inertRoot);
        if (inertNode.destroyed) {
          this._managedNodes['delete'](node);
        }

        return inertNode;
      }

      /**
       * Callback used when document has finished loading.
       */

    }, {
      key: '_onDocumentLoaded',
      value: function _onDocumentLoaded() {
        // Find all inert roots in document and make them actually inert.
        var inertElements = slice.call(this._document.querySelectorAll('[inert]'));
        inertElements.forEach(function (inertElement) {
          this.setInert(inertElement, true);
        }, this);

        // Comment this out to use programmatic API only.
        this._observer.observe(this._document.body || this._document.documentElement, { attributes: true, subtree: true, childList: true });
      }

      /**
       * Callback used when mutation observer detects attribute changes.
       * @param {!Array<!MutationRecord>} records
       * @param {!MutationObserver} self
       */

    }, {
      key: '_watchForInert',
      value: function _watchForInert(records, self) {
        var _this = this;
        records.forEach(function (record) {
          switch (record.type) {
            case 'childList':
              slice.call(record.addedNodes).forEach(function (node) {
                if (node.nodeType !== Node.ELEMENT_NODE) {
                  return;
                }
                var inertElements = slice.call(node.querySelectorAll('[inert]'));
                if (matches.call(node, '[inert]')) {
                  inertElements.unshift(node);
                }
                inertElements.forEach(function (inertElement) {
                  this.setInert(inertElement, true);
                }, _this);
              }, _this);
              break;
            case 'attributes':
              if (record.attributeName !== 'inert') {
                return;
              }
              var target = /** @type {!Element} */record.target;
              var inert = target.hasAttribute('inert');
              _this.setInert(target, inert);
              break;
          }
        }, this);
      }
    }]);

    return InertManager;
  }();

  /**
   * Recursively walk the composed tree from |node|.
   * @param {!Node} node
   * @param {(function (!Element))=} callback Callback to be called for each element traversed,
   *     before descending into child nodes.
   * @param {?ShadowRoot=} shadowRootAncestor The nearest ShadowRoot ancestor, if any.
   */


  function composedTreeWalk(node, callback, shadowRootAncestor) {
    if (node.nodeType == Node.ELEMENT_NODE) {
      var element = /** @type {!Element} */node;
      if (callback) {
        callback(element);
      }

      // Descend into node:
      // If it has a ShadowRoot, ignore all child elements - these will be picked
      // up by the <content> or <shadow> elements. Descend straight into the
      // ShadowRoot.
      var shadowRoot = /** @type {!HTMLElement} */element.shadowRoot;
      if (shadowRoot) {
        composedTreeWalk(shadowRoot, callback);
        return;
      }

      // If it is a <content> element, descend into distributed elements - these
      // are elements from outside the shadow root which are rendered inside the
      // shadow DOM.
      if (element.localName == 'content') {
        var content = /** @type {!HTMLContentElement} */element;
        // Verifies if ShadowDom v0 is supported.
        var distributedNodes = content.getDistributedNodes ? content.getDistributedNodes() : [];
        for (var i = 0; i < distributedNodes.length; i++) {
          composedTreeWalk(distributedNodes[i], callback);
        }
        return;
      }

      // If it is a <slot> element, descend into assigned nodes - these
      // are elements from outside the shadow root which are rendered inside the
      // shadow DOM.
      if (element.localName == 'slot') {
        var slot = /** @type {!HTMLSlotElement} */element;
        // Verify if ShadowDom v1 is supported.
        var _distributedNodes = slot.assignedNodes ? slot.assignedNodes({ flatten: true }) : [];
        for (var _i = 0; _i < _distributedNodes.length; _i++) {
          composedTreeWalk(_distributedNodes[_i], callback);
        }
        return;
      }
    }

    // If it is neither the parent of a ShadowRoot, a <content> element, a <slot>
    // element, nor a <shadow> element recurse normally.
    var child = node.firstChild;
    while (child != null) {
      composedTreeWalk(child, callback);
      child = child.nextSibling;
    }
  }

  /**
   * Adds a style element to the node containing the inert specific styles
   * @param {!Node} node
   */
  function addInertStyle(node) {
    if (node.querySelector('style#inert-style, link#inert-style')) {
      return;
    }
    var style = document.createElement('style');
    style.setAttribute('id', 'inert-style');
    style.textContent = '\n' + '[inert] {\n' + '  pointer-events: none;\n' + '  cursor: default;\n' + '}\n' + '\n' + '[inert], [inert] * {\n' + '  -webkit-user-select: none;\n' + '  -moz-user-select: none;\n' + '  -ms-user-select: none;\n' + '  user-select: none;\n' + '}\n';
    node.appendChild(style);
  }

  if (!Element.prototype.hasOwnProperty('inert')) {
    /** @type {!InertManager} */
    var inertManager = new InertManager(document);

    Object.defineProperty(Element.prototype, 'inert', {
      enumerable: true,
      /** @this {!Element} */
      get: function get() {
        return this.hasAttribute('inert');
      },
      /** @this {!Element} */
      set: function set(inert) {
        inertManager.setInert(this, inert);
      }
    });
  }
})();

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var exenv = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if ( module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
});

var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

function timeout$1(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}

function interval$1(callback, delay, time) {
  var t = new Timer, total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var transitionId = 0;
function getTransitionId() {
  return ++transitionId;
}
function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }
}
function once(func) {
  var called = false;
  return function transitionEvent() {
    if (!called) {
      called = true;
      func.call(this);
    }
  };
}
function isNamespace(prop) {
  return _typeof(prop) === 'object' && Array.isArray(prop) === false;
}

var linear = function linear(t) {
  return +t;
};

var timingDefaults = {
  delay: 0,
  duration: 250,
  ease: linear
};

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var Events = function Events(config) {
  var _this = this;

  _classCallCheck$1(this, Events);

  this.start = null;
  this.interrupt = null;
  this.end = null;

  if (config.events) {
    Object.keys(config.events).forEach(function (d) {
      if (typeof config.events[d] !== 'function') {
        throw new Error('Event handlers must be a function');
      } else {
        _this[d] = once(config.events[d]);
      }
    });
  }
};

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BaseNode = function () {
  function BaseNode(state) {
    _classCallCheck$2(this, BaseNode);

    this.state = state || {};
  }

  _createClass$1(BaseNode, [{
    key: "transition",
    value: function transition(config) {
      if (Array.isArray(config)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = config[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;
            this.parse(item);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        this.parse(config);
      }
    }
  }, {
    key: "isTransitioning",
    value: function isTransitioning() {
      return !!this.transitionData;
    }
  }, {
    key: "stopTransitions",
    value: function stopTransitions() {
      var transitions = this.transitionData;

      if (transitions) {
        Object.keys(transitions).forEach(function (t) {
          transitions[t].timer.stop();
        });
      }
    }
  }, {
    key: "setState",
    value: function setState(update) {
      if (typeof update === 'function') {
        extend(this.state, update(this.state));
      } else {
        extend(this.state, update);
      }
    }
  }, {
    key: "parse",
    value: function parse(config) {
      var _this = this;

      var clone = _objectSpread({}, config);

      var events = new Events(clone);

      if (clone.events) {
        delete clone.events;
      }

      var timing = _objectSpread({}, timingDefaults, clone.timing || {}, {
        time: now()
      });

      if (clone.timing) {
        delete clone.timing;
      }

      Object.keys(clone).forEach(function (stateKey) {
        var tweens = [];
        var next = clone[stateKey];

        if (isNamespace(next)) {
          Object.keys(next).forEach(function (attr) {
            var val = next[attr];

            if (Array.isArray(val)) {
              if (val.length === 1) {
                tweens.push(_this.getTween(attr, val[0], stateKey));
              } else {
                _this.setState(function (state) {
                  var _objectSpread2, _ref;

                  return _ref = {}, _ref[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread2 = {}, _objectSpread2[attr] = val[0], _objectSpread2)), _ref;
                });

                tweens.push(_this.getTween(attr, val[1], stateKey));
              }
            } else if (typeof val === 'function') {
              var getNameSpacedCustomTween = function getNameSpacedCustomTween() {
                var kapellmeisterNamespacedTween = function kapellmeisterNamespacedTween(t) {
                  _this.setState(function (state) {
                    var _objectSpread3, _ref2;

                    return _ref2 = {}, _ref2[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread3 = {}, _objectSpread3[attr] = val(t), _objectSpread3)), _ref2;
                  });
                };

                return kapellmeisterNamespacedTween;
              };

              tweens.push(getNameSpacedCustomTween);
            } else {
              _this.setState(function (state) {
                var _objectSpread4, _ref3;

                return _ref3 = {}, _ref3[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread4 = {}, _objectSpread4[attr] = val, _objectSpread4)), _ref3;
              });

              tweens.push(_this.getTween(attr, val, stateKey));
            }
          });
        } else {
          if (Array.isArray(next)) {
            if (next.length === 1) {
              tweens.push(_this.getTween(stateKey, next[0], null));
            } else {
              var _this$setState;

              _this.setState((_this$setState = {}, _this$setState[stateKey] = next[0], _this$setState));

              tweens.push(_this.getTween(stateKey, next[1], null));
            }
          } else if (typeof next === 'function') {
            var getCustomTween = function getCustomTween() {
              var kapellmeisterTween = function kapellmeisterTween(t) {
                var _this$setState2;

                _this.setState((_this$setState2 = {}, _this$setState2[stateKey] = next(t), _this$setState2));
              };

              return kapellmeisterTween;
            };

            tweens.push(getCustomTween);
          } else {
            var _this$setState3;

            _this.setState((_this$setState3 = {}, _this$setState3[stateKey] = next, _this$setState3));

            tweens.push(_this.getTween(stateKey, next, null));
          }
        }

        _this.update({
          stateKey: stateKey,
          timing: timing,
          tweens: tweens,
          events: events,
          status: 0
        });
      });
    }
  }, {
    key: "getTween",
    value: function getTween(attr, endValue, nameSpace) {
      var _this2 = this;

      return function () {
        var begValue = nameSpace ? _this2.state[nameSpace][attr] : _this2.state[attr];

        if (begValue === endValue) {
          return null;
        }

        var i = _this2.getInterpolator(begValue, endValue, attr, nameSpace);

        var stateTween;

        if (nameSpace === null) {
          stateTween = function stateTween(t) {
            var _this2$setState;

            _this2.setState((_this2$setState = {}, _this2$setState[attr] = i(t), _this2$setState));
          };
        } else {
          stateTween = function stateTween(t) {
            _this2.setState(function (state) {
              var _objectSpread5, _ref4;

              return _ref4 = {}, _ref4[nameSpace] = _objectSpread({}, state[nameSpace], (_objectSpread5 = {}, _objectSpread5[attr] = i(t), _objectSpread5)), _ref4;
            });
          };
        }

        return stateTween;
      };
    }
  }, {
    key: "update",
    value: function update(transition) {
      if (!this.transitionData) {
        this.transitionData = {};
      }

      this.init(getTransitionId(), transition);
    }
  }, {
    key: "init",
    value: function init(id, transition) {
      var _this3 = this;

      var n = transition.tweens.length;
      var tweens = new Array(n);

      var queue = function queue(elapsed) {
        transition.status = 1;
        transition.timer.restart(start, transition.timing.delay, transition.timing.time);

        if (transition.timing.delay <= elapsed) {
          start(elapsed - transition.timing.delay);
        }
      };

      this.transitionData[id] = transition;
      transition.timer = timer(queue, 0, transition.timing.time);

      var start = function start(elapsed) {
        if (transition.status !== 1) return stop();

        for (var tid in _this3.transitionData) {
          var t = _this3.transitionData[tid];

          if (t.stateKey !== transition.stateKey) {
            continue;
          }

          if (t.status === 3) {
            return timeout$1(start);
          }

          if (t.status === 4) {
            t.status = 6;
            t.timer.stop();

            if (t.events.interrupt) {
              t.events.interrupt.call(_this3);
            }

            delete _this3.transitionData[tid];
          } else if (+tid < id) {
            t.status = 6;
            t.timer.stop();
            delete _this3.transitionData[tid];
          }
        }

        timeout$1(function () {
          if (transition.status === 3) {
            transition.status = 4;
            transition.timer.restart(tick, transition.timing.delay, transition.timing.time);
            tick(elapsed);
          }
        });
        transition.status = 2;

        if (transition.events.start) {
          transition.events.start.call(_this3);
        }

        if (transition.status !== 2) {
          return;
        }

        transition.status = 3;
        var j = -1;

        for (var i = 0; i < n; ++i) {
          var res = transition.tweens[i]();

          if (res) {
            tweens[++j] = res;
          }
        }

        tweens.length = j + 1;
      };

      var tick = function tick(elapsed) {
        var t = 1;

        if (elapsed < transition.timing.duration) {
          t = transition.timing.ease(elapsed / transition.timing.duration);
        } else {
          transition.timer.restart(stop);
          transition.status = 5;
        }

        var i = -1;

        while (++i < tweens.length) {
          tweens[i](t);
        }

        if (transition.status === 5) {
          if (transition.events.end) {
            transition.events.end.call(_this3);
          }

          stop();
        }
      };

      var stop = function stop() {
        transition.status = 6;
        transition.timer.stop();
        delete _this3.transitionData[id];

        for (var _ in _this3.transitionData) {
          return;
        }

        delete _this3.transitionData;
      };
    }
  }]);

  return BaseNode;
}();



var es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BaseNode: BaseNode,
  now: now,
  timer: timer,
  interval: interval$1,
  timeout: timeout$1
});

var mergeKeys_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function mergeKeys(currNodeKeys, currKeyIndex, nextNodeKeys, nextKeyIndex) {
  var allKeys = [];

  for (var i = 0; i < nextNodeKeys.length; i++) {
    allKeys[i] = nextNodeKeys[i];
  }

  for (var _i = 0; _i < currNodeKeys.length; _i++) {
    if (nextKeyIndex[currNodeKeys[_i]] === undefined) {
      allKeys.push(currNodeKeys[_i]);
    }
  }

  return allKeys.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a];
    var nextOrderB = nextKeyIndex[b];
    var currOrderA = currKeyIndex[a];
    var currOrderB = currKeyIndex[b];

    if (nextOrderA != null && nextOrderB != null) {
      return nextKeyIndex[a] - nextKeyIndex[b];
    } else if (currOrderA != null && currOrderB != null) {
      return currKeyIndex[a] - currKeyIndex[b];
    } else if (nextOrderA != null) {
      for (var _i2 = 0; _i2 < nextNodeKeys.length; _i2++) {
        var pivot = nextNodeKeys[_i2];

        if (!currKeyIndex[pivot]) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && currOrderB > currKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && currOrderB < currKeyIndex[pivot]) {
          return 1;
        }
      }

      return 1;
    }

    for (var _i3 = 0; _i3 < nextNodeKeys.length; _i3++) {
      var _pivot = nextNodeKeys[_i3];

      if (!currKeyIndex[_pivot]) {
        continue;
      }

      if (nextOrderB < nextKeyIndex[_pivot] && currOrderA > currKeyIndex[_pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[_pivot] && currOrderA < currKeyIndex[_pivot]) {
        return -1;
      }
    }

    return -1;
  });
}

var _default = mergeKeys;
exports["default"] = _default;
});

unwrapExports(mergeKeys_1);

var types = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEAVE = exports.UPDATE = exports.ENTER = void 0;
var ENTER = 'ENTER';
exports.ENTER = ENTER;
var UPDATE = 'UPDATE';
exports.UPDATE = UPDATE;
var LEAVE = 'LEAVE';
exports.LEAVE = LEAVE;
});

unwrapExports(types);
var types_1 = types.LEAVE;
var types_2 = types.UPDATE;
var types_3 = types.ENTER;

var utils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numeric = numeric;

function numeric(beg, end) {
  var a = +beg;
  var b = +end - a;
  return function (t) {
    return a + b * t;
  };
}
});

unwrapExports(utils);
var utils_1 = utils.numeric;

var NodeGroup_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);

var _propTypes = _interopRequireDefault(PropTypes);



var _mergeKeys = _interopRequireDefault(mergeKeys_1);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NodeGroup = function (_Component) {
  _inherits(NodeGroup, _Component);

  var _super = _createSuper(NodeGroup);

  function NodeGroup(props) {
    var _this;

    _classCallCheck(this, NodeGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "animate", function () {
      var _this$state = _this.state,
          nodeKeys = _this$state.nodeKeys,
          nodeHash = _this$state.nodeHash;

      if (_this.unmounting) {
        return;
      }

      var pending = false;
      var nextNodeKeys = [];
      var length = nodeKeys.length;

      for (var i = 0; i < length; i++) {
        var k = nodeKeys[i];
        var n = nodeHash[k];
        var isTransitioning = n.isTransitioning();

        if (isTransitioning) {
          pending = true;
        }

        if (n.type === types.LEAVE && !isTransitioning) {
          delete nodeHash[k];
        } else {
          nextNodeKeys.push(k);
        }
      }

      if (!pending) {
        _this.interval.stop();
      }

      _this.setState(function () {
        return {
          nodeKeys: nextNodeKeys,
          nodes: nextNodeKeys.map(function (key) {
            return nodeHash[key];
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "interval", null);

    _defineProperty(_assertThisInitialized(_this), "unmounting", false);

    var interpolation = props.interpolation;

    var Node = function (_BaseNode) {
      _inherits(Node, _BaseNode);

      var _super2 = _createSuper(Node);

      function Node(key, data) {
        var _this2;

        _classCallCheck(this, Node);

        _this2 = _super2.call(this);

        _defineProperty(_assertThisInitialized(_this2), "getInterpolator", interpolation);

        _this2.key = key;
        _this2.data = data;
        _this2.type = types.ENTER;
        return _this2;
      }

      return Node;
    }(es.BaseNode);

    _this.state = {
      Node: Node,
      nodeKeys: [],
      nodeHash: {},
      nodes: [],
      data: null
    };
    return _this;
  }

  _createClass(NodeGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startInterval();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.data !== this.props.data && !this.unmounting) {
        this.startInterval();
      }
    }
  }, {
    key: "startInterval",
    value: function startInterval() {
      if (!this.interval) {
        this.interval = (0, es.interval)(this.animate);
      } else {
        this.interval.restart(this.animate);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state2 = this.state,
          nodeKeys = _this$state2.nodeKeys,
          nodeHash = _this$state2.nodeHash;
      this.unmounting = true;

      if (this.interval) {
        this.interval.stop();
      }

      nodeKeys.forEach(function (key) {
        nodeHash[key].stopTransitions();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var renderedChildren = this.props.children(this.state.nodes);
      return renderedChildren && _react["default"].Children.only(renderedChildren);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.data !== prevState.data) {
        var data = nextProps.data,
            keyAccessor = nextProps.keyAccessor,
            start = nextProps.start,
            enter = nextProps.enter,
            update = nextProps.update,
            leave = nextProps.leave;
        var Node = prevState.Node,
            nodeKeys = prevState.nodeKeys,
            nodeHash = prevState.nodeHash;
        var keyIndex = {};

        for (var i = 0; i < nodeKeys.length; i++) {
          keyIndex[nodeKeys[i]] = i;
        }

        var nextKeyIndex = {};
        var nextNodeKeys = [];

        for (var _i = 0; _i < data.length; _i++) {
          var d = data[_i];
          var k = keyAccessor(d, _i);
          nextKeyIndex[k] = _i;
          nextNodeKeys.push(k);

          if (keyIndex[k] === undefined) {
            var node = new Node();
            node.key = k;
            node.data = d;
            node.type = types.ENTER;
            nodeHash[k] = node;
          }
        }

        for (var _i2 = 0; _i2 < nodeKeys.length; _i2++) {
          var _k = nodeKeys[_i2];
          var n = nodeHash[_k];

          if (nextKeyIndex[_k] !== undefined) {
            n.data = data[nextKeyIndex[_k]];
            n.type = types.UPDATE;
          } else {
            n.type = types.LEAVE;
          }
        }

        var mergedNodeKeys = (0, _mergeKeys["default"])(nodeKeys, keyIndex, nextNodeKeys, nextKeyIndex);

        for (var _i3 = 0; _i3 < mergedNodeKeys.length; _i3++) {
          var _k2 = mergedNodeKeys[_i3];
          var _n = nodeHash[_k2];
          var _d = _n.data;

          if (_n.type === types.ENTER) {
            _n.setState(start(_d, nextKeyIndex[_k2]));

            _n.transition(enter(_d, nextKeyIndex[_k2]));
          } else if (_n.type === types.LEAVE) {
            _n.transition(leave(_d, keyIndex[_k2]));
          } else {
            _n.transition(update(_d, nextKeyIndex[_k2]));
          }
        }

        return {
          data: data,
          nodes: mergedNodeKeys.map(function (key) {
            return nodeHash[key];
          }),
          nodeHash: nodeHash,
          nodeKeys: mergedNodeKeys
        };
      }

      return null;
    }
  }]);

  return NodeGroup;
}(_react.Component);

NodeGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes["default"].array.isRequired,
  keyAccessor: _propTypes["default"].func.isRequired,
  interpolation: _propTypes["default"].func,
  start: _propTypes["default"].func.isRequired,
  enter: _propTypes["default"].func,
  update: _propTypes["default"].func,
  leave: _propTypes["default"].func,
  children: _propTypes["default"].func.isRequired
} : {};
NodeGroup.defaultProps = {
  enter: function enter() {},
  update: function update() {},
  leave: function leave() {},
  interpolation: utils.numeric
};
var _default = NodeGroup;
exports["default"] = _default;
});

unwrapExports(NodeGroup_1);

var Animate_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);

var _propTypes = _interopRequireDefault(PropTypes);

var _NodeGroup = _interopRequireDefault(NodeGroup_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var keyAccessor = function keyAccessor() {
  return '$$key$$';
};

var Animate = function (_Component) {
  _inherits(Animate, _Component);

  var _super = _createSuper(Animate);

  function Animate() {
    _classCallCheck(this, Animate);

    return _super.apply(this, arguments);
  }

  _createClass(Animate, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          start = _this$props.start,
          enter = _this$props.enter,
          update = _this$props.update,
          leave = _this$props.leave,
          interpolation = _this$props.interpolation,
          children = _this$props.children;
      var data = typeof start === 'function' ? start() : start;
      return _react["default"].createElement(_NodeGroup["default"], {
        data: show ? [data] : [],
        start: function start() {
          return data;
        },
        keyAccessor: keyAccessor,
        interpolation: interpolation,
        enter: typeof enter === 'function' ? enter : function () {
          return enter;
        },
        update: typeof update === 'function' ? update : function () {
          return update;
        },
        leave: typeof leave === 'function' ? leave : function () {
          return leave;
        }
      }, function (nodes) {
        if (!nodes[0]) {
          return null;
        }

        var renderedChildren = children(nodes[0].state);
        return renderedChildren && _react["default"].Children.only(renderedChildren);
      });
    }
  }]);

  return Animate;
}(_react.Component);

Animate.propTypes = process.env.NODE_ENV !== "production" ? {
  show: _propTypes["default"].bool,
  interpolation: _propTypes["default"].func,
  start: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  enter: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].array, _propTypes["default"].object]),
  update: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].array, _propTypes["default"].object]),
  leave: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].array, _propTypes["default"].object]),
  children: _propTypes["default"].func.isRequired
} : {};
Animate.defaultProps = {
  show: true,
  interpolation: utils.numeric
};
var _default = Animate;
exports["default"] = _default;
});

var Animate = unwrapExports(Animate_1);

function linear$1(t) {
  return +t;
}

function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);

var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return (+t === 1) ? 1 : 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

// tpmt is two power minus ten times t scaled to [0,1]
function tpmt(x) {
  return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

function expIn(t) {
  return tpmt(1 - +t);
}

function expOut(t) {
  return 1 - tpmt(t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
}

function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return (t = +t) * t * (s * (t - 1) + t);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((t + 1) * s + t) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * tpmt(-(--t)) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * tpmt(t = +t) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * tpmt(-t) * Math.sin((s - t) / p)
        : 2 - a * tpmt(t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);



var easing = /*#__PURE__*/Object.freeze({
  __proto__: null,
  easeLinear: linear$1,
  easeQuad: quadInOut,
  easeQuadIn: quadIn,
  easeQuadOut: quadOut,
  easeQuadInOut: quadInOut,
  easeCubic: cubicInOut,
  easeCubicIn: cubicIn,
  easeCubicOut: cubicOut,
  easeCubicInOut: cubicInOut,
  easePoly: polyInOut,
  easePolyIn: polyIn,
  easePolyOut: polyOut,
  easePolyInOut: polyInOut,
  easeSin: sinInOut,
  easeSinIn: sinIn,
  easeSinOut: sinOut,
  easeSinInOut: sinInOut,
  easeExp: expInOut,
  easeExpIn: expIn,
  easeExpOut: expOut,
  easeExpInOut: expInOut,
  easeCircle: circleInOut,
  easeCircleIn: circleIn,
  easeCircleOut: circleOut,
  easeCircleInOut: circleInOut,
  easeBounce: bounceOut,
  easeBounceIn: bounceIn,
  easeBounceOut: bounceOut,
  easeBounceInOut: bounceInOut,
  easeBack: backInOut,
  easeBackIn: backIn,
  easeBackOut: backOut,
  easeBackInOut: backInOut,
  easeElastic: elasticOut,
  easeElasticIn: elasticIn,
  easeElasticOut: elasticOut,
  easeElasticInOut: elasticInOut
});

var getImgTagStyles = function getImgTagStyles() {
  return ".slider-slide > img { width: 100%; display: block; }\n          .slider-slide > img:focus { margin: auto; }";
};
var getSlideHeight = function getSlideHeight(props) {
  var childCount = React.Children.count(props.children);
  var listWidth = props.slideWidth * childCount;
  var spacingOffset = props.cellSpacing * childCount;
  var calculatedHeight = props.vertical ? listWidth + spacingOffset : props.slideHeight;
  return calculatedHeight > 0 && props.heightMode !== 'current' ? calculatedHeight : 'auto';
};
var getAlignmentOffset = function getAlignmentOffset(slideIndex, config) {
  var offset = 0;

  switch (config.cellAlign) {
    case 'left':
      {
        offset = 0;
        offset -= config.cellSpacing * slideIndex;
        break;
      }

    case 'center':
      {
        offset = (config.frameWidth - config.slideWidth) / 2;
        offset -= config.cellSpacing * slideIndex;
        break;
      }

    case 'right':
      {
        offset = config.frameWidth - config.slideWidth;
        offset -= config.cellSpacing * slideIndex;
        break;
      }
  }

  return offset;
};
var getDecoratorStyles = function getDecoratorStyles(position) {
  switch (position) {
    case 'TopLeft':
      {
        return {
          position: 'absolute',
          top: 0,
          left: 0
        };
      }

    case 'TopCenter':
      {
        return {
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          WebkitTransform: 'translateX(-50%)',
          msTransform: 'translateX(-50%)'
        };
      }

    case 'TopRight':
      {
        return {
          position: 'absolute',
          top: 0,
          right: 0
        };
      }

    case 'CenterLeft':
      {
        return {
          position: 'absolute',
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)',
          WebkitTransform: 'translateY(-50%)',
          msTransform: 'translateY(-50%)'
        };
      }

    case 'CenterCenter':
      {
        return {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          WebkitTransform: 'translate(-50%, -50%)',
          msTransform: 'translate(-50%, -50%)'
        };
      }

    case 'CenterRight':
      {
        return {
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translateY(-50%)',
          WebkitTransform: 'translateY(-50%)',
          msTransform: 'translateY(-50%)'
        };
      }

    case 'BottomLeft':
      {
        return {
          position: 'absolute',
          bottom: 0,
          left: 0
        };
      }

    case 'BottomCenter':
      {
        return {
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          WebkitTransform: 'translateX(-50%)',
          msTransform: 'translateX(-50%)'
        };
      }

    case 'BottomRight':
      {
        return {
          position: 'absolute',
          bottom: 0,
          right: 0
        };
      }

    default:
      {
        return {
          position: 'absolute',
          top: 0,
          left: 0
        };
      }
  }
};
var getSliderStyles = function getSliderStyles(propWidth, propHeight) {
  return {
    boxSizing: 'border-box',
    display: 'block',
    height: propHeight,
    MozBoxSizing: 'border-box',
    position: 'relative',
    width: propWidth
  };
};
var getFrameStyles = function getFrameStyles(propFrameOverFlow, propVertical, propFramePadding, stateFrameWidth) {
  return {
    boxSizing: 'border-box',
    display: 'block',
    height: propVertical ? stateFrameWidth || 'initial' : '100%',
    margin: propFramePadding,
    MozBoxSizing: 'border-box',
    msTransform: 'translate(0, 0)',
    overflow: propFrameOverFlow,
    padding: 0,
    position: 'relative',
    touchAction: "pinch-zoom ".concat(propVertical ? 'pan-x' : 'pan-y'),
    transform: 'translate3d(0, 0, 0)',
    WebkitTransform: 'translate3d(0, 0, 0)'
  };
};
var getTransitionProps = function getTransitionProps(props, state) {
  return {
    animation: props.animation,
    cellAlign: props.cellAlign,
    cellSpacing: props.cellSpacing,
    currentSlide: state.currentSlide,
    dragging: props.dragging,
    frameWidth: parseInt(state.frameWidth),
    hasInteraction: state.hasInteraction,
    heightMode: props.heightMode,
    isWrappingAround: state.isWrappingAround,
    left: state.left,
    opacityScale: props.opacityScale,
    slideCount: state.slideCount,
    slideHeight: state.slideHeight,
    slideListMargin: props.slideListMargin,
    slideOffset: props.slideOffset,
    slidesToScroll: props.scrollMode === 'page' ? state.slidesToShow : props.slidesToScroll,
    slidesToShow: state.slidesToShow,
    slideWidth: state.slideWidth,
    top: state.top,
    vertical: props.vertical,
    wrapAround: props.wrapAround,
    zoomScale: props.zoomScale
  };
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultButtonStyles = function defaultButtonStyles(disabled) {
  return {
    border: 0,
    background: 'rgba(0,0,0,0.4)',
    color: 'white',
    padding: 10,
    textTransform: 'uppercase',
    opacity: disabled && 0.3,
    cursor: disabled ? 'not-allowed' : 'pointer'
  };
};

var PreviousButton = function PreviousButton(props) {
  var handleClick = function handleClick(event) {
    event.preventDefault();
    props.previousSlide();
  };

  var _props$defaultControl = props.defaultControlsConfig,
      prevButtonClassName = _props$defaultControl.prevButtonClassName,
      _props$defaultControl2 = _props$defaultControl.prevButtonStyle,
      prevButtonStyle = _props$defaultControl2 === void 0 ? {} : _props$defaultControl2,
      prevButtonText = _props$defaultControl.prevButtonText;
  var disabled = props.currentSlide === 0 && !props.wrapAround || props.slideCount === 0;
  return /*#__PURE__*/React.createElement("button", {
    className: prevButtonClassName,
    style: _objectSpread$1(_objectSpread$1({}, defaultButtonStyles(disabled)), prevButtonStyle),
    disabled: disabled,
    onClick: handleClick,
    "aria-label": "previous",
    type: "button"
  }, prevButtonText || 'Prev');
};
var nextButtonDisabled = function nextButtonDisabled(_ref) {
  var cellAlign = _ref.cellAlign,
      cellSpacing = _ref.cellSpacing,
      currentSlide = _ref.currentSlide,
      frameWidth = _ref.frameWidth,
      positionValue = _ref.positionValue,
      slideCount = _ref.slideCount,
      slidesToShow = _ref.slidesToShow,
      slideWidth = _ref.slideWidth,
      wrapAround = _ref.wrapAround,
      scrollMode = _ref.scrollMode,
      slidesToScroll = _ref.slidesToScroll;
  var buttonDisabled = false;

  if (!wrapAround) {
    var alignmentOffset = getAlignmentOffset(currentSlide, {
      cellAlign: cellAlign,
      cellSpacing: cellSpacing,
      frameWidth: frameWidth,
      slideWidth: slideWidth
    });
    var relativePosition = positionValue - alignmentOffset;
    var width = slideWidth + cellSpacing;
    var endOffset = cellAlign === 'center' ? 2 * alignmentOffset : alignmentOffset;
    var endPosition = -width * slideCount + width * slidesToShow - endOffset;
    buttonDisabled = relativePosition < endPosition || Math.abs(relativePosition - endPosition) < 0.01;
  } // return true if its last slide or slideCount =0


  var lastSlide = currentSlide > 0 && currentSlide + slidesToScroll >= slideCount;

  if (lastSlide && !wrapAround && scrollMode === 'remainder' || slideCount === 0) {
    return buttonDisabled = true;
  }

  return buttonDisabled;
};
var NextButton = function NextButton(props) {
  var handleClick = function handleClick(event) {
    event.preventDefault();
    props.nextSlide();
  };

  var cellAlign = props.cellAlign,
      cellSpacing = props.cellSpacing,
      currentSlide = props.currentSlide,
      defaultControlsConfig = props.defaultControlsConfig,
      frameWidth = props.frameWidth,
      left = props.left,
      slideCount = props.slideCount,
      slidesToShow = props.slidesToShow,
      slideWidth = props.slideWidth,
      top = props.top,
      vertical = props.vertical,
      wrapAround = props.wrapAround,
      scrollMode = props.scrollMode,
      slidesToScroll = props.slidesToScroll;
  var nextButtonClassName = defaultControlsConfig.nextButtonClassName,
      _defaultControlsConfi = defaultControlsConfig.nextButtonStyle,
      nextButtonStyle = _defaultControlsConfi === void 0 ? {} : _defaultControlsConfi,
      nextButtonText = defaultControlsConfig.nextButtonText;
  var disabled = nextButtonDisabled({
    cellAlign: cellAlign,
    cellSpacing: cellSpacing,
    currentSlide: currentSlide,
    frameWidth: frameWidth,
    positionValue: vertical ? top : left,
    slideCount: slideCount,
    slidesToShow: slidesToShow,
    slideWidth: slideWidth,
    wrapAround: wrapAround,
    scrollMode: scrollMode,
    slidesToScroll: slidesToScroll
  });
  return /*#__PURE__*/React.createElement("button", {
    className: nextButtonClassName,
    style: _objectSpread$1(_objectSpread$1({}, defaultButtonStyles(disabled)), nextButtonStyle),
    disabled: disabled,
    onClick: handleClick,
    "aria-label": "next",
    type: "button"
  }, nextButtonText || 'Next');
};
var getDotIndexes = function getDotIndexes(slideCount, slidesToScroll, slidesToShow, cellAlign) {
  var dotIndexes = [];
  var lastDotIndex = slideCount - slidesToShow;
  var slidesToShowIsDecimal = slidesToShow % 1 !== 0;

  switch (cellAlign) {
    case 'center':
    case 'right':
      lastDotIndex += slidesToShow - 1;
      break;
  } // the below condition includes the last index if slidesToShow is decimal


  if (cellAlign === 'left' && slidesToShowIsDecimal) {
    lastDotIndex += slidesToShow - 1;
  }

  if (lastDotIndex < 0) {
    return [0];
  }

  var scrollSlides = slidesToScroll === 0 ? 1 : slidesToScroll;

  for (var i = 0; i < lastDotIndex; i += scrollSlides) {
    dotIndexes.push(i);
  } // the below condition includes the last index if slidesToShow is not decimal and cellAlign = left


  if (cellAlign === 'left' && !slidesToShowIsDecimal) {
    lastDotIndex = slideCount - (slideCount % slidesToShow || slidesToShow);
  }

  if (!dotIndexes.includes(lastDotIndex)) {
    dotIndexes.push(lastDotIndex);
  }

  return dotIndexes;
};
var PagingDots = function PagingDots(props) {
  var getListStyles = function getListStyles() {
    return {
      position: 'relative',
      top: -10,
      display: 'flex',
      margin: 0,
      padding: 0,
      listStyleType: 'none'
    };
  };

  var getButtonStyles = function getButtonStyles(active) {
    return {
      cursor: 'pointer',
      opacity: active ? 1 : 0.5,
      background: 'transparent',
      border: 'none',
      fill: 'black'
    };
  };

  var indexes = getDotIndexes(props.slideCount, props.slidesToScroll, props.slidesToShow, props.cellAlign);
  var _props$defaultControl3 = props.defaultControlsConfig,
      pagingDotsContainerClassName = _props$defaultControl3.pagingDotsContainerClassName,
      pagingDotsClassName = _props$defaultControl3.pagingDotsClassName,
      _props$defaultControl4 = _props$defaultControl3.pagingDotsStyle,
      pagingDotsStyle = _props$defaultControl4 === void 0 ? {} : _props$defaultControl4;
  return /*#__PURE__*/React.createElement("ul", {
    className: pagingDotsContainerClassName,
    style: getListStyles()
  }, indexes.map(function (index, i) {
    var isActive = props.currentSlide === index; // the below condition checks and sets navigation dots active if the current slide falls in the current index range

    if (props.currentSlide < index && props.currentSlide > indexes[i - 1]) {
      isActive = true;
    }

    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: isActive ? 'paging-item active' : 'paging-item'
    }, /*#__PURE__*/React.createElement("button", {
      className: pagingDotsClassName,
      type: "button",
      style: _objectSpread$1(_objectSpread$1({}, getButtonStyles(isActive)), pagingDotsStyle),
      onClick: props.goToSlide.bind(null, index),
      "aria-label": "slide ".concat(index + 1, " bullet"),
      "aria-selected": isActive
    }, /*#__PURE__*/React.createElement("svg", {
      className: "paging-dot",
      width: "6",
      height: "6",
      "aria-hidden": "true",
      focusable: "false"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "3",
      cy: "3",
      r: "3"
    }))));
  }));
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var addEvent = function addEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }

  if (elem.addEventListener) {
    elem.addEventListener(type, eventHandle, false);
  } else if (elem.attachEvent) {
    elem.attachEvent("on".concat(type), eventHandle);
  } else {
    elem["on".concat(type)] = eventHandle;
  }
};
var removeEvent = function removeEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }

  if (elem.removeEventListener) {
    elem.removeEventListener(type, eventHandle, false);
  } else if (elem.detachEvent) {
    elem.detachEvent("on".concat(type), eventHandle);
  } else {
    elem["on".concat(type)] = null;
  }
};
var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
  var needsTabIndex;

  if (slidesToShow > 1) {
    return React.Children.map(children, function (child, index) {
      var firstVisibleSlide = index >= currentSlide;
      var lastVisibleSlide = index < slidesToShow + currentSlide;
      needsTabIndex = firstVisibleSlide && lastVisibleSlide;
      var ariaProps = needsTabIndex ? {
        'aria-hidden': 'false',
        tabIndex: 0
      } : {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.cloneElement(child, _objectSpread$2(_objectSpread$2({}, ariaProps), child.props));
    });
  } else {
    return React.Children.map(children, function (child, index) {
      needsTabIndex = index !== currentSlide;
      var ariaProps = needsTabIndex ? {
        'aria-hidden': 'true'
      } : {
        'aria-hidden': 'false',
        tabIndex: 0
      };
      return /*#__PURE__*/React.cloneElement(child, _objectSpread$2(_objectSpread$2({}, ariaProps), child.props));
    });
  }
};
var getSlideClassName = function getSlideClassName(index, currentSlide, slidesToShow) {
  var className = '';
  var visible = index >= currentSlide && index < currentSlide + slidesToShow;
  var current = index === currentSlide;

  if (visible) {
    className = ' slide-visible';

    if (current) {
      className = className.concat(' slide-current');
    }
  }

  return className;
};
var getPropsByTransitionMode = function getPropsByTransitionMode(props, keys) {
  var slidesToShow = props.slidesToShow,
      transitionMode = props.transitionMode;
  var updatedDefaults = {};

  if (transitionMode === 'fade') {
    keys.forEach(function (key) {
      switch (key) {
        case 'slidesToShow':
          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
          break;

        case 'slidesToScroll':
          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
          break;

        case 'cellAlign':
          updatedDefaults[key] = 'left';
          break;

        default:
          updatedDefaults[key] = props[key];
          break;
      }
    });
  } else {
    keys.forEach(function (key) {
      updatedDefaults[key] = props[key];
    });
  }

  return updatedDefaults;
};
var swipeDirection = function swipeDirection(x1, x2, y1, y2, vertical) {
  var xDist = x1 - x2;
  var yDist = y1 - y2;
  var r = Math.atan2(yDist, xDist);
  var swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0) {
    return 1;
  }

  if (swipeAngle <= 360 && swipeAngle >= 315) {
    return 1;
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return -1;
  }

  if (vertical === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return 1;
    } else {
      return -1;
    }
  }

  return 0;
};
var getSlideDirection = function getSlideDirection(start, end, isWrapping) {
  var direction = 0;
  if (start === end) return direction;

  if (isWrapping) {
    direction = start < end ? -1 : 1;
  } else {
    direction = start < end ? 1 : -1;
  }

  return direction;
};
var shouldUpdate = function shouldUpdate(curr, next, keys) {
  var update = false;

  for (var i = 0; i < keys.length; i++) {
    if (curr[keys[i]] !== next[keys[i]]) {
      update = true;
      break;
    }
  }

  return update;
};
var calcSomeInitialState = function calcSomeInitialState(props) {
  var _getPropsByTransition = getPropsByTransitionMode(props, ['slidesToScroll', 'slidesToShow', 'cellAlign']),
      slidesToScroll = _getPropsByTransition.slidesToScroll,
      slidesToShow = _getPropsByTransition.slidesToShow,
      cellAlign = _getPropsByTransition.cellAlign;

  var slideWidth = props.vertical ? props.initialSlideHeight || 0 : props.initialSlideWidth || 0;
  var slideHeight = props.vertical ? (props.initialSlideHeight || 0) * props.slidesToShow : props.initialSlideHeight || 0;
  var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
  var frameWidth = props.vertical ? frameHeight : null;
  return {
    slideWidth: slideWidth,
    slideHeight: slideHeight,
    frameWidth: frameWidth,
    slidesToScroll: slidesToScroll,
    slidesToShow: slidesToShow,
    cellAlign: cellAlign
  };
};
var handleSelfFocus = function handleSelfFocus(e) {
  if (e && e.currentTarget) {
    e.currentTarget.focus();
  }
};
var isFullyVisible = function isFullyVisible(slideIndex, config) {
  var currentSlide = config.currentSlide,
      cellSpacing = config.cellSpacing,
      slideCount = config.slideCount,
      slideWidth = config.slideWidth,
      frameWidth = config.frameWidth,
      wrapAround = config.wrapAround,
      cellAlign = config.cellAlign; // Slide width can't be 0

  var fullSlideWidth = slideWidth || 1; // Calculate offset without cellSpacing

  var offsetWidth = getAlignmentOffset(currentSlide, config) + cellSpacing * currentSlide;
  var remainingWidth = frameWidth - offsetWidth;
  var fullSlidesBefore = 0;

  if (cellAlign !== 'left') {
    fullSlidesBefore = Math.max(Math.floor(offsetWidth / fullSlideWidth) + 1, 0);
  } else {
    fullSlidesBefore = Math.max(Math.floor(offsetWidth / fullSlideWidth), 0);
  }

  var fullSlidesAfter = Math.max(Math.floor(remainingWidth / fullSlideWidth), 0); // when slidesToScroll is auto enable clicking of all fully visible slides

  if (fullSlidesAfter + fullSlidesBefore + currentSlide >= slideCount && !wrapAround) {
    var fullSlidesAuto = fullSlidesBefore + fullSlidesAfter;
    fullSlidesAfter = fullSlidesAuto;
    fullSlidesBefore = fullSlidesAuto;
  }

  var currentSlideIndex = Math.ceil(currentSlide);
  var fullyVisibleSlides = [];

  for (var i = currentSlideIndex - fullSlidesBefore; i < currentSlideIndex + fullSlidesAfter + 1; i++) {
    if (i < 0) {
      // -1 won't match a slide index
      fullyVisibleSlides.push(wrapAround ? slideCount + i : -1);
    } else {
      fullyVisibleSlides.push(i > slideCount - 1 ? i - slideCount : i);
    }
  }

  return fullyVisibleSlides.includes(slideIndex);
};

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var MIN_ZOOM_SCALE = 0;
var MAX_ZOOM_SCALE = 1;

var ScrollTransition = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollTransition, _React$Component);

  var _super = _createSuper(ScrollTransition);

  function ScrollTransition(props) {
    var _this;

    _classCallCheck$3(this, ScrollTransition);

    _this = _super.call(this, props);
    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
    return _this;
  }
  /* eslint-disable complexity */


  _createClass$2(ScrollTransition, [{
    key: "getSlideTargetPosition",
    value: function getSlideTargetPosition(currentSlideIndex, positionValue, childrenLength, slidesToShow) {
      var offset = 0; // Below lines help to display peeking slides when number of slides is less than 3.

      var peekSlide = true;

      switch (this.props.cellAlign) {
        case 'left':
          peekSlide = this.props.children.length <= 2 && currentSlideIndex !== 0 ? false : true;
          break;

        case 'center':
          peekSlide = this.props.children.length > 2 || this.props.currentSlide !== currentSlideIndex - 1 ? true : false;
          break;
      }

      if (this.props.animation === 'zoom' && peekSlide && (this.props.currentSlide === currentSlideIndex + 1 || this.props.currentSlide === 0 && currentSlideIndex === this.props.children.length - 1)) {
        offset = this.props.slideOffset;
      } else if (this.props.animation === 'zoom' && (this.props.currentSlide === currentSlideIndex - 1 || this.props.currentSlide === this.props.children.length - 1 && currentSlideIndex === 0)) {
        offset = -this.props.slideOffset;
      }

      var targetPosition = (this.props.slideWidth + this.props.cellSpacing) * currentSlideIndex;
      var alignmentOffset = getAlignmentOffset(currentSlideIndex, this.props);
      var relativePosition = positionValue - alignmentOffset;
      var startSlideIndex = Math.min(Math.abs(Math.floor(relativePosition / this.props.slideWidth)), this.props.slideCount - 1);

      if (this.props.wrapAround && currentSlideIndex !== startSlideIndex) {
        var slidesOutOfView = Math.max(this.props.slideCount - Math.ceil(this.props.frameWidth / this.props.slideWidth), // Total slides in view
        0);
        var slidesOutOfViewBefore = Math.floor(slidesOutOfView / 2);
        var slidesOutOfViewAfter = slidesOutOfView - slidesOutOfViewBefore;
        var direction = getSlideDirection(startSlideIndex, this.props.currentSlide, this.props.isWrappingAround);

        if (direction < 0) {
          var temp = slidesOutOfViewBefore;
          slidesOutOfViewBefore = slidesOutOfViewAfter;
          slidesOutOfViewAfter = temp;
        }

        var slidesInViewBefore = Math.ceil(alignmentOffset / this.props.slideWidth);
        var slidesBefore = slidesInViewBefore + slidesOutOfViewBefore;
        var slidesInViewAfter = Math.ceil((this.props.frameWidth - alignmentOffset) / this.props.slideWidth) - 1;
        var slidesAfter = slidesInViewAfter + slidesOutOfViewAfter;
        var distanceFromStart = Math.abs(startSlideIndex - currentSlideIndex);
        var isDistanceBiggerThanSlides = childrenLength === slidesToShow ? distanceFromStart > slidesAfter : distanceFromStart >= slidesAfter;

        if (currentSlideIndex < startSlideIndex) {
          if (distanceFromStart > slidesBefore) {
            targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount + currentSlideIndex);
          }
        } else if (isDistanceBiggerThanSlides) {
          targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount - currentSlideIndex) * -1;
        }
      }

      return targetPosition + offset || 0;
    }
    /* eslint-enable complexity */

  }, {
    key: "formatChildren",
    value: function formatChildren(children) {
      var _this2 = this;

      var _this$props = this.props,
          top = _this$props.top,
          left = _this$props.left,
          currentSlide = _this$props.currentSlide,
          slidesToShow = _this$props.slidesToShow,
          vertical = _this$props.vertical;
      var positionValue = vertical ? top : left;
      var childrenLength = React.Children.count(children);
      return React.Children.map(children, function (child, index) {
        var isVisible = isFullyVisible(index, _this2.props);
        var inert = isVisible ? {} : {
          inert: 'true'
        };
        return /*#__PURE__*/React.createElement("div", _extends({
          className: "slider-slide".concat(getSlideClassName(index, currentSlide, slidesToShow)),
          "aria-label": "slide ".concat(index + 1, " of ").concat(children.length),
          role: "group",
          style: _this2.getSlideStyles(index, positionValue, childrenLength, slidesToShow),
          key: index,
          onClick: handleSelfFocus,
          tabIndex: -1
        }, inert), child);
      });
    }
  }, {
    key: "getSlideStyles",
    value: function getSlideStyles(index, positionValue, childrenLength, slidesToShow) {
      var targetPosition = this.getSlideTargetPosition(index, positionValue, childrenLength, slidesToShow);
      var transformScale = this.props.animation === 'zoom' && this.props.currentSlide !== index ? Math.max(Math.min(this.props.zoomScale, MAX_ZOOM_SCALE), MIN_ZOOM_SCALE) : 1.0;
      return {
        boxSizing: 'border-box',
        display: this.props.vertical ? 'block' : 'inline-block',
        height: getSlideHeight(this.props),
        left: this.props.vertical ? 0 : targetPosition,
        listStyleType: 'none',
        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
        MozBoxSizing: 'border-box',
        position: 'absolute',
        top: this.props.vertical ? targetPosition : 0,
        transform: "scale(".concat(transformScale, ")"),
        transition: 'transform .4s linear',
        verticalAlign: 'top',
        width: this.props.vertical ? '100%' : this.props.slideWidth
      };
    }
  }, {
    key: "getListStyles",
    value: function getListStyles(styles) {
      var deltaX = styles.deltaX,
          deltaY = styles.deltaY;
      var listWidth = this.props.slideWidth * React.Children.count(this.props.children);
      var spacingOffset = this.props.cellSpacing * React.Children.count(this.props.children);
      var transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0)");
      var transition = this.props.heightMode === 'current' && this.props.hasInteraction ? 'height 0.2s ease-out' : '0s';
      return {
        boxSizing: 'border-box',
        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
        display: 'block',
        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
        padding: 0,
        position: 'relative',
        MozBoxSizing: 'border-box',
        msTransform: "translate(".concat(deltaX, "px, ").concat(deltaY, "px)"),
        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y'),
        transform: transform,
        WebkitTransform: transform,
        width: 'auto',
        transition: transition
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.formatChildren(this.props.children);
      var deltaX = this.props.deltaX;
      var deltaY = this.props.deltaY;
      return /*#__PURE__*/React.createElement("div", {
        className: "slider-list",
        style: this.getListStyles({
          deltaX: deltaX,
          deltaY: deltaY
        })
      }, children);
    }
  }]);

  return ScrollTransition;
}(React.Component);
ScrollTransition.propTypes = {
  animation: PropTypes.oneOf(['zoom']),
  cellAlign: PropTypes.string,
  cellSpacing: PropTypes.number,
  currentSlide: PropTypes.number,
  deltaX: PropTypes.number,
  deltaY: PropTypes.number,
  dragging: PropTypes.bool,
  frameWidth: PropTypes.number,
  hasInteraction: PropTypes.bool,
  heightMode: PropTypes.oneOf(['first', 'current', 'max']),
  isWrappingAround: PropTypes.bool,
  left: PropTypes.number,
  slideCount: PropTypes.number,
  slideHeight: PropTypes.number,
  slideOffset: PropTypes.number,
  slidesToScroll: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  slideWidth: PropTypes.number,
  top: PropTypes.number,
  vertical: PropTypes.bool,
  wrapAround: PropTypes.bool,
  zoomScale: PropTypes.number
};
ScrollTransition.defaultProps = {
  cellAlign: 'left',
  cellSpacing: 0,
  currentSlide: 0,
  deltaX: 0,
  deltaY: 0,
  dragging: false,
  frameWidth: 0,
  heightMode: 'max',
  isWrappingAround: false,
  left: 0,
  slideCount: 0,
  slideHeight: 0,
  slidesToScroll: 1,
  slideWidth: 0,
  top: 0,
  vertical: false,
  wrapAround: false,
  zoomScale: 0.85
};

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$1(subClass, superClass); }

function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$1(self); }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }

var FadeTransition = /*#__PURE__*/function (_React$Component) {
  _inherits$1(FadeTransition, _React$Component);

  var _super = _createSuper$1(FadeTransition);

  function FadeTransition(props) {
    var _this;

    _classCallCheck$4(this, FadeTransition);

    _this = _super.call(this, props);
    _this.fadeFromSlide = props.currentSlide;
    return _this;
  }

  _createClass$3(FadeTransition, [{
    key: "formatChildren",
    value: function formatChildren(children, opacity) {
      var _this2 = this;

      var _this$props = this.props,
          currentSlide = _this$props.currentSlide,
          slidesToShow = _this$props.slidesToShow;
      return React.Children.map(children, function (child, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "slider-slide".concat(getSlideClassName(index, currentSlide, slidesToShow)),
          style: _this2.getSlideStyles(index, opacity),
          key: index,
          "aria-label": "slide ".concat(index + 1, " of ").concat(children.length),
          role: "group",
          onClick: handleSelfFocus,
          tabIndex: -1
        }, child);
      });
    }
  }, {
    key: "getSlideOpacityAndLeftMap",
    value: function getSlideOpacityAndLeftMap(fadeFrom, fadeTo, fade) {
      // Figure out which position to fade to
      var fadeToPosition = fadeTo;

      if (fadeFrom > fade && fadeFrom === 0) {
        fadeToPosition = fadeFrom - this.props.slidesToShow;
      } else if (fadeFrom < fade && fadeFrom + this.props.slidesToShow > this.props.slideCount - 1) {
        fadeToPosition = fadeFrom + this.props.slidesToShow;
      } // Calculate opacity for active slides


      var opacity = {};

      if (fadeFrom === fadeTo) {
        opacity[fadeFrom] = 1;
      } else {
        var distance = fadeFrom - fadeToPosition;
        opacity[fadeFrom] = (fade - fadeToPosition) / distance;
        opacity[fadeTo] = (fadeFrom - fade) / distance;
      } // Calculate left for slides and merge in opacity


      var map = {};

      for (var i = 0; i < this.props.slidesToShow; i++) {
        map[fadeFrom + i] = {
          opacity: opacity[fadeFrom],
          left: this.props.slideWidth * i
        };
        map[fadeTo + i] = {
          opacity: opacity[fadeTo],
          left: this.props.slideWidth * i
        };
      }

      return map;
    }
  }, {
    key: "getSlideStyles",
    value: function getSlideStyles(index, data) {
      return {
        boxSizing: 'border-box',
        display: 'block',
        height: getSlideHeight(this.props),
        left: data[index] ? data[index].left : 0,
        listStyleType: 'none',
        marginBottom: 'auto',
        marginLeft: this.props.cellSpacing / 2,
        marginRight: this.props.cellSpacing / 2,
        marginTop: 'auto',
        MozBoxSizing: 'border-box',
        opacity: data[index] ? data[index].opacity : 0,
        position: 'absolute',
        top: 0,
        verticalAlign: 'top',
        visibility: data[index] ? 'inherit' : 'hidden',
        width: this.props.slideWidth
      };
    }
  }, {
    key: "getContainerStyles",
    value: function getContainerStyles() {
      var width = this.props.slideWidth * this.props.slidesToShow;
      return {
        boxSizing: 'border-box',
        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
        display: 'block',
        height: this.props.slideHeight,
        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
        MozBoxSizing: 'border-box',
        padding: 0,
        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y'),
        width: width
      };
    }
  }, {
    key: "render",
    value: function render() {
      var fade = -(this.props.deltaX || this.props.deltaY) / this.props.slideWidth % this.props.slideCount;

      if (parseInt(fade) === fade) {
        this.fadeFromSlide = fade;
      }

      var opacityAndLeftMap = this.getSlideOpacityAndLeftMap(this.fadeFromSlide, this.props.currentSlide, fade);
      var children = this.formatChildren(this.props.children, opacityAndLeftMap);
      return /*#__PURE__*/React.createElement("div", {
        className: "slider-list",
        style: this.getContainerStyles()
      }, children);
    }
  }]);

  return FadeTransition;
}(React.Component);
FadeTransition.propTypes = {
  cellSpacing: PropTypes.number,
  currentSlide: PropTypes.number,
  deltaX: PropTypes.number,
  deltaY: PropTypes.number,
  dragging: PropTypes.bool,
  heightMode: PropTypes.oneOf(['first', 'current', 'max']),
  isWrappingAround: PropTypes.bool,
  left: PropTypes.number,
  slideCount: PropTypes.number,
  slideHeight: PropTypes.number,
  slidesToShow: PropTypes.number,
  slideWidth: PropTypes.number,
  top: PropTypes.number,
  vertical: PropTypes.bool,
  wrapAround: PropTypes.bool
};
FadeTransition.defaultProps = {
  cellSpacing: 0,
  currentSlide: 0,
  deltaX: 0,
  deltaY: 0,
  dragging: false,
  heightMode: 'max',
  isWrappingAround: false,
  left: 0,
  slideCount: 0,
  slideHeight: 0,
  slidesToShow: 1,
  slideWidth: 0,
  top: 0,
  vertical: false,
  wrapAround: false
};

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$2(subClass, superClass); }

function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$2(self); }

function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }
var MIN_ZOOM_SCALE$1 = 0;
var MAX_ZOOM_SCALE$1 = 1;

var ScrollTransition3D = /*#__PURE__*/function (_React$Component) {
  _inherits$2(ScrollTransition3D, _React$Component);

  var _super = _createSuper$2(ScrollTransition3D);

  function ScrollTransition3D(props) {
    var _this;

    _classCallCheck$5(this, ScrollTransition3D);

    _this = _super.call(this, props);
    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized$2(_this));
    return _this;
  }
  /* eslint-disable complexity */


  _createClass$4(ScrollTransition3D, [{
    key: "getSlideTargetPosition",
    value: function getSlideTargetPosition(index) {
      var targetPosition = 0;
      var offset = 0;

      if (index !== this.props.currentSlide) {
        var relativeDistanceToCurrentSlide = this.getRelativeDistanceToCurrentSlide(index);
        targetPosition = (this.props.slideWidth + this.props.cellSpacing) * relativeDistanceToCurrentSlide - this.getZoomOffsetFor(relativeDistanceToCurrentSlide);
        offset = 0;

        if (this.props.animation === 'zoom' && (this.props.currentSlide === index + 1 || this.props.currentSlide === 0 && index === this.props.children.length - 1)) {
          offset = this.props.slideOffset;
        } else if (this.props.animation === 'zoom' && (this.props.currentSlide === index - 1 || this.props.currentSlide === this.props.children.length - 1 && index === 0)) {
          offset = -this.props.slideOffset;
        }
      }

      return targetPosition + offset;
    }
    /* eslint-enable complexity */

  }, {
    key: "formatChildren",
    value: function formatChildren(children) {
      var _this2 = this;

      var _this$props = this.props,
          top = _this$props.top,
          left = _this$props.left,
          currentSlide = _this$props.currentSlide,
          slidesToShow = _this$props.slidesToShow,
          vertical = _this$props.vertical;
      var positionValue = vertical ? top : left;
      return React.Children.map(children, function (child, index) {
        var visible = _this2.getDistanceToCurrentSlide(index) <= slidesToShow / 2;
        var current = currentSlide === index;
        return /*#__PURE__*/React.createElement("div", {
          className: "slider-slide".concat(visible ? ' slide-visible' : '').concat(current ? ' slide-current' : ''),
          style: _this2.getSlideStyles(index, positionValue),
          key: index,
          "aria-label": "slide ".concat(index + 1, " of ").concat(children.length),
          role: "group",
          onClick: handleSelfFocus,
          tabIndex: -1
        }, child);
      });
    }
  }, {
    key: "getZoomOffsetFor",
    value: function getZoomOffsetFor(relativeDistanceToCurrent) {
      if (relativeDistanceToCurrent === 0) {
        return 0;
      }

      var marginGeneratedByZoom = (1 - Math.pow(this.props.zoomScale, Math.abs(relativeDistanceToCurrent))) * this.props.slideWidth;
      var direction = relativeDistanceToCurrent < 0 ? -1 : 1;
      var result = marginGeneratedByZoom * direction + this.getZoomOffsetFor(relativeDistanceToCurrent < 0 ? relativeDistanceToCurrent + 1 : relativeDistanceToCurrent - 1);
      return result;
    }
  }, {
    key: "getDistance",
    value: function getDistance(index, referenceIndex) {
      return Math.abs(index - referenceIndex);
    }
  }, {
    key: "getDistanceToCurrentSlide",
    value: function getDistanceToCurrentSlide(index) {
      var _this$props2 = this.props,
          wrapAround = _this$props2.wrapAround,
          currentSlide = _this$props2.currentSlide,
          slideCount = _this$props2.slideCount;
      return wrapAround ? Math.min(Math.min(this.getDistance(index, 0) + this.getDistance(currentSlide, slideCount), this.getDistance(index, slideCount) + this.getDistance(currentSlide, 0)), this.getDistance(index, currentSlide)) : this.getDistance(index, currentSlide);
    }
  }, {
    key: "getRelativeDistanceToCurrentSlide",
    value: function getRelativeDistanceToCurrentSlide(index) {
      var _this$props3 = this.props,
          wrapAround = _this$props3.wrapAround,
          currentSlide = _this$props3.currentSlide,
          slideCount = _this$props3.slideCount;

      if (wrapAround) {
        var distanceByLeftEge = this.getDistance(index, 0) + this.getDistance(currentSlide, slideCount);
        var distanceByRightEdge = this.getDistance(index, slideCount) + this.getDistance(currentSlide, 0);
        var absoluteDirectDistance = this.getDistance(index, currentSlide);
        var minimumDistance = Math.min(Math.min(distanceByLeftEge, distanceByRightEdge), absoluteDirectDistance);

        switch (minimumDistance) {
          case absoluteDirectDistance:
            return index - currentSlide;

          case distanceByLeftEge:
            return distanceByLeftEge;

          case distanceByRightEdge:
            return -distanceByRightEdge;

          default:
            return 0;
        }
      } else {
        return index - currentSlide;
      }
    }
  }, {
    key: "getTransformScale",
    value: function getTransformScale(index) {
      return this.props.currentSlide !== index ? Math.max(Math.min(Math.pow(this.props.zoomScale, this.getDistanceToCurrentSlide(index)), MAX_ZOOM_SCALE$1), MIN_ZOOM_SCALE$1) : 1.0;
    }
  }, {
    key: "getOpacityScale",
    value: function getOpacityScale(index) {
      return this.props.currentSlide !== index ? Math.max(Math.min(Math.pow(this.props.opacityScale, this.getDistanceToCurrentSlide(index)), MAX_ZOOM_SCALE$1), MIN_ZOOM_SCALE$1) : 1.0;
    }
  }, {
    key: "getSlideStyles",
    value: function getSlideStyles(index, positionValue) {
      var _this$props4 = this.props,
          vertical = _this$props4.vertical,
          slideCount = _this$props4.slideCount,
          cellSpacing = _this$props4.cellSpacing,
          slideWidth = _this$props4.slideWidth;
      var targetPosition = this.getSlideTargetPosition(index, positionValue);
      var transformScale = this.getTransformScale(index);
      return {
        boxSizing: 'border-box',
        display: vertical ? 'block' : 'inline-block',
        height: getSlideHeight(this.props),
        left: vertical ? 0 : targetPosition,
        listStyleType: 'none',
        marginBottom: vertical ? cellSpacing / 2 : 'auto',
        marginLeft: vertical ? 'auto' : cellSpacing / 2,
        marginRight: vertical ? 'auto' : cellSpacing / 2,
        marginTop: vertical ? cellSpacing / 2 : 'auto',
        MozBoxSizing: 'border-box',
        opacity: this.getOpacityScale(index),
        position: 'absolute',
        top: vertical ? targetPosition : 0,
        transform: "scale(".concat(transformScale, ")"),
        transition: 'left 0.4s ease-out, transform 0.4s ease-out, opacity 0.4s ease-out',
        verticalAlign: 'top',
        width: vertical ? '100%' : slideWidth,
        zIndex: slideCount - this.getDistanceToCurrentSlide(index)
      };
    }
  }, {
    key: "getListStyles",
    value: function getListStyles() {
      var listWidth = this.props.slideWidth * React.Children.count(this.props.children);
      var spacingOffset = this.props.cellSpacing * React.Children.count(this.props.children);
      return {
        boxSizing: 'border-box',
        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
        left: "calc(50% - (".concat(this.props.slideWidth, "px / 2))"),
        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "".concat(this.props.slideListMargin, "px ").concat(this.props.cellSpacing / 2 * -1, "px"),
        MozBoxSizing: 'border-box',
        padding: 0,
        position: 'relative',
        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y'),
        width: this.props.vertical ? 'auto' : '100%'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.formatChildren(this.props.children);
      return /*#__PURE__*/React.createElement("div", {
        className: "slider-list",
        style: this.getListStyles()
      }, children);
    }
  }]);

  return ScrollTransition3D;
}(React.Component);
ScrollTransition3D.propTypes = {
  cellSpacing: PropTypes.number,
  currentSlide: PropTypes.number,
  dragging: PropTypes.bool,
  heightMode: PropTypes.oneOf(['first', 'current', 'max']),
  isWrappingAround: PropTypes.bool,
  left: PropTypes.number,
  opacityScale: PropTypes.number,
  slideCount: PropTypes.number,
  slideHeight: PropTypes.number,
  slideListMargin: PropTypes.number,
  slideOffset: PropTypes.number,
  slidesToShow: PropTypes.number,
  slideWidth: PropTypes.number,
  top: PropTypes.number,
  vertical: PropTypes.bool,
  wrapAround: PropTypes.bool,
  zoomScale: PropTypes.number
};
ScrollTransition3D.defaultProps = {
  cellSpacing: 0,
  currentSlide: 0,
  dragging: false,
  heightMode: 'max',
  isWrappingAround: false,
  left: 0,
  opacityScale: 0.65,
  slideCount: 0,
  slideHeight: 0,
  slideListMargin: 0,
  slidesToShow: 3,
  slideWidth: 0,
  top: 0,
  vertical: false,
  wrapAround: true,
  zoomScale: 0.75
};

var Transitions = {
  fade: FadeTransition,
  scroll: ScrollTransition,
  scroll3d: ScrollTransition3D
};

var AnnounceSlide = function AnnounceSlide(_ref) {
  var message = _ref.message;
  var styles = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    padding: 0,
    margin: '-1px',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0
  };
  return /*#__PURE__*/React.createElement("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    style: styles,
    tabIndex: -1
  }, message);
};

var defaultRenderAnnounceSlideMessage = function defaultRenderAnnounceSlideMessage(_ref2) {
  var currentSlide = _ref2.currentSlide,
      slideCount = _ref2.slideCount;
  return "Slide ".concat(currentSlide + 1, " of ").concat(slideCount);
};

var getValidChildren = function getValidChildren(children) {
  // .toArray automatically removes invalid React children
  return React.Children.toArray(children);
};

var getMax = function getMax(a, b) {
  return a > b ? a : b;
};

var getHeightOfSlide = function getHeightOfSlide(slide) {
  if (!slide) {
    return 0;
  }

  if (slide.children && slide.children.length > 0) {
    var totalHeight = 0;

    for (var i = 0; i < slide.children.length; ++i) {
      totalHeight += slide.children[i].offsetHeight;
    }

    return totalHeight;
  } else {
    return slide.offsetHeight;
  }
}; // end - is exclusive


var findMaxHeightSlideInRange = function findMaxHeightSlideInRange(slides, start, end) {
  var maxHeight = 0;

  if (slides.length === 0 || start < 0 || end < 0 || start > slides.length - 1 || end > slides.length) {
    return maxHeight;
  }

  if (start < end) {
    for (var i = start; i < end; i++) {
      maxHeight = getMax(getHeightOfSlide(slides[i]), maxHeight);
    }
  } else if (start > end) {
    // Finding max in a wrap around
    for (var _i = start; _i < slides.length; _i++) {
      maxHeight = getMax(getHeightOfSlide(slides[_i]), maxHeight);
    }

    for (var _i2 = 0; _i2 < end; _i2++) {
      maxHeight = getMax(getHeightOfSlide(slides[_i2]), maxHeight);
    }
  } else {
    // start === end
    maxHeight = getHeightOfSlide(slides[start]);
  }

  return maxHeight;
};

var ensureIndexInBounds = function ensureIndexInBounds(index, slideCount) {
  var newIndex = index;

  while (newIndex < 0) {
    newIndex += slideCount;
  }

  while (newIndex > slideCount) {
    newIndex -= slideCount;
  }

  return newIndex;
};

var findCurrentHeightSlide = function findCurrentHeightSlide(currentSlide, slidesToShow, alignment, wrapAround, slides) {
  if (slidesToShow > 1) {
    var startIndex = currentSlide;
    var lastIndex = Math.min(Math.ceil(slidesToShow) + currentSlide, slides.length);
    var offset = alignment === 'center' ? (slidesToShow - 1) / 2 : slidesToShow - 1;

    switch (alignment) {
      case 'center':
        startIndex = Math.floor(currentSlide - offset);
        lastIndex = Math.ceil(currentSlide + offset) + 1;
        break;

      case 'right':
        startIndex = Math.floor(currentSlide - offset);
        lastIndex = currentSlide + 1;
        break;

      case 'left':
        startIndex = currentSlide;
        lastIndex = Math.ceil(currentSlide + offset) + 1;
        break;
    } // inclusive


    startIndex = wrapAround ? ensureIndexInBounds(startIndex, slides.length) : Math.max(startIndex, 0); // exclusive

    lastIndex = wrapAround ? ensureIndexInBounds(lastIndex, slides.length) : Math.min(lastIndex, slides.length);
    return findMaxHeightSlideInRange(slides, startIndex, lastIndex);
  } else {
    return getHeightOfSlide(slides[currentSlide]);
  }
};
var calculateSlideHeight = function calculateSlideHeight(props, state) {
  var childNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var heightMode = props.heightMode,
      vertical = props.vertical,
      initialSlideHeight = props.initialSlideHeight,
      wrapAround = props.wrapAround;
  var slidesToShow = state.slidesToShow,
      currentSlide = state.currentSlide,
      cellAlign = state.cellAlign;
  var firstSlide = childNodes[0];

  if (firstSlide && heightMode === 'first') {
    return vertical ? getHeightOfSlide(firstSlide) * slidesToShow : getHeightOfSlide(firstSlide);
  }

  if (heightMode === 'max') {
    return findMaxHeightSlideInRange(childNodes, 0, childNodes.length);
  }

  if (heightMode === 'current') {
    return findCurrentHeightSlide(currentSlide, slidesToShow, cellAlign, wrapAround, childNodes);
  }

  return initialSlideHeight || 100;
};

function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$3(subClass, superClass); }

function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$3(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$3(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$3(this, result); }; }

function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$4(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$3(self); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits$3(Carousel, _React$Component);

  var _super = _createSuper$3(Carousel);

  function Carousel() {
    var _this;

    _classCallCheck$6(this, Carousel);

    _this = _super.apply(this, arguments);
    _this.displayName = 'Carousel';
    _this.clickDisabled = false;
    _this.latestTransitioningIndex = null;
    _this.timers = [];
    _this.touchObject = {};
    _this.controlsMap = [{
      funcName: 'renderTopLeftControls',
      key: 'TopLeft'
    }, {
      funcName: 'renderTopCenterControls',
      key: 'TopCenter'
    }, {
      funcName: 'renderTopRightControls',
      key: 'TopRight'
    }, {
      funcName: 'renderCenterLeftControls',
      key: 'CenterLeft'
    }, {
      funcName: 'renderCenterCenterControls',
      key: 'CenterCenter'
    }, {
      funcName: 'renderCenterRightControls',
      key: 'CenterRight'
    }, {
      funcName: 'renderBottomLeftControls',
      key: 'BottomLeft'
    }, {
      funcName: 'renderBottomCenterControls',
      key: 'BottomCenter'
    }, {
      funcName: 'renderBottomRightControls',
      key: 'BottomRight'
    }];
    _this.keyCodeConfig = {
      nextSlide: [39, 68, 38, 87],
      previousSlide: [37, 65, 40, 83],
      firstSlide: [81],
      lastSlide: [69],
      pause: [32]
    };
    _this.childNodesMutationObs = null;
    _this.state = _objectSpread$3({
      currentSlide: _this.props.slideIndex,
      dragging: false,
      easing: _this.props.disableAnimation ? '' : circleOut,
      hasInteraction: false,
      // to remove animation from the initial slide on the page load when non-default slideIndex is used
      isWrappingAround: false,
      left: 0,
      resetWrapAroundPosition: false,
      slideCount: getValidChildren(_this.props.children).length,
      top: 0,
      wrapToIndex: null,
      hasFocus: false
    }, calcSomeInitialState(_this.props));
    _this.autoplayIterator = _this.autoplayIterator.bind(_assertThisInitialized$3(_this));
    _this.calcSlideHeightAndWidth = _this.calcSlideHeightAndWidth.bind(_assertThisInitialized$3(_this));
    _this.getChildNodes = _this.getChildNodes.bind(_assertThisInitialized$3(_this));
    _this.getMouseEvents = _this.getMouseEvents.bind(_assertThisInitialized$3(_this));
    _this.getOffsetDeltas = _this.getOffsetDeltas.bind(_assertThisInitialized$3(_this));
    _this.getTargetLeft = _this.getTargetLeft.bind(_assertThisInitialized$3(_this));
    _this.getTouchEvents = _this.getTouchEvents.bind(_assertThisInitialized$3(_this));
    _this.blockEvent = _this.blockEvent.bind(_assertThisInitialized$3(_this));
    _this.goToSlide = _this.goToSlide.bind(_assertThisInitialized$3(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized$3(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized$3(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized$3(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized$3(_this));
    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized$3(_this));
    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized$3(_this));
    _this.handleSwipe = _this.handleSwipe.bind(_assertThisInitialized$3(_this));
    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized$3(_this));
    _this.onResize = _this.onResize.bind(_assertThisInitialized$3(_this));
    _this.onVisibilityChange = _this.onVisibilityChange.bind(_assertThisInitialized$3(_this));
    _this.previousSlide = _this.previousSlide.bind(_assertThisInitialized$3(_this));
    _this.renderControls = _this.renderControls.bind(_assertThisInitialized$3(_this));
    _this.resetAutoplay = _this.resetAutoplay.bind(_assertThisInitialized$3(_this));
    _this.setDimensions = _this.setDimensions.bind(_assertThisInitialized$3(_this));
    _this.setLeft = _this.setLeft.bind(_assertThisInitialized$3(_this));
    _this.setSlideHeightAndWidth = _this.setSlideHeightAndWidth.bind(_assertThisInitialized$3(_this));
    _this.startAutoplay = _this.startAutoplay.bind(_assertThisInitialized$3(_this));
    _this.stopAutoplay = _this.stopAutoplay.bind(_assertThisInitialized$3(_this));
    _this.establishChildNodesMutationObserver = _this.establishChildNodesMutationObserver.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$5(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
      this.mounted = true;
      this.setLeft();
      this.setDimensions();
      this.bindEvents();
      this.establishChildNodesMutationObserver();

      if (this.props.autoplay) {
        this.startAutoplay();
      }

      var keyCodeConfig = _extends$1({}, this.keyCodeConfig, this.props.keyCodeConfig);

      this.keyCodeMap = this.getKeyCodeMap(keyCodeConfig);
      this.getLockScrollEvents().lockTouchScroll();
      this.initializeCarouselHeight();
    } // eslint-disable-next-line complexity

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var slideChanged = prevState.currentSlide !== this.state.currentSlide;
      var heightModeChanged = prevProps.heightMode !== this.props.heightMode;
      var axisChanged = prevProps.vertical !== this.props.vertical;
      var childrenChanged = prevProps.children !== this.props.children;

      if (axisChanged) {
        this.onResize();
      } else if (slideChanged || heightModeChanged) {
        var image = this.getCurrentChildNodeImg();

        if (image) {
          image.addEventListener('load', this.setSlideHeightAndWidth);
          image.removeEventListener('load', this.setSlideHeightAndWidth);
        } else {
          this.setSlideHeightAndWidth();
        }
      }

      if (this.state.isWrappingAround) {
        this.isWrapped = true;
      }

      var prevSlideCount = getValidChildren(prevProps.children).length;
      var slideCount = getValidChildren(this.props.children).length;
      var slideCountChanged = prevSlideCount !== slideCount;

      if (slideCountChanged) {
        this.setState({
          slideCount: slideCount,
          currentSlide: this.props.slideIndex
        });
      }

      var _this$calcSlideHeight = this.calcSlideHeightAndWidth(),
          slideHeight = _this$calcSlideHeight.slideHeight;

      var heightMismatches = slideHeight !== prevState.slideHeight;

      if (this.mounted && heightMismatches) {
        this.setDimensions();
      } else {
        var updateDimensions = slideCountChanged || shouldUpdate(prevProps, this.props, ['cellSpacing', 'vertical', 'slideWidth', 'slideHeight', 'heightMode', 'slidesToScroll', 'slidesToShow', 'transitionMode', 'cellAlign']);

        if (updateDimensions) {
          this.setDimensions(this.props);
        }
      }

      if (childrenChanged) {
        this.initializeCarouselHeight();
      }

      if (slideCountChanged && slideCount <= this.state.currentSlide) {
        this.goToSlide(Math.max(slideCount - 1, 0), this.props);
      } else if (prevProps.slideIndex !== this.props.slideIndex && this.props.slideIndex !== this.state.currentSlide && !this.state.isWrappingAround) {
        this.goToSlide(this.props.slideIndex, this.props);
      }

      if (prevProps.autoplay !== this.props.autoplay) {
        if (this.props.autoplay) {
          this.startAutoplay();
        } else {
          this.stopAutoplay();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEvents();
      this.disconnectChildNodesMutationObserver();
      this.stopAutoplay(); // see https://github.com/facebook/react/issues/3417#issuecomment-121649937

      this.mounted = false;

      for (var i = 0; i < this.timers.length; i++) {
        clearTimeout(this.timers[i]);
      }

      this.getLockScrollEvents().unlockTouchScroll();
    }
  }, {
    key: "initializeCarouselHeight",
    value: function initializeCarouselHeight() {
      var _this2 = this;

      var initialDelay = 200;
      var timesChecked = 0;

      var initializeHeight = function initializeHeight(delay) {
        _this2.timers.push(setTimeout(function () {
          // If slideHeight is greater than zero and matches calculated slideHeight,
          // assume the app has been initialized.  If not,
          // keep trying to set dimensions until things work.
          var _this2$calcSlideHeigh = _this2.calcSlideHeightAndWidth(),
              slideHeight = _this2$calcSlideHeigh.slideHeight;

          if (_this2.state.slideHeight > 0 && _this2.state.slideHeight === slideHeight) {
            return;
          }

          _this2.setDimensions();

          ++timesChecked; // Increase delay per attempt so the checks
          // slowly decrease if content is taking forever to load.
          //
          // If we've checked more than 10 times, it's probably never going
          // to load, so we stop checking. Otherwise, the page will freeze
          // after a long period:
          // See https://github.com/FormidableLabs/nuka-carousel/issues/798

          if (timesChecked < 10) {
            // Add exponential backoff to check more slowly
            initializeHeight(delay * 1.5);
          }
        }, delay));
      };

      initializeHeight(initialDelay);
    }
  }, {
    key: "establishChildNodesMutationObserver",
    value: function establishChildNodesMutationObserver() {
      var _this3 = this;

      var childNodes = this.getChildNodes();

      if (childNodes.length && 'MutationObserver' in window) {
        this.childNodesMutationObs = new MutationObserver(function () {
          _this3.setSlideHeightAndWidth();
        });

        var observeChildNodeMutation = function observeChildNodeMutation(node) {
          _this3.childNodesMutationObs.observe(node, {
            attributeFilter: ['style'],
            attributeOldValue: false,
            attributes: true,
            characterData: false,
            characterDataOldValue: false,
            childList: false,
            subtree: false
          });
        };

        var childNodesArray = Array.from(childNodes);

        for (var _i = 0, _childNodesArray = childNodesArray; _i < _childNodesArray.length; _i++) {
          var childNode = _childNodesArray[_i];
          observeChildNodeMutation(childNode);
        }
      }
    }
  }, {
    key: "disconnectChildNodesMutationObserver",
    value: function disconnectChildNodesMutationObserver() {
      if (this.childNodesMutationObs instanceof MutationObserver) {
        this.childNodesMutationObs.disconnect();
      }
    }
  }, {
    key: "blockEvent",
    value: function blockEvent(e) {
      if (this.state.dragging) {
        var direction = swipeDirection(this.touchObject.startX, e.touches[0].pageX, this.touchObject.startY, e.touches[0].pageY, this.props.vertical);

        if (direction !== 0) {
          e.preventDefault();
        }
      }
    }
  }, {
    key: "getLockScrollEvents",
    value: function getLockScrollEvents() {
      var _this4 = this;

      var lockTouchScroll = function lockTouchScroll() {
        document.addEventListener('touchmove', _this4.blockEvent, {
          passive: false
        });
      };

      var unlockTouchScroll = function unlockTouchScroll() {
        document.removeEventListener('touchmove', _this4.blockEvent, {
          passive: false
        });
      };

      return {
        lockTouchScroll: lockTouchScroll,
        unlockTouchScroll: unlockTouchScroll
      };
    }
  }, {
    key: "getTouchEvents",
    value: function getTouchEvents() {
      var _this5 = this;

      if (this.props.swiping === false) {
        return {
          onTouchStart: this.handleMouseOver,
          onTouchEnd: this.handleMouseOut
        };
      }

      return {
        onTouchStart: function onTouchStart(e) {
          //detect pinch zoom
          if (e.touches.length === 2) {
            _this5.handleMouseOver();

            return;
          }

          _this5.touchObject = {
            startX: e.touches[0].pageX,
            startY: e.touches[0].pageY
          };

          _this5.handleMouseOver();

          _this5.setState({
            dragging: true
          });
        },
        onTouchMove: function onTouchMove(e) {
          if (e.touches.length === 2) {
            return;
          }

          var direction = swipeDirection(_this5.touchObject.startX, e.touches[0].pageX, _this5.touchObject.startY, e.touches[0].pageY, _this5.props.vertical);
          var length = _this5.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - _this5.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - _this5.touchObject.startX, 2)));

          if (length >= 10) {
            if (_this5.clickDisabled === false) _this5.props.onDragStart(e);
            _this5.clickDisabled = true;
          }

          _this5.touchObject = {
            startX: _this5.touchObject.startX,
            startY: _this5.touchObject.startY,
            endX: e.touches[0].pageX,
            endY: e.touches[0].pageY,
            length: length,
            direction: direction
          };

          _this5.setState({
            left: _this5.props.vertical ? 0 : _this5.getTargetLeft(_this5.touchObject.length * _this5.touchObject.direction),
            top: _this5.props.vertical ? _this5.getTargetLeft(_this5.touchObject.length * _this5.touchObject.direction) : 0
          });
        },
        onTouchEnd: function onTouchEnd(e) {
          if (e.touches.length === 2) {
            _this5.handleMouseOut();

            return;
          }

          _this5.handleSwipe(e);

          _this5.handleMouseOut();
        },
        onTouchCancel: function onTouchCancel(e) {
          _this5.handleSwipe(e);
        }
      };
    }
  }, {
    key: "getMouseEvents",
    value: function getMouseEvents() {
      var _this6 = this;

      if (this.props.dragging === false) {
        return {
          onMouseOver: this.handleMouseOver,
          onMouseOut: this.handleMouseOut
        };
      }

      return {
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        onMouseDown: function onMouseDown(e) {
          if (e.preventDefault) {
            e.preventDefault();
          }

          _this6.touchObject = {
            startX: e.clientX,
            startY: e.clientY
          };

          _this6.setState({
            dragging: true
          });
        },
        onMouseMove: function onMouseMove(e) {
          if (!_this6.state.dragging) {
            return;
          }

          var direction = swipeDirection(_this6.touchObject.startX, e.clientX, _this6.touchObject.startY, e.clientY, _this6.props.vertical);

          if (direction !== 0) {
            e.preventDefault();
          }

          var length = _this6.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - _this6.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - _this6.touchObject.startX, 2))); // prevents disabling click just because mouse moves a fraction of a pixel

          if (length >= 10) {
            if (_this6.clickDisabled === false) _this6.props.onDragStart(e);
            _this6.clickDisabled = true;
          }

          _this6.touchObject = {
            startX: _this6.touchObject.startX,
            startY: _this6.touchObject.startY,
            endX: e.clientX,
            endY: e.clientY,
            length: length,
            direction: direction
          };

          _this6.setState({
            left: _this6.props.vertical ? 0 : _this6.getTargetLeft(_this6.touchObject.length * _this6.touchObject.direction),
            top: _this6.props.vertical ? _this6.getTargetLeft(_this6.touchObject.length * _this6.touchObject.direction) : 0
          });
        },
        onMouseUp: function onMouseUp(e) {
          if (_this6.touchObject.length === 0 || _this6.touchObject.length === undefined) {
            _this6.setState({
              dragging: false
            });

            return;
          }

          _this6.handleSwipe(e);
        },
        onMouseLeave: function onMouseLeave(e) {
          if (!_this6.state.dragging) {
            return;
          }

          _this6.handleSwipe(e);
        }
      };
    }
  }, {
    key: "pauseAutoplay",
    value: function pauseAutoplay() {
      if (this.props.autoplay) {
        this.autoplayPaused = true;
        this.stopAutoplay();
      }
    }
  }, {
    key: "unpauseAutoplay",
    value: function unpauseAutoplay() {
      if (this.props.autoplay && this.autoplayPaused) {
        this.startAutoplay();
        this.autoplayPaused = null;
      }
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver() {
      if (this.props.pauseOnHover) {
        this.pauseAutoplay();
      }
    }
  }, {
    key: "handleMouseOut",
    value: function handleMouseOut() {
      if (this.autoplayPaused) {
        this.unpauseAutoplay();
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        hasFocus: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        hasFocus: false
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (this.clickDisabled === true) {
        if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (event.nativeEvent) {
          event.nativeEvent.stopPropagation();
        }
      }
    }
  }, {
    key: "handleSwipe",
    value: function handleSwipe() {
      var _this7 = this;

      var slidesToShow = this.state.slidesToShow;

      if (this.props.slidesToScroll === 'auto') {
        slidesToShow = this.state.slidesToScroll;
      }

      var touchLength = this.touchObject.length || 0; // touchLength must be longer than 1/5 the slideWidth / slidesToShow
      // for swiping to be initiated

      if (touchLength > this.state.slideWidth / slidesToShow / 5) {
        if (this.touchObject.direction === 1) {
          if (this.state.currentSlide + 1 >= this.state.slideCount && !this.props.wrapAround) {
            this.setState({
              easing: easing[this.props.edgeEasing]
            });
          } else {
            this.nextSlide();
          }
        } else if (this.touchObject.direction === -1) {
          if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
            this.setState({
              easing: easing[this.props.edgeEasing]
            });
          } else {
            this.previousSlide();
          }
        }
      } else if (touchLength > 0) {
        this.goToSlide(this.state.currentSlide);
      } // wait for `handleClick` event before resetting clickDisabled


      this.timers.push(setTimeout(function () {
        _this7.clickDisabled = false;
      }, 0));
      this.touchObject = {};
      this.setState({
        dragging: false
      });
    } // eslint-disable-next-line complexity

  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      if (this.state.hasFocus && this.props.enableKeyboardControls) {
        var actionName = this.keyCodeMap[e.keyCode];

        switch (actionName) {
          case 'nextSlide':
            this.nextSlide();
            break;

          case 'previousSlide':
            this.previousSlide();
            break;

          case 'firstSlide':
            this.goToSlide(0, this.props);
            break;

          case 'lastSlide':
            this.goToSlide(this.state.slideCount - 1, this.props);
            break;

          case 'pause':
            if (this.state.pauseOnHover && this.props.autoplay) {
              this.setState({
                pauseOnHover: false
              });
              this.pauseAutoplay();
              break;
            } else {
              this.setState({
                pauseOnHover: true
              });
              this.unpauseAutoplay();
              break;
            }

        }
      }
    }
  }, {
    key: "getKeyCodeMap",
    value: function getKeyCodeMap(keyCodeConfig) {
      var keyCodeMap = {};
      Object.keys(keyCodeConfig).forEach(function (actionName) {
        keyCodeConfig[actionName].forEach(function (keyCode) {
          return keyCodeMap[keyCode] = actionName;
        });
      });
      return keyCodeMap;
    }
  }, {
    key: "autoplayIterator",
    value: function autoplayIterator() {
      if (this.props.wrapAround) {
        if (this.props.autoplayReverse) {
          this.previousSlide();
        } else {
          this.nextSlide();
        }

        return;
      }

      if (this.props.autoplayReverse) {
        if (this.state.currentSlide !== 0) {
          this.previousSlide();
        } else {
          this.stopAutoplay();
        }
      } else if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
        this.nextSlide();
      } else {
        this.stopAutoplay();
      }
    }
  }, {
    key: "startAutoplay",
    value: function startAutoplay() {
      this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
    }
  }, {
    key: "resetAutoplay",
    value: function resetAutoplay() {
      if (this.props.autoplay && !this.autoplayPaused) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
  }, {
    key: "stopAutoplay",
    value: function stopAutoplay() {
      if (this.autoplayID) {
        clearInterval(this.autoplayID);
      }
    } // Animation Method

  }, {
    key: "getTargetLeft",
    value: function getTargetLeft(touchOffset, slide) {
      var target = slide || this.state.currentSlide;
      var offset = getAlignmentOffset(target, _objectSpread$3(_objectSpread$3({}, this.props), this.state));
      var left = this.state.slideWidth * target;
      var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;

      if (lastSlide && !this.props.wrapAround && this.props.scrollMode === 'remainder') {
        left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
        offset = 0;
        offset -= this.props.cellSpacing * (this.state.slideCount - 1);
      }

      if (!isNaN(touchOffset)) {
        offset -= touchOffset;
      } else {
        offset -= 0;
      }

      return (left - offset) * -1;
    }
  }, {
    key: "getOffsetDeltas",
    value: function getOffsetDeltas() {
      var offset = 0;

      if (this.state.isWrappingAround) {
        offset = this.getTargetLeft(null, this.state.wrapToIndex);
      } else {
        offset = this.getTargetLeft(this.touchObject.length * this.touchObject.direction);
      }

      return {
        tx: [this.props.vertical ? 0 : offset],
        ty: [this.props.vertical ? offset : 0]
      };
    }
  }, {
    key: "isEdgeSwiping",
    value: function isEdgeSwiping() {
      var _this$state = this.state,
          currentSlide = _this$state.currentSlide,
          slideCount = _this$state.slideCount,
          slideWidth = _this$state.slideWidth,
          slideHeight = _this$state.slideHeight,
          slidesToShow = _this$state.slidesToShow;

      var _this$getOffsetDeltas = this.getOffsetDeltas(),
          tx = _this$getOffsetDeltas.tx,
          ty = _this$getOffsetDeltas.ty;

      var offset = getAlignmentOffset(currentSlide, _objectSpread$3(_objectSpread$3({}, this.props), this.state));

      if (this.props.vertical) {
        var rowHeight = slideHeight / slidesToShow;
        var slidesLeftToShow = slideCount - slidesToShow;
        var lastSlideLimit = rowHeight * slidesLeftToShow;
        var offsetTy = ty[0] - offset; // returns true if ty offset is outside first or last slide

        return offsetTy > 0 || -offsetTy > lastSlideLimit;
      }

      var offsetTx = tx[0] - offset; // returns true if tx offset is outside first or last slide

      return offsetTx > 0 || -offsetTx > slideWidth * (slideCount - 1);
    } // Action Methods

  }, {
    key: "goToSlide",
    value: function goToSlide(index, props) {
      var _this8 = this;

      if (props === undefined) {
        props = this.props;
      }

      this.latestTransitioningIndex = index;
      this.setState({
        hasInteraction: true,
        easing: easing[props.easing]
      });
      var previousSlide = this.state.currentSlide;

      if (index >= this.state.slideCount || index < 0) {
        if (!props.wrapAround) {
          return;
        }

        if (index >= this.state.slideCount) {
          props.beforeSlide(this.state.currentSlide, 0);
          this.setState(function (prevState) {
            return {
              left: props.vertical ? 0 : _this8.getTargetLeft(_this8.state.slideWidth, prevState.currentSlide),
              top: props.vertical ? _this8.getTargetLeft(_this8.state.slideWidth, prevState.currentSlide) : 0,
              currentSlide: 0,
              isWrappingAround: true,
              wrapToIndex: _this8.state.slideCount
            };
          }, function () {
            _this8.timers.push(setTimeout(function () {
              if (index === _this8.latestTransitioningIndex) {
                _this8.resetAutoplay();

                if (index !== previousSlide) {
                  _this8.props.afterSlide(0);
                }
              }
            }, props.speed));
          });
          return;
        } else {
          var endSlide = index < 0 ? this.state.slideCount + index : this.state.slideCount - this.state.slidesToScroll;
          props.beforeSlide(this.state.currentSlide, endSlide);
          this.setState(function (prevState) {
            return {
              left: props.vertical ? 0 : _this8.getTargetLeft(0, prevState.currentSlide),
              top: props.vertical ? _this8.getTargetLeft(0, prevState.currentSlide) : 0,
              currentSlide: endSlide,
              isWrappingAround: true,
              wrapToIndex: index
            };
          }, function () {
            _this8.timers.push(setTimeout(function () {
              if (index === _this8.latestTransitioningIndex) {
                _this8.resetAutoplay();

                if (index !== previousSlide) {
                  _this8.props.afterSlide(_this8.state.slideCount - 1);
                }
              }
            }, props.speed));
          });
          return;
        }
      }

      this.props.beforeSlide(this.state.currentSlide, index);
      this.setState({
        currentSlide: index
      }, function () {
        _this8.timers.push(setTimeout(function () {
          if (index === _this8.latestTransitioningIndex) {
            _this8.resetAutoplay();

            if (index !== previousSlide) {
              _this8.props.afterSlide(index);
            }
          }
        }, props.speed));
      });
    }
  }, {
    key: "nextSlide",
    value: function nextSlide() {
      var _this$state2 = this.state,
          slidesToScroll = _this$state2.slidesToScroll,
          currentSlide = _this$state2.currentSlide,
          slideWidth = _this$state2.slideWidth,
          slideCount = _this$state2.slideCount;
      var targetSlideIndex = currentSlide + slidesToScroll;
      var slidesToShow = this.state.slidesToShow;

      if (this.props.slidesToScroll === 'auto') {
        var swipeDistance = this.touchObject.length;

        if (swipeDistance > 0) {
          targetSlideIndex = Math.round(swipeDistance / slideWidth) + currentSlide;
        } else {
          slidesToShow = slidesToScroll;
        }
      }

      if (currentSlide >= slideCount - slidesToShow && !this.props.wrapAround && this.props.cellAlign === 'left') {
        return;
      }

      if (this.props.wrapAround) {
        this.goToSlide(targetSlideIndex);
      } else {
        if (this.props.slideWidth !== 1) {
          this.goToSlide(targetSlideIndex);
          return;
        }

        var offset = targetSlideIndex;
        var leftAlignSlideIndex = this.props.scrollMode === 'page' ? offset : Math.min(offset, slideCount - Math.floor(slidesToShow));
        var nextSlideIndex = this.props.cellAlign !== 'left' ? offset : leftAlignSlideIndex; // If nextSlideIndex is larger than last index, then
        // just navigate to last index

        this.goToSlide(Math.min(nextSlideIndex, slideCount - 1));
      }
    }
  }, {
    key: "previousSlide",
    value: function previousSlide() {
      var _this$state3 = this.state,
          slidesToScroll = _this$state3.slidesToScroll,
          slideWidth = _this$state3.slideWidth,
          currentSlide = _this$state3.currentSlide;
      var targetSlideIndex = currentSlide - slidesToScroll;
      var swipeDistance = this.touchObject.length;

      if (this.props.slidesToScroll === 'auto' && swipeDistance > 0) {
        targetSlideIndex = currentSlide - Math.round(swipeDistance / slideWidth);
      }

      if (currentSlide <= 0 && !this.props.wrapAround) {
        return;
      }

      if (this.props.wrapAround) {
        this.goToSlide(targetSlideIndex);
      } else {
        this.goToSlide(Math.max(0, targetSlideIndex));
      }
    } // Bootstrapping

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      if (exenv.canUseDOM) {
        addEvent(window, 'resize', this.onResize);
        addEvent(document, 'visibilitychange', this.onVisibilityChange);
        addEvent(document, 'keydown', this.handleKeyPress);
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.setDimensions(null, this.props.onResize);
    }
  }, {
    key: "onVisibilityChange",
    value: function onVisibilityChange() {
      if (document.hidden) {
        this.pauseAutoplay();
      } else {
        this.unpauseAutoplay();
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      if (exenv.canUseDOM) {
        removeEvent(window, 'resize', this.onResize);
        removeEvent(document, 'visibilitychange', this.onVisibilityChange);
        removeEvent(document, 'keydown', this.handleKeyPress);
      }
    }
  }, {
    key: "calcSlideHeightAndWidth",
    value: function calcSlideHeightAndWidth(props) {
      // slide height
      props = props || this.props;
      var childNodes = this.getChildNodes();
      var slideHeight = calculateSlideHeight(props, this.state, childNodes); //slide width

      var _getPropsByTransition = getPropsByTransitionMode(props, ['slidesToShow']),
          slidesToShow = _getPropsByTransition.slidesToShow;

      var frame = this.frame;
      var slideWidth;

      if (this.props.animation === 'zoom') {
        slideWidth = frame.offsetWidth - frame.offsetWidth * 15 / 100;
      } else if (typeof props.slideWidth !== 'number') {
        slideWidth = parseInt(props.slideWidth);
      } else if (props.vertical) {
        slideWidth = slideHeight / slidesToShow * props.slideWidth;
      } else {
        slideWidth = frame.offsetWidth / slidesToShow * props.slideWidth;
      }

      if (!props.vertical) {
        slideWidth -= props.cellSpacing * ((100 - 100 / slidesToShow) / 100);
      }

      return {
        slideHeight: slideHeight,
        slideWidth: slideWidth
      };
    }
  }, {
    key: "setSlideHeightAndWidth",
    value: function setSlideHeightAndWidth() {
      var _this$calcSlideHeight2 = this.calcSlideHeightAndWidth(),
          slideHeight = _this$calcSlideHeight2.slideHeight,
          slideWidth = _this$calcSlideHeight2.slideWidth;

      if (slideHeight !== this.state.slideHeight || slideWidth !== this.state.slideWidth || this.isWrapped) {
        this.isWrapped = false;
        this.setState({
          slideHeight: slideHeight,
          slideWidth: slideWidth
        });
      }
    } // eslint-disable-next-line complexity

  }, {
    key: "setDimensions",
    value: function setDimensions(props) {
      var stateCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      props = props || this.props;

      var _getPropsByTransition2 = getPropsByTransitionMode(props, ['slidesToShow', 'cellAlign', 'scrollMode']),
          slidesToShow = _getPropsByTransition2.slidesToShow,
          cellAlign = _getPropsByTransition2.cellAlign,
          scrollMode = _getPropsByTransition2.scrollMode;

      var frame = this.frame;

      var _this$calcSlideHeight3 = this.calcSlideHeightAndWidth(props),
          slideHeight = _this$calcSlideHeight3.slideHeight,
          slideWidth = _this$calcSlideHeight3.slideWidth;

      var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
      var frameWidth = props.vertical ? frameHeight : frame.offsetWidth;

      var _getPropsByTransition3 = getPropsByTransitionMode(props, ['slidesToScroll']),
          slidesToScroll = _getPropsByTransition3.slidesToScroll;

      if (slidesToScroll === 'auto' || scrollMode === 'page') {
        slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
      }

      if ((props.slideWidth !== 1 || props.cellSpacing > 0) && scrollMode === 'page' && cellAlign === 'left') {
        slidesToShow = slidesToScroll;
      }

      this.setState({
        frameWidth: frameWidth,
        slideHeight: slideHeight,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        slideWidth: slideWidth,
        cellAlign: cellAlign
      }, function () {
        stateCb();
      });
    }
  }, {
    key: "getChildNodes",
    value: function getChildNodes() {
      return this.frame.childNodes[0].childNodes;
    }
  }, {
    key: "getCurrentChildNodeImg",
    value: function getCurrentChildNodeImg() {
      var childNodes = this.getChildNodes();
      var currentChildNode = childNodes[this.props.slideIndex];
      return currentChildNode ? currentChildNode.getElementsByTagName('img')[0] : null;
    }
  }, {
    key: "setLeft",
    value: function setLeft() {
      var newLeft = this.props.vertical ? 0 : this.getTargetLeft();
      var newTop = this.props.vertical ? this.getTargetLeft() : 0;

      if (newLeft !== this.state.left || newTop !== this.state.top) {
        this.setState({
          left: newLeft,
          top: newTop
        });
      }
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this9 = this;

      if (this.props.withoutControls) {
        return this.controlsMap.map(function () {
          return null;
        });
      } else {
        return this.controlsMap.map(function (_ref) {
          var funcName = _ref.funcName,
              key = _ref.key;
          var func = _this9.props[funcName];
          var controlChildren = func && typeof func === 'function' && func({
            cellAlign: _this9.props.cellAlign,
            cellSpacing: _this9.props.cellSpacing,
            currentSlide: _this9.state.currentSlide,
            defaultControlsConfig: _this9.props.defaultControlsConfig,
            frameWidth: _this9.state.frameWidth,
            goToSlide: function goToSlide(index) {
              return _this9.goToSlide(index);
            },
            left: _this9.state.left,
            nextSlide: function nextSlide() {
              return _this9.nextSlide();
            },
            previousSlide: function previousSlide() {
              return _this9.previousSlide();
            },
            scrollMode: _this9.props.scrollMode,
            slideCount: _this9.state.slideCount,
            slidesToScroll: _this9.state.slidesToScroll,
            slidesToShow: _this9.state.slidesToShow,
            slideWidth: _this9.state.slideWidth,
            top: _this9.state.top,
            vertical: _this9.props.vertical,
            wrapAround: _this9.props.wrapAround
          });
          return controlChildren && /*#__PURE__*/React.createElement("div", {
            key: key,
            className: ["slider-control-".concat(key.toLowerCase()), _this9.props.defaultControlsConfig.containerClassName || ''].join(' ').trim(),
            style: _objectSpread$3(_objectSpread$3({}, getDecoratorStyles(key)), _this9.props.getControlsContainerStyles(key))
          }, controlChildren);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      var _this$state4 = this.state,
          currentSlide = _this$state4.currentSlide,
          slideCount = _this$state4.slideCount,
          frameWidth = _this$state4.frameWidth,
          hasInteraction = _this$state4.hasInteraction;
      var _this$props = this.props,
          disableAnimation = _this$props.disableAnimation,
          frameOverflow = _this$props.frameOverflow,
          framePadding = _this$props.framePadding,
          renderAnnounceSlideMessage = _this$props.renderAnnounceSlideMessage,
          slidesToShow = _this$props.slidesToShow,
          vertical = _this$props.vertical;
      var duration = this.state.dragging || !this.state.dragging && this.state.resetWrapAroundPosition && this.props.wrapAround || disableAnimation || !hasInteraction ? 0 : this.props.speed;
      var frameStyles = getFrameStyles(frameOverflow, vertical, framePadding, frameWidth);
      var touchEvents = this.getTouchEvents();
      var mouseEvents = this.getMouseEvents();
      var TransitionControl = Transitions[this.props.transitionMode];
      var validChildren = getValidChildren(this.props.children);

      var _this$getOffsetDeltas2 = this.getOffsetDeltas(),
          _this$getOffsetDeltas3 = _slicedToArray(_this$getOffsetDeltas2.tx, 1),
          startTx = _this$getOffsetDeltas3[0],
          _this$getOffsetDeltas4 = _slicedToArray(_this$getOffsetDeltas2.ty, 1),
          startTy = _this$getOffsetDeltas4[0];

      return /*#__PURE__*/React.createElement("section", {
        className: ['slider', this.props.className || ''].join(' ').trim(),
        onFocus: this.handleFocus,
        "aria-label": "carousel-slider",
        role: "region",
        onBlur: this.handleBlur,
        ref: this.props.innerRef,
        tabIndex: 0,
        style: _extends$1({}, getSliderStyles(this.props.width, this.props.height), this.props.style)
      }, !this.props.autoplay && /*#__PURE__*/React.createElement(AnnounceSlide, {
        message: renderAnnounceSlideMessage({
          currentSlide: currentSlide,
          slideCount: slideCount
        })
      }), /*#__PURE__*/React.createElement("div", _extends$1({
        className: "slider-frame",
        ref: function ref(frame) {
          return _this10.frame = frame;
        },
        style: frameStyles
      }, touchEvents, mouseEvents, {
        onClickCapture: this.handleClick
      }), /*#__PURE__*/React.createElement(Animate, {
        show: true,
        start: {
          tx: startTx,
          ty: startTy
        },
        update: function update() {
          var _this10$getOffsetDelt = _this10.getOffsetDeltas(),
              tx = _this10$getOffsetDelt.tx,
              ty = _this10$getOffsetDelt.ty;

          if (_this10.props.disableEdgeSwiping && !_this10.props.wrapAround && _this10.isEdgeSwiping()) {
            return {};
          } else {
            return {
              tx: tx,
              ty: ty,
              timing: {
                duration: duration,
                ease: _this10.state.easing
              },
              events: {
                end: function end() {
                  var newLeft = _this10.props.vertical ? 0 : _this10.getTargetLeft();
                  var newTop = _this10.props.vertical ? _this10.getTargetLeft() : 0;

                  if (newLeft !== _this10.state.left || newTop !== _this10.state.top) {
                    _this10.setState({
                      left: newLeft,
                      top: newTop,
                      isWrappingAround: false,
                      resetWrapAroundPosition: true
                    }, function () {
                      _this10.setState({
                        resetWrapAroundPosition: false
                      });
                    });
                  }
                }
              }
            };
          }
        }
      }, function (_ref2) {
        var tx = _ref2.tx,
            ty = _ref2.ty;
        return /*#__PURE__*/React.createElement(TransitionControl, _extends$1({}, getTransitionProps(_this10.props, _this10.state), {
          deltaX: tx,
          deltaY: ty
        }), addAccessibility(validChildren, slidesToShow, currentSlide));
      })), this.renderControls(), this.props.autoGenerateStyleTag && /*#__PURE__*/React.createElement("style", {
        type: "text/css",
        dangerouslySetInnerHTML: {
          __html: getImgTagStyles()
        }
      }));
    }
  }]);

  return Carousel;
}(React.Component);
Carousel.propTypes = {
  afterSlide: PropTypes.func,
  animation: PropTypes.oneOf(['zoom']),
  autoGenerateStyleTag: PropTypes.bool,
  autoplay: PropTypes.bool,
  autoplayInterval: PropTypes.number,
  autoplayReverse: PropTypes.bool,
  beforeSlide: PropTypes.func,
  cellAlign: PropTypes.oneOf(['left', 'center', 'right']),
  cellSpacing: PropTypes.number,
  getControlsContainerStyles: PropTypes.func,
  defaultControlsConfig: PropTypes.shape({
    containerClassName: PropTypes.string,
    nextButtonClassName: PropTypes.string,
    nextButtonStyle: PropTypes.object,
    nextButtonText: PropTypes.string,
    prevButtonClassName: PropTypes.string,
    prevButtonStyle: PropTypes.object,
    prevButtonText: PropTypes.string,
    pagingDotsContainerClassName: PropTypes.string,
    pagingDotsClassName: PropTypes.string,
    pagingDotsStyle: PropTypes.object
  }),
  disableAnimation: PropTypes.bool,
  disableEdgeSwiping: PropTypes.bool,
  dragging: PropTypes.bool,
  easing: PropTypes.string,
  edgeEasing: PropTypes.string,
  enableKeyboardControls: PropTypes.bool,
  frameOverflow: PropTypes.string,
  framePadding: PropTypes.string,
  height: PropTypes.string,
  heightMode: PropTypes.oneOf(['first', 'current', 'max']),
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.elementType
  })]),
  initialSlideHeight: PropTypes.number,
  initialSlideWidth: PropTypes.number,
  keyCodeConfig: PropTypes.exact({
    previousSlide: PropTypes.arrayOf(PropTypes.number),
    nextSlide: PropTypes.arrayOf(PropTypes.number),
    firstSlide: PropTypes.arrayOf(PropTypes.number),
    lastSlide: PropTypes.arrayOf(PropTypes.number),
    pause: PropTypes.arrayOf(PropTypes.number)
  }),
  onDragStart: PropTypes.func,
  onResize: PropTypes.func,
  opacityScale: PropTypes.number,
  pauseOnHover: PropTypes.bool,
  renderAnnounceSlideMessage: PropTypes.func,
  renderBottomCenterControls: PropTypes.func,
  renderBottomLeftControls: PropTypes.func,
  renderBottomRightControls: PropTypes.func,
  renderCenterCenterControls: PropTypes.func,
  renderCenterLeftControls: PropTypes.func,
  renderCenterRightControls: PropTypes.func,
  renderTopCenterControls: PropTypes.func,
  renderTopLeftControls: PropTypes.func,
  renderTopRightControls: PropTypes.func,
  scrollMode: PropTypes.oneOf(['page', 'remainder']),
  slideIndex: PropTypes.number,
  slideListMargin: PropTypes.number,
  slideOffset: PropTypes.number,
  slidesToScroll: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]),
  slidesToShow: PropTypes.number,
  slideWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  speed: PropTypes.number,
  swiping: PropTypes.bool,
  transitionMode: PropTypes.oneOf(['scroll', 'fade', 'scroll3d']),
  vertical: PropTypes.bool,
  width: PropTypes.string,
  withoutControls: PropTypes.bool,
  wrapAround: PropTypes.bool
};
Carousel.defaultProps = {
  afterSlide: function afterSlide() {},
  autoGenerateStyleTag: true,
  autoplay: false,
  autoplayInterval: 3000,
  autoplayReverse: false,
  beforeSlide: function beforeSlide() {},
  cellAlign: 'left',
  cellSpacing: 0,
  getControlsContainerStyles: function getControlsContainerStyles() {},
  defaultControlsConfig: {},
  disableAnimation: false,
  disableEdgeSwiping: false,
  dragging: true,
  easing: 'easeCircleOut',
  edgeEasing: 'easeElasticOut',
  enableKeyboardControls: false,
  frameOverflow: 'hidden',
  framePadding: '0px',
  height: 'inherit',
  heightMode: 'max',
  keyCodeConfig: {},
  onDragStart: function onDragStart() {},
  onResize: function onResize() {},
  pauseOnHover: true,
  renderAnnounceSlideMessage: defaultRenderAnnounceSlideMessage,
  renderBottomCenterControls: function renderBottomCenterControls(props) {
    return /*#__PURE__*/React.createElement(PagingDots, props);
  },
  renderCenterLeftControls: function renderCenterLeftControls(props) {
    return /*#__PURE__*/React.createElement(PreviousButton, props);
  },
  renderCenterRightControls: function renderCenterRightControls(props) {
    return /*#__PURE__*/React.createElement(NextButton, props);
  },
  scrollMode: 'remainder',
  slideIndex: 0,
  slideListMargin: 10,
  slideOffset: 25,
  slidesToScroll: 1,
  slidesToShow: 1,
  slideWidth: 1,
  speed: 500,
  style: {},
  swiping: true,
  transitionMode: 'scroll',
  vertical: false,
  width: '100%',
  withoutControls: false,
  wrapAround: false
};

var useStyles$2 = makeStyles(function (theme) {
    var _a;
    return createStyles({
        sliderContainer: (_a = {
                position: 'relative',
                maxWidth: 'calc(100% - 24px)',
                margin: '0 auto'
            },
            _a[theme.breakpoints.up(678)] = {
                maxWidth: '1280px',
            },
            _a['&:focus, & :focus'] = {
                outline: 'none',
            },
            _a['&:focus-visible, & :focus-visible'] = {
                outline: function (props) { return "4px solid " + props.color; },
            },
            _a['& .slider-slide'] = {
                display: 'flex !important',
                alignItems: 'center',
                margin: '0 !important',
                cursor: 'unset !important',
            },
            _a['& .slider-frame'] = {
                width: '100% !important',
                display: 'flex !important',
                margin: '0 !important',
                cursor: 'unset !important',
            },
            _a['& .slider-list'] = {
                display: 'flex',
                position: 'relative',
                width: '100% !important',
                cursor: 'unset !important',
            },
            _a['& .slider-control-centerleft'] = {
                left: '-1.75rem !important',
            },
            _a['& .slider-control-centerright'] = {
                right: '-1.75rem !important',
            },
            _a['& .slider-control-centerright, & .slider-control-centerleft'] = {
                transform: 'translateY(0) !important',
                top: 'calc(50% - 0.75rem) !important',
                width: '1.5rem !important',
                height: '1.5rem !important',
            },
            _a),
        // sliderContent: {
        //   display: 'flex',
        //   transition: 'transform cubic-bezier(0.4, 0, 0.2, 1) 750',
        //   marginLeft: '0',
        //   marginRight: '0',
        //   height: '100%',
        //   padding: 0,
        // },
        // wrapper: {
        //   padding: '0 2.9375rem',
        // },
        // arrowBack: {
        //   position: 'absolute',
        //   display: 'flex',
        //   alignItems: 'center',
        //   height: '100%',
        //   transition: 'opacity cubic-bezier(0.4, 0, 1, 1) 225',
        //   padding: '0px !important',
        // },
        // slide: {
        //   textAlign: 'center',
        // },
        // arrowForward: {
        //   display: 'flex',
        //   border: 'solid gold',
        //   alignItems: 'center',
        //   height: '100%',
        //   justifyContent: 'center',
        //   transition: 'opacity cubic-bezier(0.4, 0, 1, 1) 225',
        // },
        // main: {
        //   margin: '0 auto',
        // },
        // content: { flex: 1, maxWidth: 1280 },
        // container: {
        //   display: 'flex',
        //   justifyContent: 'center',
        //   margin: '0 auto',
        //   maxWidth: 1280,
        // },
        arrowContainer: {
            position: 'absolute',
            background: 'none',
            padding: '0px !important',
            border: 0,
        },
    });
});

var CarouselComponent = function (props) {
    var 
    // cellSpacing,
    width = props.width, visibleSlides = props.visibleSlides, children = props.children, _a = props.color, color = _a === void 0 ? '#000' : _a, _b = props.autoplay, autoplay = _b === void 0 ? false : _b, _c = props.dragging, dragging = _c === void 0 ? true : _c, _d = props.disableEdgeSwiping, disableEdgeSwiping = _d === void 0 ? true : _d, _e = props.enableKeyboardControls, enableKeyboardControls = _e === void 0 ? true : _e, _f = props.nextButtonAriaLabel, nextButtonAriaLabel = _f === void 0 ? 'next' : _f, afterSlide = props.afterSlide, beforeSlide = props.beforeSlide, slideIndex = props.slideIndex, _slidesToShow = props.slidesToShow, _g = props.previousButtonAriaLabel, previousButtonAriaLabel = _g === void 0 ? 'previous' : _g, 
    // cellAlign = 'left',
    _h = props.slidesToScroll, 
    // cellAlign = 'left',
    slidesToScroll = _h === void 0 ? 1 : _h, _j = props.framePadding, framePadding = _j === void 0 ? '0 0' : _j, _k = props.renderBottomCenterControls, renderBottomCenterControls = _k === void 0 ? null : _k;
    var classes = useStyles$2(props);
    var _width = width === 'md' ? 'sm' : width === 'xl' ? 'lg' : width;
    var slidesToShow = _slidesToShow !== null && _slidesToShow !== void 0 ? _slidesToShow : visibleSlides[_width];
    var CenterLeftControls = function (props) {
        var previousSlide = props.previousSlide, slideCount = props.slideCount, currentSlide = props.currentSlide;
        var isDisabled = slidesToShow >= slideCount || !currentSlide;
        return (React.createElement(IconButton, { "aria-label": previousButtonAriaLabel, className: classes.arrowContainer, size: "medium", onClick: previousSlide, style: getControlsStyle(isDisabled) },
            React.createElement(ArrowBackIosOutlinedIcon, null)));
    };
    var getControlsStyle = function (isDisabled) {
        if (isDisabled)
            return {
                color: '#c2c2ba',
                opacity: '0.4',
                cursor: 'unset',
                'background-color': 'transparent',
            };
        else
            return {
                color: color,
            };
    };
    var CenterRightControls = function (props) {
        var nextSlide = props.nextSlide, slideCount = props.slideCount, currentSlide = props.currentSlide;
        var isDisabled = slidesToShow >= slideCount || currentSlide === slideCount - slidesToShow;
        return (React.createElement(IconButton, { "aria-label": nextButtonAriaLabel, size: "medium", className: classes.arrowContainer, onClick: nextSlide, style: getControlsStyle(isDisabled) },
            React.createElement(ArrowForwardIosOutlinedIcon, null)));
    };
    return (React.createElement("div", { className: classes.sliderContainer },
        React.createElement(Carousel, { transitionMode: "fade", autoplay: autoplay, dragging: dragging, 
            // cellAlign={cellAlign}
            slideIndex: slideIndex, 
            // cellSpacing={cellSpacing}
            framePadding: framePadding, slidesToShow: slidesToShow, slidesToScroll: slidesToScroll, disableEdgeSwiping: disableEdgeSwiping, enableKeyboardControls: enableKeyboardControls, beforeSlide: beforeSlide, afterSlide: afterSlide, renderBottomCenterControls: renderBottomCenterControls, renderCenterLeftControls: CenterLeftControls, renderCenterRightControls: CenterRightControls }, children)));
};
var Carousel$1 = withWidth()(CarouselComponent);

var useStyles$3 = makeStyles(function () {
    return createStyles({
        card: {
            maxHeight: 320,
            height: '100%',
            background: 'none',
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: 1,
            marginRight: '.5rem',
            '&:focus-visible': {
                outline: 'none',
            },
        },
        content: {
            '&:focus-within': {
                outline: '4px solid currentColor',
                outlineOffset: -4,
            },
        },
        caption: {
            display: '-webkit-box',
            color: 'currentColor',
            padding: '1rem',
            lineClamp: 3,
            boxOrient: 'vertical',
            overflow: 'hidden',
            marginTop: '0 .5rem',
            textAlign: 'center',
            width: '100%',
        },
    });
});

var useStyles$4 = makeStyles(function () {
    return createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            color: 'inherit',
            border: "2px solid",
            height: '100%',
            width: '100%',
            margin: '0 auto',
            padding: '0 1rem',
            flexWrap: 'wrap',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
        },
        headline: {
            color: 'inherit',
            textTransform: 'uppercase',
            marginBottom: '0.5rem',
        },
        secondary: {
            fontSize: '.9rem',
        },
    });
});

var FallbackImage = function (props) {
    var _a = props.label, label = _a === void 0 ? 'not found image icon' : _a, _b = props.text, text = _b === void 0 ? 'Ohne Abbildungen' : _b, _c = props.height, height = _c === void 0 ? '100%' : _c, _d = props.width, width = _d === void 0 ? '100%' : _d;
    var classes = useStyles$4();
    var multiline = text.split('LINEBREAK');
    return (React.createElement("div", { role: "img", "aria-label": label, className: classes.container, style: { height: height, width: width } },
        React.createElement(Typography, { variant: "body2", className: classes.headline }, multiline[0]),
        React.createElement(NoSimOutlinedIcon, { fontSize: "large" }),
        multiline.map(function (textLine, index) {
            if (index > 0)
                return (React.createElement(Typography, { key: index, variant: 'body2', className: classes.secondary }, textLine));
        })));
};

var CarouselImageCard = function (props) {
    var t = useTranslation().t;
    var _a = props.img, img = _a === void 0 ? '' : _a, _b = props.caption, caption = _b === void 0 ? '' : _b, _c = props.color, color = _c === void 0 ? '#000' : _c, _d = props.link, link = _d === void 0 ? '' : _d, _e = props.maxWidth, maxWidth = _e === void 0 ? 200 : _e, _f = props.maxHeight, maxHeight = _f === void 0 ? 200 : _f;
    var classes = useStyles$3();
    var renderFallbackImage = function () {
        return (React.createElement(FallbackImage, { label: caption, text: t('image.notFoundText'), width: maxWidth, height: maxHeight }));
    };
    return (
    // <Card className={getCardStyle()} style={{ color: color }}>
    // {/* <CardContent
    //   tabIndex={-1}
    //   className={classes.content}
    //   style={{ color: color }}
    // > */}
    React.createElement(Link, { "data-testid": 'carousel-card', href: link, className: classes.card, style: { color: color } },
        React.createElement(Grid, { item: true, container: true, justifyContent: "center", alignItems: "center", xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
            React.createElement(LazyLoadImage, { Fallback: renderFallbackImage(), width: maxWidth, height: maxHeight, src: img })),
        React.createElement(Grid, { item: true, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
            React.createElement(Typography, { className: classes.caption, variant: "caption", color: "inherit" }, caption)))
    // {/* </CardContent> */}
    // </Card>
    );
};

var loadScript = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0];
  var script = document.createElement('script');

  if (typeof opts === 'function') {
    cb = opts;
    opts = {};
  }

  opts = opts || {};
  cb = cb || function() {};

  script.type = opts.type || 'text/javascript';
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true;
  script.src = src;

  if (opts.attrs) {
    setAttributes(script, opts.attrs);
  }

  if (opts.text) {
    script.text = '' + opts.text;
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
  onend(script, cb);

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script);
};

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null;
    cb(null, script);
  };
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null;
    cb(new Error('Failed to load ' + this.src), script);
  };
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null;
    cb(null, script); // there is no way to catch loading errors in IE8
  };
}

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

var utils$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isMediaStream = isMediaStream;
exports.isBlobUrl = isBlobUrl;
exports.supportsWebKitPresentationMode = supportsWebKitPresentationMode;

var _loadScript = _interopRequireDefault(loadScript);

var _deepmerge = _interopRequireDefault(cjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds

function parseTimeParam(url, pattern) {
  if (url instanceof Array) {
    return undefined;
  }

  var match = url.match(pattern);

  if (match) {
    var stamp = match[1];

    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }

    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }

  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);

  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }

  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
} // http://stackoverflow.com/a/38622545


function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  }).join('&');
}

function getGlobal(key) {
  if (window[key]) {
    return window[key];
  }

  if (window.exports && window.exports[key]) {
    return window.exports[key];
  }

  if (window.module && window.module.exports && window.module.exports[key]) {
    return window.module.exports[key];
  }

  return null;
} // Util function to load an external SDK
// or return the SDK if it is already loaded


var requests = {};

function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];
  var existingGlobal = getGlobal(sdkGlobal);

  if (existingGlobal && isLoaded(existingGlobal)) {
    return Promise.resolve(existingGlobal);
  }

  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({
        resolve: resolve,
        reject: reject
      });
      return;
    }

    requests[url] = [{
      resolve: resolve,
      reject: reject
    }];

    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending request promises
      requests[url].forEach(function (request) {
        return request.resolve(sdk);
      });
    };

    if (sdkReady) {
      var previousOnReady = window[sdkReady];

      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(getGlobal(sdkGlobal));
      };
    }

    fetchScript(url, function (err) {
      if (err) {
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(function (request) {
          return request.reject(err);
        });
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(getGlobal(sdkGlobal));
      }
    });
  });
}

function getConfig(props, defaultProps) {
  return (0, _deepmerge["default"])(defaultProps.config, props.config);
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);

  var output = {};
  var keys = Object.keys(object);

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];

    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }

  return output;
}

function callPlayer(method) {
  var _this$player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");

    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }

    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_this$player = this.player)[method].apply(_this$player, args);
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

function isBlobUrl(url) {
  return /^blob:/.test(url);
}

function supportsWebKitPresentationMode() {
  var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('video');
  // Check if Safari supports PiP, and is not on mobile (other than iPad)
  // iPhone safari appears to "support" PiP through the check, however PiP does not function
  var notMobile = /iPhone|iPod/.test(navigator.userAgent) === false;
  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && notMobile;
}
});

unwrapExports(utils$1);
var utils_1$1 = utils$1.parseStartTime;
var utils_2 = utils$1.parseEndTime;
var utils_3 = utils$1.randomString;
var utils_4 = utils$1.queryString;
var utils_5 = utils$1.getSDK;
var utils_6 = utils$1.getConfig;
var utils_7 = utils$1.omit;
var utils_8 = utils$1.callPlayer;
var utils_9 = utils$1.isMediaStream;
var utils_10 = utils$1.isBlobUrl;
var utils_11 = utils$1.supportsWebKitPresentationMode;

var patterns = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canPlay = exports.FLV_EXTENSIONS = exports.DASH_EXTENSIONS = exports.HLS_EXTENSIONS = exports.VIDEO_EXTENSIONS = exports.AUDIO_EXTENSIONS = exports.MATCH_URL_KALTURA = exports.MATCH_URL_VIDYARD = exports.MATCH_URL_MIXCLOUD = exports.MATCH_URL_DAILYMOTION = exports.MATCH_URL_TWITCH_CHANNEL = exports.MATCH_URL_TWITCH_VIDEO = exports.MATCH_URL_WISTIA = exports.MATCH_URL_STREAMABLE = exports.MATCH_URL_FACEBOOK_WATCH = exports.MATCH_URL_FACEBOOK = exports.MATCH_URL_VIMEO = exports.MATCH_URL_SOUNDCLOUD = exports.MATCH_URL_YOUTUBE = void 0;



function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
exports.MATCH_URL_YOUTUBE = MATCH_URL_YOUTUBE;
var MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
exports.MATCH_URL_SOUNDCLOUD = MATCH_URL_SOUNDCLOUD;
var MATCH_URL_VIMEO = /vimeo\.com\/(?!progressive_redirect).+/;
exports.MATCH_URL_VIMEO = MATCH_URL_VIMEO;
var MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
exports.MATCH_URL_FACEBOOK = MATCH_URL_FACEBOOK;
var MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
exports.MATCH_URL_FACEBOOK_WATCH = MATCH_URL_FACEBOOK_WATCH;
var MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
exports.MATCH_URL_STREAMABLE = MATCH_URL_STREAMABLE;
var MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?(.*)$/;
exports.MATCH_URL_WISTIA = MATCH_URL_WISTIA;
var MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
exports.MATCH_URL_TWITCH_VIDEO = MATCH_URL_TWITCH_VIDEO;
var MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
exports.MATCH_URL_TWITCH_CHANNEL = MATCH_URL_TWITCH_CHANNEL;
var MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
exports.MATCH_URL_DAILYMOTION = MATCH_URL_DAILYMOTION;
var MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
exports.MATCH_URL_MIXCLOUD = MATCH_URL_MIXCLOUD;
var MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/;
exports.MATCH_URL_VIDYARD = MATCH_URL_VIDYARD;
var MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_]+)$/;
exports.MATCH_URL_KALTURA = MATCH_URL_KALTURA;
var AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
exports.AUDIO_EXTENSIONS = AUDIO_EXTENSIONS;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
exports.VIDEO_EXTENSIONS = VIDEO_EXTENSIONS;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
exports.HLS_EXTENSIONS = HLS_EXTENSIONS;
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
exports.DASH_EXTENSIONS = DASH_EXTENSIONS;
var FLV_EXTENSIONS = /\.(flv)($|\?)/i;
exports.FLV_EXTENSIONS = FLV_EXTENSIONS;

var canPlayFile = function canPlayFile(url) {
  if (url instanceof Array) {
    var _iterator = _createForOfIteratorHelper(url),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (typeof item === 'string' && canPlayFile(item)) {
          return true;
        }

        if (canPlayFile(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  }

  if ((0, utils$1.isMediaStream)(url) || (0, utils$1.isBlobUrl)(url)) {
    return true;
  }

  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url) || FLV_EXTENSIONS.test(url);
};

var canPlay = {
  youtube: function youtube(url) {
    if (url instanceof Array) {
      return url.every(function (item) {
        return MATCH_URL_YOUTUBE.test(item);
      });
    }

    return MATCH_URL_YOUTUBE.test(url);
  },
  soundcloud: function soundcloud(url) {
    return MATCH_URL_SOUNDCLOUD.test(url) && !AUDIO_EXTENSIONS.test(url);
  },
  vimeo: function vimeo(url) {
    return MATCH_URL_VIMEO.test(url) && !VIDEO_EXTENSIONS.test(url) && !HLS_EXTENSIONS.test(url);
  },
  facebook: function facebook(url) {
    return MATCH_URL_FACEBOOK.test(url) || MATCH_URL_FACEBOOK_WATCH.test(url);
  },
  streamable: function streamable(url) {
    return MATCH_URL_STREAMABLE.test(url);
  },
  wistia: function wistia(url) {
    return MATCH_URL_WISTIA.test(url);
  },
  twitch: function twitch(url) {
    return MATCH_URL_TWITCH_VIDEO.test(url) || MATCH_URL_TWITCH_CHANNEL.test(url);
  },
  dailymotion: function dailymotion(url) {
    return MATCH_URL_DAILYMOTION.test(url);
  },
  mixcloud: function mixcloud(url) {
    return MATCH_URL_MIXCLOUD.test(url);
  },
  vidyard: function vidyard(url) {
    return MATCH_URL_VIDYARD.test(url);
  },
  kaltura: function kaltura(url) {
    return MATCH_URL_KALTURA.test(url);
  },
  file: canPlayFile
};
exports.canPlay = canPlay;
});

unwrapExports(patterns);
var patterns_1 = patterns.canPlay;
var patterns_2 = patterns.FLV_EXTENSIONS;
var patterns_3 = patterns.DASH_EXTENSIONS;
var patterns_4 = patterns.HLS_EXTENSIONS;
var patterns_5 = patterns.VIDEO_EXTENSIONS;
var patterns_6 = patterns.AUDIO_EXTENSIONS;
var patterns_7 = patterns.MATCH_URL_KALTURA;
var patterns_8 = patterns.MATCH_URL_VIDYARD;
var patterns_9 = patterns.MATCH_URL_MIXCLOUD;
var patterns_10 = patterns.MATCH_URL_DAILYMOTION;
var patterns_11 = patterns.MATCH_URL_TWITCH_CHANNEL;
var patterns_12 = patterns.MATCH_URL_TWITCH_VIDEO;
var patterns_13 = patterns.MATCH_URL_WISTIA;
var patterns_14 = patterns.MATCH_URL_STREAMABLE;
var patterns_15 = patterns.MATCH_URL_FACEBOOK_WATCH;
var patterns_16 = patterns.MATCH_URL_FACEBOOK;
var patterns_17 = patterns.MATCH_URL_VIMEO;
var patterns_18 = patterns.MATCH_URL_SOUNDCLOUD;
var patterns_19 = patterns.MATCH_URL_YOUTUBE;

var YouTube_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_PLAYLIST = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/;
var MATCH_USER_UPLOADS = /user\/([a-zA-Z0-9_-]+)\/?/;
var MATCH_NOCOOKIE = /youtube-nocookie\.com/;
var NOCOOKIE_HOST = 'https://www.youtube-nocookie.com';

var YouTube = /*#__PURE__*/function (_Component) {
  _inherits(YouTube, _Component);

  var _super = _createSuper(YouTube);

  function YouTube() {
    var _this;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "parsePlaylist", function (url) {
      if (url instanceof Array) {
        return {
          listType: 'playlist',
          playlist: url.map(_this.getID).join(',')
        };
      }

      if (MATCH_PLAYLIST.test(url)) {
        var _url$match = url.match(MATCH_PLAYLIST),
            _url$match2 = _slicedToArray(_url$match, 2),
            playlistId = _url$match2[1];

        return {
          listType: 'playlist',
          list: playlistId.replace(/^UC/, 'UU')
        };
      }

      if (MATCH_USER_UPLOADS.test(url)) {
        var _url$match3 = url.match(MATCH_USER_UPLOADS),
            _url$match4 = _slicedToArray(_url$match3, 2),
            username = _url$match4[1];

        return {
          listType: 'user_uploads',
          list: username
        };
      }

      return {};
    });

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (event) {
      var data = event.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onBufferEnd = _this$props.onBufferEnd,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop,
          _this$props$config = _this$props.config,
          playerVars = _this$props$config.playerVars,
          onUnstarted = _this$props$config.onUnstarted;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          UNSTARTED = _window$SDK_GLOBAL$Pl.UNSTARTED,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;
      if (data === UNSTARTED) onUnstarted();

      if (data === PLAYING) {
        onPlay();
        onBufferEnd();
      }

      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();

      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist'); // Only loop manually if not playing a playlist

        if (loop && !isPlaylist) {
          if (playerVars.start) {
            _this.seekTo(playerVars.start);
          } else {
            _this.play();
          }
        }

        onEnded();
      }

      if (data === CUED) onReady();
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unMute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(YouTube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "getID",
    value: function getID(url) {
      if (!url || url instanceof Array || MATCH_PLAYLIST.test(url)) {
        return null;
      }

      return url.match(patterns.MATCH_URL_YOUTUBE)[1];
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props2 = this.props,
          playing = _this$props2.playing,
          muted = _this$props2.muted,
          playsinline = _this$props2.playsinline,
          controls = _this$props2.controls,
          loop = _this$props2.loop,
          config = _this$props2.config,
          _onError = _this$props2.onError;
      var playerVars = config.playerVars,
          embedOptions = config.embedOptions;
      var id = this.getID(url);

      if (isReady) {
        if (MATCH_PLAYLIST.test(url) || MATCH_USER_UPLOADS.test(url) || url instanceof Array) {
          this.player.loadPlaylist(this.parsePlaylist(url));
          return;
        }

        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, utils$1.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, utils$1.parseEndTime)(url) || playerVars.end
        });
        return;
      }

      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _objectSpread({
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _objectSpread(_objectSpread({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, utils$1.parseStartTime)(url),
            end: (0, utils$1.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline ? 1 : 0
          }, _this2.parsePlaylist(url)), playerVars),
          events: {
            onReady: function onReady() {
              if (loop) {
                _this2.player.setLoop(true); // Enable playlist looping

              }

              _this2.props.onReady();
            },
            onPlaybackRateChange: function onPlaybackRateChange(event) {
              return _this2.props.onPlaybackRateChange(event.data);
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          },
          host: MATCH_NOCOOKIE.test(url) ? NOCOOKIE_HOST : undefined
        }, embedOptions));
      }, _onError);

      if (embedOptions.events) {
        console.warn('Using `embedOptions.events` will likely break things. Use ReactPlayer’s callback props instead, eg onReady, onPlay, onPause');
      }
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);

      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return YouTube;
}(_react.Component);

exports["default"] = YouTube;

_defineProperty(YouTube, "displayName", 'YouTube');

_defineProperty(YouTube, "canPlay", patterns.canPlay.youtube);
});

unwrapExports(YouTube_1);

var SoundCloud_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';

var SoundCloud = /*#__PURE__*/function (_Component) {
  _inherits(SoundCloud, _Component);

  var _super = _createSuper(SoundCloud);

  function SoundCloud() {
    var _this;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "fractionLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(SoundCloud, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);

          _this2.player.bind(PLAY, _this2.props.onPlay);

          _this2.player.bind(PAUSE, function () {
            var remaining = _this2.duration - _this2.currentTime;

            if (remaining < 0.05) {
              // Prevent onPause firing right before onEnded
              return;
            }

            _this2.props.onPause();
          });

          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });

          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });

          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }

        _this2.player.load(url, _objectSpread(_objectSpread({}, _this2.props.config.options), {}, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;

              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
        style: style,
        frameBorder: 0,
        allow: "autoplay"
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

exports["default"] = SoundCloud;

_defineProperty(SoundCloud, "displayName", 'SoundCloud');

_defineProperty(SoundCloud, "canPlay", patterns.canPlay.soundcloud);

_defineProperty(SoundCloud, "loopOnEnded", true);
});

unwrapExports(SoundCloud_1);

var Vimeo_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';

var Vimeo = /*#__PURE__*/function (_Component) {
  _inherits(Vimeo, _Component);

  var _super = _createSuper(Vimeo);

  function Vimeo() {
    var _this;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(Vimeo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        var _this2$props$config = _this2.props.config,
            playerOptions = _this2$props$config.playerOptions,
            title = _this2$props$config.title;
        _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop,
          playsinline: _this2.props.playsinline,
          controls: _this2.props.controls
        }, playerOptions));

        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');

          iframe.style.width = '100%';
          iframe.style.height = '100%';

          if (title) {
            iframe.title = title;
          }
        })["catch"](_this2.props.onError);

        _this2.player.on('loaded', function () {
          _this2.props.onReady();

          _this2.refreshDuration();
        });

        _this2.player.on('play', function () {
          _this2.props.onPlay();

          _this2.refreshDuration();
        });

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var seconds = _ref.seconds;
          _this2.currentTime = seconds;
        });

        _this2.player.on('progress', function (_ref2) {
          var seconds = _ref2.seconds;
          _this2.secondsLoaded = seconds;
        });

        _this2.player.on('bufferstart', _this2.props.onBuffer);

        _this2.player.on('bufferend', _this2.props.onBufferEnd);
      }, this.props.onError);
    }
  }, {
    key: "refreshDuration",
    value: function refreshDuration() {
      var _this3 = this;

      this.player.getDuration().then(function (duration) {
        _this3.duration = duration;
      });
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.callPlayer('play');

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

exports["default"] = Vimeo;

_defineProperty(Vimeo, "displayName", 'Vimeo');

_defineProperty(Vimeo, "canPlay", patterns.canPlay.vimeo);

_defineProperty(Vimeo, "forceLoad", true);
});

unwrapExports(Vimeo_1);

var Facebook_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = /*#__PURE__*/function (_Component) {
  _inherits(Facebook, _Component);

  var _super = _createSuper(Facebook);

  function Facebook() {
    var _this;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, utils$1.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Facebook, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }

      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.appId,
          xfbml: true,
          version: _this2.props.config.version
        });
        FB.Event.subscribe('xfbml.render', function (msg) {
          // Here we know the SDK has loaded, even if onReady/onPlay
          // is not called due to a video that cannot be embedded
          _this2.props.onLoaded();
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;

            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);

            _this2.player.subscribe('paused', _this2.props.onPause);

            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);

            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);

            _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);

            _this2.player.subscribe('error', _this2.props.onError);

            if (_this2.props.muted) {
              _this2.callPlayer('mute');
            } else {
              _this2.callPlayer('unmute');
            }

            _this2.props.onReady(); // For some reason Facebook have added `visibility: hidden`
            // to the iframe when autoplay fails, so here we set it back


            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
          }
        });
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var attributes = this.props.config.attributes;
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        style: style,
        id: this.playerID,
        className: "fb-video",
        "data-href": this.props.url,
        "data-autoplay": this.props.playing ? 'true' : 'false',
        "data-allowfullscreen": "true",
        "data-controls": this.props.controls ? 'true' : 'false'
      }, attributes));
    }
  }]);

  return Facebook;
}(_react.Component);

exports["default"] = Facebook;

_defineProperty(Facebook, "displayName", 'Facebook');

_defineProperty(Facebook, "canPlay", patterns.canPlay.facebook);

_defineProperty(Facebook, "loopOnEnded", true);
});

unwrapExports(Facebook_1);

var Streamable_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';

var Streamable = /*#__PURE__*/function (_Component) {
  _inherits(Streamable, _Component);

  var _super = _createSuper(Streamable);

  function Streamable() {
    var _this;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Streamable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);

        _this2.player.setLoop(_this2.props.loop);

        _this2.player.on('ready', _this2.props.onReady);

        _this2.player.on('play', _this2.props.onPlay);

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', _this2.props.onSeek);

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var duration = _ref.duration,
              seconds = _ref.seconds;
          _this2.duration = duration;
          _this2.currentTime = seconds;
        });

        _this2.player.on('buffered', function (_ref2) {
          var percent = _ref2.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });

        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.url.match(patterns.MATCH_URL_STREAMABLE)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://streamable.com/o/".concat(id),
        frameBorder: "0",
        scrolling: "no",
        style: style,
        allowFullScreen: true
      });
    }
  }]);

  return Streamable;
}(_react.Component);

exports["default"] = Streamable;

_defineProperty(Streamable, "displayName", 'Streamable');

_defineProperty(Streamable, "canPlay", patterns.canPlay.streamable);
});

unwrapExports(Streamable_1);

var Wistia_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var PLAYER_ID_PREFIX = 'wistia-player-';

var Wistia = /*#__PURE__*/function (_Component) {
  _inherits(Wistia, _Component);

  var _super = _createSuper(Wistia);

  function Wistia() {
    var _this;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, utils$1.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props;

      return (_this$props = _this.props).onPlay.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPause.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onSeek.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onEnded.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlaybackRateChange", function () {
      var _this$props5;

      return (_this$props5 = _this.props).onPlaybackRateChange.apply(_this$props5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Wistia, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props6 = this.props,
          playing = _this$props6.playing,
          muted = _this$props6.muted,
          controls = _this$props6.controls,
          _onReady = _this$props6.onReady,
          config = _this$props6.config,
          onError = _this$props6.onError;
      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Wistia) {
        if (config.customControls) {
          config.customControls.forEach(function (control) {
            return Wistia.defineControl(control);
          });
        }

        window._wq = window._wq || [];

        window._wq.push({
          id: _this2.playerID,
          options: _objectSpread({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls,
            fullscreenButton: controls,
            playbar: controls,
            playbackRateControl: controls,
            qualityControl: controls,
            volumeControl: controls,
            settingsControl: controls,
            smallPlayButton: controls
          }, config.options),
          onReady: function onReady(player) {
            _this2.player = player;

            _this2.unbind();

            _this2.player.bind('play', _this2.onPlay);

            _this2.player.bind('pause', _this2.onPause);

            _this2.player.bind('seek', _this2.onSeek);

            _this2.player.bind('end', _this2.onEnded);

            _this2.player.bind('playbackratechange', _this2.onPlaybackRateChange);

            _onReady();
          }
        });
      }, onError);
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.player.unbind('play', this.onPlay);
      this.player.unbind('pause', this.onPause);
      this.player.unbind('seek', this.onSeek);
      this.player.unbind('end', this.onEnded);
      this.player.unbind('playbackratechange', this.onPlaybackRateChange);
    } // Proxy methods to prevent listener leaks

  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.unbind();
      this.callPlayer('remove');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var url = this.props.url;
      var videoID = url && url.match(patterns.MATCH_URL_WISTIA)[1];
      var className = "wistia_embed wistia_async_".concat(videoID);
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: this.playerID,
        key: videoID,
        className: className,
        style: style
      });
    }
  }]);

  return Wistia;
}(_react.Component);

exports["default"] = Wistia;

_defineProperty(Wistia, "displayName", 'Wistia');

_defineProperty(Wistia, "canPlay", patterns.canPlay.wistia);

_defineProperty(Wistia, "loopOnEnded", true);
});

unwrapExports(Wistia_1);

var Twitch_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = /*#__PURE__*/function (_Component) {
  _inherits(Twitch, _Component);

  var _super = _createSuper(Twitch);

  function Twitch() {
    var _this;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, utils$1.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    return _this;
  }

  _createClass(Twitch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props = this.props,
          playsinline = _this$props.playsinline,
          onError = _this$props.onError,
          config = _this$props.config,
          controls = _this$props.controls;

      var isChannel = patterns.MATCH_URL_TWITCH_CHANNEL.test(url);

      var id = isChannel ? url.match(patterns.MATCH_URL_TWITCH_CHANNEL)[1] : url.match(patterns.MATCH_URL_TWITCH_VIDEO)[1];

      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }

        return;
      }

      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
          controls: isChannel ? true : controls,
          time: (0, utils$1.parseStartTime)(url)
        }, config.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAYING = _Twitch$Player.PLAYING,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED,
            ONLINE = _Twitch$Player.ONLINE,
            OFFLINE = _Twitch$Player.OFFLINE,
            SEEK = _Twitch$Player.SEEK;

        _this2.player.addEventListener(READY, _this2.props.onReady);

        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);

        _this2.player.addEventListener(PAUSE, _this2.props.onPause);

        _this2.player.addEventListener(ENDED, _this2.props.onEnded);

        _this2.player.addEventListener(SEEK, _this2.props.onSeek); // Prevent weird isLoading behaviour when streams are offline


        _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);

        _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        id: this.playerID
      });
    }
  }]);

  return Twitch;
}(_react.Component);

exports["default"] = Twitch;

_defineProperty(Twitch, "displayName", 'Twitch');

_defineProperty(Twitch, "canPlay", patterns.canPlay.twitch);

_defineProperty(Twitch, "loopOnEnded", true);
});

unwrapExports(Twitch_1);

var DailyMotion_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';

var DailyMotion = /*#__PURE__*/function (_Component) {
  _inherits(DailyMotion, _Component);

  var _super = _createSuper(DailyMotion);

  function DailyMotion() {
    var _this;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onDurationChange", function () {
      var duration = _this.getDuration();

      _this.props.onDuration(duration);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(DailyMotion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props = this.props,
          controls = _this$props.controls,
          config = _this$props.config,
          onError = _this$props.onError,
          playing = _this$props.playing;

      var _url$match = url.match(patterns.MATCH_URL_DAILYMOTION),
          _url$match2 = _slicedToArray(_url$match, 2),
          id = _url$match2[1];

      if (this.player) {
        this.player.load(id, {
          start: (0, utils$1.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }

      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _objectSpread({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, utils$1.parseStartTime)(url),
            origin: window.location.origin
          }, config.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return DailyMotion;
}(_react.Component);

exports["default"] = DailyMotion;

_defineProperty(DailyMotion, "displayName", 'DailyMotion');

_defineProperty(DailyMotion, "canPlay", patterns.canPlay.dailymotion);

_defineProperty(DailyMotion, "loopOnEnded", true);
});

unwrapExports(DailyMotion_1);

var Mixcloud_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';

var Mixcloud = /*#__PURE__*/function (_Component) {
  _inherits(Mixcloud, _Component);

  var _super = _createSuper(Mixcloud);

  function Mixcloud() {
    var _this;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Mixcloud, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);

        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);

          _this2.player.events.pause.on(_this2.props.onPause);

          _this2.player.events.ended.on(_this2.props.onEnded);

          _this2.player.events.error.on(_this2.props.error);

          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });

          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {// No volume support
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          config = _this$props.config;
      var id = url.match(patterns.MATCH_URL_MIXCLOUD)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, utils$1.queryString)(_objectSpread(_objectSpread({}, config.options), {}, {
        feed: "/".concat(id, "/")
      })); // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track

      return /*#__PURE__*/_react["default"].createElement("iframe", {
        key: id,
        ref: this.ref,
        style: style,
        src: "https://www.mixcloud.com/widget/iframe/?".concat(query),
        frameBorder: "0"
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

exports["default"] = Mixcloud;

_defineProperty(Mixcloud, "displayName", 'Mixcloud');

_defineProperty(Mixcloud, "canPlay", patterns.canPlay.mixcloud);

_defineProperty(Mixcloud, "loopOnEnded", true);
});

unwrapExports(Mixcloud_1);

var Vidyard_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://play.vidyard.com/embed/v4.js';
var SDK_GLOBAL = 'VidyardV4';
var SDK_GLOBAL_READY = 'onVidyardAPI';

var Vidyard = /*#__PURE__*/function (_Component) {
  _inherits(Vidyard, _Component);

  var _super = _createSuper(Vidyard);

  function Vidyard() {
    var _this;

    _classCallCheck(this, Vidyard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(Vidyard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props = this.props,
          playing = _this$props.playing,
          config = _this$props.config,
          onError = _this$props.onError,
          onDuration = _this$props.onDuration;
      var id = url && url.match(patterns.MATCH_URL_VIDYARD)[1];

      if (this.player) {
        this.stop();
      }

      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (Vidyard) {
        if (!_this2.container) return;
        Vidyard.api.addReadyListener(function (data, player) {
          _this2.player = player;

          _this2.player.on('ready', _this2.props.onReady);

          _this2.player.on('play', _this2.props.onPlay);

          _this2.player.on('pause', _this2.props.onPause);

          _this2.player.on('seek', _this2.props.onSeek);

          _this2.player.on('playerComplete', _this2.props.onEnded);
        }, id);
        Vidyard.api.renderPlayer(_objectSpread({
          uuid: id,
          container: _this2.container,
          autoplay: playing ? 1 : 0
        }, config.options));
        Vidyard.api.getPlayerMetadata(id).then(function (meta) {
          _this2.duration = meta.length_in_seconds;
          onDuration(meta.length_in_seconds);
        });
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      window.VidyardV4.api.destroyPlayer(this.player);
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seek', amount);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackSpeed', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('currentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return Vidyard;
}(_react.Component);

exports["default"] = Vidyard;

_defineProperty(Vidyard, "displayName", 'Vidyard');

_defineProperty(Vidyard, "canPlay", patterns.canPlay.vidyard);
});

unwrapExports(Vidyard_1);

var Kaltura_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';

var Kaltura = /*#__PURE__*/function (_Component) {
  _inherits(Kaltura, _Component);

  var _super = _createSuper(Kaltura);

  function Kaltura() {
    var _this;

    _classCallCheck(this, Kaltura);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Kaltura, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);

        _this2.player.on('ready', function () {
          // An arbitrary timeout is required otherwise
          // the event listeners won’t work
          setTimeout(function () {
            _this2.player.isReady = true;

            _this2.player.setLoop(_this2.props.loop);

            if (_this2.props.muted) {
              _this2.player.mute();
            }

            _this2.addListeners(_this2.player, _this2.props);

            _this2.props.onReady();
          }, 500);
        });
      }, this.props.onError);
    }
  }, {
    key: "addListeners",
    value: function addListeners(player, props) {
      var _this3 = this;

      player.on('play', props.onPlay);
      player.on('pause', props.onPause);
      player.on('ended', props.onEnded);
      player.on('error', props.onError);
      player.on('timeupdate', function (_ref) {
        var duration = _ref.duration,
            seconds = _ref.seconds;
        _this3.duration = duration;
        _this3.currentTime = seconds;
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: this.props.url,
        frameBorder: "0",
        scrolling: "no",
        style: style,
        allowFullScreen: true,
        allow: "encrypted-media;autoplay",
        referrerPolicy: "no-referrer-when-downgrade"
      });
    }
  }]);

  return Kaltura;
}(_react.Component);

exports["default"] = Kaltura;

_defineProperty(Kaltura, "displayName", 'Kaltura');

_defineProperty(Kaltura, "canPlay", patterns.canPlay.kaltura);
});

unwrapExports(Kaltura_1);

var FilePlayer_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HAS_NAVIGATOR = typeof navigator !== 'undefined';
var IS_IPAD_PRO = HAS_NAVIGATOR && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
var IS_IOS = HAS_NAVIGATOR && (/iPad|iPhone|iPod/.test(navigator.userAgent) || IS_IPAD_PRO) && !window.MSStream;
var HLS_SDK_URL = 'https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var FLV_SDK_URL = 'https://cdn.jsdelivr.net/npm/flv.js@VERSION/dist/flv.min.js';
var FLV_GLOBAL = 'flvjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
var MATCH_CLOUDFLARE_STREAM = /https:\/\/watch\.cloudflarestream\.com\/([a-z0-9]+)/;
var REPLACE_CLOUDFLARE_STREAM = 'https://videodelivery.net/{id}/manifest/video.m3u8';

var FilePlayer = /*#__PURE__*/function (_Component) {
  _inherits(FilePlayer, _Component);

  var _super = _createSuper(FilePlayer);

  function FilePlayer() {
    var _this;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "onReady", function () {
      var _this$props;

      return (_this$props = _this.props).onReady.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBuffer", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBufferEnd", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props5;

      return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props6;

      return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function () {
      var _this$props7;

      return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayBackRateChange", function (event) {
      return _this.props.onPlaybackRateChange(event.target.playbackRate);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnablePIP", function () {
      var _this$props8;

      return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDisablePIP", function (e) {
      var _this$props9 = _this.props,
          onDisablePIP = _this$props9.onDisablePIP,
          playing = _this$props9.playing;
      onDisablePIP(e);

      if (playing) {
        _this.play();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPresentationModeChange", function (e) {
      if (_this.player && (0, utils$1.supportsWebKitPresentationMode)(_this.player)) {
        var webkitPresentationMode = _this.player.webkitPresentationMode;

        if (webkitPresentationMode === 'picture-in-picture') {
          _this.onEnablePIP(e);
        } else if (webkitPresentationMode === 'inline') {
          _this.onDisablePIP(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function (e) {
      _this.props.onSeek(e.target.currentTime);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.player.muted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.player.muted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSourceElement", function (source, index) {
      if (typeof source === 'string') {
        return /*#__PURE__*/_react["default"].createElement("source", {
          key: index,
          src: source
        });
      }

      return /*#__PURE__*/_react["default"].createElement("source", _extends({
        key: index
      }, source));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrack", function (track, index) {
      return /*#__PURE__*/_react["default"].createElement("track", _extends({
        key: index
      }, track));
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
      if (_this.player) {
        // Store previous player to be used by removeListeners()
        _this.prevPlayer = _this.player;
      }

      _this.player = player;
    });

    return _this;
  }

  _createClass(FilePlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
      this.addListeners(this.player);

      if (IS_IOS) {
        this.player.load();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.removeListeners(this.prevPlayer, prevProps.url);
        this.addListeners(this.player);
      }

      if (this.props.url !== prevProps.url && !(0, utils$1.isMediaStream)(this.props.url)) {
        this.player.srcObject = null;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners(this.player);

      if (this.hls) {
        this.hls.destroy();
      }
    }
  }, {
    key: "addListeners",
    value: function addListeners(player) {
      var _this$props10 = this.props,
          url = _this$props10.url,
          playsinline = _this$props10.playsinline;
      player.addEventListener('play', this.onPlay);
      player.addEventListener('waiting', this.onBuffer);
      player.addEventListener('playing', this.onBufferEnd);
      player.addEventListener('pause', this.onPause);
      player.addEventListener('seeked', this.onSeek);
      player.addEventListener('ended', this.onEnded);
      player.addEventListener('error', this.onError);
      player.addEventListener('ratechange', this.onPlayBackRateChange);
      player.addEventListener('enterpictureinpicture', this.onEnablePIP);
      player.addEventListener('leavepictureinpicture', this.onDisablePIP);
      player.addEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

      if (!this.shouldUseHLS(url)) {
        // onReady is handled by hls.js
        player.addEventListener('canplay', this.onReady);
      }

      if (playsinline) {
        player.setAttribute('playsinline', '');
        player.setAttribute('webkit-playsinline', '');
        player.setAttribute('x5-playsinline', '');
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners(player, url) {
      player.removeEventListener('canplay', this.onReady);
      player.removeEventListener('play', this.onPlay);
      player.removeEventListener('waiting', this.onBuffer);
      player.removeEventListener('playing', this.onBufferEnd);
      player.removeEventListener('pause', this.onPause);
      player.removeEventListener('seeked', this.onSeek);
      player.removeEventListener('ended', this.onEnded);
      player.removeEventListener('error', this.onError);
      player.removeEventListener('ratechange', this.onPlayBackRateChange);
      player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
      player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
      player.removeEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

      if (!this.shouldUseHLS(url)) {
        // onReady is handled by hls.js
        player.removeEventListener('canplay', this.onReady);
      }
    } // Proxy methods to prevent listener leaks

  }, {
    key: "shouldUseAudio",
    value: function shouldUseAudio(props) {
      if (props.config.forceVideo) {
        return false;
      }

      if (props.config.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }

      return patterns.AUDIO_EXTENSIONS.test(props.url) || props.config.forceAudio;
    }
  }, {
    key: "shouldUseHLS",
    value: function shouldUseHLS(url) {
      if (this.props.config.forceHLS) {
        return true;
      }

      if (IS_IOS) {
        return false;
      }

      return patterns.HLS_EXTENSIONS.test(url) || MATCH_CLOUDFLARE_STREAM.test(url);
    }
  }, {
    key: "shouldUseDASH",
    value: function shouldUseDASH(url) {
      return patterns.DASH_EXTENSIONS.test(url) || this.props.config.forceDASH;
    }
  }, {
    key: "shouldUseFLV",
    value: function shouldUseFLV(url) {
      return patterns.FLV_EXTENSIONS.test(url) || this.props.config.forceFLV;
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props$config = this.props.config,
          hlsVersion = _this$props$config.hlsVersion,
          hlsOptions = _this$props$config.hlsOptions,
          dashVersion = _this$props$config.dashVersion,
          flvVersion = _this$props$config.flvVersion;

      if (this.hls) {
        this.hls.destroy();
      }

      if (this.dash) {
        this.dash.reset();
      }

      if (this.shouldUseHLS(url)) {
        (0, utils$1.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(hlsOptions);

          _this2.hls.on(Hls.Events.MANIFEST_PARSED, function () {
            _this2.props.onReady();
          });

          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });

          if (MATCH_CLOUDFLARE_STREAM.test(url)) {
            var id = url.match(MATCH_CLOUDFLARE_STREAM)[1];

            _this2.hls.loadSource(REPLACE_CLOUDFLARE_STREAM.replace('{id}', id));
          } else {
            _this2.hls.loadSource(url);
          }

          _this2.hls.attachMedia(_this2.player);

          _this2.props.onLoaded();
        });
      }

      if (this.shouldUseDASH(url)) {
        (0, utils$1.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();

          _this2.dash.initialize(_this2.player, url, _this2.props.playing);

          _this2.dash.on('error', _this2.props.onError);

          if (parseInt(dashVersion) < 3) {
            _this2.dash.getDebug().setLogToBrowserConsole(false);
          } else {
            _this2.dash.updateSettings({
              debug: {
                logLevel: dashjs.Debug.LOG_LEVEL_NONE
              }
            });
          }

          _this2.props.onLoaded();
        });
      }

      if (this.shouldUseFLV(url)) {
        (0, utils$1.getSDK)(FLV_SDK_URL.replace('VERSION', flvVersion), FLV_GLOBAL).then(function (flvjs) {
          _this2.flv = flvjs.createPlayer({
            type: 'flv',
            url: url
          });

          _this2.flv.attachMediaElement(_this2.player);

          _this2.flv.load();

          _this2.props.onLoaded();
        });
      }

      if (url instanceof Array) {
        // When setting new urls (<source>) on an already loaded video,
        // HTMLMediaElement.load() is needed to reset the media element
        // and restart the media resource. Just replacing children source
        // dom nodes is not enough
        this.player.load();
      } else if ((0, utils$1.isMediaStream)(url)) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.player.play();

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.player.removeAttribute('src');

      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: "enablePIP",
    value: function enablePIP() {
      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
        this.player.requestPictureInPicture();
      } else if ((0, utils$1.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'picture-in-picture') {
        this.player.webkitSetPresentationMode('picture-in-picture');
      }
    }
  }, {
    key: "disablePIP",
    value: function disablePIP() {
      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
        document.exitPictureInPicture();
      } else if ((0, utils$1.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'inline') {
        this.player.webkitSetPresentationMode('inline');
      }
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      try {
        this.player.playbackRate = rate;
      } catch (error) {
        this.props.onError(error);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.player) return null;
      var _this$player = this.player,
          duration = _this$player.duration,
          seekable = _this$player.seekable; // on iOS, live streams return Infinity for the duration
      // so instead we use the end of the seekable timerange

      if (duration === Infinity && seekable.length > 0) {
        return seekable.end(seekable.length - 1);
      }

      return duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.player) return null;
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.player) return null;
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }

      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();

      if (end > duration) {
        return duration;
      }

      return end;
    }
  }, {
    key: "getSource",
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);
      var useFLV = this.shouldUseFLV(url);

      if (url instanceof Array || (0, utils$1.isMediaStream)(url) || useHLS || useDASH || useFLV) {
        return undefined;
      }

      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }

      return url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          url = _this$props11.url,
          playing = _this$props11.playing,
          loop = _this$props11.loop,
          controls = _this$props11.controls,
          muted = _this$props11.muted,
          config = _this$props11.config,
          width = _this$props11.width,
          height = _this$props11.height;
      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return /*#__PURE__*/_react["default"].createElement(Element, _extends({
        ref: this.ref,
        src: this.getSource(url),
        style: style,
        preload: "auto",
        autoPlay: playing || undefined,
        controls: controls,
        muted: muted,
        loop: loop
      }, config.attributes), url instanceof Array && url.map(this.renderSourceElement), config.tracks.map(this.renderTrack));
    }
  }]);

  return FilePlayer;
}(_react.Component);

exports["default"] = FilePlayer;

_defineProperty(FilePlayer, "displayName", 'FilePlayer');

_defineProperty(FilePlayer, "canPlay", patterns.canPlay.file);
});

unwrapExports(FilePlayer_1);

var players = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;







function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = [{
  key: 'youtube',
  name: 'YouTube',
  canPlay: patterns.canPlay.youtube,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(YouTube_1);
    });
  })
}, {
  key: 'soundcloud',
  name: 'SoundCloud',
  canPlay: patterns.canPlay.soundcloud,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(SoundCloud_1);
    });
  })
}, {
  key: 'vimeo',
  name: 'Vimeo',
  canPlay: patterns.canPlay.vimeo,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Vimeo_1);
    });
  })
}, {
  key: 'facebook',
  name: 'Facebook',
  canPlay: patterns.canPlay.facebook,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Facebook_1);
    });
  })
}, {
  key: 'streamable',
  name: 'Streamable',
  canPlay: patterns.canPlay.streamable,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Streamable_1);
    });
  })
}, {
  key: 'wistia',
  name: 'Wistia',
  canPlay: patterns.canPlay.wistia,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Wistia_1);
    });
  })
}, {
  key: 'twitch',
  name: 'Twitch',
  canPlay: patterns.canPlay.twitch,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Twitch_1);
    });
  })
}, {
  key: 'dailymotion',
  name: 'DailyMotion',
  canPlay: patterns.canPlay.dailymotion,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(DailyMotion_1);
    });
  })
}, {
  key: 'mixcloud',
  name: 'Mixcloud',
  canPlay: patterns.canPlay.mixcloud,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Mixcloud_1);
    });
  })
}, {
  key: 'vidyard',
  name: 'Vidyard',
  canPlay: patterns.canPlay.vidyard,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Vidyard_1);
    });
  })
}, {
  key: 'kaltura',
  name: 'Kaltura',
  canPlay: patterns.canPlay.kaltura,
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Kaltura_1);
    });
  })
}, {
  key: 'file',
  name: 'FilePlayer',
  canPlay: patterns.canPlay.file,
  canEnablePIP: function canEnablePIP(url) {
    return patterns.canPlay.file(url) && (document.pictureInPictureEnabled || (0, utils$1.supportsWebKitPresentationMode)()) && !patterns.AUDIO_EXTENSIONS.test(url);
  },
  lazyPlayer: /*#__PURE__*/(0, React.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(FilePlayer_1);
    });
  })
}];
exports["default"] = _default;
});

unwrapExports(players);

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var props = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var string = _propTypes["default"].string,
    bool = _propTypes["default"].bool,
    number = _propTypes["default"].number,
    array = _propTypes["default"].array,
    oneOfType = _propTypes["default"].oneOfType,
    shape = _propTypes["default"].shape,
    object = _propTypes["default"].object,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  stopOnUnmount: bool,
  light: oneOfType([bool, string]),
  playIcon: node,
  previewTabIndex: number,
  fallback: node,
  oEmbedUrl: string,
  wrapper: oneOfType([string, func, shape({
    render: func.isRequired
  })]),
  config: shape({
    soundcloud: shape({
      options: object
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      onUnstarted: func
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string,
      attributes: object
    }),
    dailymotion: shape({
      params: object
    }),
    vimeo: shape({
      playerOptions: object,
      title: string
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      forceFLV: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string,
      flvVersion: string
    }),
    wistia: shape({
      options: object,
      playerId: string,
      customControls: array
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    }),
    vidyard: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onPlaybackRateChange: func,
  onProgress: func,
  onClickPreview: func,
  onEnablePIP: func,
  onDisablePIP: func
};
exports.propTypes = propTypes;

var noop = function noop() {};

var defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  stopOnUnmount: true,
  light: false,
  fallback: null,
  wrapper: 'div',
  previewTabIndex: 0,
  oEmbedUrl: 'https://noembed.com/embed?url={url}',
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: noop
    },
    facebook: {
      appId: '1309697205772819',
      version: 'v3.3',
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      }
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      title: null
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      forceFLV: false,
      hlsOptions: {},
      hlsVersion: '1.1.4',
      dashVersion: '3.1.3',
      flvVersion: '1.5.0'
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: noop,
  onStart: noop,
  onPlay: noop,
  onPause: noop,
  onBuffer: noop,
  onBufferEnd: noop,
  onEnded: noop,
  onError: noop,
  onDuration: noop,
  onSeek: noop,
  onPlaybackRateChange: noop,
  onProgress: noop,
  onClickPreview: noop,
  onEnablePIP: noop,
  onDisablePIP: noop
};
exports.defaultProps = defaultProps;
});

unwrapExports(props);
var props_1 = props.defaultProps;
var props_2 = props.propTypes;

var Player_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);

var _reactFastCompare = _interopRequireDefault(reactFastCompare);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = /*#__PURE__*/function (_Component) {
  _inherits(Player, _Component);

  var _super = _createSuper(Player);

  function Player() {
    var _this;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "isReady", false);

    _defineProperty(_assertThisInitialized(_this), "isPlaying", false);

    _defineProperty(_assertThisInitialized(_this), "isLoading", true);

    _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);

    _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);

    _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);

    _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);

    _defineProperty(_assertThisInitialized(_this), "handlePlayerMount", function (player) {
      _this.player = player;

      _this.player.load(_this.props.url);

      _this.progress();
    });

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    });

    _defineProperty(_assertThisInitialized(_this), "progress", function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;

        var loadedSeconds = _this.getSecondsLoaded();

        var duration = _this.getDuration();

        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };

          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          } // Only call onProgress if values have changed


          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }

          _this.prevPlayed = progress.playedSeconds;
          _this.prevLoaded = progress.loadedSeconds;
        }
      }

      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;
      onReady();

      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }

      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);

        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate && playbackRate !== 1) {
          _this.player.setPlaybackRate(playbackRate);
        }

        onStart();
        _this.startOnPlay = false;
      }

      onPlay();

      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);

        _this.seekOnPlay = null;
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
      _this.isPlaying = false;

      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }

      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
      var _this$props4;

      _this.isLoading = false;

      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
      clearTimeout(_this.durationCheckTimeout);

      var duration = _this.getDuration();

      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);

          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    });

    return _this;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);

      if (this.isReady && this.props.stopOnUnmount) {
        this.player.stop();

        if (this.player.disablePIP) {
          this.player.disablePIP();
        }
      }

      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // If there isn’t a player available, don’t do anything
      if (!this.player) {
        return;
      } // Invoke player methods based on changed props


      var _this$props5 = this.props,
          url = _this$props5.url,
          playing = _this$props5.playing,
          volume = _this$props5.volume,
          muted = _this$props5.muted,
          playbackRate = _this$props5.playbackRate,
          pip = _this$props5.pip,
          loop = _this$props5.loop,
          activePlayer = _this$props5.activePlayer,
          disableDeferredLoading = _this$props5.disableDeferredLoading;

      if (!(0, _reactFastCompare["default"])(prevProps.url, url)) {
        if (this.isLoading && !activePlayer.forceLoad && !disableDeferredLoading && !(0, utils$1.isMediaStream)(url)) {
          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
          this.loadOnReady = url;
          return;
        }

        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(url, this.isReady);
      }

      if (!prevProps.playing && playing && !this.isPlaying) {
        this.player.play();
      }

      if (prevProps.playing && !playing && this.isPlaying) {
        this.player.pause();
      }

      if (!prevProps.pip && pip && this.player.enablePIP) {
        this.player.enablePIP();
      }

      if (prevProps.pip && !pip && this.player.disablePIP) {
        this.player.disablePIP();
      }

      if (prevProps.volume !== volume && volume !== null) {
        this.player.setVolume(volume);
      }

      if (prevProps.muted !== muted) {
        if (muted) {
          this.player.mute();
        } else {
          this.player.unmute();

          if (volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(volume);
            });
          }
        }
      }

      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(playbackRate);
      }

      if (prevProps.loop !== loop && this.player.setLoop) {
        this.player.setLoop(loop);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount, type) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady) {
        if (amount !== 0) {
          this.seekOnPlay = amount;
          setTimeout(function () {
            _this3.seekOnPlay = null;
          }, SEEK_ON_PLAY_EXPIRY);
        }

        return;
      }

      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';

      if (isFraction) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();

        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }

        this.player.seekTo(duration * amount);
        return;
      }

      this.player.seekTo(amount);
    }
  }, {
    key: "render",
    value: function render() {
      var Player = this.props.activePlayer;

      if (!Player) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, this.props, {
        onMount: this.handlePlayerMount,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }));
    }
  }]);

  return Player;
}(_react.Component);

exports["default"] = Player;

_defineProperty(Player, "displayName", 'Player');

_defineProperty(Player, "propTypes", props.propTypes);

_defineProperty(Player, "defaultProps", props.defaultProps);
});

unwrapExports(Player_1);

var Preview_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ICON_SIZE = '64px';
var cache = {};

var Preview = /*#__PURE__*/function (_Component) {
  _inherits(Preview, _Component);

  var _super = _createSuper(Preview);

  function Preview() {
    var _this;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      image: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        _this.props.onClick();
      }
    });

    return _this;
  }

  _createClass(Preview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchImage(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          url = _this$props.url,
          light = _this$props.light;

      if (prevProps.url !== url || prevProps.light !== light) {
        this.fetchImage(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "fetchImage",
    value: function fetchImage(_ref) {
      var _this2 = this;

      var url = _ref.url,
          light = _ref.light,
          oEmbedUrl = _ref.oEmbedUrl;

      if (typeof light === 'string') {
        this.setState({
          image: light
        });
        return;
      }

      if (cache[url]) {
        this.setState({
          image: cache[url]
        });
        return;
      }

      this.setState({
        image: null
      });
      return window.fetch(oEmbedUrl.replace('{url}', url)).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url && _this2.mounted) {
          var image = data.thumbnail_url.replace('height=100', 'height=480');

          _this2.setState({
            image: image
          });

          cache[url] = image;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          playIcon = _this$props2.playIcon,
          previewTabIndex = _this$props2.previewTabIndex;
      var image = this.state.image;
      var flexCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
      var styles = {
        preview: _objectSpread({
          width: '100%',
          height: '100%',
          backgroundImage: image ? "url(".concat(image, ")") : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer'
        }, flexCenter),
        shadow: _objectSpread({
          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE
        }, flexCenter),
        playIcon: {
          borderStyle: 'solid',
          borderWidth: '16px 0 16px 26px',
          borderColor: 'transparent transparent transparent white',
          marginLeft: '7px'
        }
      };

      var defaultPlayIcon = /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.shadow,
        className: "react-player__shadow"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.playIcon,
        className: "react-player__play-icon"
      }));

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.preview,
        className: "react-player__preview",
        onClick: onClick,
        tabIndex: previewTabIndex,
        onKeyPress: this.handleKeyPress
      }, playIcon || defaultPlayIcon);
    }
  }]);

  return Preview;
}(_react.Component);

exports["default"] = Preview;
});

unwrapExports(Preview_1);

var ReactPlayer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReactPlayer = void 0;

var _react = _interopRequireWildcard(React);

var _deepmerge = _interopRequireDefault(cjs);

var _memoizeOne = _interopRequireDefault(memoizeOne);

var _reactFastCompare = _interopRequireDefault(reactFastCompare);





var _Player3 = _interopRequireDefault(Player_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Preview = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(Preview_1);
  });
});
var IS_BROWSER = typeof window !== 'undefined' && window.document;
var IS_GLOBAL = typeof commonjsGlobal !== 'undefined' && commonjsGlobal.window && commonjsGlobal.window.document;
var SUPPORTED_PROPS = Object.keys(props.propTypes); // Return null when rendering on the server
// as Suspense is not supported yet

var UniversalSuspense = IS_BROWSER || IS_GLOBAL ? _react.Suspense : function () {
  return null;
};
var customPlayers = [];

var createReactPlayer = function createReactPlayer(players, fallback) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(ReactPlayer, _Component);

    var _super = _createSuper(ReactPlayer);

    function ReactPlayer() {
      var _this;

      _classCallCheck(this, ReactPlayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        showPreview: !!_this.props.light
      });

      _defineProperty(_assertThisInitialized(_this), "references", {
        wrapper: function wrapper(_wrapper) {
          _this.wrapper = _wrapper;
        },
        player: function player(_player) {
          _this.player = _player;
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function (e) {
        _this.setState({
          showPreview: false
        });

        _this.props.onClickPreview(e);
      });

      _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
        _this.setState({
          showPreview: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      });

      _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      });

      _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      });

      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      });

      _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
        if (!_this.player) return null;

        _this.player.seekTo(fraction, type);
      });

      _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
        _this.props.onReady(_assertThisInitialized(_this));
      });

      _defineProperty(_assertThisInitialized(_this), "getActivePlayer", (0, _memoizeOne["default"])(function (url) {
        for (var _i = 0, _arr = [].concat(customPlayers, _toConsumableArray(players)); _i < _arr.length; _i++) {
          var player = _arr[_i];

          if (player.canPlay(url)) {
            return player;
          }
        }

        if (fallback) {
          return fallback;
        }

        return null;
      }));

      _defineProperty(_assertThisInitialized(_this), "getConfig", (0, _memoizeOne["default"])(function (url, key) {
        var config = _this.props.config;
        return _deepmerge["default"].all([props.defaultProps.config, props.defaultProps.config[key] || {}, config, config[key] || {}]);
      }));

      _defineProperty(_assertThisInitialized(_this), "getAttributes", (0, _memoizeOne["default"])(function (url) {
        return (0, utils$1.omit)(_this.props, SUPPORTED_PROPS);
      }));

      _defineProperty(_assertThisInitialized(_this), "renderActivePlayer", function (url) {
        if (!url) return null;

        var player = _this.getActivePlayer(url);

        if (!player) return null;

        var config = _this.getConfig(url, player.key);

        return /*#__PURE__*/_react["default"].createElement(_Player3["default"], _extends({}, _this.props, {
          key: player.key,
          ref: _this.references.player,
          config: config,
          activePlayer: player.lazyPlayer || player,
          onReady: _this.handleReady
        }));
      });

      return _this;
    }

    _createClass(ReactPlayer, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !(0, _reactFastCompare["default"])(this.props, nextProps) || !(0, _reactFastCompare["default"])(this.state, nextState);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var light = this.props.light;

        if (!prevProps.light && light) {
          this.setState({
            showPreview: true
          });
        }

        if (prevProps.light && !light) {
          this.setState({
            showPreview: false
          });
        }
      }
    }, {
      key: "renderPreview",
      value: function renderPreview(url) {
        if (!url) return null;
        var _this$props = this.props,
            light = _this$props.light,
            playIcon = _this$props.playIcon,
            previewTabIndex = _this$props.previewTabIndex,
            oEmbedUrl = _this$props.oEmbedUrl;
        return /*#__PURE__*/_react["default"].createElement(Preview, {
          url: url,
          light: light,
          playIcon: playIcon,
          previewTabIndex: previewTabIndex,
          oEmbedUrl: oEmbedUrl,
          onClick: this.handleClickPreview
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            url = _this$props2.url,
            style = _this$props2.style,
            width = _this$props2.width,
            height = _this$props2.height,
            fallback = _this$props2.fallback,
            Wrapper = _this$props2.wrapper;
        var showPreview = this.state.showPreview;
        var attributes = this.getAttributes(url);
        return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
          ref: this.references.wrapper,
          style: _objectSpread(_objectSpread({}, style), {}, {
            width: width,
            height: height
          })
        }, attributes), /*#__PURE__*/_react["default"].createElement(UniversalSuspense, {
          fallback: fallback
        }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)));
      }
    }]);

    return ReactPlayer;
  }(_react.Component), _defineProperty(_class, "displayName", 'ReactPlayer'), _defineProperty(_class, "propTypes", props.propTypes), _defineProperty(_class, "defaultProps", props.defaultProps), _defineProperty(_class, "addCustomPlayer", function (player) {
    customPlayers.push(player);
  }), _defineProperty(_class, "removeCustomPlayers", function () {
    customPlayers.length = 0;
  }), _defineProperty(_class, "canPlay", function (url) {
    for (var _i2 = 0, _arr2 = [].concat(customPlayers, _toConsumableArray(players)); _i2 < _arr2.length; _i2++) {
      var _Player = _arr2[_i2];

      if (_Player.canPlay(url)) {
        return true;
      }
    }

    return false;
  }), _defineProperty(_class, "canEnablePIP", function (url) {
    for (var _i3 = 0, _arr3 = [].concat(customPlayers, _toConsumableArray(players)); _i3 < _arr3.length; _i3++) {
      var _Player2 = _arr3[_i3];

      if (_Player2.canEnablePIP && _Player2.canEnablePIP(url)) {
        return true;
      }
    }

    return false;
  }), _temp;
};

exports.createReactPlayer = createReactPlayer;
});

unwrapExports(ReactPlayer);
var ReactPlayer_1 = ReactPlayer.createReactPlayer;

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _players = _interopRequireDefault(players);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Fall back to FilePlayer if nothing else can play the URL
var fallback = _players["default"][_players["default"].length - 1];

var _default = (0, ReactPlayer.createReactPlayer)(_players["default"], fallback);

exports["default"] = _default;
});

var ReactPlayer$1 = unwrapExports(lib);

var css$2 = ".carousel-headline {\n  padding-bottom: 2.5rem;\n}\n.carousel-headline__divider {\n  position: \"relative\";\n  height: 0.25rem;\n  background: #0f0900;\n  margin-bottom: 1.75rem;\n}\n.carousel-headline__video {\n  margin-top: 0.75rem !important;\n}\n.carousel-headline__text {\n  width: 100%;\n  margin-top: 0.75rem !important;\n  font-weight: 500 !important;\n}\n@media (min-width: 800px) {\n  .carousel-headline__text {\n    max-width: 80%;\n  }\n}";
n(css$2,{});

/* eslint-disable react/jsx-key */
var CarouselHeadlineComponent = function (props) {
    var children = props.children, _a = props.href, href = _a === void 0 ? '#' : _a, _b = props.text, text = _b === void 0 ? '' : _b, _c = props.link, link = _c === void 0 ? true : _c, assets = props.assets;
    var lang = LanguageService.getCurrentStrapiLanguage();
    function createMarkup(richText) {
        return { __html: richText };
    }
    var getTextClassVariant = function () {
        return lang === 'de-LS' ? 'text-card__rich-text__leichte-sprache' : '';
    };
    return (React.createElement("div", { className: 'carousel-headline' },
        React.createElement("div", { className: 'carousel-headline__divider' }),
        React.createElement(Typography$1, { variant: 'h3', component: 'h4', className: 'carousel-headline__header' },
            link && (React.createElement(Link$1, { color: "inherit", href: href }, children)),
            !link && children),
        !(assets === null || assets === void 0 ? void 0 : assets.length) && text && (React.createElement(Typography$1, { className: "carousel-headline__text " + getTextClassVariant(), variant: 'body2', component: 'div', dangerouslySetInnerHTML: createMarkup(text) })),
        assets && assets.length > 0 && (React.createElement("div", { className: "video-card__video-conatiner carousel-headline__video" }, assets.map(function (asset, index) {
            return (React.createElement(ReactPlayer$1, { key: "video-search-buttons-block-" + index, className: 'video-card__player', url: asset.url, controls: true }));
        })))));
};
var CarouselHeadline = CarouselHeadlineComponent;

function FooterGrid(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: className },
        React.createElement(Grid$1, { container: true, spacing: 0, direction: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }, children.map(function (child, index) { return (React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 3, lg: 3, key: index }, child)); }))));
}

var fallbackFont = 'Arial';
var palette = {
    primary: {
        main: '#0F0900',
        light: '#c2c2ba',
        dark: '#666',
        contrastText: '#ffffff',
    },
    secondary: {
        main: '#c2c2ba',
        light: '#ffffff',
        dark: '#6f7045',
        contrastText: '#0F0900',
    },
    text: {
        primary: '#22201E',
        secondary: '#0F0900',
        hint: '#f9ff04',
        disabled: '#666666',
    },
};
var CommonTheme = createTheme({
    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },
    palette: palette,
    typography: {
        fontFamily: "ClanOTNarrow-News, " + fallbackFont,
        // H1 Highlight
        h1: {
            fontFamily: "GTWalsheimPro-Black, " + fallbackFont,
            fontSize: '2.5rem',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '3.25rem',
            letterSpacing: '0.0675em',
            color: 'inherit',
        },
        // H2
        h2: {
            fontFamily: "GTWalsheimPro-Black, " + fallbackFont,
            fontSize: '2.25rem',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '2.625rem',
            letterSpacing: '0.0625em',
            color: 'inherit',
        },
        // H3 Button Text
        h3: {
            fontFamily: "GTWalsheimPro-Bold, " + fallbackFont,
            fontSize: '1.75rem',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '2.25rem',
            letterSpacing: '0.065em',
            color: 'inherit',
        },
        // H4
        h4: {
            fontFamily: "GTWalsheimPro-Bold, " + fallbackFont,
            fontSize: '1.5rem',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.75rem',
            letterSpacing: '0.065em',
            color: 'inherit',
        },
        // H5
        h5: {
            fontFamily: "ClanOTNarrow, " + fallbackFont,
            fontSize: '1.3125rem',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '2rem',
            letterSpacing: '0.07875em',
            color: 'inherit',
        },
        h6: {
            fontFamily: "GTWalsheimPro-Bold, " + fallbackFont,
            fontSize: '1.125rem',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.625rem',
            letterSpacing: '0.07875em',
        },
        subtitle1: {
            fontFamily: "GTWalsheimPro-Bold, " + fallbackFont,
            fontSize: '1.125rem',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.625rem',
            letterSpacing: '1px',
        },
        // Description
        body1: {
            fontFamily: "ClanOTNarrow, " + fallbackFont,
            fontSize: '1.125rem',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.875rem',
            letterSpacing: '0.075em',
            color: 'inherit',
        },
        body2: {
            fontFamily: "ClanOTNarrow, " + fallbackFont,
            fontSize: '1.125rem',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.875rem',
            letterSpacing: '0.071875em',
            color: 'inherit',
        },
        caption: {
            fontFamily: "ClanOTNarrow, " + fallbackFont,
            fontSize: '1rem',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.25rem',
            letterSpacing: '0.07875em',
            color: 'inherit',
        },
        overline: {
            fontFamily: "ClanOTNarrow, " + fallbackFont,
            fontSize: '1rem',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.25rem',
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: 'inherit',
        },
    },
    transitions: {
        duration: {
            complex: 750,
        },
    },
});
var globalFocusVisibleOverride = {
    '&:focus-visible': {
        outline: "4px solid",
    },
};
CommonTheme.overrides = __assign(__assign({}, CommonTheme.overrides), { MuiFormControlLabel: {
        root: __assign({}, globalFocusVisibleOverride),
    }, MuiLinearProgress: {
        determinate: {
            backgroundColor: '#666666',
            opacity: 0.6,
        },
        barColorPrimary: {
            backgroundColor: '#f9ff04',
            opacity: 1,
        },
    }, MuiButton: {
        root: {
            color: CommonTheme.palette.secondary.contrastText,
            '&:hover': {
                backgroundColor: 'transparent',
            },
            '&:focus-visible': {
                outline: '4px solid',
            },
        },
    }, MuiSwitch: {
        root: __assign({}, globalFocusVisibleOverride),
    }, MuiSelect: {
        root: {
            '&:hover': {},
        },
    }, MuiInputBase: {
        root: {
            color: palette.secondary.contrastText,
        },
    }, MuiCheckbox: {
        root: {
            '&:hover': {
                backgroundColor: 'transparent',
            },
            '&:focus-visible': {
                outline: '4px solid',
            },
        },
    }, MuiIconButton: {
        root: {
            fontSize: '1rem',
            '&:hover': {
                backgroundColor: 'transparent',
                '& svg': {
                    color: palette.secondary.main,
                },
            },
            '&:focus-visible': {
                outline: '4px solid',
            },
        },
    }, 
    // Link Text
    MuiLink: {
        button: {
            fontFamily: 'ClanOTNarrow-Medium',
            fontSize: '0.875rem',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: '2px',
            color: 'inherit',
            '&:hover': {
                backgroundColor: 'transparent',
                '& a svg': {
                    color: 'white',
                },
            },
            '&:focus-visible': {
                outline: '4px solid',
            },
        },
        root: {
            fontWeight: 'bold',
            '&:focus-visible': {
                outline: '4px solid',
            },
        },
    }, MuiBackdrop: {
        root: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
    }, MuiAccordionSummary: {
        root: {
            padding: 0,
            color: palette.secondary.contrastText,
            '&:hover': {
                textTransform: 'underline',
            },
        },
    }, MuiAccordionDetails: {
        root: {
            padding: 0,
        },
    }, MuiPaper: {
        root: __assign(__assign({}, globalFocusVisibleOverride), { color: palette.secondary.contrastText }),
    }, MuiDialogTitle: {
        root: {
            backgroundColor: palette.secondary.main,
            color: palette.secondary.contrastText,
        },
    }, MuiDialogContent: {
        root: {
            backgroundColor: palette.secondary.main,
            color: palette.secondary.contrastText,
        },
    }, MuiDialogActions: {
        root: {
            backgroundColor: palette.secondary.main,
            color: palette.secondary.contrastText,
        },
    } });

var icon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22195%22%20height%3D%22191%22%20viewBox%3D%220%200%20195%20191%22%3E%20%20%3Cg%20fill%3D%22%23FFF%22%3E%20%20%20%20%3Cpath%20d%3D%22M185.818%2C0.161%20L128.778%2C0.161%20C123.807%2C0.161%20119.778%2C4.19%20119.778%2C9.161%20C119.778%2C14.132%20123.807%2C18.161%20128.778%2C18.161%20L164.09%2C18.161%20L77.79%2C104.461%20C74.275%2C107.976%2074.275%2C113.674%2077.79%2C117.189%20C79.548%2C118.946%2081.851%2C119.825%2084.154%2C119.825%20C86.457%2C119.825%2088.76%2C118.946%2090.518%2C117.189%20L176.818%2C30.889%20L176.818%2C66.202%20C176.818%2C71.173%20180.847%2C75.202%20185.818%2C75.202%20C190.789%2C75.202%20194.818%2C71.173%20194.818%2C66.202%20L194.818%2C9.162%20C194.818%2C4.19%20190.789%2C0.161%20185.818%2C0.161%20Z%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M149%2C75.201%20C144.029%2C75.201%20140%2C79.23%20140%2C84.201%20L140%2C172.657%20L18%2C172.657%20L18%2C50.657%20L111.778%2C50.657%20C116.749%2C50.657%20120.778%2C46.628%20120.778%2C41.657%20C120.778%2C36.686%20116.749%2C32.657%20111.778%2C32.657%20L9%2C32.657%20C4.029%2C32.657%200%2C36.686%200%2C41.657%20L0%2C181.657%20C0%2C186.628%204.029%2C190.657%209%2C190.657%20L149%2C190.657%20C153.971%2C190.657%20158%2C186.628%20158%2C181.657%20L158%2C84.201%20C158%2C79.23%20153.971%2C75.201%20149%2C75.201%20Z%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var useStyles$5 = makeStyles(function (theme) {
    var _a;
    return createStyles({
        sectionWrapper: (_a = {
                background: '#0F0900',
                paddingBottom: '3.75rem',
                paddingLeft: '1rem',
                paddingRight: '1rem'
            },
            _a[theme.breakpoints.up(500)] = {
                paddingLeft: '1.5rem',
                paddingRight: '1.5rem',
            },
            _a[theme.breakpoints.up(678)] = {
                paddingLeft: '2rem',
                paddingRight: '2rem',
            },
            _a[theme.breakpoints.up(1024)] = {
                paddingLeft: '3rem',
                paddingRight: '3rem',
            },
            _a[theme.breakpoints.up('lg')] = {
                paddingLeft: '4rem',
                paddingRight: '4rem',
            },
            _a),
        footerGrid: {
            paddingTop: '3rem',
            paddingBottom: '3rem',
        },
        link: {
            marginBottom: '1rem',
        },
        linkExternal: {
            marginBottom: '1rem',
            position: 'relative',
            '& span': {
                background: "url(" + icon + ") no-repeat right",
                backgroundSize: '0.875rem',
                paddingRight: '1.5rem',
            },
        },
        footerCard: {
            display: 'inline-grid',
            border: 'none',
            borderRadius: 0,
            boxShadow: 'none',
            backgroundColor: 'transparent',
            margin: '0 auto',
            padding: '0.75rem 0',
            color: theme.palette.primary.contrastText,
        },
        maxWidth: {
            width: '100%',
            maxWidth: 1280,
            margin: '0 auto',
        },
    });
});

var css$3 = "@media (min-width: 500px) {\n  .footer__copyright {\n    text-align: right;\n  }\n}";
n(css$3,{});

// Query all categories.
var FetchSiteConfig = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query fetchSiteConfig($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbSiteConfig(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            localizations(publicationState: LIVE) {\n              data {\n                attributes {\n                  locale\n                  legalPages {\n                    ... on ComponentComponentsLegalPages {\n                      slug\n                    }\n                  }\n                }\n              }\n            }\n            headerMenuItems {\n              headline\n              subHeadline\n              href\n              id\n              type\n            }\n            contactTextBlock {\n              headline\n              linkText\n              linkUrl\n              subHeadline\n              text\n            }\n            contactVideoBlock {\n              subHeadline\n              linkUrl\n              linkText\n              headline\n              assets {\n                data {\n                  attributes {\n                    alternativeText\n                    caption\n                    url\n                  }\n                }\n              }\n            }\n            copyright\n            legalPages {\n              ... on ComponentComponentsLegalPages {\n                header\n                slug\n                footerLink\n                matomo\n                block {\n                  id\n                  text\n                  assets {\n                    data {\n                      attributes {\n                        url\n                        alternativeText\n                      }\n                    }\n                  }\n                  videoAssets {\n                    data {\n                      attributes {\n                        alternativeText\n                        url\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query fetchSiteConfig($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbSiteConfig(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            localizations(publicationState: LIVE) {\n              data {\n                attributes {\n                  locale\n                  legalPages {\n                    ... on ComponentComponentsLegalPages {\n                      slug\n                    }\n                  }\n                }\n              }\n            }\n            headerMenuItems {\n              headline\n              subHeadline\n              href\n              id\n              type\n            }\n            contactTextBlock {\n              headline\n              linkText\n              linkUrl\n              subHeadline\n              text\n            }\n            contactVideoBlock {\n              subHeadline\n              linkUrl\n              linkText\n              headline\n              assets {\n                data {\n                  attributes {\n                    alternativeText\n                    caption\n                    url\n                  }\n                }\n              }\n            }\n            copyright\n            legalPages {\n              ... on ComponentComponentsLegalPages {\n                header\n                slug\n                footerLink\n                matomo\n                block {\n                  id\n                  text\n                  assets {\n                    data {\n                      attributes {\n                        url\n                        alternativeText\n                      }\n                    }\n                  }\n                  videoAssets {\n                    data {\n                      attributes {\n                        alternativeText\n                        url\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
var FetchGuidePage = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query FetchGuidePage($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbGuidepage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            fallbackHeader\n            fallbackText\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query FetchGuidePage($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbGuidepage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            fallbackHeader\n            fallbackText\n          }\n        }\n      }\n    }\n  }\n"])));
var FetchTopicPage = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  query FetchTopicPage($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbTopicspage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            heroFallbackHeader\n            heroFallbackText\n            heroFallbackAsset {\n              data {\n                attributes {\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query FetchTopicPage($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbTopicspage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            heroFallbackHeader\n            heroFallbackText\n            heroFallbackAsset {\n              data {\n                attributes {\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
var SiteConfigRepository = /** @class */ (function () {
    function SiteConfigRepository() {
    }
    SiteConfigRepository.prototype.fetchSiteConfig = function (lang) {
        var _a, _b, _c, _d;
        var _e = useQuery(FetchSiteConfig, {
            variables: {
                lang: lang,
            },
        }), loading = _e.loading, error = _e.error, data = _e.data;
        var resultData = null;
        if (!loading &&
            data &&
            data.strapi_smb && ((_b = (_a = data.strapi_smb.smbSiteConfig) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.attributes)) {
            resultData = (_d = (_c = data.strapi_smb.smbSiteConfig) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.attributes;
        }
        return { loading: loading, error: error, data: resultData };
    };
    SiteConfigRepository.prototype.fetchGuidePage = function (lang) {
        var _a, _b;
        var _c = useQuery(FetchGuidePage, {
            variables: {
                lang: lang,
            },
        }), loading = _c.loading, error = _c.error, data = _c.data;
        var resultData = null;
        if (!loading && data && !error) {
            resultData = (_b = (_a = data === null || data === void 0 ? void 0 : data.strapi_smb) === null || _a === void 0 ? void 0 : _a.smbGuidepage) === null || _b === void 0 ? void 0 : _b.data;
        }
        return { loading: loading, error: error, data: resultData };
    };
    SiteConfigRepository.prototype.fetchTopicPage = function (lang) {
        var _a, _b;
        var _c = useQuery(FetchTopicPage, {
            variables: {
                lang: lang,
            },
        }), loading = _c.loading, error = _c.error, data = _c.data;
        var resultData = null;
        if (!loading && data && !error) {
            resultData = (_b = (_a = data === null || data === void 0 ? void 0 : data.strapi_smb) === null || _a === void 0 ? void 0 : _a.smbTopicspage) === null || _b === void 0 ? void 0 : _b.data;
        }
        return { loading: loading, error: error, data: resultData };
    };
    return SiteConfigRepository;
}());
var templateObject_1, templateObject_2, templateObject_3;

var Observable_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver =
/*#__PURE__*/
function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: "next",
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: "error",
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: "complete",
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable =
/*#__PURE__*/
function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: "subscribe",
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }

      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: "map",
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "reduce",
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;
      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "concat",
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);
      return new C(function (observer) {
        var subscription;
        var index = 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (index === sources.length) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources[index++]));
              }
            }
          });
        }

        startNext(_this5);
        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: "flatMap",
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });
            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: SymbolObservable,
    value: function () {
      return this;
    }
  }], [{
    key: "from",
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;
      if (x == null) throw new TypeError(x + ' is not an object');
      var method = getMethod(x, SymbolObservable);

      if (method) {
        var observable = method.call(x);
        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
        if (isObservable(observable) && observable.constructor === C) return observable;
        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, SymbolIterator);

        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _item = _step.value;
                  observer.next(_item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: "of",
    value: function of() {
      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }
  }, {
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}
});

unwrapExports(Observable_1);
var Observable_2 = Observable_1.Observable;

var zenObservable = Observable_1.Observable;

var Observable = zenObservable;

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    __extends(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
function wrapConsoleMethod(method) {
    return function () {
        return console[method].apply(console, arguments);
    };
}
(function (invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }

function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw process.env.NODE_ENV === "production" ? new InvariantError(2) : new InvariantError("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = (function (_super) {
    __extends(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
function isTerminating(link) {
    return link.request.length <= 1;
}
function fromError(errorValue) {
    return new Observable(function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? getOperationName(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = __assign({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = __assign({}, context, next(context));
        }
        else {
            context = __assign({}, context, next);
        }
    };
    var getContext = function () { return (__assign({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([operationName, query, variables]);
}

function passthrough(op, forward) {
    return forward ? forward(op) : Observable.of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function () { return Observable.of(); });
}
function from(links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || Observable.of()
                : rightLink.request(operation) || Observable.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || Observable.of()
                : rightLink.request(operation, forward) || Observable.of();
        });
    }
}
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) {
        process.env.NODE_ENV === "production" || invariant.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || Observable.of(); }) || Observable.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || Observable.of();
            }) || Observable.of());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw process.env.NODE_ENV === "production" ? new InvariantError(1) : new InvariantError('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());
function execute(link, operation) {
    return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || Observable.of());
}

var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.name = 'ServerParseError';
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined')
            library = 'node-fetch';
        throw process.env.NODE_ENV === "production" ? new InvariantError(1) : new InvariantError("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = __assign({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    configs.forEach(function (config) {
        options = __assign({}, options, config.options, { headers: __assign({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = __assign({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = print(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = process.env.NODE_ENV === "production" ? new InvariantError(2) : new InvariantError("Network request failed. " + label + " is not serializable: " + e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};

var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = __rest(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
    checkFetcher(fetcher);
    if (!fetcher) {
        fetcher = fetch;
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = __assign({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return fromError(parseError);
            }
        }
        return new Observable(function (observer) {
            fetcher(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(parseAndCheckHttpResponse(operation))
                .then(function (result) {
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                if (err.name === 'AbortError')
                    return;
                if (err.result && err.result.errors && err.result.data) {
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
var HttpLink = (function (_super) {
    __extends(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, createHttpLink(opts).request) || this;
    }
    return HttpLink;
}(ApolloLink));

var createGraphQlClient = function (config) {
    return new ApolloClient({
        link: new HttpLink({
            uri: config.GRAPHQL_ENDPOINT,
        }),
        cache: new InMemoryCache(),
    });
};
function useGraphQlClient() {
    var _a = useConfigLoader(), loadingConfig = _a.loadingConfig, config = _a.config;
    var _b = useState(), graphQlClient = _b[0], setGraphQlClient = _b[1];
    useEffect(function () {
        if (config) {
            setGraphQlClient(createGraphQlClient(config));
        }
    }, [config]);
    return {
        loading: loadingConfig,
        graphQlClient: graphQlClient,
    };
}

function getWindowDimensions() {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height
    };
}
function useWindowDimensions() {
    var _a = useState(getWindowDimensions()), windowDimensions = _a[0], setWindowDimensions = _a[1];
    useEffect(function () {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowDimensions;
}

var requirePromise = function requirePromise() {
	if (typeof Promise !== 'function') {
		throw new TypeError('`Promise.allSettled` requires a global `Promise` be available.');
	}
};

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;


var hasSymbols = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

var implementation = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation;

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$1 = hasSymbols();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$1 ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$1 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$1 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$1 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$1 ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols$1 ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace = functionBind.call(Function.call, String.prototype.replace);
var $strSlice = functionBind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind = createCommonjsModule(function (module) {




var $apply = getIntrinsic('%Function.prototype.apply%');
var $call = getIntrinsic('%Function.prototype.call%');
var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $gOPD = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = getIntrinsic('%Object.defineProperty%', true);
var $max = getIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(functionBind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});
var callBind_1 = callBind.apply;

var $resolve = getIntrinsic('%Promise.resolve%', true);
var $PromiseResolve = $resolve && callBind($resolve);

// https://262.ecma-international.org/9.0/#sec-promise-resolve

var PromiseResolve = function PromiseResolve(C, x) {
	if (!$PromiseResolve) {
		throw new SyntaxError('This environment does not support Promises.');
	}
	return $PromiseResolve(C, x);
};

// https://262.ecma-international.org/5.1/#sec-8

var Type = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

var Type$1 = function Type$1(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return Type(x);
};

var shams$1 = function hasToStringTagShams() {
	return shams() && !!Symbol.toStringTag;
};

var $indexOf = callBind(getIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = getIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var hasToStringTag = shams$1();


var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

var isArguments = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

var toString = {}.toString;

var isarray = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$1 = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag$1 = shams$1();

var isString = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag$1 ? tryStringObject(value) : toStr$1.call(value) === strClass;
};

var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Map) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` does not have a `has` method
		return false;
	};
}

var isMap = exported || function isMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x);
		if ($setHas) {
			try {
				$setHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Map; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};

var $Map$1 = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set$1 = typeof Set === 'function' && Set.prototype ? Set : null;

var exported$1;

if (!$Set$1) {
	// eslint-disable-next-line no-unused-vars
	exported$1 = function isSet(x) {
		// `Set` is not present in this environment.
		return false;
	};
}

var $mapHas$1 = $Map$1 ? Map.prototype.has : null;
var $setHas$1 = $Set$1 ? Set.prototype.has : null;
if (!exported$1 && !$setHas$1) {
	// eslint-disable-next-line no-unused-vars
	exported$1 = function isSet(x) {
		// `Set` does not have a `has` method
		return false;
	};
}

var isSet = exported$1 || function isSet(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$setHas$1.call(x);
		if ($mapHas$1) {
			try {
				$mapHas$1.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Set$1; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};

var esGetIterator = createCommonjsModule(function (module) {

/* eslint global-require: 0 */
// the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.



if (hasSymbols() || shams()) {
	var $iterator = Symbol.iterator;
	// Symbol is available natively or shammed
	// natively:
	//  - Chrome >= 38
	//  - Edge 12-14?, Edge >= 15 for sure
	//  - FF >= 36
	//  - Safari >= 9
	//  - node >= 0.12
	module.exports = function getIterator(iterable) {
		// alternatively, `iterable[$iterator]?.()`
		if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
			return iterable[$iterator]();
		}
		if (isArguments(iterable)) {
			// arguments objects lack Symbol.iterator
			// - node 0.12
			return Array.prototype[$iterator].call(iterable);
		}
	};
} else {
	// Symbol is not available, native or shammed
	var isArray = isarray;
	var isString$1 = isString;
	var GetIntrinsic = getIntrinsic;
	var $Map = GetIntrinsic('%Map%', true);
	var $Set = GetIntrinsic('%Set%', true);
	var callBound$1 = callBound;
	var $arrayPush = callBound$1('Array.prototype.push');
	var $charCodeAt = callBound$1('String.prototype.charCodeAt');
	var $stringSlice = callBound$1('String.prototype.slice');

	var advanceStringIndex = function advanceStringIndex(S, index) {
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	};

	var getArrayIterator = function getArrayIterator(arraylike) {
		var i = 0;
		return {
			next: function next() {
				var done = i >= arraylike.length;
				var value;
				if (!done) {
					value = arraylike[i];
					i += 1;
				}
				return {
					done: done,
					value: value
				};
			}
		};
	};

	var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
		if (isArray(iterable) || isArguments(iterable)) {
			return getArrayIterator(iterable);
		}
		if (isString$1(iterable)) {
			var i = 0;
			return {
				next: function next() {
					var nextIndex = advanceStringIndex(iterable, i);
					var value = $stringSlice(iterable, i, nextIndex);
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		}

		// es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
		if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
			return iterable['_es6-shim iterator_']();
		}
	};

	if (!$Map && !$Set) {
		// the only language iterables are Array, String, arguments
		// - Safari <= 6.0
		// - Chrome < 38
		// - node < 0.12
		// - FF < 13
		// - IE < 11
		// - Edge < 11

		module.exports = function getIterator(iterable) {
			if (iterable != null) {
				return getNonCollectionIterator(iterable, true);
			}
		};
	} else {
		// either Map or Set are available, but Symbol is not
		// - es6-shim on an ES5 browser
		// - Safari 6.2 (maybe 6.1?)
		// - FF v[13, 36)
		// - IE 11
		// - Edge 11
		// - Safari v[6, 9)

		var isMap$1 = isMap;
		var isSet$1 = isSet;

		// Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
		var $mapForEach = callBound$1('Map.prototype.forEach', true);
		var $setForEach = callBound$1('Set.prototype.forEach', true);
		if (typeof process === 'undefined' || !process.versions || !process.versions.node) { // "if is not node"

			// Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
			// returns a value, or throws a StopIteration object. These browsers
			// do not have any other mechanism for iteration.
			var $mapIterator = callBound$1('Map.prototype.iterator', true);
			var $setIterator = callBound$1('Set.prototype.iterator', true);
			var getStopIterationIterator = function (iterator) {
				var done = false;
				return {
					next: function next() {
						try {
							return {
								done: done,
								value: done ? undefined : iterator.next()
							};
						} catch (e) {
							done = true;
							return {
								done: true,
								value: undefined
							};
						}
					}
				};
			};
		}
		// Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
		// this returns a proper iterator object, so we should use it instead of forEach.
		// newer es6-shim versions use a string "_es6-shim iterator_" property.
		var $mapAtAtIterator = callBound$1('Map.prototype.@@iterator', true) || callBound$1('Map.prototype._es6-shim iterator_', true);
		var $setAtAtIterator = callBound$1('Set.prototype.@@iterator', true) || callBound$1('Set.prototype._es6-shim iterator_', true);

		var getCollectionIterator = function getCollectionIterator(iterable) {
			if (isMap$1(iterable)) {
				if ($mapIterator) {
					return getStopIterationIterator($mapIterator(iterable));
				}
				if ($mapAtAtIterator) {
					return $mapAtAtIterator(iterable);
				}
				if ($mapForEach) {
					var entries = [];
					$mapForEach(iterable, function (v, k) {
						$arrayPush(entries, [k, v]);
					});
					return getArrayIterator(entries);
				}
			}
			if (isSet$1(iterable)) {
				if ($setIterator) {
					return getStopIterationIterator($setIterator(iterable));
				}
				if ($setAtAtIterator) {
					return $setAtAtIterator(iterable);
				}
				if ($setForEach) {
					var values = [];
					$setForEach(iterable, function (v) {
						$arrayPush(values, v);
					});
					return getArrayIterator(values);
				}
			}
		};

		module.exports = function getIterator(iterable) {
			return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
		};
	}
}
});

var $TypeError$1 = TypeError;

// eslint-disable-next-line consistent-return
var iterateIterator = function iterateIterator(iterator) {
	if (!iterator || typeof iterator.next !== 'function') {
		throw new $TypeError$1('iterator must be an object with a `next` method');
	}
	if (arguments.length > 1) {
		var callback = arguments[1];
		if (typeof callback !== 'function') {
			throw new $TypeError$1('`callback`, if provided, must be a function');
		}
	}
	var values = callback || [];
	var result;
	while ((result = iterator.next()) && !result.done) {
		if (callback) {
			callback(result.value); // eslint-disable-line callback-return
		} else {
			values.push(result.value);
		}
	}
	if (!callback) {
		return values;
	}
};

var $TypeError$2 = TypeError;


var iterateValue = function iterateValue(iterable) {
	var iterator = esGetIterator(iterable);
	if (!iterator) {
		throw new $TypeError$2('non-iterable value provided');
	}
	if (arguments.length > 1) {
		return iterateIterator(iterator, arguments[1]);
	}
	return iterateIterator(iterator);
};

var toStr$2 = Object.prototype.toString;

var isArguments$1 = function isArguments(value) {
	var str = toStr$2.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr$2.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr$3 = Object.prototype.toString;
	var isArgs = isArguments$1; // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$3.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr$3.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation$1 = keysShim;

var slice$1 = Array.prototype.slice;


var origKeys = Object.keys;
var keysShim$1 = origKeys ? function keys(o) { return origKeys(o); } : implementation$1;

var originalKeys = Object.keys;

keysShim$1.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArguments$1(object)) {
					return originalKeys(slice$1.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim$1;
	}
	return Object.keys || keysShim$1;
};

var objectKeys = keysShim$1;

var hasSymbols$2 = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$4 = Object.prototype.toString;
var concat$1 = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr$4.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = objectKeys(map);
	if (hasSymbols$2) {
		props = concat$1.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var defineProperties_1 = defineProperties;

var $TypeError$3 = getIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

var CheckObjectCoercible = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError$3(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};

var RequireObjectCoercible = CheckObjectCoercible;

var $abs = getIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

var abs = function abs(x) {
	return $abs(x);
};

// var modulo = require('./modulo');
var $floor = Math.floor;

// http://262.ecma-international.org/5.1/#sec-5.2

var floor = function floor(x) {
	// return x - modulo(x, 1);
	return $floor(x);
};

var _isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};

var $isNaN = Number.isNaN || function (a) { return a !== a; };

var _isFinite = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };

// https://tc39.es/ecma262/#sec-isintegralnumber

var IsIntegralNumber = function IsIntegralNumber(argument) {
	if (Type$1(argument) !== 'Number' || _isNaN(argument) || !_isFinite(argument)) {
		return false;
	}
	var absValue = abs(argument);
	return floor(absValue) === absValue;
};

var $ArrayPrototype = getIntrinsic('%Array.prototype%');
var $RangeError = getIntrinsic('%RangeError%');
var $SyntaxError$1 = getIntrinsic('%SyntaxError%');
var $TypeError$4 = getIntrinsic('%TypeError%');



var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var $setProto = getIntrinsic('%Object.setPrototypeOf%', true) || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayPrototype
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
);

// https://www.ecma-international.org/ecma-262/12.0/#sec-arraycreate

var ArrayCreate = function ArrayCreate(length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError$4('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new $RangeError('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 3, 5
	if (proto !== $ArrayPrototype) { // step 4
		if (!$setProto) {
			throw new $SyntaxError$1('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 6
		A.length = length;
	}
	/* step 6, the above as a shortcut for the below
	OrdinaryDefineOwnProperty(A, 'length', {
		'[[Configurable]]': false,
		'[[Enumerable]]': false,
		'[[Value]]': length,
		'[[Writable]]': true
	});
	*/
	return A;
};

var isBuffer = function isBuffer(arg) {
  return arg instanceof Buffer;
};

var inherits_browser = createCommonjsModule(function (module) {
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}
});

var inherits = createCommonjsModule(function (module) {
try {
  var util$1 = util;
  if (typeof util$1.inherits !== 'function') throw '';
  module.exports = util$1.inherits;
} catch (e) {
  module.exports = inherits_browser;
}
});

var util = createCommonjsModule(function (module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var length = output.reduce(function(prev, cur) {
    if (cur.indexOf('\n') >= 0) ;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = inherits;

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
};

exports.promisify.custom = kCustomPromisifiedSymbol;

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret); },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb); });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;
});
var util_1 = util.format;
var util_2 = util.deprecate;
var util_3 = util.debuglog;
var util_4 = util.inspect;
var util_5 = util.isArray;
var util_6 = util.isBoolean;
var util_7 = util.isNull;
var util_8 = util.isNullOrUndefined;
var util_9 = util.isNumber;
var util_10 = util.isString;
var util_11 = util.isSymbol;
var util_12 = util.isUndefined;
var util_13 = util.isRegExp;
var util_14 = util.isObject;
var util_15 = util.isDate;
var util_16 = util.isError;
var util_17 = util.isFunction;
var util_18 = util.isPrimitive;
var util_19 = util.isBuffer;
var util_20 = util.log;
var util_21 = util.inherits;
var util_22 = util._extend;
var util_23 = util.promisify;
var util_24 = util.callbackify;

var util_inspect = util.inspect;

var hasMap$1 = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap$1 ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap$1 && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap$1 && Map.prototype.forEach;
var hasSet$1 = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet$1 ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet$1 && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet$1 && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace$1 = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat$1 = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor$1 = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable$1 = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor$1(-num) : $floor$1(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace$1.call(intStr, sepRegex, '$&_') + '.' + $replace$1.call($replace$1.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace$1.call(str, sepRegex, '$&_');
}

var inspectCustom = util_inspect.custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$1(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$1(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$1(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$1(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$1(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$1(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace$1.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if ('cause' in obj && !isEnumerable$1.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat$1.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap$1(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet$1(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString$1(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr$5(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat$1.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace$1.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr$5(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr$5(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr$5(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr$5(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString$1(obj) { return toStr$5(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr$5(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr$5(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$1(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr$5(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap$1(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet$1(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace$1.call($replace$1.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$1(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$1(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable$1.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

// https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

var IsPropertyKey = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};

var $TypeError$5 = getIntrinsic('%TypeError%');






// https://ecma-international.org/ecma-262/6.0/#sec-get-o-p

var Get = function Get(O, P) {
	// 7.3.1.1
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$5('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError$5('Assertion failed: IsPropertyKey(P) is not true, got ' + objectInspect(P));
	}
	// 7.3.1.3
	return O[P];
};

var $Array = getIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr$6 = !$Array.isArray && callBound('Object.prototype.toString');

// https://ecma-international.org/ecma-262/6.0/#sec-isarray

var IsArray = $Array.isArray || function IsArray(argument) {
	return toStr$6(argument) === '[object Array]';
};

// TODO: remove, semver-major

var GetIntrinsic = getIntrinsic;

var $TypeError$6 = getIntrinsic('%TypeError%');

var isPropertyDescriptor = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

	for (var key in Desc) { // eslint-disable-line no-restricted-syntax
		if (src(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError$6('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};

var $Array$1 = getIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr$7 = !$Array$1.isArray && callBound('Object.prototype.toString');

// https://ecma-international.org/ecma-262/6.0/#sec-isarray

var IsArray$1 = $Array$1.isArray || function IsArray(argument) {
	return toStr$7(argument) === '[object Array]';
};

var $defineProperty = getIntrinsic('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

// node v0.6 has a bug where array lengths can be Set but not Defined
var hasArrayLengthDefineBug = $defineProperty && $defineProperty([], 'length', { value: 1 }).length === 0;

// eslint-disable-next-line global-require
var isArray$1 = hasArrayLengthDefineBug && IsArray$1; // this does not depend on any other AOs.



var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
var DefineOwnProperty = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	if (
		hasArrayLengthDefineBug
		&& P === 'length'
		&& '[[Value]]' in desc
		&& isArray$1(O)
		&& O.length !== desc['[[Value]]']
	) {
		// eslint-disable-next-line no-param-reassign
		O.length = desc['[[Value]]'];
		return O.length === desc['[[Value]]'];
	}

	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};

var $TypeError$7 = getIntrinsic('%TypeError%');
var $SyntaxError$2 = getIntrinsic('%SyntaxError%');



var predicates = {
	// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Type, Desc) {
		if (Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (src(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = src(Desc, '[[Value]]');
		var IsAccessor = src(Desc, '[[Get]]') || src(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError$7('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	}
};

var assertRecord = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError$2('unknown record type: ' + recordType);
	}
	if (!predicate(Type, value)) {
		throw new $TypeError$7(argumentName + ' must be a ' + recordType);
	}
};

// https://ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

var FromPropertyDescriptor = function FromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = Desc['[[Configurable]]'];
	}
	return obj;
};

// https://ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

var IsAccessorDescriptor = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Get]]') && !src(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};

// https://ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

var IsDataDescriptor = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Value]]') && !src(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};

// http://262.ecma-international.org/5.1/#sec-9.12

var SameValue = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return _isNaN(x) && _isNaN(y);
};

// http://262.ecma-international.org/5.1/#sec-9.2

var ToBoolean = function ToBoolean(value) { return !!value; };

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$8 = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag$2 = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

var isCallable = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag$2) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr$8.call(value);
		return strClass === fnClass || strClass === genClass;
	};

// http://262.ecma-international.org/5.1/#sec-9.11

var IsCallable = isCallable;

var $TypeError$8 = getIntrinsic('%TypeError%');





// https://262.ecma-international.org/5.1/#sec-8.10.5

var ToPropertyDescriptor = function ToPropertyDescriptor(Obj) {
	if (Type$1(Obj) !== 'Object') {
		throw new $TypeError$8('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (src(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (src(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (src(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (src(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (src(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError$8('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (src(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError$8('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((src(desc, '[[Get]]') || src(desc, '[[Set]]')) && (src(desc, '[[Value]]') || src(desc, '[[Writable]]'))) {
		throw new $TypeError$8('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};

var $TypeError$9 = getIntrinsic('%TypeError%');












// https://ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

var DefinePropertyOrThrow = function DefinePropertyOrThrow(O, P, desc) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$9('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError$9('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type$1,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type$1,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError$9('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};

var IsConstructor = createCommonjsModule(function (module) {



var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow$1 = DefinePropertyOrThrow;
try {
	DefinePropertyOrThrow$1({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow$1 = null;
}

// https://ecma-international.org/ecma-262/6.0/#sec-isconstructor

if (DefinePropertyOrThrow$1 && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow$1(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}
});

var $species = getIntrinsic('%Symbol.species%', true);
var $TypeError$a = getIntrinsic('%TypeError%');








// https://ecma-international.org/ecma-262/12.0/#sec-arrayspeciescreate

var ArraySpeciesCreate = function ArraySpeciesCreate(originalArray, length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError$a('Assertion failed: length must be an integer >= 0');
	}

	var isArray = IsArray(originalArray);
	if (!isArray) {
		return ArrayCreate(length);
	}

	var C = Get(originalArray, 'constructor');
	// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
	// if (IsConstructor(C)) {
	// 	if C is another realm's Array, C = undefined
	// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
	// }
	if ($species && Type$1(C) === 'Object') {
		C = Get(C, $species);
		if (C === null) {
			C = void 0;
		}
	}

	if (typeof C === 'undefined') {
		return ArrayCreate(length);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError$a('C must be a constructor');
	}
	return new C(length); // Construct(C, length);
};

var $TypeError$b = getIntrinsic('%TypeError%');



var $apply = getIntrinsic('%Reflect.apply%', true) || callBound('%Function.prototype.apply%');

// https://ecma-international.org/ecma-262/6.0/#sec-call

var Call = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray(argumentsList)) {
		throw new $TypeError$b('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};

var $gOPD$1 = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD$1) {
	try {
		$gOPD$1([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD$1 = null;
	}
}

var getOwnPropertyDescriptor = $gOPD$1;

var hasToStringTag$3 = shams$1();
var has$2;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$3) {
	has$2 = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString$1 = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex = hasToStringTag$3
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has$2(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString$1(value) === regexClass;
	};

var $match$1 = getIntrinsic('%Symbol.match%', true);





// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

var IsRegExp = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match$1) {
		var isRegExp = argument[$match$1];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return isRegex(argument);
};

var $TypeError$c = getIntrinsic('%TypeError%');



var $isEnumerable$1 = callBound('Object.prototype.propertyIsEnumerable');









// https://ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

var OrdinaryGetOwnProperty = function OrdinaryGetOwnProperty(O, P) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$c('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$c('Assertion failed: P must be a Property Key');
	}
	if (!src(O, P)) {
		return void 0;
	}
	if (!getOwnPropertyDescriptor) {
		// ES3 / IE 8 fallback
		var arrayLength = IsArray(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable$1(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor(getOwnPropertyDescriptor(O, P));
};

var isPrimitive = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var $preventExtensions = getIntrinsic('%Object.preventExtensions%', true);
var $isExtensible = getIntrinsic('%Object.isExtensible%', true);



// https://ecma-international.org/ecma-262/6.0/#sec-isextensible-o

var IsExtensible = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive(obj);
	};

var $TypeError$d = getIntrinsic('%TypeError%');











// https://ecma-international.org/ecma-262/6.0/#sec-createdataproperty

var CreateDataProperty = function CreateDataProperty(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$d('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$d('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = OrdinaryGetOwnProperty(O, P);
	var extensible = !oldDesc || IsExtensible(O);
	var immutable = oldDesc && (!oldDesc['[[Writable]]'] || !oldDesc['[[Configurable]]']);
	if (immutable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};

var $TypeError$e = getIntrinsic('%TypeError%');





// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

var CreateDataPropertyOrThrow = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$e('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$e('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError$e('unable to create data property');
	}
	return success;
};

var $TypeError$f = getIntrinsic('%TypeError%');




// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

var HasProperty = function HasProperty(O, P) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$f('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$f('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};

var $test$1 = getIntrinsic('RegExp.prototype.test');



var regexTester = function regexTester(regex) {
	return callBind($test$1, regex);
};

var isPrimitive$1 = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr$9 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$4 = shams$1();

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag$4 ? tryDateObject(value) : toStr$9.call(value) === dateClass;
};

var isSymbol$1 = createCommonjsModule(function (module) {

var toStr = Object.prototype.toString;
var hasSymbols$1 = hasSymbols();

if (hasSymbols$1) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false ;
	};
}
});

var hasSymbols$3 = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';






var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive$1(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
var es2015 = function ToPrimitive(input) {
	if (isPrimitive$1(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols$3) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol$1(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive$1(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDateObject(input) || isSymbol$1(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

// https://ecma-international.org/ecma-262/6.0/#sec-toprimitive

var ToPrimitive = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return es2015(input, arguments[1]);
	}
	return es2015(input);
};

var $TypeError$g = getIntrinsic('%TypeError%');
var $Number = getIntrinsic('%Number%');
var $RegExp = getIntrinsic('%RegExp%');
var $parseInteger = getIntrinsic('%parseInt%');





var $strSlice$1 = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace$2 = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace$2(value, trimRegex, '');
};



// https://ecma-international.org/ecma-262/6.0/#sec-tonumber

var ToNumber = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
	if (typeof value === 'symbol') {
		throw new $TypeError$g('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'bigint') {
		throw new $TypeError$g('Conversion from \'BigInt\' to \'number\' is not allowed.');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice$1(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice$1(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		}
		var trimmed = $trim(value);
		if (trimmed !== value) {
			return ToNumber(trimmed);
		}

	}
	return $Number(value);
};

// http://262.ecma-international.org/5.1/#sec-9.6

var ToUint32 = function ToUint32(x) {
	return ToNumber(x) >>> 0;
};

var $Object = getIntrinsic('%Object%');



// https://ecma-international.org/ecma-262/6.0/#sec-toobject

var ToObject = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};

var $String = getIntrinsic('%String%');
var $TypeError$h = getIntrinsic('%TypeError%');

// https://ecma-international.org/ecma-262/6.0/#sec-tostring

var ToString = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError$h('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};

// Check failure of by-index access of string characters (IE < 9) and failure of `0 in boxedString` (Rhino)
var boxedString = Object('a');
var splitString = boxedString[0] !== 'a' || !(0 in boxedString);

var strSplit = callBound('String.prototype.split');

var implementation$2 = function map(callbackfn) {
	var O = ToObject(this);
	var self = splitString && isString(O) ? strSplit(O, '') : O;
	var len = ToUint32(self.length);

	// If no callback function or if callback is not a callable function
	if (!IsCallable(callbackfn)) {
		throw new TypeError('Array.prototype.map callback must be a function');
	}

	var T;
	if (arguments.length > 1) {
		T = arguments[1];
	}

	var A = ArraySpeciesCreate(O, len);
	var k = 0;
	while (k < len) {
		var Pk = ToString(k);
		var kPresent = HasProperty(O, Pk);
		if (kPresent) {
			var kValue = Get(O, Pk);
			var mappedValue = Call(callbackfn, T, [kValue, k, O]);
			CreateDataPropertyOrThrow(A, Pk, mappedValue);
		}
		k += 1;
	}

	return A;
};

var esArrayMethodBoxesProperly = function properlyBoxed(method) {
	// Check node 0.6.21 bug where third parameter is not boxed
	var properlyBoxesNonStrict = true;
	var properlyBoxesStrict = true;
	var threwException = false;
	if (typeof method === 'function') {
		try {
			// eslint-disable-next-line max-params
			method.call('f', function (_, __, O) {
				if (typeof O !== 'object') {
					properlyBoxesNonStrict = false;
				}
			});

			method.call(
				[null],
				function () {
					'use strict';

					properlyBoxesStrict = typeof this === 'string'; // eslint-disable-line no-invalid-this
				},
				'x'
			);
		} catch (e) {
			threwException = true;
		}
		return !threwException && properlyBoxesNonStrict && properlyBoxesStrict;
	}
	return false;
};

var polyfill = function getPolyfill() {
	var method = Array.prototype.map;
	return esArrayMethodBoxesProperly(method) ? method : implementation$2;
};

var shim = function shimArrayPrototypeMap() {
	var polyfill$1 = polyfill();
	defineProperties_1(
		Array.prototype,
		{ map: polyfill$1 },
		{ map: function () { return Array.prototype.map !== polyfill$1; } }
	);
	return polyfill$1;
};

var polyfill$1 = polyfill();


var $slice$1 = callBound('Array.prototype.slice');

// eslint-disable-next-line no-unused-vars
var boundMapShim = function map(array, callbackfn) {
	RequireObjectCoercible(array);
	return polyfill$1.apply(array, $slice$1(arguments, 1));
};
defineProperties_1(boundMapShim, {
	getPolyfill: polyfill,
	implementation: implementation$2,
	shim: shim
});

var array_prototype_map = boundMapShim;

requirePromise();








var all = callBind(getIntrinsic('%Promise.all%'));
var reject = callBind(getIntrinsic('%Promise.reject%'));

var implementation$3 = function allSettled(iterable) {
	var C = this;
	if (Type$1(C) !== 'Object') {
		throw new TypeError('`this` value must be an object');
	}
	var values = iterateValue(iterable);
	return all(C, array_prototype_map(values, function (item) {
		var onFulfill = function (value) {
			return { status: 'fulfilled', value: value };
		};
		var onReject = function (reason) {
			return { status: 'rejected', reason: reason };
		};
		var itemPromise = PromiseResolve(C, item);
		try {
			return itemPromise.then(onFulfill, onReject);
		} catch (e) {
			return reject(C, e);
		}
	}));
};

function useLazyImageLoader(src) {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(false), error = _b[0], setError = _b[1];
    var _c = useState(''), imageSrc = _c[0], setImageSrc = _c[1];
    useEffect(function () {
        var img = new Image();
        if (img) {
            img.onload = function () {
                setLoading(false);
                setImageSrc(src);
            };
            img.onerror = function () {
                setLoading(false);
                setError(true);
            };
            img.src = src;
        }
        return function () {
            img.src = '';
        };
    }, [src]);
    return { loadingImage: loading, imageSrc: imageSrc, loadingError: error };
}
function useLazyImagesLoader(srcs) {
    var _this = this;
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var error = useState(false)[0];
    useEffect(function () {
        var imgPromises = [];
        var _loop_1 = function (i) {
            imgPromises.push(
            // eslint-disable-next-line no-async-promise-executor
            new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                var img;
                return __generator(this, function (_a) {
                    img = new Image();
                    img.onload = function () {
                        resolve();
                    };
                    img.src = srcs[i];
                    return [2 /*return*/];
                });
            }); }));
        };
        for (var i in srcs) {
            _loop_1(i);
        }
        implementation$3(imgPromises).then(function () {
            setLoading(false);
        });
    }, [srcs]);
    return { loadingImages: loading, loadingError: error };
}

var HeaderPlatformColors = {
    INTRO: {
        color: '#0F0900',
        drawerColor: '#fff',
    },
    RESEARCH: {
        color: '#0F0900',
        drawerColor: '#79a9f5',
    },
    TOPIC: {
        color: '#F9FF4B',
        drawerColor: '#F9FF4B',
    },
    GUIDE: {
        color: '#F84040',
        drawerColor: '#F84040',
    },
};

var SiteConfigService = /** @class */ (function () {
    function SiteConfigService() {
        var _this = this;
        this.getApiData = function (lang) {
            var apiLang = lang ? lang : _this.lang;
            var siteConfigRepository = new SiteConfigRepository();
            return siteConfigRepository.fetchSiteConfig(apiLang);
        };
        // this.lang = LanguageService.getCurrentStrapiLanguage();
        this.lang = LanguageService.getCurrentStrapiLanguage();
        this.currentLang = LanguageService.getCurrentLanguage();
        this.config = ConfigLoader.CurrentConfig;
    }
    SiteConfigService.prototype.getGuidePage = function () {
        this.lang = LanguageService.getCurrentStrapiLanguage();
        var siteConfigRepository = new SiteConfigRepository();
        var _a = siteConfigRepository.fetchGuidePage(this.lang), loading = _a.loading, error = _a.error, data = _a.data;
        var contextData = null;
        if (!loading && data) {
            contextData = data;
        }
        return { loading: loading, error: error, contextData: contextData };
    };
    SiteConfigService.prototype.getTopicPage = function () {
        var _a, _b, _c, _d, _e, _f;
        this.lang = LanguageService.getCurrentStrapiLanguage();
        var siteConfigRepository = new SiteConfigRepository();
        var _g = siteConfigRepository.fetchTopicPage(this.lang), loading = _g.loading, error = _g.error, data = _g.data;
        var contextData = null;
        if (!loading && data) {
            contextData = [
                {
                    title: (_a = data === null || data === void 0 ? void 0 : data.attributes) === null || _a === void 0 ? void 0 : _a.heroFallbackHeader,
                    text: (_b = data === null || data === void 0 ? void 0 : data.attributes) === null || _b === void 0 ? void 0 : _b.heroFallbackText,
                    image: this.config.STRAPI_CONFIG.backend.smb + ((_f = (_e = (_d = (_c = data.attributes) === null || _c === void 0 ? void 0 : _c.heroFallbackAsset) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f.url),
                    actionText: '',
                    actionHref: '',
                    caption: null,
                    target: '',
                    href: '#',
                },
            ];
        }
        return { loading: loading, error: error, contextData: contextData };
    };
    SiteConfigService.prototype.getSiteConfigData = function () {
        var _a;
        var _b = this.getApiData(), loading = _b.loading, data = _b.data;
        var headerData, footerData, localizations;
        if (!loading && data) {
            headerData = this.convertHeaderData(data === null || data === void 0 ? void 0 : data.headerMenuItems);
            localizations = this.convertLocalizationsData((_a = data === null || data === void 0 ? void 0 : data.localizations) === null || _a === void 0 ? void 0 : _a.data, data === null || data === void 0 ? void 0 : data.legalPages, this.lang, this.currentLang);
            footerData = this.convertFooterData(data, this.lang);
        }
        return {
            loading: loading,
            data: { headerData: headerData, footerData: footerData, localizations: localizations },
        };
    };
    SiteConfigService.prototype.getStaticPages = function () {
        var _a = this.getApiData(), loading = _a.loading, data = _a.data, error = _a.error;
        var staticPages;
        if (!loading && !error && data) {
            staticPages = this.convertStaticPagesData(data === null || data === void 0 ? void 0 : data.legalPages);
        }
        return {
            loading: loading,
            data: staticPages,
            error: error,
        };
    };
    SiteConfigService.prototype.convertStaticPagesData = function (items) {
        var _this = this;
        return items === null || items === void 0 ? void 0 : items.map(function (item) {
            if (item) {
                var header = item.header, block = item.block, slug = item.slug, footerLink = item.footerLink, id = item.id, matomo = item.matomo;
                return {
                    id: id,
                    title: header,
                    name: footerLink,
                    path: slug,
                    matomo: matomo,
                    block: block
                        ? block.map(function (item) {
                            var _a, _b;
                            return {
                                text: item === null || item === void 0 ? void 0 : item.text,
                                assets: (_a = item === null || item === void 0 ? void 0 : item.assets) === null || _a === void 0 ? void 0 : _a.data,
                                videoAssets: (_b = item === null || item === void 0 ? void 0 : item.videoAssets) === null || _b === void 0 ? void 0 : _b.data,
                                assetBaseUrl: _this.config.STRAPI_CONFIG.backend.smb,
                            };
                        })
                        : [],
                };
            }
        }).filter(function (item) { return item !== undefined; });
    };
    SiteConfigService.prototype.getStaticPagesRoutes = function (items) {
        return items === null || items === void 0 ? void 0 : items.map(function (item) {
            if (item) {
                var slug = item.slug, footerLink = item.footerLink, id = item.id;
                return {
                    id: id,
                    name: footerLink,
                    path: slug,
                };
            }
        }).filter(function (item) { return item !== undefined; });
    };
    SiteConfigService.prototype.convertHeaderData = function (items) {
        return items === null || items === void 0 ? void 0 : items.map(function (item) {
            if (item) {
                var headline = item.headline, subHeadline = item.subHeadline, href = item.href, type = item.type, id = item.id;
                return {
                    id: id,
                    title: headline,
                    subTitle: subHeadline,
                    color: HeaderPlatformColors[type].color,
                    drawerColor: HeaderPlatformColors[type].drawerColor,
                    href: href,
                    type: type,
                };
            }
        }).filter(function (item) { return item !== undefined; });
    };
    SiteConfigService.prototype.convertLocalizationsData = function (items, currentLegalPages, lang, currentLang) {
        var _this = this;
        var locales = {
            main: [],
            options: [],
            availableLanguages: [],
        };
        var obj;
        items &&
            items.map(function (item) {
                if (item) {
                    var _a = item === null || item === void 0 ? void 0 : item.attributes, locale = _a.locale, legalPages = _a.legalPages;
                    if (locale === 'de' || locale === 'en') {
                        obj = _this.getLanguageObjcet(locale, currentLegalPages, legalPages, true);
                        locales.main.push(obj);
                    }
                    obj = _this.getLanguageObjcet(locale, currentLegalPages, legalPages);
                    if (locale.includes(currentLang)) {
                        locales.options.push(obj);
                    }
                    locales.availableLanguages.push(obj.value);
                }
            });
        if (lang === 'de' || lang === 'en') {
            obj = this.getLanguageObjcet(lang, currentLegalPages, currentLegalPages, true);
            locales.main.push(obj);
        }
        obj = this.getLanguageObjcet(lang, currentLegalPages, currentLegalPages);
        locales.options.push(obj);
        locales.main.sort(function (a, b) { return a.index - b.index; });
        locales.options.sort(function (a, b) { return a.index - b.index; });
        return locales;
    };
    SiteConfigService.prototype.getLanguageObjcet = function (lang, currentLegalPages, localeLegalPages, main) {
        var locale = lang.toLocaleLowerCase();
        if (main)
            return {
                value: lang,
                map: getLanguageMap(),
                legalPages: getLegalPagesMap(currentLegalPages, localeLegalPages),
                index: getLanguageIndex(locale),
            };
        else
            return {
                value: getLanguageValue(lang),
                icon: getLanguageIcon(locale),
                legalPages: getLegalPagesMap(currentLegalPages, localeLegalPages),
                index: getLanguageIndex(locale),
            };
    };
    SiteConfigService.prototype.convertFooterData = function (items, lang) {
        var _this = this;
        var section = [];
        var getBlockAssets = function (block) {
            var _a, _b;
            if (lang === 'de-DGS' && block && ((_a = block.assets) === null || _a === void 0 ? void 0 : _a.data.length)) {
                return (_b = block.assets) === null || _b === void 0 ? void 0 : _b.data.map(function (asset) {
                    var _a;
                    return {
                        url: "" + _this.config.STRAPI_CONFIG.backend.smb + ((_a = asset === null || asset === void 0 ? void 0 : asset.attributes) === null || _a === void 0 ? void 0 : _a.url),
                    };
                });
            }
            return [];
        };
        var headerMenuItems = items.headerMenuItems, contactTextBlock = items.contactTextBlock, contactVideoBlock = items.contactVideoBlock, copyright = items.copyright, legalPages = items.legalPages;
        if (contactTextBlock) {
            section.push({
                type: 'TextBlock',
                link: {
                    caption: contactTextBlock.linkText,
                    href: contactTextBlock.linkUrl,
                },
                title: contactTextBlock.headline,
                subtitle: contactTextBlock.subHeadline,
                text: contactTextBlock.text,
                moduleBackgroundColor: '',
                textAreaColor: '',
                textColor: '',
                titleColor: '',
                moduleType: 4,
            });
        }
        if (contactVideoBlock && lang === 'de-DGS') {
            var videoData = {
                type: 'VideoBlock',
                title: contactVideoBlock.headline,
                subtitle: contactVideoBlock.subHeadline,
                assets: getBlockAssets(contactVideoBlock),
                link: {
                    caption: contactVideoBlock.linkText,
                    href: contactVideoBlock.linkUrl,
                },
            };
            if (contactTextBlock) {
                section.splice(0, 1, videoData);
            }
            else {
                section.push(videoData);
            }
        }
        var menuItems = headerMenuItems &&
            headerMenuItems
                .map(function (item) {
                if (item) {
                    var headline = item.headline, href = item.href;
                    return {
                        text: headline,
                        href: href,
                    };
                }
            })
                .filter(function (item) { return item !== undefined; });
        var staticRoutes = legalPages
            ? this.getStaticPagesRoutes(__spreadArrays(legalPages))
            : [];
        return {
            links: menuItems,
            staticRoutes: staticRoutes,
            section: {
                id: '10',
                moduleType: 4,
                hasSwiperBlock: false,
                sections: section,
            },
            copyright: copyright,
        };
    };
    return SiteConfigService;
}());

var currentLocalePathSegment = function () {
    var defaultLang = LanguageService.getDefaultLanguage();
    var currentLang = LanguageService.getCurrentStrapiLanguage();
    return currentLang === defaultLang ? '' : "/" + currentLang;
};
var Footer = function (_a) {
    var configuration = _a.configuration, showContactSection = _a.showContactSection;
    var t = useTranslation().t;
    var classes = useStyles$5();
    var _b = useState([]), col1 = _b[0], setCol1 = _b[1];
    var _c = useState([]), col4 = _c[0], setCol4 = _c[1];
    var _d = useState(''), copyright = _d[0], setCopyright = _d[1];
    var _e = useState([]), cardBlock = _e[0], setCardBlock = _e[1];
    var siteFooterData = new SiteConfigService();
    var _f = siteFooterData.getSiteConfigData(), loading = _f.loading, footerData = _f.data.footerData;
    useEffect(function () {
        var _a;
        if (!loading) {
            setCol1(footerData === null || footerData === void 0 ? void 0 : footerData.links); // {text:string, href:string}[]
            setCol4(footerData === null || footerData === void 0 ? void 0 : footerData.staticRoutes); // {name:string, path:string}[]
            var currentYear = new Date().getFullYear();
            var copyright_1 = (_a = footerData === null || footerData === void 0 ? void 0 : footerData.copyright) !== null && _a !== void 0 ? _a : 'Staatliche Museen zu Berlin';
            setCopyright(currentYear + " " + copyright_1);
            setCardBlock(footerData === null || footerData === void 0 ? void 0 : footerData.section);
        }
    }, [loading]);
    var routesToLinks = function (col) {
        if (col) {
            var lang_1 = currentLocalePathSegment();
            return col.map(function (route) {
                var external = route.path.match(/^http(s)?:\/\/.+/);
                return {
                    text: route.name,
                    href: external ? route.path : "" + configuration.INTRO_DOMAIN + lang_1 + "/" + route.path,
                    type: external ? EFooterLinkType.external : EFooterLinkType.internal
                };
            });
        }
        else
            return [];
    };
    var links = {
        col1: col1 !== null && col1 !== void 0 ? col1 : [],
        col2: [
            {
                text: t('footer.staatliche'),
                href: 'https://www.smb.museum/home',
                type: EFooterLinkType.external
            },
            {
                text: t('footer.blog'),
                href: 'https://blog.smb.museum/',
                type: EFooterLinkType.external
            },
            {
                text: t('footer.newsletter'),
                href: 'https://www.smb.museum/newsletter/abonnieren',
                type: EFooterLinkType.external
            },
            {
                text: t('footer.webshop'),
                href: 'https://www.smb-webshop.de',
                type: EFooterLinkType.external
            },
        ],
        col3: [
            {
                text: 'Facebook',
                href: 'https://www.facebook.com/staatlichemuseenzuberlin',
                type: EFooterLinkType.external
            },
            {
                text: 'Instagram',
                href: 'https://www.instagram.com/staatlichemuseenzuberlin',
                type: EFooterLinkType.external
            },
            {
                text: 'Youtube',
                href: 'https://www.youtube.com/user/smbchannel',
                type: EFooterLinkType.external
            },
        ],
        col4: routesToLinks(col4),
    };
    var renderLink = function (link, i, col) {
        return (React.createElement(React.Fragment, { key: i },
            React.createElement(Link$1, { target: link.type === EFooterLinkType.external ? "_blank" : "", rel: link.type === EFooterLinkType.external ? "noopener noreferrer" : "", className: link.type === EFooterLinkType.external ? classes.linkExternal : classes.link, "data-cy": "footer-link-col" + col + "-" + i, href: link.href, color: 'inherit' },
                React.createElement(Typography, { variant: 'caption', color: 'inherit' }, link.text))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MuiThemeProvider, { theme: CommonTheme },
            showContactSection && cardBlock && (React.createElement(Sections, { sections: [cardBlock], isFooter: true })),
            React.createElement("div", { className: classes.sectionWrapper },
                React.createElement("div", { className: classes.maxWidth },
                    React.createElement(FooterGrid, { className: classes.footerGrid },
                        React.createElement(Paper, { className: classes.footerCard }, links.col1.length > 0 && links.col1.map(function (link, i) { return renderLink(__assign(__assign({}, link), { type: EFooterLinkType.internal }), i, 1); })),
                        React.createElement(Paper, { className: classes.footerCard }, links.col2.length > 0 && links.col2.map(function (link, i) { return renderLink(link, i, 2); })),
                        React.createElement(Paper, { className: classes.footerCard }, links.col3.length > 0 && links.col3.map(function (link, i) { return renderLink(link, i, 3); })),
                        React.createElement(Paper, { className: classes.footerCard }, links.col4.length > 0 && links.col4.map(function (link, i) { return renderLink(link, i, 4); }))),
                    React.createElement(Typography, { display: "block", variant: "h5", component: "p", className: "footer__copyright", style: { color: 'white' } },
                        "\u00A9",
                        copyright))))));
};

var useStyles$6 = makeStyles(function (theme) {
    return createStyles({
        sliderContainer: {
            // height: '35vh',
            // maxWidth: 1280 + 46 + 46,
            margin: '0 auto',
        },
        sliderContent: {
            transition: 'transform cubic-bezier(0.4, 0, 0.2, 1) 750',
            marginLeft: '0',
            marginRight: '0',
            display: 'flex',
            height: '100%',
            padding: 0,
        },
        dotWrapper: {
            margin: '2rem',
        },
        dot: {
            transition: theme.transitions.create(['background-color'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.standard,
            }),
            padding: theme.spacing(1),
            marginRight: theme.spacing(3),
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.contrastText,
            position: 'relative',
            '&:focus': {},
            '&:hover': {},
        },
        dotActive: {
            '&:before': {
                content: 'no-open-quote',
                backgroundColor: theme.palette.primary.contrastText,
                padding: theme.spacing(2),
                marginRight: theme.spacing(3),
                borderRadius: '50%',
                opacity: '0.5',
                position: 'absolute',
                top: '-50%',
                left: '-50%',
            },
        },
    });
});

var SliderComponent = function (props) {
    var children = props.children, silderSlides = props.silderSlides, _a = props.autoplay, autoplay = _a === void 0 ? false : _a, _b = props.wrapAround, wrapAround = _b === void 0 ? false : _b, _c = props.enableKeyboardControls, enableKeyboardControls = _c === void 0 ? true : _c, _d = props.pauseOnHover, pauseOnHover = _d === void 0 ? false : _d;
    var classes = useStyles$6();
    var BottomCenterControls = function (props) {
        var currentSlide = props.currentSlide, slideCount = props.slideCount;
        // const isDisabled = slidesToShow >= slideCount || !currentSlide;
        var dots = [];
        for (var index = 0; index < slideCount; index++) {
            dots[index] = (React.createElement("div", { key: index, className: clsx(classes.dot, index === currentSlide && classes.dotActive) }));
        }
        return (React.createElement(Grid, { container: true, wrap: 'nowrap', className: classes.dotWrapper, direction: "row" }, dots));
    };
    var CenterLeftControls = function (props) {
        var previousSlide = props.previousSlide, slideCount = props.slideCount, slidesToShow = props.slidesToShow, currentSlide = props.currentSlide;
        var isDisabled = slidesToShow >= slideCount || !currentSlide;
        if (isDisabled) {
            return null;
        }
        return (React.createElement(IconButton
        // disabled={isDisabled}
        // className={classes.arrowContainer}
        , { "aria-label": 'arrow left', role: "button", size: "medium", onClick: previousSlide, style: { color: 'white' } }, React.createElement(ArrowBackIosOutlinedIcon, null)));
    };
    var CenterRightControls = function (props) {
        var nextSlide = props.nextSlide, slidesToShow = props.slidesToShow, slideCount = props.slideCount, currentSlide = props.currentSlide;
        var isDisabled = slidesToShow >= slideCount || currentSlide === slideCount - slidesToShow;
        if (isDisabled) {
            return null;
        }
        return (React.createElement(IconButton
        // disabled={isDisabled}
        // className={classes.arrowContainer}
        , { "aria-label": 'arrow right', role: "button", size: "medium", onClick: nextSlide, style: { color: 'white' } },
            React.createElement(ArrowForwardIosOutlinedIcon, null)));
    };
    return (React.createElement("div", { className: classes.sliderContainer },
        React.createElement(Carousel, { autoplay: autoplay, wrapAround: wrapAround, enableKeyboardControls: enableKeyboardControls, renderAnnounceSlideMessage: function (_a) {
                var _b;
                var currentSlide = _a.currentSlide, slideCount = _a.slideCount;
                return "Slide " + (currentSlide + 1) + " von " + slideCount + " inhalt: \n          " + (silderSlides && ((_b = silderSlides[currentSlide]) === null || _b === void 0 ? void 0 : _b.slideText));
            }, pauseOnHover: pauseOnHover, heightMode: 'first', renderBottomCenterControls: BottomCenterControls, renderCenterLeftControls: CenterLeftControls, renderCenterRightControls: CenterRightControls }, children)));
};
var Slider = SliderComponent;

var useStyles$7 = makeStyles(function (theme) {
    var _a;
    return createStyles({
        slide: (_a = {
                height: '95vh'
            },
            _a[theme.breakpoints.up('sm')] = {
                height: '80vh',
            },
            _a.backgroundSize = 'cover',
            _a.backgroundRepeat = 'no-repeat',
            _a.backgroundPosition = 'center 33%',
            _a),
    });
});

function Slide(_a) {
    var image = _a.image, children = _a.children, _b = _a.slideClasses, slideClasses = _b === void 0 ? '' : _b, onClick = _a.onClick, onMouseMove = _a.onMouseMove;
    var classes = useStyles$7();
    return (React.createElement("div", { className: clsx(classes.slide, slideClasses), style: { backgroundImage: "url(" + image + ")" }, onClick: function (event) { return onClick && onClick(event); }, onMouseMove: function (event) { return onMouseMove && onMouseMove(event); } }, children));
}

var useStyles$8 = makeStyles(function (theme) {
    return createStyles({
        sliderModule: {
            position: 'relative',
            height: '35vh',
            width: '100vw',
            margin: '0 auto',
            overflow: 'hidden',
            transition: theme.transitions.create(['opacity'], {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        arrowBack: {
            display: 'flex',
            position: 'absolute',
            top: '49%',
            transition: theme.transitions.create(['opacity'], {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.enteringScreen,
            }),
            left: theme.spacing(1),
        },
        arrowForward: {
            display: 'flex',
            position: 'absolute',
            top: '49%',
            transition: theme.transitions.create(['opacity'], {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.enteringScreen,
            }),
            right: theme.spacing(1),
        },
    });
});

var useStyles$9 = makeStyles(function (theme) {
    return createStyles({
        sliderContent: {
            transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.complex,
            }),
            display: 'flex',
            height: '100%',
        },
    });
});

function SliderContent(_a) {
    var activeIndex = _a.activeIndex, children = _a.children;
    var classes = useStyles$9();
    var length = 1;
    if (Array.isArray(children)) {
        length = children.length;
    }
    var width = 100 * length;
    var translateX = (100 / length) * activeIndex;
    return (React.createElement("div", { className: classes.sliderContent, style: { width: width + "%", transform: "translateX(-" + translateX + "%)" } }, children));
}

var useStyles$a = makeStyles(function (theme) {
    return createStyles({
        dots: {
            transition: theme.transitions.create(['background-color'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.standard,
            }),
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            bottom: theme.spacing(2),
        },
        dot: {
            transition: theme.transitions.create(['background-color'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.standard,
            }),
            padding: theme.spacing(1),
            marginRight: theme.spacing(3),
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.contrastText,
            position: 'relative',
        },
        dotActive: {
            '&:before': {
                content: 'no-open-quote',
                backgroundColor: theme.palette.primary.contrastText,
                padding: theme.spacing(2),
                marginRight: theme.spacing(3),
                borderRadius: '50%',
                opacity: '0.5',
                position: 'absolute',
                top: '-50%',
                left: '-50%',
            },
        },
    });
});

function Dots(_a) {
    var activeIndex = _a.activeIndex, length = _a.length;
    var classes = useStyles$a();
    var dots = [];
    for (var i = 0; i < length; i++) {
        if (i === activeIndex) {
            dots.push(React.createElement("span", { key: i, className: clsx(classes.dot, classes.dotActive) }));
        }
        else {
            dots.push(React.createElement("span", { key: i, className: classes.dot }));
        }
    }
    return React.createElement("div", { className: classes.dots }, dots);
}

function calcActiveIndex(index, length) {
    if (index < 0) {
        return length - 1;
    }
    if (index >= length) {
        return 0;
    }
    return index;
}
function SliderModule(_a) {
    var children = _a.children, interval = _a.interval, _b = _a.playing, playing = _b === void 0 ? true : _b, _c = _a.arrows, arrows = _c === void 0 ? true : _c, _d = _a.dots, dots = _d === void 0 ? true : _d, _e = _a.sliderClasses, sliderClasses = _e === void 0 ? '' : _e, onSlide = _a.onSlide, _f = _a.activeIndex, activeIndex = _f === void 0 ? 0 : _f, setActiveIndex = _a.setActiveIndex, onProgressUpdate = _a.onProgressUpdate, _g = _a.progressUpdateStepSize, progressUpdateStepSize = _g === void 0 ? 60 : _g;
    var classes = useStyles$8();
    var _h = useState(0), progressValue = _h[0], setProgressValue = _h[1];
    var _j = useState(activeIndex), index = _j[0], setIndex = _j[1];
    var autoPlay = useRef();
    var length = 1;
    if (Array.isArray(children)) {
        length = children.length;
    }
    var updateValues = function (index) {
        setActiveIndex(index);
        setIndex(index);
        setProgressValue(0);
        onSlide && onSlide(index);
    };
    var incrementActiveIndex = function () {
        var newIndex = calcActiveIndex(activeIndex + 1, length);
        updateValues(newIndex);
    };
    var decrementActiveIndex = function () {
        var newIndex = calcActiveIndex(activeIndex - 1, length);
        updateValues(newIndex);
    };
    var updateProgress = function () {
        if (!interval || !playing) {
            return;
        }
        var newProgressValue = progressValue + progressUpdateStepSize;
        if (newProgressValue >= interval) {
            newProgressValue = 0;
            incrementActiveIndex();
        }
        if (index !== activeIndex) {
            setIndex(activeIndex);
            newProgressValue = 0;
        }
        onProgressUpdate && onProgressUpdate(newProgressValue);
        setProgressValue(newProgressValue);
    };
    useEffect(function () {
        if (interval && playing) {
            autoPlay.current = updateProgress;
        }
    });
    useEffect(function () {
        if (!playing && activeIndex !== index) {
            setProgressValue(0);
            onProgressUpdate && onProgressUpdate(0);
        }
    }, [playing, activeIndex, index, progressValue, onProgressUpdate]);
    useEffect(function () {
        if (!interval || !playing) {
            return;
        }
        var play = function () {
            autoPlay.current && autoPlay.current();
        };
        var autoPlayInterval = setInterval(play, progressUpdateStepSize);
        return function () { return clearInterval(autoPlayInterval); };
    });
    var t = useTranslation().t;
    return (React.createElement("div", { className: clsx(classes.sliderModule, sliderClasses) },
        React.createElement(SliderContent, { activeIndex: activeIndex }, children),
        arrows && (React.createElement(IconButton, { "aria-label": t('carousel.previousTopic'), className: classes.arrowBack, color: "inherit", onClick: decrementActiveIndex },
            React.createElement(ArrowBackIosIcon, { color: 'inherit' }))),
        arrows && (React.createElement(IconButton, { "aria-label": t('carousel.nextTopic'), className: classes.arrowForward, color: "inherit", onClick: incrementActiveIndex },
            React.createElement(ArrowForwardIosIcon, { color: 'inherit' }))),
        dots && React.createElement(Dots, { activeIndex: activeIndex, length: length })));
}

var _path;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var SvgSmbLogo = function SvgSmbLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    viewBox: "0 0 739 144"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2v102.482c10.83-13.246 20.173-18.76 24.095-20.502.36-.16.376-.41.36-.5-.014-.091-.215-.376-.686-.371-1.928 0-5.916 1.106-8.516 2.068-.606.225-.706-.18-.455-.641.556-1.047 3.105-3.446 10.73-6.51 12.583-5.079 25.592-4.508 31.559-1.538 2.64 1.327 3.747 3.966 4.067 4.918.04.12 0 .185-.105.185-9.242-.1-13.405.366-16.165 1.207-.822.255-.902.866-.176 1.412 1.303 1.002 5.355 2.028 6.973 2.299.403.088.818-.079 1.047-.42.346-.396.782-.962 1.168-1.338.305-.295.455-.325 1.032-.365.856-.066 2.83-.096 4.568-.066 8.095.146 17.127 2.149 17.127 13.607a20.257 20.257 0 01-2.505 9.38c-.5.811-1.352.776-1.302-.436.215-5.629-.691-7.937-9.598-7.937-4.508 0-11.617.646-14.813 2.148-1.182.556-1.297 1.572-.1 1.467 1.773-.15 8.726-.63 13.656-.63 3.256 0 5.82.325 6.747 1.622.22.315.266.906-.5.791a17.035 17.035 0 00-2.29-.14c-10.254 0-20.278 6.045-20.278 16.526C45.64 137.35 70.126 144 100.743 144c24.656 0 41.257-5.288 41.257-5.288V2H0zm739 29.41V16.33c0-5.897-3.167-9.063-8.177-9.063a9.93 9.93 0 00-6.544 2.346l-.897-2.03-4.38.27v23.556h6.099V14.454c.826-1.135 2.47-1.8 4.008-1.8 2.505 0 3.838 1.055 3.838 3.676v15.08H739zM713.005 2.615C713.005.9 711.953 0 709.563 0s-3.477.94-3.477 2.616c0 1.915 1.132 2.576 3.477 2.576 2.345 0 3.442-.856 3.442-2.576m-.35 28.793V7.737l-6.219.27V31.41h6.219zm-13.028 0V.705l-6.143.27V31.41h6.143zm-19.22 0V19.791c0-3.861 2.35-6.117 5.511-6.117a8.92 8.92 0 012.586.38l.39-5.967a8.963 8.963 0 00-2.585-.35c-2.7 0-5.01 1.406-6.514 4.256h-.12l-.546-3.94-4.85.23v23.126h6.128zm-24.742-14.254c.275-3.441 1.413-4.811 4.349-4.811 2.545 0 4.113 1.33 4.189 4.811h-8.538zm5.671 14.684a19.314 19.314 0 007.747-1.5l-.667-4.882a17.384 17.384 0 01-6.338 1.176c-4.074 0-6.013-1.5-6.303-5.437h13.819c.111-.946.163-1.898.155-2.85 0-7.503-3.718-11.004-9.785-11.004-7.125 0-10.447 4.411-10.447 11.954 0 8.287 3.637 12.578 11.82 12.578m-23.049-21.09c0 2.305-1.002 3.245-3.367 3.245h-5.482V7.652h5.342c2.465 0 3.507.825 3.507 3.131m.747 11.604c0 2.775-1.178 3.636-3.798 3.636h-5.838v-7.118h5.677c2.861 0 3.959 1 3.959 3.502m6.608.5c0-3.716-1.718-6.002-4.965-6.917v-.075c2.345-1 3.908-3.001 3.908-6.297 0-4.647-3.207-7.502-9.585-7.502h-11.94v29.298h12.095c7.396 0 10.487-3.236 10.487-8.502M606.11 7.752h-6.063v15.2c0 2.425-1.252 3.556-3.918 3.556-2.665 0-3.918-1.21-3.918-3.556V7.737h-6.033v15.32c0 5.621 3.247 8.782 9.981 8.782s9.981-3.04 9.981-8.782l-.03-15.305zm-24.777 4.216V7.752h-17.05l-.196 5.037h10.216l.035.08-1.879 2.46-8.688 11.844v4.251h17.773l.155-5.031h-10.883l-.04-.12 1.879-2.421 8.678-11.884zm-33.395 19.456V16.33c0-5.897-3.167-9.063-8.177-9.063a9.934 9.934 0 00-6.54 2.346l-.901-2.03-4.38.27v23.556h6.129V14.454c.821-1.135 2.465-1.8 4.008-1.8 2.505 0 3.838 1.055 3.838 3.676v15.08l6.023.014zM509.3 17.17c.276-3.441 1.413-4.811 4.35-4.811 2.545 0 4.113 1.33 4.193 4.811H509.3zm5.682 14.684a19.317 19.317 0 007.747-1.5l-.662-4.882a17.393 17.393 0 01-6.343 1.176c-4.074 0-6.013-1.5-6.303-5.437h13.819c.111-.946.163-1.898.155-2.85 0-7.503-3.718-11.004-9.786-11.004-7.125 0-10.446 4.411-10.446 11.954 0 8.287 3.637 12.578 11.82 12.578M485.58 17.205c.276-3.441 1.408-4.811 4.35-4.811 2.545 0 4.113 1.33 4.188 4.811h-8.538zm5.682 14.684a19.33 19.33 0 007.747-1.5l-.667-4.882a17.363 17.363 0 01-6.338 1.176c-4.074 0-6.013-1.5-6.303-5.437h13.814c.115-.946.169-1.898.16-2.85 0-7.503-3.718-11.004-9.785-11.004-7.125 0-10.447 4.411-10.447 11.954 0 8.287 3.637 12.578 11.82 12.578m-15.233-7.767c0-7.952-10.842-5.862-10.842-9.358 0-1.18 1.097-1.94 3.096-1.94 2.166.02 4.31.42 6.338 1.18l.501-4.926a17.904 17.904 0 00-6.729-1.29c-6.108 0-9.019 3.045-9.019 7.241 0 8.063 11.024 5.932 11.024 9.623 0 1.37-1.003 2.32-3.448 2.32a14.956 14.956 0 01-6.769-1.635l-.626 4.952a15.55 15.55 0 007.435 1.64c6.419 0 9.02-3.16 9.02-7.807m-21.18-16.335h-6.063v15.2c0 2.425-1.253 3.556-3.913 3.556s-3.918-1.21-3.918-3.556V7.737h-6.028v15.32c0 5.621 3.247 8.782 9.98 8.782 6.735 0 9.977-3.04 9.977-8.782l-.035-15.235zm-56.209-5.711v29.298h5.828V16.525l-.04-3.161.08-.04 1.097 2.97 5.988 15.115h4.384l6.013-15.154 1.097-2.971.115.04-.08 3.166v14.92h6.013V2.11h-7.246l-6.85 17.11-1.096 2.931h-.11l-1.098-2.93-6.82-17.11h-7.275zM368.44 17.155c.27-3.441 1.408-4.811 4.344-4.811 2.545 0 4.114 1.33 4.194 4.811h-8.538zm5.677 14.684a19.312 19.312 0 007.746-1.5l-.661-4.882a17.398 17.398 0 01-6.344 1.176c-4.068 0-6.012-1.5-6.303-5.437h13.82c.11-.946.162-1.898.155-2.85 0-7.503-3.718-11.004-9.786-11.004-7.125 0-10.447 4.411-10.447 11.954 0 8.287 3.638 12.578 11.82 12.578m-16.17-.43V16.33c0-5.702-2.935-9.063-7.94-9.063a9.104 9.104 0 00-5.918 2.03l-.116-.074.076-3.126V.705l-6.063.31V31.41h6.063V14.454a5.073 5.073 0 014.038-1.8c2.58 0 3.798 1.25 3.798 3.676v15.08l6.063.034zm-24.74-22.656a16.91 16.91 0 00-5.712-1c-7.591 0-10.838 4.41-10.838 12.073 0 8.087 3.713 12.068 10.717 12.068 2.546 0 4.66-.5 6.068-1.365l-.43-4.701a10.5 10.5 0 01-4.305.875c-3.678 0-5.757-1.936-5.757-6.877 0-4.862 1.453-6.647 5.872-6.647 1.366.026 2.72.27 4.009.72l.376-5.146zm-21.49-6.172C311.715.9 310.662 0 308.272 0s-3.477.94-3.477 2.616c0 1.915 1.132 2.576 3.477 2.576 2.345 0 3.442-.856 3.442-2.576m-.35 28.793V7.737l-6.218.27V31.41h6.218zm-13.028 0V.705l-6.143.27V31.41h6.143zm-10.732-19.145V7.762h-5.286V2.111l-4.77.42-1.003 5.206h-2.936v4.502h2.66v12.003c0 4.426 2.31 7.157 7.046 7.157a11.541 11.541 0 004.068-.66l-.35-4.406a6.64 6.64 0 01-1.88.27c-1.878 0-2.82-.765-2.82-2.551V12.264h5.27zm-23.876 11.958c0 1.215-1.879 2.39-3.953 2.39s-3.372-.77-3.372-2.935c0-1.94 1.258-2.931 3.958-2.931 1.143-.022 2.28.147 3.367.5v2.976zm1.373 7.187h4.65V16.765c0-6.502-2.42-9.503-9.43-9.503a20.574 20.574 0 00-8.142 1.566l.501 4.841a15.454 15.454 0 016.514-1.29c3.252 0 4.51 1.095 4.51 3.5v1.366a15.313 15.313 0 00-4.545-.66c-5.402 0-8.448 3-8.448 7.377 0 4.926 2.851 7.462 7.356 7.462 2.7 0 4.97-1 6.418-2.69l.12.04.496 2.635zm-24.897-7.187c0 1.215-1.88 2.39-3.958 2.39-2.005 0-3.368-.77-3.368-2.935 0-1.94 1.253-2.931 3.959-2.931 1.142-.021 2.28.148 3.367.5v2.976zm1.368 7.187h4.655V16.765c0-6.502-2.426-9.503-9.43-9.503a20.57 20.57 0 00-8.142 1.566l.5 4.841a15.439 15.439 0 016.514-1.29c3.252 0 4.51 1.095 4.51 3.5v1.366a15.309 15.309 0 00-4.545-.66c-5.401 0-8.453 3-8.453 7.377 0 4.926 2.857 7.462 7.356 7.462 2.706 0 4.975-1 6.423-2.69l.12.04.492 2.635zM224.23 12.264V7.762h-5.28V2.111l-4.776.42-1.002 5.206h-2.931v4.502h2.65v12.003c0 4.426 2.305 7.157 7.015 7.157a11.623 11.623 0 004.074-.66l-.356-4.406c-.61.18-1.243.27-1.879.27-1.879 0-2.816-.765-2.816-2.551V12.264h5.301zm-16.274 10.358c0-9.923-13.503-7.813-13.503-12.389 0-1.56.977-2.81 4.62-2.81 2.411.049 4.801.47 7.084 1.25l.822-5.547c-2.623-1-5.41-1.51-8.217-1.5-7.441 0-10.648 4-10.648 9.002 0 9.808 13.504 7.852 13.504 12.464 0 2.035-1.408 3.206-4.62 3.206a17.064 17.064 0 01-8.142-2.151L188 29.814a19.242 19.242 0 009.074 2.185c6.855 0 10.883-3.55 10.883-9.337m412.31 43.805l-3.57.183v21.844h3.57V66.467zm-313.139 0l-3.57.183v21.844h3.57V66.467zm-101.84 2.992c0 4.254-1.923 5.476-5.915 5.476h-5.522V64.062h5.522c4.107 0 5.914 1.37 5.914 5.422m3.947 0c0-6.023-2.932-8.685-9.86-8.685H190v27.72h3.836V78.11h5.522c7.004 0 9.86-2.957 9.86-8.65m17.663.843l.226-3.539a8.004 8.004 0 00-2.225-.296c-3.047 0-5.522 1.849-6.888 4.998h-.075l-.301-4.702-2.857.187v21.544h3.57V77.533c0-4.653 2.826-7.517 6.326-7.517a7.3 7.3 0 012.224.286m18.375 5.259h-11.251c.226-4.11 1.923-6.062 5.728-6.062 3.238 0 5.462 1.67 5.523 6.062m3.193 2.4c.04-.492.075-1.143.075-1.695 0-6.698-3.514-9.799-8.846-9.799-6.175 0-9.258 3.83-9.258 10.425 0 8.246 3.047 12.051 10.428 12.051 2.41.031 4.792-.528 6.928-1.627l-.417-2.957a13.497 13.497 0 01-6.1 1.405c-4.82 0-7.028-1.996-7.194-7.803h14.384zm22.858 3.293V66.467h-3.514v14.718c0 2.997-1.773 4.51-5.161 4.51-3.47 0-5.202-1.553-5.202-4.51V66.467h-3.514v14.787c0 4.845 2.822 7.65 8.695 7.65 5.874 0 8.736-2.77 8.736-7.65m25.866.241c0-6.008-8.279-6.989-8.279-8.872 0-1.528 4.895-3.386 4.895-7.063 0-2.922-2.786-5.249-6.818-5.249-5.648 0-8.77 3.317-8.77 9.508V94h3.514V69.479c0-4.116 1.732-6.156 5.16-6.156 2.15 0 3.515.985 3.515 2.331 0 2.957-5.312 4.697-5.312 7.393 0 3.426 8.475 4.042 8.475 8.557 0 2.464-2.224 3.682-5.347 3.682a9.792 9.792 0 01-3.92-.858l-.222 3.199c1.512.58 3.122.875 4.745.867 5.02 0 8.354-2.656 8.354-6.999m10.467-20.607c0-1.223-.753-1.888-2.294-1.888s-2.294.665-2.294 1.888c0 1.4.753 1.878 2.294 1.878s2.294-.587 2.294-1.878m9.83 11.499c0-1.77 1.693-2.888 4.368-2.888 2.001.022 3.98.413 5.834 1.153l.301-2.928a14.789 14.789 0 00-6.06-1.257c-5.16 0-7.826 2.465-7.826 6.102 0 7.27 11.482 4.993 11.482 9.858 0 2.026-1.356 3.544-4.634 3.544-2.149 0-4.71-.65-6.401-1.878l-.447 2.987c1.727 1.217 4.212 1.848 6.883 1.848 5.522 0 7.907-2.77 7.907-6.826 0-7.522-11.406-5.136-11.406-9.73m19.354 5.121c0-5.58 1.807-7.827 6.662-7.827 1.572.017 3.124.352 4.558.986l.226-3.12a14.636 14.636 0 00-5.522-1.075c-6.703 0-9.635 3.756-9.635 11.041 0 7.936 3.234 11.47 9.54 11.47 2.04.054 4.054-.471 5.798-1.514l-.261-2.853a9.485 9.485 0 01-4.784 1.227c-4.293 0-6.587-2.243-6.587-8.33m31.217 10.987h3.514v-14.59c0-5.027-2.67-7.832-7.565-7.832a8.675 8.675 0 00-6.291 2.435l-.075-.035.035-2.957V59.1l-3.515.221v29.16h3.515V71.82c.908-1.405 2.942-2.514 5.276-2.514 3.464 0 5.086 1.627 5.086 4.584l.02 14.595zm23.757-12.934h-11.266c.226-4.11 1.923-6.062 5.723-6.062 3.244 0 5.463 1.67 5.523 6.062m3.198 2.4c.035-.492.075-1.143.075-1.695 0-6.698-3.514-9.799-8.846-9.799-6.175 0-9.263 3.83-9.263 10.425 0 8.246 3.048 12.051 10.428 12.051a14.718 14.718 0 006.928-1.626l-.411-2.958a13.514 13.514 0 01-6.1 1.405c-4.82 0-7.029-1.996-7.195-7.802h14.384zm17.883-7.659l.226-3.539a7.959 7.959 0 00-2.22-.296c-3.052 0-5.522 1.849-6.892 4.998h-.076l-.3-4.702-2.857.187v21.545h3.574V77.533c0-4.653 2.822-7.517 6.326-7.517.75-.019 1.5.078 2.22.286m39.802 18.192L442.37 73.895l9.75-13.12h-4.593l-8.66 11.72h-4.178v-11.72h-3.826v27.72h3.836V75.703h4.097l9.077 12.79h4.815zm21.492-7.24V66.467h-3.514v14.718c0 2.997-1.767 4.51-5.161 4.51-3.394 0-5.196-1.553-5.196-4.51V66.467h-3.515v14.787c0 4.845 2.822 7.65 8.696 7.65s8.736-2.77 8.736-7.65m7.38 7.24h3.574v-29.38l-3.574.221v29.16zm16.11-19.291h5.523v-2.736h-5.523v-5.693l-2.78.296-.679 5.397h-3.248v2.736h3.128v13.342c0 3.85 2.008 5.95 5.829 5.95a7.952 7.952 0 003.127-.553l-.226-2.651c-.606.2-1.242.298-1.882.29-2.008 0-3.279-.906-3.279-3.144l.01-13.234zm27.709 12.05V66.468h-3.515v14.718c0 2.997-1.772 4.51-5.16 4.51-3.465 0-5.202-1.553-5.202-4.51V66.467h-3.514v14.787c0 4.845 2.821 7.65 8.695 7.65 5.874 0 8.736-2.77 8.736-7.65m18.786-10.952l.226-3.539a7.952 7.952 0 00-2.219-.296c-3.052 0-5.522 1.849-6.893 4.998h-.075l-.296-4.702-2.862.187v21.544h3.575V77.533c0-4.653 2.821-7.517 6.325-7.517.75-.019 1.5.078 2.22.286m20.528 7.181c0 6.842-2.334 8.503-5.839 8.503-2.75 0-4.633-1.257-5.522-2.696V71.864c1.165-1.666 3.128-2.627 5.497-2.627 3.695 0 5.88 1.553 5.88 8.246m3.61-.074c0-8.35-3.31-11.336-8.536-11.336a8.793 8.793 0 00-6.406 2.464l-.075-.039.04-2.957v-6.467l-3.514.222v29.198h2.37l.562-2.291.11-.035c1.396 1.7 3.73 2.736 6.527 2.736 5.688 0 8.961-3.214 8.961-11.495m19.284-1.848h-11.371c.225-4.11 1.922-6.062 5.728-6.062 3.238 0 5.462 1.67 5.522 6.062m3.194 2.4c.04-.492.075-1.143.075-1.695 0-6.698-3.515-9.799-8.846-9.799-6.175 0-9.258 3.83-9.258 10.425 0 8.246 3.042 12.051 10.427 12.051 2.41.032 4.79-.527 6.924-1.627l-.412-2.957a13.5 13.5 0 01-6.1 1.405c-4.82 0-7.029-1.996-7.194-7.803h14.384zm8.032-5.574c0-1.77 1.697-2.888 4.373-2.888 2.001.022 3.98.413 5.834 1.153l.301-2.928a14.792 14.792 0 00-6.06-1.257c-5.16 0-7.831 2.465-7.831 6.102 0 7.27 11.486 4.993 11.486 9.858 0 2.026-1.355 3.544-4.634 3.544-2.148 0-4.709-.65-6.4-1.878l-.468 3.007c1.733 1.217 4.213 1.848 6.889 1.848 5.522 0 7.907-2.77 7.907-6.827 0-7.521-11.412-5.136-11.412-9.73m21.99-11.498c0-1.223-.753-1.888-2.294-1.888-1.542 0-2.295.665-2.295 1.888 0 1.4.753 1.878 2.295 1.878 1.541 0 2.294-.587 2.294-1.878m12.28 8.31h5.523v-2.736h-5.523v-5.693l-2.781.296-.678 5.397h-3.238v2.736h3.128v13.342c0 3.85 2.008 5.95 5.828 5.95a7.957 7.957 0 003.128-.553l-.226-2.651c-.606.2-1.243.298-1.882.29-2.009 0-3.279-.906-3.279-3.144V69.203zm15.744 13.825l9.941-14.013v-2.548h-15.328l-.11 3.032h11.296l.035.073-1.767 2.366-9.98 14.048v2.508h15.965l.115-3.026h-11.899l-.04-.108 1.772-2.332z"
  })));
};

var useStyles$b = function (props) {
    return makeStyles(function (theme) {
        var _a;
        return createStyles({
            logoLink: (_a = {
                    alignSelf: 'flex-start',
                    color: props.color,
                    zIndex: 1200,
                    '&:focus-visible': {
                        outline: "4px solid " + props.color,
                    },
                    display: 'block',
                    height: 64
                },
                _a[theme.breakpoints.down('xs')] = {
                    height: 38,
                },
                _a[theme.breakpoints.down(375)] = {
                    height: 32,
                },
                _a),
            logo: {
                height: '100%',
            },
        });
    });
};

var HeaderLogo = function (_a) {
    var color = _a.color, link = _a.link, props = __rest(_a, ["color", "link"]);
    var t = useTranslation().t;
    var classes = useStyles$b({ color: color })();
    var getCurrentLocale = function () {
        var defaultLang = 'de';
        var lang = LanguageService.getCurrentStrapiLanguage();
        var currentLocale = link;
        if (currentLocale.includes("/" + lang))
            return currentLocale;
        if (lang !== defaultLang && currentLocale !== '/') {
            return currentLocale + "/" + lang;
        }
        else if (lang !== defaultLang) {
            return "" + currentLocale + lang;
        }
        return currentLocale;
    };
    return (React.createElement(Link, __assign({ className: classes.logoLink, href: getCurrentLocale(), "aria-label": t('header.logo') }, props),
        React.createElement(SvgSmbLogo, { className: classes.logo, fill: color })));
};

var css$4 = ".language-switch {\n  display: flex;\n  justify-content: flex-end;\n  flex: 1;\n}\n@media (min-width: 900px) {\n  .language-switch {\n    justify-content: center;\n  }\n}\n.language-switch__lang {\n  display: none;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  text-transform: uppercase;\n  cursor: pointer;\n  width: 3.5rem;\n  height: 3.5rem;\n}\n.language-switch__lang svg {\n  width: 1.75rem;\n}\n@media (min-width: 1024px) {\n  .language-switch__lang {\n    width: 3.5rem;\n    height: 3.5rem;\n    display: flex;\n  }\n  .language-switch__lang svg {\n    width: 1.75rem;\n  }\n}\n.language-switch__lang + .language-switch__lang {\n  margin-left: 0.5rem !important;\n}\n@media (min-width: 1024px) {\n  .language-switch__lang + .language-switch__lang {\n    margin-left: 0.5rem !important;\n  }\n}\n.language-switch__lang--intro:hover {\n  background: #0f0900;\n  color: white;\n}\n.language-switch__lang--intro:hover svg {\n  color: white;\n}\n.language-switch__lang--intro:hover svg text {\n  fill: #0f0900;\n}\n.language-switch__lang--topic {\n  background: transparent;\n  color: #f9ff4b;\n}\n.language-switch__lang--topic svg {\n  color: #f9ff4b;\n}\n.language-switch__lang--topic svg text {\n  fill: #0f0900;\n}\n.language-switch__lang--topic:hover {\n  background: #f9ff4b;\n  color: #0f0900;\n}\n.language-switch__lang--topic:hover svg {\n  color: #0f0900;\n}\n.language-switch__lang--topic:hover svg text {\n  fill: #f9ff4b;\n}\n.language-switch__lang--guide {\n  background: transparent;\n  color: #f84040;\n}\n.language-switch__lang--guide svg {\n  color: #f84040;\n}\n.language-switch__lang--guide svg text {\n  fill: #0f0900;\n}\n.language-switch__lang--guide:hover {\n  background: #f84040;\n  color: #0f0900;\n}\n.language-switch__lang--guide:hover svg {\n  color: #0f0900;\n}\n.language-switch__lang--guide:hover svg text {\n  fill: #f84040;\n}\n.language-switch__lang--selected-intro {\n  background: #0f0900;\n  color: white;\n}\n.language-switch__lang--selected-intro svg {\n  color: white;\n}\n.language-switch__lang--selected-intro svg text {\n  fill: #0f0900;\n}\n.language-switch__lang--selected-topic {\n  background: #f9ff4b;\n  color: #0f0900 !important;\n}\n.language-switch__lang--selected-topic svg {\n  color: #0f0900 !important;\n}\n.language-switch__lang--selected-topic svg text {\n  fill: #f9ff4b !important;\n}\n.language-switch__lang--selected-guide {\n  background: #f84040;\n  color: #0f0900 !important;\n}\n.language-switch__lang--selected-guide svg {\n  color: #0f0900 !important;\n}\n.language-switch__lang--selected-guide svg text {\n  fill: #f84040 !important;\n}\n.language-switch__lang--mobile {\n  display: flex !important;\n}\n@media (min-width: 1024px) {\n  .language-switch__lang--mobile {\n    display: none;\n  }\n}\n.language-switch button {\n  display: flex;\n}\n.language-switch button p {\n  font-size: 1rem;\n  line-height: 1.25rem;\n}\n@media (min-width: 600px) {\n  .language-switch button p {\n    font-size: 1.5rem;\n  }\n}\n.language-switch button.language-switch__lang {\n  width: 2rem;\n  height: 2rem;\n}\n@media (min-width: 600px) {\n  .language-switch button.language-switch__lang {\n    width: 3.5rem;\n    height: 3.5rem;\n    display: flex;\n  }\n}\n.language-switch__menu__item:not(:last-of-type) {\n  margin-right: 1rem;\n}\n.language-switch__menu__item a {\n  display: block;\n}\n.language-switch__menu__item a:hover {\n  text-decoration: none;\n}\n.language-switch__menu__item--options {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1.5rem;\n}\n@media (min-width: 1024px) {\n  .language-switch__menu__item--options {\n    display: none;\n  }\n}\n.language-switch__menu ul {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 1.5rem;\n}\n.language-switch__menu--intro ul {\n  background: white;\n}\n.language-switch__menu--intro ul a,\n.language-switch__menu--intro ul p {\n  color: #0f0900;\n}\n.language-switch__menu--topic ul {\n  background: #0f0900;\n}\n.language-switch__menu--topic ul a,\n.language-switch__menu--topic ul p {\n  color: #f9ff4b;\n}\n.language-switch__menu--guide ul {\n  background: #0f0900;\n}\n.language-switch__menu--guide ul a,\n.language-switch__menu--guide ul p {\n  color: #f84040;\n}\n.language-switch__language {\n  border-bottom: 0.25rem solid transparent;\n}\n.language-switch__language--selected {\n  border-bottom: 0.25rem solid;\n}";
n(css$4,{});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var LanguageSwitch = function (_a) {
    var platform = _a.platform, className = _a.className, localizations = _a.localizations;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState('de'), selectedLanguage = _c[0], setSelectedLanguage = _c[1];
    var strapiLanguage = LanguageService.getCurrentStrapiLanguage();
    var currentLanguage = LanguageService.getCurrentLanguage();
    var t = useTranslation().t;
    useEffect(function () {
        if (currentLanguage) {
            setSelectedLanguage(currentLanguage);
        }
    }, [currentLanguage]);
    var selectedLanguageClass = function (lang, anchorEl) {
        return "" + strapiLanguage.toLocaleLowerCase() === lang || anchorEl
            ? "language-switch__lang language-switch__lang--" + platform + " language-switch__lang--selected-" + platform
            : "language-switch__lang language-switch__lang--" + platform;
    };
    var mobileClass = function (isMobile) {
        return isMobile ? "language-switch__lang--mobile" : '';
    };
    var handleClick = function () {
        var anchorEl = document.querySelector('header');
        setAnchorEl(anchorEl);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var renderLanguageOptions = function (option, isMobile) {
        var lang = option.value.toLocaleLowerCase();
        var optionObj = getLanguageObject(lang, option.icon, true);
        return (React.createElement(Link, { tabIndex: 0, key: optionObj.value, href: getLanguageRoute(option), hrefLang: optionObj.hrefLang, "aria-label": optionObj.ariaLabel, className: selectedLanguageClass(optionObj.value) + " " + mobileClass(isMobile) },
            React.createElement("svg", { viewBox: "0 0 28 30", dangerouslySetInnerHTML: { __html: optionObj.icon } })));
    };
    var getLanguageObject = function (lang, icon, options) {
        var locale = lang.toLocaleLowerCase();
        if (options)
            return {
                value: lang,
                hrefLang: t("language." + locale + ".hrefLang"),
                ariaLabel: t("language." + locale + ".ariaLabel"),
                icon: getLanguageOptionIcon(icon),
            };
        return {
            value: lang,
            label: t("language." + locale + ".label"),
            hrefLang: t("language." + locale + ".hrefLang"),
            ariaLabel: t("language." + locale + ".ariaLabel"),
        };
    };
    var renderMenuItem = function (lang) {
        var routeObj = getLanguageObject(lang.value);
        var route = getLanguageRoute(lang, localizations.availableLanguages, true);
        return (React.createElement("li", { className: "language-switch__menu__item", key: routeObj.value, tabIndex: -1 }, route ? (React.createElement(Link, { variant: "h4", tabIndex: 0, href: route, hrefLang: routeObj.hrefLang, "aria-label": routeObj.ariaLabel, className: 'language-switch__language' }, routeObj.label)) : (React.createElement(Typography, { component: 'p', variant: 'h4', className: 'language-switch__language language-switch__language--selected' }, routeObj.label))));
    };
    var StyledMenu = withStyles({
        paper: {
            left: '0 !important',
            width: '100%',
            right: 0,
            maxWidth: '100%',
            borderRadius: 0,
            boxShadow: 'none',
            outlineColor: 'transparent !important',
        },
    })(function (props) { return (React.createElement(Menu, __assign({ elevation: 0, getContentAnchorEl: null, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
        } }, props))); });
    return (React.createElement("div", { className: "language-switch " + className },
        React.createElement("button", { className: "button-reset " + selectedLanguageClass('', Boolean(anchorEl)) + " " + mobileClass(true), "aria-controls": "customized-menu", "aria-haspopup": "true", onClick: handleClick },
            React.createElement(Typography, { component: 'p', variant: 'h4' }, selectedLanguage)),
        localizations.options &&
            localizations.options.map(function (option) {
                return renderLanguageOptions(option);
            }),
        React.createElement(StyledMenu, { className: "language-switch__menu language-switch__menu--" + platform + " ", id: "customized-menu", anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleClose },
            localizations.main &&
                localizations.main.map(function (lang) {
                    return renderMenuItem(lang);
                }),
            React.createElement("li", { className: "language-switch__menu__item language-switch__menu__item--options", tabIndex: -1 }, localizations.options &&
                localizations.options.map(function (option) {
                    return renderLanguageOptions(option, true);
                })))));
};

var useStyles$c = function (props) {
    return makeStyles(function () {
        return createStyles({
            toolbar: {
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                padding: 0,
                maxWidth: 1280,
                margin: '0 auto',
                '& a': {
                    '&:focus-visible': {
                        outline: "4px solid " + props.color + " !important",
                    },
                },
            },
            languageSwitch: {
                '& li a': {
                    '&:focus-visible': {
                        outline: "4px solid " + props.color + " !important",
                    },
                },
            },
            menuButton: {
                alignItems: 'center',
                padding: 0,
                color: 'inherit',
                '&:focus-visible': {
                    outline: "4px solid " + props.color + " !important",
                },
            },
            menuButtonFocus: {
                '&:focus-visible': {
                    outline: "4px solid " + props.color + " !important",
                },
            },
            title: {
                marginRight: 10,
                color: props.color,
                textTransform: 'uppercase',
            },
            menuIconArrow: {
                color: props.color,
            },
        });
    });
};

var css$5 = ".header-toolbar {\n  display: flex;\n  padding: 0;\n  max-width: 1280;\n  margin: 0 auto;\n  width: 100%;\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n@media (min-width: 500px) {\n  .header-toolbar {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n}\n@media (min-width: 678px) {\n  .header-toolbar {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n}\n.header-toolbar__item {\n  display: flex !important;\n  justify-content: space-between;\n}\n@media (min-width: 900px) {\n  .header-toolbar__item {\n    justify-content: unset !important;\n    align-items: center !important;\n    width: auto;\n    flex: 1;\n  }\n}\n.header-toolbar__menu {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-end !important;\n  width: auto !important;\n  align-self: flex-end;\n}\n@media (min-width: 900px) {\n  .header-toolbar__menu {\n    align-self: unset;\n  }\n}\n.header-toolbar button:focus-visible,\n.header-toolbar a:focus-visible {\n  outline: 4px solid;\n}\n.header-toolbar--with-lang {\n  flex-direction: column;\n}\n@media (min-width: 900px) {\n  .header-toolbar--with-lang {\n    flex-direction: row;\n  }\n}\n.header-toolbar--with-lang .header-toolbar__item {\n  width: 100%;\n}";
n(css$5,{});

/* eslint-disable no-console */
var HeaderToolbar = function (props) {
    var onMenuOpen = props.onMenuOpen, color = props.color, title = props.title, type = props.type, shouldDisplayLang = props.shouldDisplayLang, logoLink = props.logoLink, localizations = props.localizations, children = props.children;
    var classes = useStyles$c(props)();
    var platform = type ? type.toLocaleLowerCase() : '';
    var getToolbarClassName = function () {
        return "header-toolbar header-toolbar--with-lang " + classes.toolbar;
    };
    return (React.createElement(Toolbar, { className: getToolbarClassName() },
        React.createElement("div", { className: "header-toolbar__item" },
            React.createElement(HeaderLogo, { color: color, link: logoLink }),
            shouldDisplayLang && (React.createElement(LanguageSwitch, { platform: platform, className: classes.languageSwitch, localizations: localizations })),
            children),
        React.createElement(ButtonBase, { className: "header-toolbar__menu " + classes.menuButtonFocus, onClick: onMenuOpen },
            React.createElement(Typography, { variant: "h2", component: "h1", className: classes.title }, title),
            React.createElement(DehazeIcon, { viewBox: "-5 0 24 24", className: classes.menuIconArrow, fontSize: 'large' }))));
};

var NavigationDrawer = function (props) {
    var children = props.children, open = props.open, onClose = props.onClose;
    var classes = useStyles(props)();
    return (React.createElement("nav", { className: classes.navigation },
        React.createElement(Drawer, { open: open, anchor: "top", variant: "temporary", classes: { paper: classes.drawerPaper }, ModalProps: {
                keepMounted: true,
                disableScrollLock: false,
                BackdropProps: {
                    invisible: true,
                },
            }, onClose: onClose },
            React.createElement("div", { className: classes.content }, children))));
};

var useStyles$d = function (props) {
    return makeStyles(function (theme) {
        return createStyles({
            link: {
                display: 'inline-block',
                padding: '20px 10px 20px 10px',
                textDecoration: 'none !important',
                background: 'transparent',
                '&:focus': {
                    outline: '0 !important',
                },
                '&:focus-visible': {
                    outline: "4px solid " + props.color,
                    '& h2, & p': {
                        color: props.color,
                    },
                },
                '&:hover': {
                    '& h2, & p': {
                        color: props.color,
                    },
                },
            },
            title: {
                color: theme.palette.primary.dark,
                textTransform: 'uppercase',
                textAlign: 'end',
                transition: theme.transitions.create(['color'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
            subtitle: {
                color: theme.palette.primary.dark,
                textAlign: 'end',
                transition: theme.transitions.create(['color'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
        });
    });
};

var HeaderLink = function (props) {
    var selected = props.selected, selectedColor = props.selectedColor, title = props.title, subtitle = props.subtitle, href = props.href, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave;
    var classes = useStyles$d(props)();
    var mouseOver = function () {
        !selected && onMouseOver && onMouseOver();
    };
    var mouseLeave = function () {
        !selected && onMouseLeave && onMouseLeave();
    };
    return (React.createElement(Link, { href: href, className: classes.link, onMouseOver: mouseOver, onMouseLeave: mouseLeave, onFocus: mouseOver, onBlur: mouseLeave },
        React.createElement(Typography, { variant: "h1", component: "h2", className: classes.title, style: { color: selected ? selectedColor : '' } }, title),
        React.createElement(Typography, { variant: "subtitle1", component: "p", className: classes.subtitle, style: { color: selected ? selectedColor : '' } }, subtitle)));
};

// import {
//   navHeight,
//   navHeightMob,
// } from './components/HeaderDrawer/navigationDrawer.jss';
var useStyles$e = function () {
    return makeStyles(function (theme) {
        var _a;
        return createStyles({
            appBar: {
                boxShadow: 'none',
                background: 'transparent',
                // height: navHeight,
                zIndex: 1000,
                display: 'flex',
                justifyContent: 'center',
            },
            appBarWithLang: {
            // height: navHeightMob,
            // [theme.breakpoints.up(900)]: {
            //   height: navHeight,
            // },
            },
            appBarBlack: {
                background: '#0F0900 !important',
            },
            toolbar: {
                display: 'flex',
                justifyContent: 'center',
                height: '100%',
            },
            drawerHeader: {
                marginBottom: '.5rem',
                // height: '64px',
                display: 'flex',
                alignItems: 'center',
            },
            wrapper: {
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                maxWidth: '1280px',
                width: '100%',
                margin: '0 auto',
                padding: '0 20px',
            },
            buttonArea: {
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
            },
            menuButton: {
                alignItems: 'center',
                padding: 0,
                '&:focus-visible': {
                    outline: "4px solid",
                    color: 'inhert',
                },
            },
            menuText: {
                marginRight: 10,
                // [theme.breakpoints.down('xs')]: {
                //   fontSize: '1.35rem',
                // },
                transition: theme.transitions.create(['opacity'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
            menuIconArrow: {
                transform: 'rotate(-90deg)',
                transition: theme.transitions.create(['transform'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
            menuIconClose: {
                fontSize: '3rem',
                transition: theme.transitions.create(['transform'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
            sectionWrapper: (_a = {
                    paddingLeft: '1rem',
                    paddingRight: '1rem'
                },
                _a[theme.breakpoints.up(500)] = {
                    paddingLeft: '1.5rem',
                    paddingRight: '1.5rem',
                },
                _a[theme.breakpoints.up(678)] = {
                    paddingLeft: '2rem',
                    paddingRight: '2rem',
                },
                _a[theme.breakpoints.up(1024)] = {
                    paddingLeft: '3rem',
                    paddingRight: '3rem',
                },
                _a[theme.breakpoints.up('lg')] = {
                    paddingLeft: '4rem',
                    paddingRight: '4rem',
                },
                _a),
        });
    });
};

/* eslint-disable no-console */
var useHeaderFadeInOutAnimation = function () {
    var ref = useState(createRef())[0];
    var _a = useState(1), appBarOpacity = _a[0], setAppBarOpacity = _a[1];
    var _b = useState('visible'), appBarVisibility = _b[0], setAppBarVisibility = _b[1];
    var history = useHistory();
    var updateAppBarOpacity = function () {
        if (!ref.current) {
            return;
        }
        var nativeElement = ref.current;
        var scrollY = window.scrollY;
        var opacity;
        var currectOpacity;
        var visibility;
        if (!scrollY) {
            opacity = 1;
            visibility = 'visible';
        }
        else if (scrollY - 50 >= nativeElement.offsetHeight) {
            opacity = 0;
            visibility = 'hidden';
        }
        else {
            currectOpacity =
                (nativeElement.offsetHeight - scrollY - 50) /
                    nativeElement.offsetHeight;
            opacity = currectOpacity > 0 ? currectOpacity : 0;
            visibility = opacity === 0 ? 'hidden' : 'visible';
        }
        setAppBarVisibility(visibility);
        setAppBarOpacity(opacity);
    };
    useLayoutEffect(function () {
        var unregisterHistoryListener = history.listen(updateAppBarOpacity);
        document.addEventListener('scroll', updateAppBarOpacity);
        return function () {
            unregisterHistoryListener();
            document.removeEventListener('scroll', updateAppBarOpacity);
        };
    }, []);
    return {
        opacity: appBarOpacity,
        visibility: appBarVisibility,
        ref: ref,
    };
};

/* eslint-disable no-console */
var useHeaderPalette = function (palette) {
    var _a;
    if (palette === void 0) { palette = {}; }
    var _b = useState((_a = palette.main) !== null && _a !== void 0 ? _a : '#ffffff'), main = _b[0], setMain = _b[1];
    return { main: main, handlers: { setMain: setMain } };
};
var useDrawer = function () {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var closeDrawer = useCallback(function () {
        setOpen(false);
    }, []);
    var openDrawer = useCallback(function () {
        setOpen(true);
    }, []);
    return { open: open, handlers: { closeDrawer: closeDrawer, openDrawer: openDrawer } };
};
var Header = function (props) {
    var isBlackBackground = props.isBlackBackground, shouldDisplayLang = props.shouldDisplayLang, currentPortal = props.currentPortal, configuration = props.configuration, children = props.children;
    var backgroundColor = '#0f0900f7'; // 97% opacity
    var _a = useState(''), selectedColor = _a[0], setSelectedColor = _a[1];
    var _b = useState(true), selectedLink = _b[0], setSelectedLink = _b[1];
    var _c = useState(''), color = _c[0], setColor = _c[1];
    var _d = useState(''), title = _d[0], setTitle = _d[1];
    var _e = useState(''), drawerColor = _e[0], setDrawerColor = _e[1];
    var siteHeaderMenu = new SiteConfigService();
    var _f = siteHeaderMenu.getSiteConfigData(), loading = _f.loading, _g = _f.data, links = _g.headerData, localizations = _g.localizations;
    useEffect(function () {
        if (!loading && !links)
            return;
        if (!loading) {
            links &&
                links.forEach(function (link) {
                    if (link.type === currentPortal) {
                        var color_1 = (link === null || link === void 0 ? void 0 : link.drawerColor) ? link === null || link === void 0 ? void 0 : link.drawerColor : link === null || link === void 0 ? void 0 : link.color;
                        setSelectedColor(color_1);
                        setMain(color_1);
                    }
                });
            var currentPortalLinkConfig = (links && links.find(function (_a) {
                var type = _a.type;
                return type === currentPortal;
            })) ||
                (links && links[0]);
            var color_2 = currentPortalLinkConfig.color, title_1 = currentPortalLinkConfig.title, drawerColor_1 = currentPortalLinkConfig.drawerColor;
            setColor(color_2);
            setTitle(title_1);
            setDrawerColor(drawerColor_1);
        }
    }, [loading]);
    //Header fade out/in animation function
    var _h = useHeaderFadeInOutAnimation(), appBarRef = _h.ref, appBarOpacity = _h.opacity, appBarVisibility = _h.visibility;
    var _j = useDrawer(), open = _j.open, _k = _j.handlers, closeDrawer = _k.closeDrawer, openDrawer = _k.openDrawer;
    var _l = useHeaderPalette({
        main: drawerColor,
    }), mainColor = _l.main, handlers = _l.handlers;
    var setMain = handlers.setMain;
    var setCurrentPortalColors = useCallback(function () {
        drawerColor ? setMain(drawerColor) : setMain(color);
        setSelectedLink(true);
    }, [drawerColor]);
    var handleDrawerClose = useCallback(function () {
        closeDrawer();
        setCurrentPortalColors();
    }, []);
    var onLinkMouseOver = function (color, drawerColor) {
        drawerColor ? setMain(drawerColor) : setMain(color);
        setSelectedLink(false);
    };
    var classes = useStyles$e()();
    var getAppBarClass = function () {
        return isBlackBackground
            ? classes.appBar + " " + classes.appBarBlack + " " + classes.appBarWithLang
            : classes.appBar + " " + classes.appBarWithLang;
    };
    var getLogoLink = function () {
        if (links) {
            var logoLink = links.filter(function (link) { return link.type === 'INTRO'; });
            return logoLink[0].href;
        }
        return '/';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MuiThemeProvider, { theme: CommonTheme },
            !open && (React.createElement(AppBar, { position: "fixed", className: getAppBarClass(), ref: appBarRef, style: {
                    opacity: appBarOpacity,
                    visibility: appBarVisibility,
                } }, !loading && (React.createElement("div", { className: (classes.wrapper, classes.sectionWrapper) },
                React.createElement(HeaderToolbar, { configuration: configuration, title: title, type: currentPortal, color: color, logoLink: getLogoLink(), localizations: localizations, shouldDisplayLang: shouldDisplayLang, onMenuOpen: openDrawer }, children))))),
            !loading && (React.createElement(NavigationDrawer, { open: open, onClose: handleDrawerClose, backgroundColor: backgroundColor },
                React.createElement(Grid, { container: true, justifyContent: "center", alignItems: "flex-start", className: classes.drawerHeader },
                    React.createElement(Grid, { item: true, xs: 8, container: true, justifyContent: "flex-start", alignItems: "flex-start" },
                        React.createElement(HeaderLogo, { color: mainColor, tabIndex: -1, link: getLogoLink() })),
                    React.createElement(Grid, { item: true, xs: 4, container: true, justifyContent: "flex-end", alignItems: "flex-start" },
                        React.createElement(ButtonBase, { className: classes.menuButton, color: "inherit", onClick: closeDrawer, style: { outlineColor: mainColor } },
                            React.createElement(CloseOutlinedIcon, { className: classes.menuIconClose, style: { color: mainColor } })))),
                React.createElement(Grid, { container: true, direction: "column", alignItems: "flex-end" }, links &&
                    links.map(function (_a, index) {
                        var href = _a.href, color = _a.color, drawerColor = _a.drawerColor, title = _a.title, subTitle = _a.subTitle, type = _a.type;
                        return (React.createElement(HeaderLink, { selected: selectedLink && type === currentPortal, selectedColor: selectedColor, key: index, href: href, color: mainColor, title: title, subtitle: subTitle, onMouseOver: function () { return onLinkMouseOver(color, drawerColor); }, onMouseLeave: setCurrentPortalColors }));
                    })))))));
};

var LanguageService$1 = /** @class */ (function () {
    function LanguageService() {
    }
    LanguageService.getCurrentLanguage = function () {
        return i18next.language || 'de';
    };
    return LanguageService;
}());

var useStyles$f = makeStyles(function (theme) {
    var _a;
    return createStyles({
        container: (_a = {
                flex: 1,
                height: '100%',
                width: '100%',
                maxWidth: 1280,
                margin: '0 auto',
                padding: '0 10px',
                paddingTop: 100,
                maxHeight: '100%'
            },
            _a[theme.breakpoints.down('md')] = {
                paddingTop: 50,
            },
            _a),
        content: {
            marginTop: navHeight,
            maxWidth: 600,
            width: '100%',
            margin: '0 auto',
        },
        toMainPageContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
            paddingTop: 20,
        },
        toMainPageLink: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
        },
    });
});

var NotFoundPage = function () {
    var _a, _b;
    var t = useTranslation().t;
    var pathname = useLocation().pathname;
    var classes = useStyles$f();
    var type = 'notFound';
    if (pathname === '/gebärdensprache') {
        type = pathname.split('/')[1];
    }
    var getCurrentLocale = function () {
        var defaultLang = 'de';
        var lang = LanguageService$1.getCurrentLanguage();
        var currentLocale = '';
        if (lang !== defaultLang) {
            currentLocale = "/" + currentLocale + lang;
        }
        return currentLocale;
    };
    var textContext = {
        notFound: {
            title: '404',
            subTitle: t('notFoundPage.title'),
            description: t('notFoundPage.description'),
            link: {
                href: "" + getCurrentLocale(),
                text: t('notFoundPage.toMainPage'),
            },
        },
        gebärdensprache: {
            title: 'Gebärdensprache',
            subTitle: t('notFoundPage.title'),
            description: t('notFoundPage.description'),
            link: {
                href: "/",
                text: t('notFoundPage.toMainPage'),
            },
        },
    };
    return (React.createElement("div", { className: classes.container },
        React.createElement(Grid, { className: classes.content, container: true },
            React.createElement(Grid, { item: true, lg: 12, md: 12, xs: 12 },
                React.createElement(Typography, { variant: "h1", component: "p" }, (_a = textContext[type]) === null || _a === void 0 ? void 0 : _a.title)),
            React.createElement(Grid, { item: true, lg: 12, md: 12, xs: 12 },
                React.createElement(Typography, { variant: "h3", component: "p" }, t('notFoundPage.title'))),
            React.createElement(Grid, { item: true, lg: 12, md: 12, xs: 12 },
                React.createElement(Typography, { variant: "body1", component: "p" }, t('notFoundPage.description')),
                React.createElement("div", { className: classes.toMainPageContainer },
                    React.createElement(Link, { component: Link$2, to: (_b = textContext[type]) === null || _b === void 0 ? void 0 : _b.link.href, className: classes.toMainPageLink, color: "secondary" },
                        React.createElement(ArrowBackIosIcon, { color: "secondary" }),
                        t('notFoundPage.toMainPage')))))));
};

var ClanOtNarrowBold = "data:font/woff2;base64,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";

var ClanOtNarrowBook = "data:font/woff2;base64,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";

var ClanOtNarrowMedium = "data:font/woff2;base64,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";

var ClanOtNarrowNews = "data:font/woff2;base64,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";

var GtWalsheimProBlack = "data:font/woff2;base64,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";

var GtWalsheimProBold = "data:font/woff2;base64,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";

var globalStyles = function (theme) { return ({
    '@global': {
        '@font-face': [
            {
                fontFamily: 'ClanOTNarrow',
                src: "local('ClanOTNarrow-Bold'), url(" + ClanOtNarrowBold + ") format('woff2')",
                fontWeight: 'bold',
                fontStyle: 'normal',
                fontDisplay: 'swap',
            },
            {
                fontFamily: 'ClanOTNarrow',
                src: "local('ClanOTNarrow-Medium'), url(" + ClanOtNarrowMedium + ") format('woff2')",
                fontWeight: 500,
                fontStyle: 'normal',
                fontDisplay: 'swap',
            },
            {
                fontFamily: 'ClanOTNarrow-Book',
                src: "local('ClanOTNarrow-Book'), url(" + ClanOtNarrowBook + ") format('woff2')",
                fontWeight: 'normal',
                fontStyle: 'normal',
                fontDisplay: 'swap',
            },
            {
                fontFamily: 'ClanOTNarrow-News',
                src: "local('ClanOTNarrow-News'), url(" + ClanOtNarrowNews + ") format('woff2')",
                fontStyle: 'normal',
                fontWeight: 'normal',
                fontDisplay: 'swap',
            },
            {
                fontFamily: 'GTWalsheimPro-Bold',
                src: "local('GTWalsheimPro-Bold'), url(" + GtWalsheimProBold + ") format('woff2')",
                fontStyle: 'normal',
                fontWeight: 700,
                fontDisplay: 'swap',
            },
            {
                fontFamily: 'GTWalsheimPro-Black',
                src: "local('GTWalsheimPro-Black'), url(" + GtWalsheimProBlack + ") format('woff2')",
                fontStyle: 'normal',
                fontWeight: 900,
                fontDisplay: 'swap',
            },
        ],
        html: {
            minHeight: '100%',
            backgroundColor: theme.palette.primary.main,
            fontSize: 16,
            '@media (max-width: 500px)': {
                fontSize: 10,
            }
        },
        body: {
            minHeight: '100%',
            fontFamily: 'ClanOTNarrow, Arial',
            fontWeight: 'normal',
            backgroundColor: 'white',
            color: '#0F0900',
        },
        '#root': {
            minHeight: '100%',
        },
        '*': {
            touchAction: 'manipulation',
        },
    },
}); };
function CustomCssBaseline() {
    return globalStyles;
}
var CustomCssBaseline$1 = withStyles$1(globalStyles)(CustomCssBaseline);

var useLazyLoadImage = function (src) {
    var _a = useState(null), source = _a[0], setSource = _a[1];
    var _b = useState(false), isError = _b[0], setIsError = _b[1];
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var blockReactRef = useRef(null);
    var handleLoad = function () {
        setIsLoading(false);
    };
    var imageRef = new Image();
    imageRef.addEventListener('load', handleLoad);
    imageRef.onerror = function () {
        setIsLoading(false);
        setIsError(true);
    };
    var loadImage = function (_src) {
        setIsError(false);
        setIsLoading(true);
        setSource(_src);
        imageRef.src = _src;
    };
    useEffect(function () {
        var didCancel = false;
        var observer;
        if (blockReactRef.current !== null && source !== src) {
            if (IntersectionObserver) {
                observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (!didCancel && (entry.intersectionRatio > 0 || entry.isIntersecting)) {
                            loadImage(src);
                            if (blockReactRef.current) {
                                observer.unobserve(blockReactRef.current);
                            }
                        }
                    });
                }, {
                    threshold: 0.01,
                    rootMargin: '0%',
                });
                observer.observe(blockReactRef.current);
            }
            else {
                loadImage(src);
            }
        }
        return function () {
            didCancel = true;
            if (blockReactRef.current) {
                observer === null || observer === void 0 ? void 0 : observer.unobserve(blockReactRef.current);
            }
        };
    }, [src, source, blockReactRef.current]);
    useEffect(function () {
        return function () {
            imageRef.removeEventListener('load', handleLoad);
        };
    }, []);
    return { isLoading: isLoading, isError: isError, source: source, blockRef: blockReactRef };
};

var useStyles$g = makeStyles(function () {
    return createStyles({
        image: {
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        },
        loaderContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            left: 0,
            top: 0,
        },
    });
});

var LazyLoadImage = function (props) {
    var _a = props.width, width = _a === void 0 ? '100%' : _a, _b = props.height, height = _b === void 0 ? '100%' : _b, _c = props.cssClass, cssClass = _c === void 0 ? '' : _c, _d = props.Fallback, Fallback = _d === void 0 ? null : _d, _e = props.src, src = _e === void 0 ? '' : _e, _f = props.size, size = _f === void 0 ? 'contain' : _f, onClick = props.onClick;
    var _g = useLazyLoadImage(src), isError = _g.isError, isLoading = _g.isLoading, source = _g.source, blockRef = _g.blockRef;
    var classes = useStyles$g();
    var imageDimensions = {
        height: height,
        width: width,
    };
    var handleClick = function () { return onClick && onClick(); };
    var styles = __assign(__assign({}, imageDimensions), { backgroundSize: size, backgroundImage: "url(" + source + ")" });
    return (React.createElement("div", { style: __assign(__assign({}, imageDimensions), { position: 'relative' }), className: cssClass },
        (isLoading || isError) && (React.createElement("div", { className: classes.loaderContainer, style: imageDimensions },
            isLoading && React.createElement(LoadingSpinner, null),
            isError && Fallback)),
        React.createElement("div", { ref: blockRef, className: classes.image, style: styles, onClick: handleClick })));
};

var TextModuleType;
(function (TextModuleType) {
    TextModuleType[TextModuleType["TEXT"] = 0] = "TEXT";
    TextModuleType[TextModuleType["RESEARCH"] = 1] = "RESEARCH";
    TextModuleType[TextModuleType["TOPIC"] = 2] = "TOPIC";
    TextModuleType[TextModuleType["GUIDE"] = 3] = "GUIDE";
    TextModuleType[TextModuleType["INTRO"] = 4] = "INTRO";
})(TextModuleType || (TextModuleType = {}));
var TextSectionContext = createContext({
    sections: [],
});

var css$6 = ".text-card {\n  width: 100%;\n}\n.text-card__header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.text-card__header--headline {\n  font-size: 2.25rem !important;\n  margin-right: 0.5rem !important;\n  text-transform: uppercase !important;\n}\n@media (min-width: 500px) {\n  .text-card__header--headline {\n    font-size: 2.5rem !important;\n  }\n}\n.text-card__header--headline2 {\n  font-size: 2.25rem !important;\n}\n@media (min-width: 500px) {\n  .text-card__header--headline2 {\n    font-size: 2.5rem !important;\n  }\n}\n.text-card__horizontal-line {\n  margin: 1.75rem 0 2.5rem !important;\n  height: 0.375rem;\n  background: #0f0900 !important;\n}\n.text-card__rich-text {\n  width: 100%;\n  font-weight: 500 !important;\n}\n@media (min-width: 800px) {\n  .text-card__rich-text {\n    max-width: 80%;\n  }\n}\n.text-card__rich-text p:not(:last-of-type) {\n  margin-bottom: 2rem;\n}\n.text-card__rich-text__leichte-sprache {\n  font-size: 1.5rem !important;\n  letter-spacing: 0.09625em !important;\n}\n.text-card__rich-text__leichte-sprache p:not(:last-of-type) {\n  margin-bottom: 2.5rem;\n}\n.text-card__button {\n  display: flex;\n  padding: 3.5rem 0 3rem;\n}\n@media (min-width: 500px) {\n  .text-card__button {\n    justify-content: flex-end;\n  }\n}\n.text-card__button__link {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase !important;\n  font-weight: bold !important;\n  letter-spacing: 0.075em !important;\n  font-size: 1.5rem !important;\n  line-height: 1.75rem !important;\n}\n.text-card__button__link:hover {\n  text-decoration: underline;\n}\n.text-card__button__link svg {\n  flex-shrink: 0;\n  width: 56px;\n}\n@media (min-width: 375px) {\n  .text-card__button__link svg {\n    width: initial;\n  }\n}\n.text-card__button__arrow {\n  margin-right: 1rem;\n}\n.text-card__button--no-padding {\n  padding-bottom: 0;\n}";
n(css$6,{});

/* eslint-disable no-console */
function TextSection(_a) {
    var textSectionData = _a.textSectionData, _b = _a.target, target = _b === void 0 ? '_blank' : _b, noPadding = _a.noPadding;
    var lang = LanguageService.getCurrentStrapiLanguage();
    var getButtonCss = function () {
        return noPadding
            ? 'text-card__button text-card__button--no-padding'
            : 'text-card__button';
    };
    function createMarkup(richText) {
        return { __html: richText };
    }
    var getTextClassVariant = function () {
        return lang === 'de-LS'
            ? 'text-card__rich-text text-card__rich-text__leichte-sprache'
            : 'text-card__rich-text';
    };
    return (React.createElement("div", { className: 'text-card' },
        React.createElement("div", { className: 'text-card__header' },
            React.createElement(Typography$1, { className: 'text-card__header--headline', variant: 'h1', component: 'h2' },
                textSectionData.title,
                " ",
                textSectionData.subtitle && ' – '),
            React.createElement(Typography$1, { variant: 'h1', component: "h3", className: 'text-card__header--headline2' }, textSectionData.subtitle)),
        React.createElement("div", { className: 'text-card__horizontal-line' }),
        React.createElement(Typography$1, { className: getTextClassVariant(), variant: 'body2', component: 'div', dangerouslySetInnerHTML: createMarkup(textSectionData.text) }),
        textSectionData.link &&
            textSectionData.link.href &&
            textSectionData.link.caption && (React.createElement("div", { className: getButtonCss() },
            React.createElement(Link$1, { className: 'text-card__button__link', href: textSectionData.link.href, target: target, "aria-label": "Link zu " + textSectionData.title, variant: 'subtitle1' },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "68.7", height: "52.842", viewBox: "0 0 68.7 52.842", className: 'text-card__button__arrow' },
                    React.createElement("path", { id: "icon_arrow_link", d: "M51.568,19.816H0V33.026H51.568V52.842L68.7,26.421,51.568,0V19.816Z", fill: "#0f0900" })),
                textSectionData.link.caption)))));
}

var css$7 = ".video-card {\n  width: 100%;\n}\n.video-card__header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.video-card__header--headline {\n  margin-right: 0.5rem !important;\n  text-transform: uppercase !important;\n}\n.video-card__horizontal-line {\n  margin: 1.75rem 0 2.5rem !important;\n  height: 0.375rem;\n  background: #0f0900 !important;\n}\n.video-card__video-conatiner {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  flex-wrap: wrap;\n}\n.video-card__player {\n  position: relative;\n  width: 100% !important;\n  height: 100% !important;\n  padding-bottom: 56.25%;\n}\n.video-card__player:not(.video-card__player:last-of-type) {\n  margin-bottom: 1rem;\n}\n.video-card__player video {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  cursor: pointer;\n}\n@media (min-width: 740px) {\n  .video-card__player {\n    width: 740px !important;\n    height: 416px !important;\n    padding-bottom: 0;\n  }\n}\n.video-card__button {\n  display: flex;\n  padding: 3.5rem 0 3rem;\n  flex: 1;\n}\n@media (min-width: 500px) {\n  .video-card__button {\n    justify-content: flex-end;\n  }\n}\n@media (min-width: 740px) {\n  .video-card__button {\n    margin-left: 2rem;\n  }\n}\n.video-card__button__link {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase !important;\n  font-weight: bold !important;\n  letter-spacing: 0.075em !important;\n  font-size: 1.5rem !important;\n  line-height: 1.75rem !important;\n}\n.video-card__button__link:hover {\n  text-decoration: underline;\n}\n.video-card__button__link svg {\n  flex-shrink: 0;\n}\n.video-card__button__arrow {\n  margin-right: 1rem;\n}\n.video-card__button--no-padding {\n  padding-bottom: 0;\n}";
n(css$7,{});

function VideoSection(_a) {
    var data = _a.data, _b = _a.target, target = _b === void 0 ? '_blank' : _b, noPadding = _a.noPadding;
    var getButtoClassName = function () {
        return noPadding
            ? 'video-card__button video-card__button--no-padding'
            : 'video-card__button';
    };
    var getVideoContainerClassName = function () {
        return 'video-card__video-conatiner';
    };
    return (React.createElement("div", { className: 'video-card' },
        React.createElement("div", { className: 'video-card__header' },
            React.createElement(Typography$1, { className: 'video-card__header--headline', variant: 'h1', component: 'h2' },
                data.title,
                " ",
                data.subtitle && ' - '),
            React.createElement(Typography$1, { variant: 'h1', component: "h3" }, data.subtitle)),
        React.createElement("div", { className: 'video-card__horizontal-line' }),
        React.createElement("div", { className: getVideoContainerClassName() },
            data.assets.length > 0 &&
                data.assets.map(function (asset, index) {
                    return (React.createElement(ReactPlayer$1, { key: "video-section-" + index, className: 'video-card__player', url: asset.url, controls: true }));
                }),
            data.link && data.link.href && data.link.caption && (React.createElement("div", { className: getButtoClassName() },
                React.createElement(Link$1, { className: 'video-card__button__link', href: data.link.href, target: target, variant: 'subtitle1' },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "68.7", height: "52.842", viewBox: "0 0 68.7 52.842", className: 'video-card__button__arrow' },
                        React.createElement("path", { id: "icon_arrow_link", d: "M51.568,19.816H0V33.026H51.568V52.842L68.7,26.421,51.568,0V19.816Z", fill: "#0f0900" })),
                    data.link.caption))))));
}

var useStyles$h = makeStyles(function (theme) {
    return createStyles({
        playButton: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 35,
            width: '100%',
            maxWidth: 250,
            height: 58,
            margin: '25px 25px 25px 0px',
            cursor: 'pointer',
            color: 'inherit',
            backgroundColor: theme.palette.text.hint,
            '&:hover': {
                // TODO add to theme
                backgroundColor: theme.palette.primary.light,
                // filter: 'brightness(150%)',
                boxShadow: '0px 0px',
            },
            '&:focus': {
                outlineOffset: '8px',
                outline: "4px solid " + theme.palette.text.hint,
            },
        },
        playButtonTypo: {
            textTransform: 'uppercase',
            lineHeight: 1,
        },
    });
});

function HighlightButton(_a) {
    var caption = _a.caption, onClick = _a.onClick, children = _a.children;
    var classes = useStyles$h();
    var t = useTranslation().t;
    return (React.createElement(Button, { "aria-label": t('button play'), className: classes.playButton, onClick: function (event) { return onClick(event); } },
        React.createElement(Typography, { component: "div", variant: 'h4', className: clsx(classes.playButtonTypo) }, caption),
        children));
}

var useStyles$i = makeStyles(function (theme) {
    return createStyles({
        spinner: {
            textAlign: 'center',
            margin: 'auto',
            width: '48px',
            '& > div': {
                width: '12px',
                height: '12px',
                margin: '2px',
                backgroundColor: theme.palette.primary.dark,
                display: 'inline-block',
            },
        },
        bounce1: {
            animationDelay: '-0.32s',
            animation: '1.4s infinite ease-in-out both',
            animationName: '$bouncedelay',
        },
        bounce2: {
            animationDelay: '-0.16s',
            animation: '1.4s infinite ease-in-out both',
            animationName: '$bouncedelay',
        },
        bounce3: {
            animationDelay: '0s',
            animation: '1.4s infinite ease-in-out both',
            animationName: '$bouncedelay',
        },
        '@keyframes bouncedelay': {
            '0%, 80%, 100%': {
                transform: 'scale(0)',
            },
            '40%': {
                transform: 'scale(1.0)',
            },
        },
    });
});

var css$8 = ".spinner--imageZoom {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n}\n.spinner--imageZoom #spinner-div {\n  background: white;\n}";
n(css$8,{});

var LoadingSpinner = function (_a) {
    var _b = _a.styleClasses, styleClasses = _b === void 0 ? '' : _b;
    var classes = useStyles$i();
    return (React.createElement("div", { "data-testid": 'default-loading-spinner', className: clsx(classes.spinner, styleClasses) },
        React.createElement("div", { className: classes.bounce1, id: 'spinner-div' }),
        React.createElement("div", { className: classes.bounce2, id: 'spinner-div' }),
        React.createElement("div", { className: classes.bounce3, id: 'spinner-div' })));
};

var useStyles$j = makeStyles(function () {
    return createStyles({
        loadingWrapper: {
            height: 'calc(100vh)',
            width: '100vw',
            top: '-100px',
            position: 'relative',
            backgroundColor: '#0F0900',
        },
        wrapper: {
            height: '100%',
            width: '100%',
        },
        loadingSpinner: {
            position: 'relative',
            top: '50%',
        },
    });
});

var css$9 = ".loading-platform--intro {\n  background: #fff !important;\n}\n.loading-platform--intro #spinner-div {\n  background-color: #0f0900 !important;\n}\n.loading-platform--topics {\n  background: #0f0900 !important;\n}\n.loading-platform--topics #spinner-div {\n  background-color: #f9ff4b !important;\n}\n.loading-platform--guide {\n  background: #0f0900 !important;\n}\n.loading-platform--guide #spinner-div {\n  background-color: #f84040 !important;\n}\n.loading-platform--research {\n  background: #fff !important;\n}\n.loading-platform--research #spinner-div {\n  background-color: #0f0900 !important;\n}";
n(css$9,{});

var Spinner = function (_a) {
    var platform = _a.platform;
    var classes = useStyles$j();
    var getSpinnerClassName = function () {
        return classes.loadingWrapper + " loading-platform--" + platform;
    };
    return (React.createElement("div", { "data-testid": 'page-loading-spinner-wrapper', className: getSpinnerClassName() },
        React.createElement(LoadingSpinner, { styleClasses: classes.loadingSpinner })));
};
var areEqual = function (prevProps, nextProps) { return prevProps.loading === nextProps.loading; };
var WrappedSpinner = React.memo(Spinner, areEqual);

var useStyles$k = makeStyles(function (theme) {
    var _a;
    return createStyles({
        imageZoom: (_a = {
                height: '100vh',
                width: '100%'
            },
            _a[theme.breakpoints.down('sm')] = {
                paddingBottom: 50,
            },
            _a),
        buttonContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            color: '#fff',
            paddingBottom: 50,
        },
    });
});

var ImageZoom = function (_a) {
    var src = _a.src;
    var _b = useZoom(), zoomIn = _b.zoomIn, zoomOut = _b.zoomOut;
    var osdOptions = useMemo(function () {
        return {
            showNavigator: true,
            navigatorPosition: 'BOTTOM_RIGHT',
            navigatorAutoFade: true,
            navigatorHeight: 200,
            navigatorWidth: 200,
            maxZoomLevel: 10,
        };
    }, []);
    var sources = useMemo(function () {
        return [{ type: 'image', url: src }];
    }, [src]);
    var _c = useOpenSeadragon(sources, osdOptions), imageZoomRef = _c[0], isReady = _c[1].isReady;
    var classes = useStyles$k();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: imageZoomRef, className: classes.imageZoom }),
        React.createElement("div", { className: classes.buttonContainer },
            React.createElement(IconButton$1, { color: "inherit", onClick: zoomIn },
                React.createElement(AddCircleOutlineOutlinedIcon, null)),
            React.createElement(IconButton$1, { color: "inherit", onClick: zoomOut },
                React.createElement(RemoveCircleOutlineOutlinedIcon, null))),
        !isReady && React.createElement(LoadingSpinner, { styleClasses: "spinner--imageZoom" })));
};
var propsAreEqual = function (previousProps, nextProps) {
    return previousProps.src !== nextProps.src;
};
var ImageZoom$1 = React.memo(ImageZoom, propsAreEqual);

var useStyles$l = makeStyles(function () {
    return createStyles({
        container: {
            position: 'relative',
            height: '100vh',
            width: '100vw',
            display: 'flex',
        },
        closeButton: {
            position: 'absolute',
            right: 0,
            top: 0,
            color: '#fff',
            marginTop: '0px',
            '@media (max-width: 500px)': {
                marginTop: '5%'
            }
        },
    });
});

var ImageZoomModal = function (_a) {
    var open = _a.open, src = _a.src, onClose = _a.onClose;
    var classes = useStyles$l();
    return (React.createElement(Modal, { open: open, onClose: onClose, onContextMenu: function (event) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            event === null || event === void 0 ? void 0 : event.stopPropagation();
        } },
        React.createElement(Backdrop, { open: open },
            React.createElement("div", { className: classes.container },
                React.createElement(ViewerProvider, null,
                    React.createElement(ImageZoom$1, { src: src })),
                React.createElement(IconButton$1, { className: classes.closeButton, onClick: onClose },
                    React.createElement(CloseOutlinedIcon, { fontSize: 'large' }))))));
};

var build = createCommonjsModule(function (module) {
/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/components/LazyLoadComponent.jsx":
/*!**********************************************!*\
  !*** ./src/components/LazyLoadComponent.jsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ \"react\");\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ \"./node_modules/prop-types/index.js\");\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _PlaceholderWithoutTracking_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./PlaceholderWithoutTracking.jsx */ \"./src/components/PlaceholderWithoutTracking.jsx\");\n/* harmony import */ var _PlaceholderWithTracking_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PlaceholderWithTracking.jsx */ \"./src/components/PlaceholderWithTracking.jsx\");\n/* harmony import */ var _utils_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/intersection-observer */ \"./src/utils/intersection-observer.js\");\nfunction _typeof(obj) { \"@babel/helpers - typeof\"; if (typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; }; } return _typeof(obj); }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function\"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }\n\nfunction _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }\n\nfunction _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }\n\nfunction _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === \"object\" || typeof call === \"function\")) { return call; } else if (call !== void 0) { throw new TypeError(\"Derived constructors may only return object or undefined\"); } return _assertThisInitialized(self); }\n\nfunction _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return self; }\n\nfunction _isNativeReflectConstruct() { if (typeof Reflect === \"undefined\" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === \"function\") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }\n\nfunction _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }\n\n\n\n\n\n\n\nvar LazyLoadComponent = /*#__PURE__*/function (_React$Component) {\n  _inherits(LazyLoadComponent, _React$Component);\n\n  var _super = _createSuper(LazyLoadComponent);\n\n  function LazyLoadComponent(props) {\n    var _this;\n\n    _classCallCheck(this, LazyLoadComponent);\n\n    _this = _super.call(this, props);\n    var afterLoad = props.afterLoad,\n        beforeLoad = props.beforeLoad,\n        scrollPosition = props.scrollPosition,\n        visibleByDefault = props.visibleByDefault;\n    _this.state = {\n      visible: visibleByDefault\n    };\n\n    if (visibleByDefault) {\n      beforeLoad();\n      afterLoad();\n    }\n\n    _this.onVisible = _this.onVisible.bind(_assertThisInitialized(_this));\n    _this.isScrollTracked = Boolean(scrollPosition && Number.isFinite(scrollPosition.x) && scrollPosition.x >= 0 && Number.isFinite(scrollPosition.y) && scrollPosition.y >= 0);\n    return _this;\n  }\n\n  _createClass(LazyLoadComponent, [{\n    key: \"componentDidUpdate\",\n    value: function componentDidUpdate(prevProps, prevState) {\n      if (prevState.visible !== this.state.visible) {\n        this.props.afterLoad();\n      }\n    }\n  }, {\n    key: \"onVisible\",\n    value: function onVisible() {\n      this.props.beforeLoad();\n      this.setState({\n        visible: true\n      });\n    }\n  }, {\n    key: \"render\",\n    value: function render() {\n      if (this.state.visible) {\n        return this.props.children;\n      }\n\n      var _this$props = this.props,\n          className = _this$props.className,\n          delayMethod = _this$props.delayMethod,\n          delayTime = _this$props.delayTime,\n          height = _this$props.height,\n          placeholder = _this$props.placeholder,\n          scrollPosition = _this$props.scrollPosition,\n          style = _this$props.style,\n          threshold = _this$props.threshold,\n          useIntersectionObserver = _this$props.useIntersectionObserver,\n          width = _this$props.width;\n\n      if (this.isScrollTracked || useIntersectionObserver && (0,_utils_intersection_observer__WEBPACK_IMPORTED_MODULE_4__.default)()) {\n        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PlaceholderWithoutTracking_jsx__WEBPACK_IMPORTED_MODULE_2__.default, {\n          className: className,\n          height: height,\n          onVisible: this.onVisible,\n          placeholder: placeholder,\n          scrollPosition: scrollPosition,\n          style: style,\n          threshold: threshold,\n          useIntersectionObserver: useIntersectionObserver,\n          width: width\n        });\n      }\n\n      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PlaceholderWithTracking_jsx__WEBPACK_IMPORTED_MODULE_3__.default, {\n        className: className,\n        delayMethod: delayMethod,\n        delayTime: delayTime,\n        height: height,\n        onVisible: this.onVisible,\n        placeholder: placeholder,\n        style: style,\n        threshold: threshold,\n        width: width\n      });\n    }\n  }]);\n\n  return LazyLoadComponent;\n}((react__WEBPACK_IMPORTED_MODULE_0___default().Component));\n\nLazyLoadComponent.propTypes = {\n  afterLoad: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.func,\n  beforeLoad: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.func,\n  useIntersectionObserver: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.bool,\n  visibleByDefault: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.bool\n};\nLazyLoadComponent.defaultProps = {\n  afterLoad: function afterLoad() {\n    return {};\n  },\n  beforeLoad: function beforeLoad() {\n    return {};\n  },\n  useIntersectionObserver: true,\n  visibleByDefault: false\n};\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LazyLoadComponent);\n\n//# sourceURL=webpack://react-lazy-load-image-component/./src/components/LazyLoadComponent.jsx?");

/***/ }),

/***/ "./src/components/LazyLoadImage.jsx":
/*!******************************************!*\
  !*** ./src/components/LazyLoadImage.jsx ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ \"react\");\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ \"./node_modules/prop-types/index.js\");\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _LazyLoadComponent_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./LazyLoadComponent.jsx */ \"./src/components/LazyLoadComponent.jsx\");\nfunction _typeof(obj) { \"@babel/helpers - typeof\"; if (typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; }; } return _typeof(obj); }\n\nvar _excluded = [\"afterLoad\", \"beforeLoad\", \"delayMethod\", \"delayTime\", \"effect\", \"placeholder\", \"placeholderSrc\", \"scrollPosition\", \"threshold\", \"useIntersectionObserver\", \"visibleByDefault\", \"wrapperClassName\", \"wrapperProps\"];\n\nfunction _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }\n\nfunction _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }\n\nfunction _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function\"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }\n\nfunction _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }\n\nfunction _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }\n\nfunction _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === \"object\" || typeof call === \"function\")) { return call; } else if (call !== void 0) { throw new TypeError(\"Derived constructors may only return object or undefined\"); } return _assertThisInitialized(self); }\n\nfunction _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return self; }\n\nfunction _isNativeReflectConstruct() { if (typeof Reflect === \"undefined\" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === \"function\") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }\n\nfunction _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }\n\n\n\n\n\nvar LazyLoadImage = /*#__PURE__*/function (_React$Component) {\n  _inherits(LazyLoadImage, _React$Component);\n\n  var _super = _createSuper(LazyLoadImage);\n\n  function LazyLoadImage(props) {\n    var _this;\n\n    _classCallCheck(this, LazyLoadImage);\n\n    _this = _super.call(this, props);\n    _this.state = {\n      loaded: false\n    };\n    return _this;\n  }\n\n  _createClass(LazyLoadImage, [{\n    key: \"onImageLoad\",\n    value: function onImageLoad() {\n      var _this2 = this;\n\n      if (this.state.loaded) {\n        return null;\n      }\n\n      return function () {\n        _this2.props.afterLoad();\n\n        _this2.setState({\n          loaded: true\n        });\n      };\n    }\n  }, {\n    key: \"getImg\",\n    value: function getImg() {\n      var _this$props = this.props,\n          afterLoad = _this$props.afterLoad,\n          beforeLoad = _this$props.beforeLoad,\n          delayMethod = _this$props.delayMethod,\n          delayTime = _this$props.delayTime,\n          effect = _this$props.effect,\n          placeholder = _this$props.placeholder,\n          placeholderSrc = _this$props.placeholderSrc,\n          scrollPosition = _this$props.scrollPosition,\n          threshold = _this$props.threshold,\n          useIntersectionObserver = _this$props.useIntersectionObserver,\n          visibleByDefault = _this$props.visibleByDefault,\n          wrapperClassName = _this$props.wrapperClassName,\n          wrapperProps = _this$props.wrapperProps,\n          imgProps = _objectWithoutProperties(_this$props, _excluded);\n\n      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(\"img\", _extends({\n        onLoad: this.onImageLoad()\n      }, imgProps));\n    }\n  }, {\n    key: \"getLazyLoadImage\",\n    value: function getLazyLoadImage() {\n      var _this$props2 = this.props,\n          beforeLoad = _this$props2.beforeLoad,\n          className = _this$props2.className,\n          delayMethod = _this$props2.delayMethod,\n          delayTime = _this$props2.delayTime,\n          height = _this$props2.height,\n          placeholder = _this$props2.placeholder,\n          scrollPosition = _this$props2.scrollPosition,\n          style = _this$props2.style,\n          threshold = _this$props2.threshold,\n          useIntersectionObserver = _this$props2.useIntersectionObserver,\n          visibleByDefault = _this$props2.visibleByDefault,\n          width = _this$props2.width;\n      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_LazyLoadComponent_jsx__WEBPACK_IMPORTED_MODULE_2__.default, {\n        beforeLoad: beforeLoad,\n        className: className,\n        delayMethod: delayMethod,\n        delayTime: delayTime,\n        height: height,\n        placeholder: placeholder,\n        scrollPosition: scrollPosition,\n        style: style,\n        threshold: threshold,\n        useIntersectionObserver: useIntersectionObserver,\n        visibleByDefault: visibleByDefault,\n        width: width\n      }, this.getImg());\n    }\n  }, {\n    key: \"getWrappedLazyLoadImage\",\n    value: function getWrappedLazyLoadImage(lazyLoadImage) {\n      var _this$props3 = this.props,\n          effect = _this$props3.effect,\n          height = _this$props3.height,\n          placeholderSrc = _this$props3.placeholderSrc,\n          width = _this$props3.width,\n          wrapperClassName = _this$props3.wrapperClassName,\n          wrapperProps = _this$props3.wrapperProps;\n      var loaded = this.state.loaded;\n      var loadedClassName = loaded ? ' lazy-load-image-loaded' : '';\n      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(\"span\", _extends({\n        className: wrapperClassName + ' lazy-load-image-background ' + effect + loadedClassName,\n        style: {\n          backgroundImage: loaded || !placeholderSrc ? '' : \"url(\".concat(placeholderSrc, \")\"),\n          backgroundSize: loaded || !placeholderSrc ? '' : '100% 100%',\n          color: 'transparent',\n          display: 'inline-block',\n          height: height,\n          width: width\n        }\n      }, wrapperProps), lazyLoadImage);\n    }\n  }, {\n    key: \"render\",\n    value: function render() {\n      var _this$props4 = this.props,\n          effect = _this$props4.effect,\n          placeholderSrc = _this$props4.placeholderSrc,\n          visibleByDefault = _this$props4.visibleByDefault,\n          wrapperClassName = _this$props4.wrapperClassName,\n          wrapperProps = _this$props4.wrapperProps;\n      var lazyLoadImage = this.getLazyLoadImage();\n      var needsWrapper = (effect || placeholderSrc) && !visibleByDefault;\n\n      if (!needsWrapper && !wrapperClassName && !wrapperProps) {\n        return lazyLoadImage;\n      }\n\n      return this.getWrappedLazyLoadImage(lazyLoadImage);\n    }\n  }]);\n\n  return LazyLoadImage;\n}((react__WEBPACK_IMPORTED_MODULE_0___default().Component));\n\nLazyLoadImage.propTypes = {\n  afterLoad: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.func,\n  beforeLoad: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.func,\n  delayMethod: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.string,\n  delayTime: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.number,\n  effect: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.string,\n  placeholderSrc: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.string,\n  threshold: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.number,\n  useIntersectionObserver: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.bool,\n  visibleByDefault: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.bool,\n  wrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.string,\n  wrapperProps: prop_types__WEBPACK_IMPORTED_MODULE_1__.PropTypes.object\n};\nLazyLoadImage.defaultProps = {\n  afterLoad: function afterLoad() {\n    return {};\n  },\n  beforeLoad: function beforeLoad() {\n    return {};\n  },\n  delayMethod: 'throttle',\n  delayTime: 300,\n  effect: '',\n  placeholderSrc: null,\n  threshold: 100,\n  useIntersectionObserver: true,\n  visibleByDefault: false,\n  wrapperClassName: ''\n};\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LazyLoadImage);\n\n//# sourceURL=webpack://react-lazy-load-image-component/./src/components/LazyLoadImage.jsx?");

/***/ }),

/***/ "./src/components/PlaceholderWithTracking.jsx":
/*!****************************************************!*\
  !*** ./src/components/PlaceholderWithTracking.jsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ \"react\");\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _PlaceholderWithoutTracking_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PlaceholderWithoutTracking.jsx */ \"./src/components/PlaceholderWithoutTracking.jsx\");\n/* harmony import */ var _hoc_trackWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../hoc/trackWindowScroll.js */ \"./src/hoc/trackWindowScroll.js\");\nfunction _typeof(obj) { \"@babel/helpers - typeof\"; if (typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; }; } return _typeof(obj); }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function\"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }\n\nfunction _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }\n\nfunction _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }\n\nfunction _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === \"object\" || typeof call === \"function\")) { return call; } else if (call !== void 0) { throw new TypeError(\"Derived constructors may only return object or undefined\"); } return _assertThisInitialized(self); }\n\nfunction _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return self; }\n\nfunction _isNativeReflectConstruct() { if (typeof Reflect === \"undefined\" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === \"function\") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }\n\nfunction _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }\n\n\n\n\n\nvar PlaceholderWithTracking = /*#__PURE__*/function (_React$Component) {\n  _inherits(PlaceholderWithTracking, _React$Component);\n\n  var _super = _createSuper(PlaceholderWithTracking);\n\n  function PlaceholderWithTracking(props) {\n    _classCallCheck(this, PlaceholderWithTracking);\n\n    return _super.call(this, props);\n  }\n\n  _createClass(PlaceholderWithTracking, [{\n    key: \"render\",\n    value: function render() {\n      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PlaceholderWithoutTracking_jsx__WEBPACK_IMPORTED_MODULE_1__.default, this.props);\n    }\n  }]);\n\n  return PlaceholderWithTracking;\n}((react__WEBPACK_IMPORTED_MODULE_0___default().Component));\n\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_hoc_trackWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__.default)(PlaceholderWithTracking));\n\n//# sourceURL=webpack://react-lazy-load-image-component/./src/components/PlaceholderWithTracking.jsx?");

/***/ }),

/***/ "./src/components/PlaceholderWithoutTracking.jsx":
/*!*******************************************************!*\
  !*** ./src/components/PlaceholderWithoutTracking.jsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ \"react\");\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ \"react-dom\");\n/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ \"./node_modules/prop-types/index.js\");\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var _utils_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/intersection-observer */ \"./src/utils/intersection-observer.js\");\nfunction _typeof(obj) { \"@babel/helpers - typeof\"; if (typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; }; } return _typeof(obj); }\n\nfunction ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }\n\nfunction _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }\n\nfunction _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function\"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }\n\nfunction _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }\n\nfunction _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }\n\nfunction _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === \"object\" || typeof call === \"function\")) { return call; } else if (call !== void 0) { throw new TypeError(\"Derived constructors may only return object or undefined\"); } return _assertThisInitialized(self); }\n\nfunction _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return self; }\n\nfunction _isNativeReflectConstruct() { if (typeof Reflect === \"undefined\" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === \"function\") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }\n\nfunction _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }\n\n\n\n\n\n\nvar checkIntersections = function checkIntersections(entries) {\n  entries.forEach(function (entry) {\n    if (entry.isIntersecting) {\n      entry.target.onVisible();\n    }\n  });\n};\n\nvar LAZY_LOAD_OBSERVERS = {};\n\nvar getObserver = function getObserver(threshold) {\n  LAZY_LOAD_OBSERVERS[threshold] = LAZY_LOAD_OBSERVERS[threshold] || new IntersectionObserver(checkIntersections, {\n    rootMargin: threshold + 'px'\n  });\n  return LAZY_LOAD_OBSERVERS[threshold];\n};\n\nvar PlaceholderWithoutTracking = /*#__PURE__*/function (_React$Component) {\n  _inherits(PlaceholderWithoutTracking, _React$Component);\n\n  var _super = _createSuper(PlaceholderWithoutTracking);\n\n  function PlaceholderWithoutTracking(props) {\n    var _this;\n\n    _classCallCheck(this, PlaceholderWithoutTracking);\n\n    _this = _super.call(this, props);\n    _this.supportsObserver = !props.scrollPosition && props.useIntersectionObserver && (0,_utils_intersection_observer__WEBPACK_IMPORTED_MODULE_3__.default)();\n\n    if (_this.supportsObserver) {\n      var threshold = props.threshold;\n      _this.observer = getObserver(threshold);\n    }\n\n    return _this;\n  }\n\n  _createClass(PlaceholderWithoutTracking, [{\n    key: \"componentDidMount\",\n    value: function componentDidMount() {\n      if (this.placeholder && this.observer) {\n        this.placeholder.onVisible = this.props.onVisible;\n        this.observer.observe(this.placeholder);\n      }\n\n      if (!this.supportsObserver) {\n        this.updateVisibility();\n      }\n    }\n  }, {\n    key: \"componentWillUnmount\",\n    value: function componentWillUnmount() {\n      if (this.observer) {\n        this.observer.unobserve(this.placeholder);\n      }\n    }\n  }, {\n    key: \"componentDidUpdate\",\n    value: function componentDidUpdate() {\n      if (!this.supportsObserver) {\n        this.updateVisibility();\n      }\n    }\n  }, {\n    key: \"getPlaceholderBoundingBox\",\n    value: function getPlaceholderBoundingBox() {\n      var scrollPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollPosition;\n      var boundingRect = this.placeholder.getBoundingClientRect();\n      var style = react_dom__WEBPACK_IMPORTED_MODULE_1___default().findDOMNode(this.placeholder).style;\n      var margin = {\n        left: parseInt(style.getPropertyValue('margin-left'), 10) || 0,\n        top: parseInt(style.getPropertyValue('margin-top'), 10) || 0\n      };\n      return {\n        bottom: scrollPosition.y + boundingRect.bottom + margin.top,\n        left: scrollPosition.x + boundingRect.left + margin.left,\n        right: scrollPosition.x + boundingRect.right + margin.left,\n        top: scrollPosition.y + boundingRect.top + margin.top\n      };\n    }\n  }, {\n    key: \"isPlaceholderInViewport\",\n    value: function isPlaceholderInViewport() {\n      if (typeof window === 'undefined' || !this.placeholder) {\n        return false;\n      }\n\n      var _this$props = this.props,\n          scrollPosition = _this$props.scrollPosition,\n          threshold = _this$props.threshold;\n      var boundingBox = this.getPlaceholderBoundingBox(scrollPosition);\n      var viewport = {\n        bottom: scrollPosition.y + window.innerHeight,\n        left: scrollPosition.x,\n        right: scrollPosition.x + window.innerWidth,\n        top: scrollPosition.y\n      };\n      return Boolean(viewport.top - threshold <= boundingBox.bottom && viewport.bottom + threshold >= boundingBox.top && viewport.left - threshold <= boundingBox.right && viewport.right + threshold >= boundingBox.left);\n    }\n  }, {\n    key: \"updateVisibility\",\n    value: function updateVisibility() {\n      if (this.isPlaceholderInViewport()) {\n        this.props.onVisible();\n      }\n    }\n  }, {\n    key: \"render\",\n    value: function render() {\n      var _this2 = this;\n\n      var _this$props2 = this.props,\n          className = _this$props2.className,\n          height = _this$props2.height,\n          placeholder = _this$props2.placeholder,\n          style = _this$props2.style,\n          width = _this$props2.width;\n\n      if (placeholder && typeof placeholder.type !== 'function') {\n        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().cloneElement(placeholder, {\n          ref: function ref(el) {\n            return _this2.placeholder = el;\n          }\n        });\n      }\n\n      var styleProp = _objectSpread({\n        display: 'inline-block'\n      }, style);\n\n      if (typeof width !== 'undefined') {\n        styleProp.width = width;\n      }\n\n      if (typeof height !== 'undefined') {\n        styleProp.height = height;\n      }\n\n      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(\"span\", {\n        className: className,\n        ref: function ref(el) {\n          return _this2.placeholder = el;\n        },\n        style: styleProp\n      }, placeholder);\n    }\n  }]);\n\n  return PlaceholderWithoutTracking;\n}((react__WEBPACK_IMPORTED_MODULE_0___default().Component));\n\nPlaceholderWithoutTracking.propTypes = {\n  onVisible: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.func.isRequired,\n  className: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.string,\n  height: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.number, prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.string]),\n  placeholder: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.element,\n  threshold: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.number,\n  useIntersectionObserver: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.bool,\n  scrollPosition: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.shape({\n    x: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.number.isRequired,\n    y: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.number.isRequired\n  }),\n  width: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.number, prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.string])\n};\nPlaceholderWithoutTracking.defaultProps = {\n  className: '',\n  placeholder: null,\n  threshold: 100,\n  useIntersectionObserver: true\n};\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PlaceholderWithoutTracking);\n\n//# sourceURL=webpack://react-lazy-load-image-component/./src/components/PlaceholderWithoutTracking.jsx?");

/***/ }),

/***/ "./src/hoc/trackWindowScroll.js":
/*!**************************************!*\
  !*** ./src/hoc/trackWindowScroll.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ \"react\");\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ \"react-dom\");\n/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ \"./node_modules/prop-types/index.js\");\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash.debounce */ \"./node_modules/lodash.debounce/index.js\");\n/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);\n/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash.throttle */ \"./node_modules/lodash.throttle/index.js\");\n/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_4__);\n/* harmony import */ var _utils_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/intersection-observer */ \"./src/utils/intersection-observer.js\");\n/* harmony import */ var _utils_get_scroll_ancestor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/get-scroll-ancestor */ \"./src/utils/get-scroll-ancestor.ts\");\nfunction _typeof(obj) { \"@babel/helpers - typeof\"; if (typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; }; } return _typeof(obj); }\n\nvar _excluded = [\"delayMethod\", \"delayTime\"];\n\nfunction _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }\n\nfunction _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }\n\nfunction _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function\"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }\n\nfunction _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }\n\nfunction _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }\n\nfunction _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === \"object\" || typeof call === \"function\")) { return call; } else if (call !== void 0) { throw new TypeError(\"Derived constructors may only return object or undefined\"); } return _assertThisInitialized(self); }\n\nfunction _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return self; }\n\nfunction _isNativeReflectConstruct() { if (typeof Reflect === \"undefined\" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === \"function\") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }\n\nfunction _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }\n\n\n\n\n\n\n\n\n\nvar getScrollX = function getScrollX() {\n  return typeof window === 'undefined' ? 0 : window.scrollX || window.pageXOffset;\n};\n\nvar getScrollY = function getScrollY() {\n  return typeof window === 'undefined' ? 0 : window.scrollY || window.pageYOffset;\n};\n\nconsole.log(':)');\n\nvar trackWindowScroll = function trackWindowScroll(BaseComponent) {\n  var ScrollAwareComponent = /*#__PURE__*/function (_React$Component) {\n    _inherits(ScrollAwareComponent, _React$Component);\n\n    var _super = _createSuper(ScrollAwareComponent);\n\n    function ScrollAwareComponent(props) {\n      var _this;\n\n      _classCallCheck(this, ScrollAwareComponent);\n\n      _this = _super.call(this, props);\n      console.log('props', props);\n      _this.useIntersectionObserver = props.useIntersectionObserver && (0,_utils_intersection_observer__WEBPACK_IMPORTED_MODULE_5__.default)();\n\n      if (_this.useIntersectionObserver) {\n        return _possibleConstructorReturn(_this);\n      }\n\n      var onChangeScroll = _this.onChangeScroll.bind(_assertThisInitialized(_this));\n\n      if (props.delayMethod === 'debounce') {\n        _this.delayedScroll = lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(onChangeScroll, props.delayTime);\n      } else if (props.delayMethod === 'throttle') {\n        _this.delayedScroll = lodash_throttle__WEBPACK_IMPORTED_MODULE_4___default()(onChangeScroll, props.delayTime);\n      }\n\n      _this.state = {\n        scrollPosition: {\n          x: getScrollX(),\n          y: getScrollY()\n        }\n      };\n      _this.baseComponentRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createRef();\n      return _this;\n    }\n\n    _createClass(ScrollAwareComponent, [{\n      key: \"componentDidMount\",\n      value: function componentDidMount() {\n        this.addListeners();\n      }\n    }, {\n      key: \"componentWillUnmount\",\n      value: function componentWillUnmount() {\n        this.removeListeners();\n      }\n    }, {\n      key: \"componentDidUpdate\",\n      value: function componentDidUpdate() {\n        if (typeof window === 'undefined' || this.useIntersectionObserver) {\n          return;\n        }\n\n        var scrollElement = (0,_utils_get_scroll_ancestor__WEBPACK_IMPORTED_MODULE_6__.default)(react_dom__WEBPACK_IMPORTED_MODULE_1___default().findDOMNode(this.baseComponentRef.current));\n\n        if (scrollElement !== this.scrollElement) {\n          this.removeListeners();\n          this.addListeners();\n        }\n      }\n    }, {\n      key: \"addListeners\",\n      value: function addListeners() {\n        if (typeof window === 'undefined' || this.useIntersectionObserver) {\n          return;\n        }\n\n        this.scrollElement = (0,_utils_get_scroll_ancestor__WEBPACK_IMPORTED_MODULE_6__.default)(react_dom__WEBPACK_IMPORTED_MODULE_1___default().findDOMNode(this.baseComponentRef.current));\n        this.scrollElement.addEventListener('scroll', this.delayedScroll, {\n          passive: true\n        });\n        window.addEventListener('resize', this.delayedScroll, {\n          passive: true\n        });\n\n        if (this.scrollElement !== window) {\n          window.addEventListener('scroll', this.delayedScroll, {\n            passive: true\n          });\n        }\n      }\n    }, {\n      key: \"removeListeners\",\n      value: function removeListeners() {\n        if (typeof window === 'undefined' || this.useIntersectionObserver) {\n          return;\n        }\n\n        this.scrollElement.removeEventListener('scroll', this.delayedScroll);\n        window.removeEventListener('resize', this.delayedScroll);\n\n        if (this.scrollElement !== window) {\n          window.removeEventListener('scroll', this.delayedScroll);\n        }\n      }\n    }, {\n      key: \"onChangeScroll\",\n      value: function onChangeScroll() {\n        if (this.useIntersectionObserver) {\n          return;\n        }\n\n        this.setState({\n          scrollPosition: {\n            x: getScrollX(),\n            y: getScrollY()\n          }\n        });\n      }\n    }, {\n      key: \"render\",\n      value: function render() {\n        var _this$props = this.props,\n            delayMethod = _this$props.delayMethod,\n            delayTime = _this$props.delayTime,\n            props = _objectWithoutProperties(_this$props, _excluded);\n\n        var scrollPosition = this.useIntersectionObserver ? null : this.state.scrollPosition;\n        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(BaseComponent, _extends({\n          ref: this.baseComponentRef,\n          scrollPosition: scrollPosition\n        }, props));\n      }\n    }]);\n\n    return ScrollAwareComponent;\n  }((react__WEBPACK_IMPORTED_MODULE_0___default().Component));\n\n  ScrollAwareComponent.propTypes = {\n    delayMethod: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.oneOf(['debounce', 'throttle']),\n    delayTime: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.number,\n    useIntersectionObserver: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.bool\n  };\n  ScrollAwareComponent.defaultProps = {\n    delayMethod: 'throttle',\n    delayTime: 300,\n    useIntersectionObserver: true\n  };\n  return ScrollAwareComponent;\n};\n\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (trackWindowScroll);\n\n//# sourceURL=webpack://react-lazy-load-image-component/./src/hoc/trackWindowScroll.js?");

/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"LazyLoadImage\": () => (/* reexport safe */ _components_LazyLoadImage_jsx__WEBPACK_IMPORTED_MODULE_0__.default),\n/* harmony export */   \"LazyLoadComponent\": () => (/* reexport safe */ _components_LazyLoadComponent_jsx__WEBPACK_IMPORTED_MODULE_1__.default),\n/* harmony export */   \"trackWindowScroll\": () => (/* reexport safe */ _hoc_trackWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__.default)\n/* harmony export */ });\n/* harmony import */ var _components_LazyLoadImage_jsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/LazyLoadImage.jsx */ \"./src/components/LazyLoadImage.jsx\");\n/* harmony import */ var _components_LazyLoadComponent_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/LazyLoadComponent.jsx */ \"./src/components/LazyLoadComponent.jsx\");\n/* harmony import */ var _hoc_trackWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./hoc/trackWindowScroll.js */ \"./src/hoc/trackWindowScroll.js\");\n\n\n\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./src/index.js?");

/***/ }),

/***/ "./src/utils/get-scroll-ancestor.ts":
/*!******************************************!*\
  !*** ./src/utils/get-scroll-ancestor.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\n// Adapted from https://github.com/loktar00/react-lazy-load/blob/master/src/utils/parentScroll.js\nvar getElementOverflowValues = function getElementOverflowValues(element) {\n  var computedStyle = getComputedStyle(element, null);\n  return computedStyle.getPropertyValue('overflow') + computedStyle.getPropertyValue('overflow-y') + computedStyle.getPropertyValue('overflow-x');\n};\n\nvar getScrollAncestor = function getScrollAncestor(element) {\n  console.log('getScrollAncestor');\n\n  if (!(element instanceof HTMLElement)) {\n    return window;\n  }\n\n  var parent = element;\n\n  while (parent) {\n    if (!(parent instanceof HTMLElement)) {\n      break;\n    }\n\n    if (/(scroll|auto)/.test(getElementOverflowValues(parent))) {\n      return parent;\n    }\n\n    parent = parent.parentNode;\n  }\n\n  return window;\n};\n\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getScrollAncestor);\n\n//# sourceURL=webpack://react-lazy-load-image-component/./src/utils/get-scroll-ancestor.ts?");

/***/ }),

/***/ "./src/utils/intersection-observer.js":
/*!********************************************!*\
  !*** ./src/utils/intersection-observer.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\n/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {\n  return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype;\n}\n\n//# sourceURL=webpack://react-lazy-load-image-component/./src/utils/intersection-observer.js?");

/***/ }),

/***/ "./node_modules/lodash.debounce/index.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash.debounce/index.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

eval("/**\n * lodash (Custom Build) <https://lodash.com/>\n * Build: `lodash modularize exports=\"npm\" -o ./`\n * Copyright jQuery Foundation and other contributors <https://jquery.org/>\n * Released under MIT license <https://lodash.com/license>\n * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>\n * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors\n */\n\n/** Used as the `TypeError` message for \"Functions\" methods. */\nvar FUNC_ERROR_TEXT = 'Expected a function';\n\n/** Used as references for various `Number` constants. */\nvar NAN = 0 / 0;\n\n/** `Object#toString` result references. */\nvar symbolTag = '[object Symbol]';\n\n/** Used to match leading and trailing whitespace. */\nvar reTrim = /^\\s+|\\s+$/g;\n\n/** Used to detect bad signed hexadecimal string values. */\nvar reIsBadHex = /^[-+]0x[0-9a-f]+$/i;\n\n/** Used to detect binary string values. */\nvar reIsBinary = /^0b[01]+$/i;\n\n/** Used to detect octal string values. */\nvar reIsOctal = /^0o[0-7]+$/i;\n\n/** Built-in method references without a dependency on `root`. */\nvar freeParseInt = parseInt;\n\n/** Detect free variable `global` from Node.js. */\nvar freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;\n\n/** Detect free variable `self`. */\nvar freeSelf = typeof self == 'object' && self && self.Object === Object && self;\n\n/** Used as a reference to the global object. */\nvar root = freeGlobal || freeSelf || Function('return this')();\n\n/** Used for built-in method references. */\nvar objectProto = Object.prototype;\n\n/**\n * Used to resolve the\n * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)\n * of values.\n */\nvar objectToString = objectProto.toString;\n\n/* Built-in method references for those with the same name as other `lodash` methods. */\nvar nativeMax = Math.max,\n    nativeMin = Math.min;\n\n/**\n * Gets the timestamp of the number of milliseconds that have elapsed since\n * the Unix epoch (1 January 1970 00:00:00 UTC).\n *\n * @static\n * @memberOf _\n * @since 2.4.0\n * @category Date\n * @returns {number} Returns the timestamp.\n * @example\n *\n * _.defer(function(stamp) {\n *   console.log(_.now() - stamp);\n * }, _.now());\n * // => Logs the number of milliseconds it took for the deferred invocation.\n */\nvar now = function() {\n  return root.Date.now();\n};\n\n/**\n * Creates a debounced function that delays invoking `func` until after `wait`\n * milliseconds have elapsed since the last time the debounced function was\n * invoked. The debounced function comes with a `cancel` method to cancel\n * delayed `func` invocations and a `flush` method to immediately invoke them.\n * Provide `options` to indicate whether `func` should be invoked on the\n * leading and/or trailing edge of the `wait` timeout. The `func` is invoked\n * with the last arguments provided to the debounced function. Subsequent\n * calls to the debounced function return the result of the last `func`\n * invocation.\n *\n * **Note:** If `leading` and `trailing` options are `true`, `func` is\n * invoked on the trailing edge of the timeout only if the debounced function\n * is invoked more than once during the `wait` timeout.\n *\n * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred\n * until to the next tick, similar to `setTimeout` with a timeout of `0`.\n *\n * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)\n * for details over the differences between `_.debounce` and `_.throttle`.\n *\n * @static\n * @memberOf _\n * @since 0.1.0\n * @category Function\n * @param {Function} func The function to debounce.\n * @param {number} [wait=0] The number of milliseconds to delay.\n * @param {Object} [options={}] The options object.\n * @param {boolean} [options.leading=false]\n *  Specify invoking on the leading edge of the timeout.\n * @param {number} [options.maxWait]\n *  The maximum time `func` is allowed to be delayed before it's invoked.\n * @param {boolean} [options.trailing=true]\n *  Specify invoking on the trailing edge of the timeout.\n * @returns {Function} Returns the new debounced function.\n * @example\n *\n * // Avoid costly calculations while the window size is in flux.\n * jQuery(window).on('resize', _.debounce(calculateLayout, 150));\n *\n * // Invoke `sendMail` when clicked, debouncing subsequent calls.\n * jQuery(element).on('click', _.debounce(sendMail, 300, {\n *   'leading': true,\n *   'trailing': false\n * }));\n *\n * // Ensure `batchLog` is invoked once after 1 second of debounced calls.\n * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });\n * var source = new EventSource('/stream');\n * jQuery(source).on('message', debounced);\n *\n * // Cancel the trailing debounced invocation.\n * jQuery(window).on('popstate', debounced.cancel);\n */\nfunction debounce(func, wait, options) {\n  var lastArgs,\n      lastThis,\n      maxWait,\n      result,\n      timerId,\n      lastCallTime,\n      lastInvokeTime = 0,\n      leading = false,\n      maxing = false,\n      trailing = true;\n\n  if (typeof func != 'function') {\n    throw new TypeError(FUNC_ERROR_TEXT);\n  }\n  wait = toNumber(wait) || 0;\n  if (isObject(options)) {\n    leading = !!options.leading;\n    maxing = 'maxWait' in options;\n    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;\n    trailing = 'trailing' in options ? !!options.trailing : trailing;\n  }\n\n  function invokeFunc(time) {\n    var args = lastArgs,\n        thisArg = lastThis;\n\n    lastArgs = lastThis = undefined;\n    lastInvokeTime = time;\n    result = func.apply(thisArg, args);\n    return result;\n  }\n\n  function leadingEdge(time) {\n    // Reset any `maxWait` timer.\n    lastInvokeTime = time;\n    // Start the timer for the trailing edge.\n    timerId = setTimeout(timerExpired, wait);\n    // Invoke the leading edge.\n    return leading ? invokeFunc(time) : result;\n  }\n\n  function remainingWait(time) {\n    var timeSinceLastCall = time - lastCallTime,\n        timeSinceLastInvoke = time - lastInvokeTime,\n        result = wait - timeSinceLastCall;\n\n    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;\n  }\n\n  function shouldInvoke(time) {\n    var timeSinceLastCall = time - lastCallTime,\n        timeSinceLastInvoke = time - lastInvokeTime;\n\n    // Either this is the first call, activity has stopped and we're at the\n    // trailing edge, the system time has gone backwards and we're treating\n    // it as the trailing edge, or we've hit the `maxWait` limit.\n    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||\n      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));\n  }\n\n  function timerExpired() {\n    var time = now();\n    if (shouldInvoke(time)) {\n      return trailingEdge(time);\n    }\n    // Restart the timer.\n    timerId = setTimeout(timerExpired, remainingWait(time));\n  }\n\n  function trailingEdge(time) {\n    timerId = undefined;\n\n    // Only invoke if we have `lastArgs` which means `func` has been\n    // debounced at least once.\n    if (trailing && lastArgs) {\n      return invokeFunc(time);\n    }\n    lastArgs = lastThis = undefined;\n    return result;\n  }\n\n  function cancel() {\n    if (timerId !== undefined) {\n      clearTimeout(timerId);\n    }\n    lastInvokeTime = 0;\n    lastArgs = lastCallTime = lastThis = timerId = undefined;\n  }\n\n  function flush() {\n    return timerId === undefined ? result : trailingEdge(now());\n  }\n\n  function debounced() {\n    var time = now(),\n        isInvoking = shouldInvoke(time);\n\n    lastArgs = arguments;\n    lastThis = this;\n    lastCallTime = time;\n\n    if (isInvoking) {\n      if (timerId === undefined) {\n        return leadingEdge(lastCallTime);\n      }\n      if (maxing) {\n        // Handle invocations in a tight loop.\n        timerId = setTimeout(timerExpired, wait);\n        return invokeFunc(lastCallTime);\n      }\n    }\n    if (timerId === undefined) {\n      timerId = setTimeout(timerExpired, wait);\n    }\n    return result;\n  }\n  debounced.cancel = cancel;\n  debounced.flush = flush;\n  return debounced;\n}\n\n/**\n * Checks if `value` is the\n * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)\n * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)\n *\n * @static\n * @memberOf _\n * @since 0.1.0\n * @category Lang\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is an object, else `false`.\n * @example\n *\n * _.isObject({});\n * // => true\n *\n * _.isObject([1, 2, 3]);\n * // => true\n *\n * _.isObject(_.noop);\n * // => true\n *\n * _.isObject(null);\n * // => false\n */\nfunction isObject(value) {\n  var type = typeof value;\n  return !!value && (type == 'object' || type == 'function');\n}\n\n/**\n * Checks if `value` is object-like. A value is object-like if it's not `null`\n * and has a `typeof` result of \"object\".\n *\n * @static\n * @memberOf _\n * @since 4.0.0\n * @category Lang\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is object-like, else `false`.\n * @example\n *\n * _.isObjectLike({});\n * // => true\n *\n * _.isObjectLike([1, 2, 3]);\n * // => true\n *\n * _.isObjectLike(_.noop);\n * // => false\n *\n * _.isObjectLike(null);\n * // => false\n */\nfunction isObjectLike(value) {\n  return !!value && typeof value == 'object';\n}\n\n/**\n * Checks if `value` is classified as a `Symbol` primitive or object.\n *\n * @static\n * @memberOf _\n * @since 4.0.0\n * @category Lang\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.\n * @example\n *\n * _.isSymbol(Symbol.iterator);\n * // => true\n *\n * _.isSymbol('abc');\n * // => false\n */\nfunction isSymbol(value) {\n  return typeof value == 'symbol' ||\n    (isObjectLike(value) && objectToString.call(value) == symbolTag);\n}\n\n/**\n * Converts `value` to a number.\n *\n * @static\n * @memberOf _\n * @since 4.0.0\n * @category Lang\n * @param {*} value The value to process.\n * @returns {number} Returns the number.\n * @example\n *\n * _.toNumber(3.2);\n * // => 3.2\n *\n * _.toNumber(Number.MIN_VALUE);\n * // => 5e-324\n *\n * _.toNumber(Infinity);\n * // => Infinity\n *\n * _.toNumber('3.2');\n * // => 3.2\n */\nfunction toNumber(value) {\n  if (typeof value == 'number') {\n    return value;\n  }\n  if (isSymbol(value)) {\n    return NAN;\n  }\n  if (isObject(value)) {\n    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;\n    value = isObject(other) ? (other + '') : other;\n  }\n  if (typeof value != 'string') {\n    return value === 0 ? value : +value;\n  }\n  value = value.replace(reTrim, '');\n  var isBinary = reIsBinary.test(value);\n  return (isBinary || reIsOctal.test(value))\n    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)\n    : (reIsBadHex.test(value) ? NAN : +value);\n}\n\nmodule.exports = debounce;\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./node_modules/lodash.debounce/index.js?");

/***/ }),

/***/ "./node_modules/lodash.throttle/index.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash.throttle/index.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

eval("/**\n * lodash (Custom Build) <https://lodash.com/>\n * Build: `lodash modularize exports=\"npm\" -o ./`\n * Copyright jQuery Foundation and other contributors <https://jquery.org/>\n * Released under MIT license <https://lodash.com/license>\n * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>\n * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors\n */\n\n/** Used as the `TypeError` message for \"Functions\" methods. */\nvar FUNC_ERROR_TEXT = 'Expected a function';\n\n/** Used as references for various `Number` constants. */\nvar NAN = 0 / 0;\n\n/** `Object#toString` result references. */\nvar symbolTag = '[object Symbol]';\n\n/** Used to match leading and trailing whitespace. */\nvar reTrim = /^\\s+|\\s+$/g;\n\n/** Used to detect bad signed hexadecimal string values. */\nvar reIsBadHex = /^[-+]0x[0-9a-f]+$/i;\n\n/** Used to detect binary string values. */\nvar reIsBinary = /^0b[01]+$/i;\n\n/** Used to detect octal string values. */\nvar reIsOctal = /^0o[0-7]+$/i;\n\n/** Built-in method references without a dependency on `root`. */\nvar freeParseInt = parseInt;\n\n/** Detect free variable `global` from Node.js. */\nvar freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;\n\n/** Detect free variable `self`. */\nvar freeSelf = typeof self == 'object' && self && self.Object === Object && self;\n\n/** Used as a reference to the global object. */\nvar root = freeGlobal || freeSelf || Function('return this')();\n\n/** Used for built-in method references. */\nvar objectProto = Object.prototype;\n\n/**\n * Used to resolve the\n * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)\n * of values.\n */\nvar objectToString = objectProto.toString;\n\n/* Built-in method references for those with the same name as other `lodash` methods. */\nvar nativeMax = Math.max,\n    nativeMin = Math.min;\n\n/**\n * Gets the timestamp of the number of milliseconds that have elapsed since\n * the Unix epoch (1 January 1970 00:00:00 UTC).\n *\n * @static\n * @memberOf _\n * @since 2.4.0\n * @category Date\n * @returns {number} Returns the timestamp.\n * @example\n *\n * _.defer(function(stamp) {\n *   console.log(_.now() - stamp);\n * }, _.now());\n * // => Logs the number of milliseconds it took for the deferred invocation.\n */\nvar now = function() {\n  return root.Date.now();\n};\n\n/**\n * Creates a debounced function that delays invoking `func` until after `wait`\n * milliseconds have elapsed since the last time the debounced function was\n * invoked. The debounced function comes with a `cancel` method to cancel\n * delayed `func` invocations and a `flush` method to immediately invoke them.\n * Provide `options` to indicate whether `func` should be invoked on the\n * leading and/or trailing edge of the `wait` timeout. The `func` is invoked\n * with the last arguments provided to the debounced function. Subsequent\n * calls to the debounced function return the result of the last `func`\n * invocation.\n *\n * **Note:** If `leading` and `trailing` options are `true`, `func` is\n * invoked on the trailing edge of the timeout only if the debounced function\n * is invoked more than once during the `wait` timeout.\n *\n * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred\n * until to the next tick, similar to `setTimeout` with a timeout of `0`.\n *\n * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)\n * for details over the differences between `_.debounce` and `_.throttle`.\n *\n * @static\n * @memberOf _\n * @since 0.1.0\n * @category Function\n * @param {Function} func The function to debounce.\n * @param {number} [wait=0] The number of milliseconds to delay.\n * @param {Object} [options={}] The options object.\n * @param {boolean} [options.leading=false]\n *  Specify invoking on the leading edge of the timeout.\n * @param {number} [options.maxWait]\n *  The maximum time `func` is allowed to be delayed before it's invoked.\n * @param {boolean} [options.trailing=true]\n *  Specify invoking on the trailing edge of the timeout.\n * @returns {Function} Returns the new debounced function.\n * @example\n *\n * // Avoid costly calculations while the window size is in flux.\n * jQuery(window).on('resize', _.debounce(calculateLayout, 150));\n *\n * // Invoke `sendMail` when clicked, debouncing subsequent calls.\n * jQuery(element).on('click', _.debounce(sendMail, 300, {\n *   'leading': true,\n *   'trailing': false\n * }));\n *\n * // Ensure `batchLog` is invoked once after 1 second of debounced calls.\n * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });\n * var source = new EventSource('/stream');\n * jQuery(source).on('message', debounced);\n *\n * // Cancel the trailing debounced invocation.\n * jQuery(window).on('popstate', debounced.cancel);\n */\nfunction debounce(func, wait, options) {\n  var lastArgs,\n      lastThis,\n      maxWait,\n      result,\n      timerId,\n      lastCallTime,\n      lastInvokeTime = 0,\n      leading = false,\n      maxing = false,\n      trailing = true;\n\n  if (typeof func != 'function') {\n    throw new TypeError(FUNC_ERROR_TEXT);\n  }\n  wait = toNumber(wait) || 0;\n  if (isObject(options)) {\n    leading = !!options.leading;\n    maxing = 'maxWait' in options;\n    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;\n    trailing = 'trailing' in options ? !!options.trailing : trailing;\n  }\n\n  function invokeFunc(time) {\n    var args = lastArgs,\n        thisArg = lastThis;\n\n    lastArgs = lastThis = undefined;\n    lastInvokeTime = time;\n    result = func.apply(thisArg, args);\n    return result;\n  }\n\n  function leadingEdge(time) {\n    // Reset any `maxWait` timer.\n    lastInvokeTime = time;\n    // Start the timer for the trailing edge.\n    timerId = setTimeout(timerExpired, wait);\n    // Invoke the leading edge.\n    return leading ? invokeFunc(time) : result;\n  }\n\n  function remainingWait(time) {\n    var timeSinceLastCall = time - lastCallTime,\n        timeSinceLastInvoke = time - lastInvokeTime,\n        result = wait - timeSinceLastCall;\n\n    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;\n  }\n\n  function shouldInvoke(time) {\n    var timeSinceLastCall = time - lastCallTime,\n        timeSinceLastInvoke = time - lastInvokeTime;\n\n    // Either this is the first call, activity has stopped and we're at the\n    // trailing edge, the system time has gone backwards and we're treating\n    // it as the trailing edge, or we've hit the `maxWait` limit.\n    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||\n      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));\n  }\n\n  function timerExpired() {\n    var time = now();\n    if (shouldInvoke(time)) {\n      return trailingEdge(time);\n    }\n    // Restart the timer.\n    timerId = setTimeout(timerExpired, remainingWait(time));\n  }\n\n  function trailingEdge(time) {\n    timerId = undefined;\n\n    // Only invoke if we have `lastArgs` which means `func` has been\n    // debounced at least once.\n    if (trailing && lastArgs) {\n      return invokeFunc(time);\n    }\n    lastArgs = lastThis = undefined;\n    return result;\n  }\n\n  function cancel() {\n    if (timerId !== undefined) {\n      clearTimeout(timerId);\n    }\n    lastInvokeTime = 0;\n    lastArgs = lastCallTime = lastThis = timerId = undefined;\n  }\n\n  function flush() {\n    return timerId === undefined ? result : trailingEdge(now());\n  }\n\n  function debounced() {\n    var time = now(),\n        isInvoking = shouldInvoke(time);\n\n    lastArgs = arguments;\n    lastThis = this;\n    lastCallTime = time;\n\n    if (isInvoking) {\n      if (timerId === undefined) {\n        return leadingEdge(lastCallTime);\n      }\n      if (maxing) {\n        // Handle invocations in a tight loop.\n        timerId = setTimeout(timerExpired, wait);\n        return invokeFunc(lastCallTime);\n      }\n    }\n    if (timerId === undefined) {\n      timerId = setTimeout(timerExpired, wait);\n    }\n    return result;\n  }\n  debounced.cancel = cancel;\n  debounced.flush = flush;\n  return debounced;\n}\n\n/**\n * Creates a throttled function that only invokes `func` at most once per\n * every `wait` milliseconds. The throttled function comes with a `cancel`\n * method to cancel delayed `func` invocations and a `flush` method to\n * immediately invoke them. Provide `options` to indicate whether `func`\n * should be invoked on the leading and/or trailing edge of the `wait`\n * timeout. The `func` is invoked with the last arguments provided to the\n * throttled function. Subsequent calls to the throttled function return the\n * result of the last `func` invocation.\n *\n * **Note:** If `leading` and `trailing` options are `true`, `func` is\n * invoked on the trailing edge of the timeout only if the throttled function\n * is invoked more than once during the `wait` timeout.\n *\n * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred\n * until to the next tick, similar to `setTimeout` with a timeout of `0`.\n *\n * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)\n * for details over the differences between `_.throttle` and `_.debounce`.\n *\n * @static\n * @memberOf _\n * @since 0.1.0\n * @category Function\n * @param {Function} func The function to throttle.\n * @param {number} [wait=0] The number of milliseconds to throttle invocations to.\n * @param {Object} [options={}] The options object.\n * @param {boolean} [options.leading=true]\n *  Specify invoking on the leading edge of the timeout.\n * @param {boolean} [options.trailing=true]\n *  Specify invoking on the trailing edge of the timeout.\n * @returns {Function} Returns the new throttled function.\n * @example\n *\n * // Avoid excessively updating the position while scrolling.\n * jQuery(window).on('scroll', _.throttle(updatePosition, 100));\n *\n * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.\n * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });\n * jQuery(element).on('click', throttled);\n *\n * // Cancel the trailing throttled invocation.\n * jQuery(window).on('popstate', throttled.cancel);\n */\nfunction throttle(func, wait, options) {\n  var leading = true,\n      trailing = true;\n\n  if (typeof func != 'function') {\n    throw new TypeError(FUNC_ERROR_TEXT);\n  }\n  if (isObject(options)) {\n    leading = 'leading' in options ? !!options.leading : leading;\n    trailing = 'trailing' in options ? !!options.trailing : trailing;\n  }\n  return debounce(func, wait, {\n    'leading': leading,\n    'maxWait': wait,\n    'trailing': trailing\n  });\n}\n\n/**\n * Checks if `value` is the\n * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)\n * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)\n *\n * @static\n * @memberOf _\n * @since 0.1.0\n * @category Lang\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is an object, else `false`.\n * @example\n *\n * _.isObject({});\n * // => true\n *\n * _.isObject([1, 2, 3]);\n * // => true\n *\n * _.isObject(_.noop);\n * // => true\n *\n * _.isObject(null);\n * // => false\n */\nfunction isObject(value) {\n  var type = typeof value;\n  return !!value && (type == 'object' || type == 'function');\n}\n\n/**\n * Checks if `value` is object-like. A value is object-like if it's not `null`\n * and has a `typeof` result of \"object\".\n *\n * @static\n * @memberOf _\n * @since 4.0.0\n * @category Lang\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is object-like, else `false`.\n * @example\n *\n * _.isObjectLike({});\n * // => true\n *\n * _.isObjectLike([1, 2, 3]);\n * // => true\n *\n * _.isObjectLike(_.noop);\n * // => false\n *\n * _.isObjectLike(null);\n * // => false\n */\nfunction isObjectLike(value) {\n  return !!value && typeof value == 'object';\n}\n\n/**\n * Checks if `value` is classified as a `Symbol` primitive or object.\n *\n * @static\n * @memberOf _\n * @since 4.0.0\n * @category Lang\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.\n * @example\n *\n * _.isSymbol(Symbol.iterator);\n * // => true\n *\n * _.isSymbol('abc');\n * // => false\n */\nfunction isSymbol(value) {\n  return typeof value == 'symbol' ||\n    (isObjectLike(value) && objectToString.call(value) == symbolTag);\n}\n\n/**\n * Converts `value` to a number.\n *\n * @static\n * @memberOf _\n * @since 4.0.0\n * @category Lang\n * @param {*} value The value to process.\n * @returns {number} Returns the number.\n * @example\n *\n * _.toNumber(3.2);\n * // => 3.2\n *\n * _.toNumber(Number.MIN_VALUE);\n * // => 5e-324\n *\n * _.toNumber(Infinity);\n * // => Infinity\n *\n * _.toNumber('3.2');\n * // => 3.2\n */\nfunction toNumber(value) {\n  if (typeof value == 'number') {\n    return value;\n  }\n  if (isSymbol(value)) {\n    return NAN;\n  }\n  if (isObject(value)) {\n    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;\n    value = isObject(other) ? (other + '') : other;\n  }\n  if (typeof value != 'string') {\n    return value === 0 ? value : +value;\n  }\n  value = value.replace(reTrim, '');\n  var isBinary = reIsBinary.test(value);\n  return (isBinary || reIsOctal.test(value))\n    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)\n    : (reIsBadHex.test(value) ? NAN : +value);\n}\n\nmodule.exports = throttle;\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./node_modules/lodash.throttle/index.js?");

/***/ }),

/***/ "./node_modules/object-assign/index.js":
/*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/
/***/ ((module) => {
eval("/*\nobject-assign\n(c) Sindre Sorhus\n@license MIT\n*/\n\n\n/* eslint-disable no-unused-vars */\nvar getOwnPropertySymbols = Object.getOwnPropertySymbols;\nvar hasOwnProperty = Object.prototype.hasOwnProperty;\nvar propIsEnumerable = Object.prototype.propertyIsEnumerable;\n\nfunction toObject(val) {\n\tif (val === null || val === undefined) {\n\t\tthrow new TypeError('Object.assign cannot be called with null or undefined');\n\t}\n\n\treturn Object(val);\n}\n\nfunction shouldUseNative() {\n\ttry {\n\t\tif (!Object.assign) {\n\t\t\treturn false;\n\t\t}\n\n\t\t// Detect buggy property enumeration order in older V8 versions.\n\n\t\t// https://bugs.chromium.org/p/v8/issues/detail?id=4118\n\t\tvar test1 = new String('abc');  // eslint-disable-line no-new-wrappers\n\t\ttest1[5] = 'de';\n\t\tif (Object.getOwnPropertyNames(test1)[0] === '5') {\n\t\t\treturn false;\n\t\t}\n\n\t\t// https://bugs.chromium.org/p/v8/issues/detail?id=3056\n\t\tvar test2 = {};\n\t\tfor (var i = 0; i < 10; i++) {\n\t\t\ttest2['_' + String.fromCharCode(i)] = i;\n\t\t}\n\t\tvar order2 = Object.getOwnPropertyNames(test2).map(function (n) {\n\t\t\treturn test2[n];\n\t\t});\n\t\tif (order2.join('') !== '0123456789') {\n\t\t\treturn false;\n\t\t}\n\n\t\t// https://bugs.chromium.org/p/v8/issues/detail?id=3056\n\t\tvar test3 = {};\n\t\t'abcdefghijklmnopqrst'.split('').forEach(function (letter) {\n\t\t\ttest3[letter] = letter;\n\t\t});\n\t\tif (Object.keys(Object.assign({}, test3)).join('') !==\n\t\t\t\t'abcdefghijklmnopqrst') {\n\t\t\treturn false;\n\t\t}\n\n\t\treturn true;\n\t} catch (err) {\n\t\t// We don't expect any of the above to throw, but better to be safe.\n\t\treturn false;\n\t}\n}\n\nmodule.exports = shouldUseNative() ? Object.assign : function (target, source) {\n\tvar from;\n\tvar to = toObject(target);\n\tvar symbols;\n\n\tfor (var s = 1; s < arguments.length; s++) {\n\t\tfrom = Object(arguments[s]);\n\n\t\tfor (var key in from) {\n\t\t\tif (hasOwnProperty.call(from, key)) {\n\t\t\t\tto[key] = from[key];\n\t\t\t}\n\t\t}\n\n\t\tif (getOwnPropertySymbols) {\n\t\t\tsymbols = getOwnPropertySymbols(from);\n\t\t\tfor (var i = 0; i < symbols.length; i++) {\n\t\t\t\tif (propIsEnumerable.call(from, symbols[i])) {\n\t\t\t\t\tto[symbols[i]] = from[symbols[i]];\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\treturn to;\n};\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./node_modules/object-assign/index.js?");

/***/ }),

/***/ "./node_modules/prop-types/checkPropTypes.js":
/*!***************************************************!*\
  !*** ./node_modules/prop-types/checkPropTypes.js ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {
eval("/**\n * Copyright (c) 2013-present, Facebook, Inc.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE file in the root directory of this source tree.\n */\n\n\n\nvar printWarning = function() {};\n\nif (true) {\n  var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ \"./node_modules/prop-types/lib/ReactPropTypesSecret.js\");\n  var loggedTypeFailures = {};\n  var has = Function.call.bind(Object.prototype.hasOwnProperty);\n\n  printWarning = function(text) {\n    var message = 'Warning: ' + text;\n    if (typeof console !== 'undefined') {\n      console.error(message);\n    }\n    try {\n      // --- Welcome to debugging React ---\n      // This error was thrown as a convenience so that you can use this stack\n      // to find the callsite that caused this warning to fire.\n      throw new Error(message);\n    } catch (x) {}\n  };\n}\n\n/**\n * Assert that the values match with the type specs.\n * Error messages are memorized and will only be shown once.\n *\n * @param {object} typeSpecs Map of name to a ReactPropType\n * @param {object} values Runtime values that need to be type-checked\n * @param {string} location e.g. \"prop\", \"context\", \"child context\"\n * @param {string} componentName Name of the component for error messages.\n * @param {?Function} getStack Returns the component stack.\n * @private\n */\nfunction checkPropTypes(typeSpecs, values, location, componentName, getStack) {\n  if (true) {\n    for (var typeSpecName in typeSpecs) {\n      if (has(typeSpecs, typeSpecName)) {\n        var error;\n        // Prop type validation may throw. In case they do, we don't want to\n        // fail the render phase where it didn't fail before. So we log it.\n        // After these have been cleaned up, we'll let them throw.\n        try {\n          // This is intentionally an invariant that gets caught. It's the same\n          // behavior as without this statement except with a better message.\n          if (typeof typeSpecs[typeSpecName] !== 'function') {\n            var err = Error(\n              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +\n              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'\n            );\n            err.name = 'Invariant Violation';\n            throw err;\n          }\n          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);\n        } catch (ex) {\n          error = ex;\n        }\n        if (error && !(error instanceof Error)) {\n          printWarning(\n            (componentName || 'React class') + ': type specification of ' +\n            location + ' `' + typeSpecName + '` is invalid; the type checker ' +\n            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +\n            'You may have forgotten to pass an argument to the type checker ' +\n            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +\n            'shape all require an argument).'\n          );\n        }\n        if (error instanceof Error && !(error.message in loggedTypeFailures)) {\n          // Only monitor this failure once because there tends to be a lot of the\n          // same error.\n          loggedTypeFailures[error.message] = true;\n\n          var stack = getStack ? getStack() : '';\n\n          printWarning(\n            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')\n          );\n        }\n      }\n    }\n  }\n}\n\n/**\n * Resets warning cache when testing.\n *\n * @private\n */\ncheckPropTypes.resetWarningCache = function() {\n  if (true) {\n    loggedTypeFailures = {};\n  }\n}\n\nmodule.exports = checkPropTypes;\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./node_modules/prop-types/checkPropTypes.js?");

/***/ }),

/***/ "./node_modules/prop-types/factoryWithTypeCheckers.js":
/*!************************************************************!*\
  !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
  \************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {
eval("/**\n * Copyright (c) 2013-present, Facebook, Inc.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE file in the root directory of this source tree.\n */\n\n\n\nvar ReactIs = __webpack_require__(/*! react-is */ \"./node_modules/react-is/index.js\");\nvar assign = __webpack_require__(/*! object-assign */ \"./node_modules/object-assign/index.js\");\n\nvar ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ \"./node_modules/prop-types/lib/ReactPropTypesSecret.js\");\nvar checkPropTypes = __webpack_require__(/*! ./checkPropTypes */ \"./node_modules/prop-types/checkPropTypes.js\");\n\nvar has = Function.call.bind(Object.prototype.hasOwnProperty);\nvar printWarning = function() {};\n\nif (true) {\n  printWarning = function(text) {\n    var message = 'Warning: ' + text;\n    if (typeof console !== 'undefined') {\n      console.error(message);\n    }\n    try {\n      // --- Welcome to debugging React ---\n      // This error was thrown as a convenience so that you can use this stack\n      // to find the callsite that caused this warning to fire.\n      throw new Error(message);\n    } catch (x) {}\n  };\n}\n\nfunction emptyFunctionThatReturnsNull() {\n  return null;\n}\n\nmodule.exports = function(isValidElement, throwOnDirectAccess) {\n  /* global Symbol */\n  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;\n  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.\n\n  /**\n   * Returns the iterator method function contained on the iterable object.\n   *\n   * Be sure to invoke the function with the iterable as context:\n   *\n   *     var iteratorFn = getIteratorFn(myIterable);\n   *     if (iteratorFn) {\n   *       var iterator = iteratorFn.call(myIterable);\n   *       ...\n   *     }\n   *\n   * @param {?object} maybeIterable\n   * @return {?function}\n   */\n  function getIteratorFn(maybeIterable) {\n    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);\n    if (typeof iteratorFn === 'function') {\n      return iteratorFn;\n    }\n  }\n\n  /**\n   * Collection of methods that allow declaration and validation of props that are\n   * supplied to React components. Example usage:\n   *\n   *   var Props = require('ReactPropTypes');\n   *   var MyArticle = React.createClass({\n   *     propTypes: {\n   *       // An optional string prop named \"description\".\n   *       description: Props.string,\n   *\n   *       // A required enum prop named \"category\".\n   *       category: Props.oneOf(['News','Photos']).isRequired,\n   *\n   *       // A prop named \"dialog\" that requires an instance of Dialog.\n   *       dialog: Props.instanceOf(Dialog).isRequired\n   *     },\n   *     render: function() { ... }\n   *   });\n   *\n   * A more formal specification of how these methods are used:\n   *\n   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)\n   *   decl := ReactPropTypes.{type}(.isRequired)?\n   *\n   * Each and every declaration produces a function with the same signature. This\n   * allows the creation of custom validation functions. For example:\n   *\n   *  var MyLink = React.createClass({\n   *    propTypes: {\n   *      // An optional string or URI prop named \"href\".\n   *      href: function(props, propName, componentName) {\n   *        var propValue = props[propName];\n   *        if (propValue != null && typeof propValue !== 'string' &&\n   *            !(propValue instanceof URI)) {\n   *          return new Error(\n   *            'Expected a string or an URI for ' + propName + ' in ' +\n   *            componentName\n   *          );\n   *        }\n   *      }\n   *    },\n   *    render: function() {...}\n   *  });\n   *\n   * @internal\n   */\n\n  var ANONYMOUS = '<<anonymous>>';\n\n  // Important!\n  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.\n  var ReactPropTypes = {\n    array: createPrimitiveTypeChecker('array'),\n    bool: createPrimitiveTypeChecker('boolean'),\n    func: createPrimitiveTypeChecker('function'),\n    number: createPrimitiveTypeChecker('number'),\n    object: createPrimitiveTypeChecker('object'),\n    string: createPrimitiveTypeChecker('string'),\n    symbol: createPrimitiveTypeChecker('symbol'),\n\n    any: createAnyTypeChecker(),\n    arrayOf: createArrayOfTypeChecker,\n    element: createElementTypeChecker(),\n    elementType: createElementTypeTypeChecker(),\n    instanceOf: createInstanceTypeChecker,\n    node: createNodeChecker(),\n    objectOf: createObjectOfTypeChecker,\n    oneOf: createEnumTypeChecker,\n    oneOfType: createUnionTypeChecker,\n    shape: createShapeTypeChecker,\n    exact: createStrictShapeTypeChecker,\n  };\n\n  /**\n   * inlined Object.is polyfill to avoid requiring consumers ship their own\n   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is\n   */\n  /*eslint-disable no-self-compare*/\n  function is(x, y) {\n    // SameValue algorithm\n    if (x === y) {\n      // Steps 1-5, 7-10\n      // Steps 6.b-6.e: +0 != -0\n      return x !== 0 || 1 / x === 1 / y;\n    } else {\n      // Step 6.a: NaN == NaN\n      return x !== x && y !== y;\n    }\n  }\n  /*eslint-enable no-self-compare*/\n\n  /**\n   * We use an Error-like object for backward compatibility as people may call\n   * PropTypes directly and inspect their output. However, we don't use real\n   * Errors anymore. We don't inspect their stack anyway, and creating them\n   * is prohibitively expensive if they are created too often, such as what\n   * happens in oneOfType() for any type before the one that matched.\n   */\n  function PropTypeError(message) {\n    this.message = message;\n    this.stack = '';\n  }\n  // Make `instanceof Error` still work for returned errors.\n  PropTypeError.prototype = Error.prototype;\n\n  function createChainableTypeChecker(validate) {\n    if (true) {\n      var manualPropTypeCallCache = {};\n      var manualPropTypeWarningCount = 0;\n    }\n    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {\n      componentName = componentName || ANONYMOUS;\n      propFullName = propFullName || propName;\n\n      if (secret !== ReactPropTypesSecret) {\n        if (throwOnDirectAccess) {\n          // New behavior only for users of `prop-types` package\n          var err = new Error(\n            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +\n            'Use `PropTypes.checkPropTypes()` to call them. ' +\n            'Read more at http://fb.me/use-check-prop-types'\n          );\n          err.name = 'Invariant Violation';\n          throw err;\n        } else if ( true && typeof console !== 'undefined') {\n          // Old behavior for people using React.PropTypes\n          var cacheKey = componentName + ':' + propName;\n          if (\n            !manualPropTypeCallCache[cacheKey] &&\n            // Avoid spamming the console because they are often not actionable except for lib authors\n            manualPropTypeWarningCount < 3\n          ) {\n            printWarning(\n              'You are manually calling a React.PropTypes validation ' +\n              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +\n              'and will throw in the standalone `prop-types` package. ' +\n              'You may be seeing this warning due to a third-party PropTypes ' +\n              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'\n            );\n            manualPropTypeCallCache[cacheKey] = true;\n            manualPropTypeWarningCount++;\n          }\n        }\n      }\n      if (props[propName] == null) {\n        if (isRequired) {\n          if (props[propName] === null) {\n            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));\n          }\n          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));\n        }\n        return null;\n      } else {\n        return validate(props, propName, componentName, location, propFullName);\n      }\n    }\n\n    var chainedCheckType = checkType.bind(null, false);\n    chainedCheckType.isRequired = checkType.bind(null, true);\n\n    return chainedCheckType;\n  }\n\n  function createPrimitiveTypeChecker(expectedType) {\n    function validate(props, propName, componentName, location, propFullName, secret) {\n      var propValue = props[propName];\n      var propType = getPropType(propValue);\n      if (propType !== expectedType) {\n        // `propValue` being instance of, say, date/regexp, pass the 'object'\n        // check, but we can offer a more precise error message here rather than\n        // 'of type `object`'.\n        var preciseType = getPreciseType(propValue);\n\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createAnyTypeChecker() {\n    return createChainableTypeChecker(emptyFunctionThatReturnsNull);\n  }\n\n  function createArrayOfTypeChecker(typeChecker) {\n    function validate(props, propName, componentName, location, propFullName) {\n      if (typeof typeChecker !== 'function') {\n        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');\n      }\n      var propValue = props[propName];\n      if (!Array.isArray(propValue)) {\n        var propType = getPropType(propValue);\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));\n      }\n      for (var i = 0; i < propValue.length; i++) {\n        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);\n        if (error instanceof Error) {\n          return error;\n        }\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createElementTypeChecker() {\n    function validate(props, propName, componentName, location, propFullName) {\n      var propValue = props[propName];\n      if (!isValidElement(propValue)) {\n        var propType = getPropType(propValue);\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createElementTypeTypeChecker() {\n    function validate(props, propName, componentName, location, propFullName) {\n      var propValue = props[propName];\n      if (!ReactIs.isValidElementType(propValue)) {\n        var propType = getPropType(propValue);\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createInstanceTypeChecker(expectedClass) {\n    function validate(props, propName, componentName, location, propFullName) {\n      if (!(props[propName] instanceof expectedClass)) {\n        var expectedClassName = expectedClass.name || ANONYMOUS;\n        var actualClassName = getClassName(props[propName]);\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createEnumTypeChecker(expectedValues) {\n    if (!Array.isArray(expectedValues)) {\n      if (true) {\n        if (arguments.length > 1) {\n          printWarning(\n            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +\n            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'\n          );\n        } else {\n          printWarning('Invalid argument supplied to oneOf, expected an array.');\n        }\n      }\n      return emptyFunctionThatReturnsNull;\n    }\n\n    function validate(props, propName, componentName, location, propFullName) {\n      var propValue = props[propName];\n      for (var i = 0; i < expectedValues.length; i++) {\n        if (is(propValue, expectedValues[i])) {\n          return null;\n        }\n      }\n\n      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {\n        var type = getPreciseType(value);\n        if (type === 'symbol') {\n          return String(value);\n        }\n        return value;\n      });\n      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createObjectOfTypeChecker(typeChecker) {\n    function validate(props, propName, componentName, location, propFullName) {\n      if (typeof typeChecker !== 'function') {\n        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');\n      }\n      var propValue = props[propName];\n      var propType = getPropType(propValue);\n      if (propType !== 'object') {\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));\n      }\n      for (var key in propValue) {\n        if (has(propValue, key)) {\n          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);\n          if (error instanceof Error) {\n            return error;\n          }\n        }\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createUnionTypeChecker(arrayOfTypeCheckers) {\n    if (!Array.isArray(arrayOfTypeCheckers)) {\n       true ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : 0;\n      return emptyFunctionThatReturnsNull;\n    }\n\n    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {\n      var checker = arrayOfTypeCheckers[i];\n      if (typeof checker !== 'function') {\n        printWarning(\n          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +\n          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'\n        );\n        return emptyFunctionThatReturnsNull;\n      }\n    }\n\n    function validate(props, propName, componentName, location, propFullName) {\n      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {\n        var checker = arrayOfTypeCheckers[i];\n        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {\n          return null;\n        }\n      }\n\n      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createNodeChecker() {\n    function validate(props, propName, componentName, location, propFullName) {\n      if (!isNode(props[propName])) {\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createShapeTypeChecker(shapeTypes) {\n    function validate(props, propName, componentName, location, propFullName) {\n      var propValue = props[propName];\n      var propType = getPropType(propValue);\n      if (propType !== 'object') {\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));\n      }\n      for (var key in shapeTypes) {\n        var checker = shapeTypes[key];\n        if (!checker) {\n          continue;\n        }\n        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);\n        if (error) {\n          return error;\n        }\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createStrictShapeTypeChecker(shapeTypes) {\n    function validate(props, propName, componentName, location, propFullName) {\n      var propValue = props[propName];\n      var propType = getPropType(propValue);\n      if (propType !== 'object') {\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));\n      }\n      // We need to check all keys in case some are required but missing from\n      // props.\n      var allKeys = assign({}, props[propName], shapeTypes);\n      for (var key in allKeys) {\n        var checker = shapeTypes[key];\n        if (!checker) {\n          return new PropTypeError(\n            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +\n            '\\nBad object: ' + JSON.stringify(props[propName], null, '  ') +\n            '\\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')\n          );\n        }\n        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);\n        if (error) {\n          return error;\n        }\n      }\n      return null;\n    }\n\n    return createChainableTypeChecker(validate);\n  }\n\n  function isNode(propValue) {\n    switch (typeof propValue) {\n      case 'number':\n      case 'string':\n      case 'undefined':\n        return true;\n      case 'boolean':\n        return !propValue;\n      case 'object':\n        if (Array.isArray(propValue)) {\n          return propValue.every(isNode);\n        }\n        if (propValue === null || isValidElement(propValue)) {\n          return true;\n        }\n\n        var iteratorFn = getIteratorFn(propValue);\n        if (iteratorFn) {\n          var iterator = iteratorFn.call(propValue);\n          var step;\n          if (iteratorFn !== propValue.entries) {\n            while (!(step = iterator.next()).done) {\n              if (!isNode(step.value)) {\n                return false;\n              }\n            }\n          } else {\n            // Iterator will provide entry [k,v] tuples rather than values.\n            while (!(step = iterator.next()).done) {\n              var entry = step.value;\n              if (entry) {\n                if (!isNode(entry[1])) {\n                  return false;\n                }\n              }\n            }\n          }\n        } else {\n          return false;\n        }\n\n        return true;\n      default:\n        return false;\n    }\n  }\n\n  function isSymbol(propType, propValue) {\n    // Native Symbol.\n    if (propType === 'symbol') {\n      return true;\n    }\n\n    // falsy value can't be a Symbol\n    if (!propValue) {\n      return false;\n    }\n\n    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'\n    if (propValue['@@toStringTag'] === 'Symbol') {\n      return true;\n    }\n\n    // Fallback for non-spec compliant Symbols which are polyfilled.\n    if (typeof Symbol === 'function' && propValue instanceof Symbol) {\n      return true;\n    }\n\n    return false;\n  }\n\n  // Equivalent of `typeof` but with special handling for array and regexp.\n  function getPropType(propValue) {\n    var propType = typeof propValue;\n    if (Array.isArray(propValue)) {\n      return 'array';\n    }\n    if (propValue instanceof RegExp) {\n      // Old webkits (at least until Android 4.0) return 'function' rather than\n      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/\n      // passes PropTypes.object.\n      return 'object';\n    }\n    if (isSymbol(propType, propValue)) {\n      return 'symbol';\n    }\n    return propType;\n  }\n\n  // This handles more types than `getPropType`. Only used for error messages.\n  // See `createPrimitiveTypeChecker`.\n  function getPreciseType(propValue) {\n    if (typeof propValue === 'undefined' || propValue === null) {\n      return '' + propValue;\n    }\n    var propType = getPropType(propValue);\n    if (propType === 'object') {\n      if (propValue instanceof Date) {\n        return 'date';\n      } else if (propValue instanceof RegExp) {\n        return 'regexp';\n      }\n    }\n    return propType;\n  }\n\n  // Returns a string that is postfixed to a warning about an invalid type.\n  // For example, \"undefined\" or \"of type array\"\n  function getPostfixForTypeWarning(value) {\n    var type = getPreciseType(value);\n    switch (type) {\n      case 'array':\n      case 'object':\n        return 'an ' + type;\n      case 'boolean':\n      case 'date':\n      case 'regexp':\n        return 'a ' + type;\n      default:\n        return type;\n    }\n  }\n\n  // Returns class name of the object, if any.\n  function getClassName(propValue) {\n    if (!propValue.constructor || !propValue.constructor.name) {\n      return ANONYMOUS;\n    }\n    return propValue.constructor.name;\n  }\n\n  ReactPropTypes.checkPropTypes = checkPropTypes;\n  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;\n  ReactPropTypes.PropTypes = ReactPropTypes;\n\n  return ReactPropTypes;\n};\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./node_modules/prop-types/factoryWithTypeCheckers.js?");

/***/ }),

/***/ "./node_modules/prop-types/index.js":
/*!******************************************!*\
  !*** ./node_modules/prop-types/index.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

eval("/**\n * Copyright (c) 2013-present, Facebook, Inc.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE file in the root directory of this source tree.\n */\n\nif (true) {\n  var ReactIs = __webpack_require__(/*! react-is */ \"./node_modules/react-is/index.js\");\n\n  // By explicitly using `prop-types` you are opting into new development behavior.\n  // http://fb.me/prop-types-in-prod\n  var throwOnDirectAccess = true;\n  module.exports = __webpack_require__(/*! ./factoryWithTypeCheckers */ \"./node_modules/prop-types/factoryWithTypeCheckers.js\")(ReactIs.isElement, throwOnDirectAccess);\n} else {}\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./node_modules/prop-types/index.js?");

/***/ }),

/***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js":
/*!*************************************************************!*\
  !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \*************************************************************/
/***/ ((module) => {
eval("/**\n * Copyright (c) 2013-present, Facebook, Inc.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE file in the root directory of this source tree.\n */\n\n\n\nvar ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';\n\nmodule.exports = ReactPropTypesSecret;\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./node_modules/prop-types/lib/ReactPropTypesSecret.js?");

/***/ }),

/***/ "./node_modules/react-is/cjs/react-is.development.js":
/*!***********************************************************!*\
  !*** ./node_modules/react-is/cjs/react-is.development.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {
eval("/** @license React v16.13.1\n * react-is.development.js\n *\n * Copyright (c) Facebook, Inc. and its affiliates.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE file in the root directory of this source tree.\n */\n\n\n\n\n\nif (true) {\n  (function() {\n'use strict';\n\n// The Symbol used to tag the ReactElement-like types. If there is no native Symbol\n// nor polyfill, then a plain number is used for performance.\nvar hasSymbol = typeof Symbol === 'function' && Symbol.for;\nvar REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;\nvar REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;\nvar REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;\nvar REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;\nvar REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;\nvar REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;\nvar REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary\n// (unstable) APIs that have been removed. Can we remove the symbols?\n\nvar REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;\nvar REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;\nvar REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;\nvar REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;\nvar REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;\nvar REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;\nvar REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;\nvar REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;\nvar REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;\nvar REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;\nvar REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;\n\nfunction isValidElementType(type) {\n  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.\n  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);\n}\n\nfunction typeOf(object) {\n  if (typeof object === 'object' && object !== null) {\n    var $$typeof = object.$$typeof;\n\n    switch ($$typeof) {\n      case REACT_ELEMENT_TYPE:\n        var type = object.type;\n\n        switch (type) {\n          case REACT_ASYNC_MODE_TYPE:\n          case REACT_CONCURRENT_MODE_TYPE:\n          case REACT_FRAGMENT_TYPE:\n          case REACT_PROFILER_TYPE:\n          case REACT_STRICT_MODE_TYPE:\n          case REACT_SUSPENSE_TYPE:\n            return type;\n\n          default:\n            var $$typeofType = type && type.$$typeof;\n\n            switch ($$typeofType) {\n              case REACT_CONTEXT_TYPE:\n              case REACT_FORWARD_REF_TYPE:\n              case REACT_LAZY_TYPE:\n              case REACT_MEMO_TYPE:\n              case REACT_PROVIDER_TYPE:\n                return $$typeofType;\n\n              default:\n                return $$typeof;\n            }\n\n        }\n\n      case REACT_PORTAL_TYPE:\n        return $$typeof;\n    }\n  }\n\n  return undefined;\n} // AsyncMode is deprecated along with isAsyncMode\n\nvar AsyncMode = REACT_ASYNC_MODE_TYPE;\nvar ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;\nvar ContextConsumer = REACT_CONTEXT_TYPE;\nvar ContextProvider = REACT_PROVIDER_TYPE;\nvar Element = REACT_ELEMENT_TYPE;\nvar ForwardRef = REACT_FORWARD_REF_TYPE;\nvar Fragment = REACT_FRAGMENT_TYPE;\nvar Lazy = REACT_LAZY_TYPE;\nvar Memo = REACT_MEMO_TYPE;\nvar Portal = REACT_PORTAL_TYPE;\nvar Profiler = REACT_PROFILER_TYPE;\nvar StrictMode = REACT_STRICT_MODE_TYPE;\nvar Suspense = REACT_SUSPENSE_TYPE;\nvar hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated\n\nfunction isAsyncMode(object) {\n  {\n    if (!hasWarnedAboutDeprecatedIsAsyncMode) {\n      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint\n\n      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');\n    }\n  }\n\n  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;\n}\nfunction isConcurrentMode(object) {\n  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;\n}\nfunction isContextConsumer(object) {\n  return typeOf(object) === REACT_CONTEXT_TYPE;\n}\nfunction isContextProvider(object) {\n  return typeOf(object) === REACT_PROVIDER_TYPE;\n}\nfunction isElement(object) {\n  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;\n}\nfunction isForwardRef(object) {\n  return typeOf(object) === REACT_FORWARD_REF_TYPE;\n}\nfunction isFragment(object) {\n  return typeOf(object) === REACT_FRAGMENT_TYPE;\n}\nfunction isLazy(object) {\n  return typeOf(object) === REACT_LAZY_TYPE;\n}\nfunction isMemo(object) {\n  return typeOf(object) === REACT_MEMO_TYPE;\n}\nfunction isPortal(object) {\n  return typeOf(object) === REACT_PORTAL_TYPE;\n}\nfunction isProfiler(object) {\n  return typeOf(object) === REACT_PROFILER_TYPE;\n}\nfunction isStrictMode(object) {\n  return typeOf(object) === REACT_STRICT_MODE_TYPE;\n}\nfunction isSuspense(object) {\n  return typeOf(object) === REACT_SUSPENSE_TYPE;\n}\n\nexports.AsyncMode = AsyncMode;\nexports.ConcurrentMode = ConcurrentMode;\nexports.ContextConsumer = ContextConsumer;\nexports.ContextProvider = ContextProvider;\nexports.Element = Element;\nexports.ForwardRef = ForwardRef;\nexports.Fragment = Fragment;\nexports.Lazy = Lazy;\nexports.Memo = Memo;\nexports.Portal = Portal;\nexports.Profiler = Profiler;\nexports.StrictMode = StrictMode;\nexports.Suspense = Suspense;\nexports.isAsyncMode = isAsyncMode;\nexports.isConcurrentMode = isConcurrentMode;\nexports.isContextConsumer = isContextConsumer;\nexports.isContextProvider = isContextProvider;\nexports.isElement = isElement;\nexports.isForwardRef = isForwardRef;\nexports.isFragment = isFragment;\nexports.isLazy = isLazy;\nexports.isMemo = isMemo;\nexports.isPortal = isPortal;\nexports.isProfiler = isProfiler;\nexports.isStrictMode = isStrictMode;\nexports.isSuspense = isSuspense;\nexports.isValidElementType = isValidElementType;\nexports.typeOf = typeOf;\n  })();\n}\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./node_modules/react-is/cjs/react-is.development.js?");

/***/ }),

/***/ "./node_modules/react-is/index.js":
/*!****************************************!*\
  !*** ./node_modules/react-is/index.js ***!
  \****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {
eval("\n\nif (false) {} else {\n  module.exports = __webpack_require__(/*! ./cjs/react-is.development.js */ \"./node_modules/react-is/cjs/react-is.development.js\");\n}\n\n\n//# sourceURL=webpack://react-lazy-load-image-component/./node_modules/react-is/index.js?");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {
module.exports = React;

/***/ }),

/***/ "react-dom":
/*!****************************!*\
  !*** external "react-dom" ***!
  \****************************/
/***/ ((module) => {
module.exports = reactDom;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop));
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.js");
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
});

unwrapExports(build);
var build_1 = build.LazyLoadImage;
var build_2 = build.LazyLoadComponent;

var css$a = ".no-data {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  background: #fff;\n  min-height: 80vh;\n}\n.no-data__content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 960px;\n}\n.no-data__header {\n  margin-bottom: 1rem !important;\n  word-wrap: break-word;\n  text-align: center;\n}\n.no-data__rich-text h2,\n.no-data__rich-text h3,\n.no-data__rich-text h4,\n.no-data__rich-text h5,\n.no-data__rich-text h6 {\n  font-family: \"GTWalsheimPro-Bold\", Arial, sans-serif;\n}\n.no-data__rich-text h2 {\n  font-size: 1.75rem;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2.25rem;\n  letter-spacing: 0.065em;\n  color: inherit;\n  margin-top: 2rem;\n  margin-bottom: 0.25rem;\n}\n.no-data__rich-text h3 {\n  font-size: 1.5rem;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.75rem;\n  letter-spacing: 0.065em;\n  color: inherit;\n  margin-top: 2rem;\n  margin-bottom: 0.25rem;\n}\n.no-data__rich-text h4 {\n  font-size: 1.313rem;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2rem;\n  letter-spacing: 0.07875em;\n  color: inherit;\n  margin-top: 2rem;\n  margin-bottom: 0.25rem;\n}\n.no-data__rich-text p {\n  font-size: 1.125rem;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.875rem;\n  letter-spacing: 0.075em;\n  color: inherit;\n  margin-bottom: 0.5rem;\n}\n.no-data__rich-text ul,\n.no-data__rich-text ol {\n  margin: 1rem 0;\n}\n.no-data__rich-text li {\n  margin: 0.25rem 0;\n}";
n(css$a,{});

function NoDataPage(_a) {
    var content = _a.content;
    function createMarkup(richText) {
        return {
            __html: richText,
        };
    }
    return (React.createElement("section", { className: "no-data section section--default" },
        React.createElement("div", { className: "no-data__content" },
            React.createElement(Typography$1, { className: 'no-data__header', variant: 'h2' }, content.fallbackHeader),
            React.createElement(Typography$1, { className: 'no-data__rich-text', variant: 'body1', component: 'div', dangerouslySetInnerHTML: createMarkup(content.fallbackText) }))));
}

/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend$1(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject(src[key]) &&
            isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend$1(target[key], src[key]);
        }
    });
}

var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend$1(doc, ssrDocument);
    return doc;
}

var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
    requestAnimationFrame: function (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend$1(win, ssrWindow);
    return win;
}

/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf$4(o) {
  _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$4(o);
}

function _setPrototypeOf$4(o, p) {
  _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$4(o, p);
}

function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$4()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$4(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf$4(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$4(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized$4(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/* eslint-disable no-proto */
function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inheritsLoose(Dom7, _Array);

  function Dom7(items) {
    var _this;

    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
    makeReactive(_assertThisInitialized$4(_this));
    return _this;
  }

  return Dom7;
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat(arr) {
  if (arr === void 0) {
    arr = [];
  }

  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = getWindow();
  var document = getDocument();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

function addClass() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, classNames);
  });
  return this;
}

function removeClass() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
  });
  return this;
}

function toggleClass() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}

function hasClass() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
  }

  return this;
}

function on() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function trigger() {
  var window = getWindow();

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = getWindow();
    var document = getDocument();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window ? window.scrollY : el.scrollTop;
    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function styles() {
  var window = getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css$b(props, value) {
  var window = getWindow();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  var window = getWindow();
  var document = getDocument();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append() {
  var newChild;
  var document = getDocument();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  var document = getDocument();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

var Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: outerWidth,
  outerHeight: outerHeight,
  styles: styles,
  offset: offset,
  css: css$b,
  each: each,
  html: html,
  text: text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});

function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now$1() {
  return Date.now();
}

function getComputedStyle$1(el) {
  var window = getWindow();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var window = getWindow();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle$1(el);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject$1(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend$2() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];

  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$2(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$2(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function bindModuleMethods(instance, obj) {
  Object.keys(obj).forEach(function (key) {
    if (isObject$1(obj[key])) {
      Object.keys(obj[key]).forEach(function (subKey) {
        if (typeof obj[key][subKey] === 'function') {
          obj[key][subKey] = obj[key][subKey].bind(instance);
        }
      });
    }

    instance[key] = obj[key];
  });
}

function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.');
}

function createElementIfNotDefined($container, params, createElements, checkProps) {
  var document = getDocument();

  if (createElements) {
    Object.keys(checkProps).forEach(function (key) {
      if (!params[key] && params.auto === true) {
        var element = document.createElement('div');
        element.className = checkProps[key];
        $container.append(element);
        params[key] = element;
      }
    });
  }

  return params;
}

var support;

function calcSupport() {
  var window = getWindow();
  var document = getDocument();
  return {
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
    observer: function checkObserver() {
      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
    }(),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}

var device;

function calcDevice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;

  var support = getSupport();
  var window = getWindow();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!device) {
    device = calcDevice(overrides);
  }

  return device;
}

var browser;

function calcBrowser() {
  var window = getWindow();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isEdge: !!window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}

var supportsResizeObserver = function supportsResizeObserver() {
  var window = getWindow();
  return typeof window.ResizeObserver !== 'undefined';
};

var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    extend$2(swiper, {
      resize: {
        observer: null,
        createObserver: function createObserver() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.resize.observer = new ResizeObserver(function (entries) {
            var width = swiper.width,
                height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function (_ref) {
              var contentBoxSize = _ref.contentBoxSize,
                  contentRect = _ref.contentRect,
                  target = _ref.target;
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });

            if (newWidth !== width || newHeight !== height) {
              swiper.resize.resizeHandler();
            }
          });
          swiper.resize.observer.observe(swiper.el);
        },
        removeObserver: function removeObserver() {
          if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
            swiper.resize.observer.unobserve(swiper.el);
            swiper.resize.observer = null;
          }
        },
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },
  on: {
    init: function init(swiper) {
      var window = getWindow();

      if (swiper.params.resizeObserver && supportsResizeObserver()) {
        swiper.resize.createObserver();
        return;
      } // Emit resize


      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy(swiper) {
      var window = getWindow();
      swiper.resize.removeObserver();
      window.removeEventListener('resize', swiper.resize.resizeHandler);
      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
};

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var Observer = {
  attach: function attach(target, options) {
    if (options === void 0) {
      options = {};
    }

    var window = getWindow();
    var swiper = this;
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!swiper.support.observer || !swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    } // Observe container


    swiper.observer.attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    swiper.observer.attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};
var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      observer: _extends$3({}, Observer, {
        observers: []
      })
    });
  },
  on: {
    init: function init(swiper) {
      swiper.observer.init();
    },
    destroy: function destroy(swiper) {
      swiper.observer.destroy();
    }
  }
};

var modular = {
  useParams: function useParams(instanceParams) {
    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName]; // Extend params

      if (module.params) {
        extend$2(instanceParams, module.params);
      }
    });
  },
  useModules: function useModules(modulesParams) {
    if (modulesParams === void 0) {
      modulesParams = {};
    }

    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      } // Module create callback


      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  }
};

/* eslint-disable no-underscore-dangle */
var eventsEmitter = {
  on: function on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(data));
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  extend$2(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children("." + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  });
  var slidesNumberEvenToRows;

  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }

    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  } // Calc slides


  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;

      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;

        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;

          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }

      slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = slide[0],
              clientWidth = _slide$.clientWidth,
              offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: swiper.virtualSize + params.spaceBetween + "px"
    });
  }

  if (params.setWrapperSize) {
    var _$wrapperEl$css;

    $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
  }

  if (params.slidesPerColumn > 1) {
    var _$wrapperEl$css2;

    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

    if (params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid = newSlidesGrid;
    }
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    newSlidesGrid = [];

    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var _slides$filter$css;

    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  extend$2(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
  }

  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  extend$2(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  extend$2(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = $(e.target).closest("." + params.slideClass)[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};

function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }

    swiper.emit('slideChangeTransitionStart');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd$1(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }

    swiper.emit('slideChangeTransitionEnd');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition$1 = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd$1
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGird = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGird) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = -translate;

    if (rtl) {
      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
    }

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      enabled = swiper.enabled;
  if (!enabled) return swiper;
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach(function (snap) {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }

  var prevIndex;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
      nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
  var slides = $wrapperEl.children("." + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = $(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }

      slides = $wrapperEl.children("." + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    var slide = $(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < appendSlides.length; _i += 1) {
    $wrapperEl.append($(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
    $wrapperEl.prepend($(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }
}

function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var _i = 0; _i < slides.length; _i += 1) {
      if (slides[_i]) $wrapperEl.append(slides[_i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
    $wrapperEl.append(slidesBuffer[_i2]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};

function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }

  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  var swiper = this;
  var document = getDocument();
  var window = getWindow();
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = $(event.path[0]);
  }

  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  extend$2(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now$1();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) preventDefault = false;

    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var document = getDocument();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      extend$2(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now$1();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now$1()
    });
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = now$1();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now$1();
  nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now$1() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeModeMomentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(function () {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      swiper.emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

var dummyEventAttached = false;

function dummyEventListener() {}

function attachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
        passive: false,
        capture: capture
      } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }

      if (!dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      document.addEventListener('mousemove', swiper.onTouchMove, capture);
      document.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper.on('observerUpdate', onResize, true);
  }
}

function detachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  } // Resize handler


  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

var events = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

  if (breakpointOnlyParams) {
    ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
      var paramValue = breakpointOnlyParams[param];
      if (typeof paramValue === 'undefined') return;

      if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
        breakpointOnlyParams[param] = 'auto';
      } else if (param === 'slidesPerView') {
        breakpointOnlyParams[param] = parseFloat(paramValue);
      } else {
        breakpointOnlyParams[param] = parseInt(paramValue, 10);
      }
    });
  }

  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = params.slidesPerColumn > 1;
  var isMultiRow = breakpointParams.slidesPerColumn > 1;
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(params.containerModifierClass + "multirow");

    if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
      $el.addClass(params.containerModifierClass + "multirow-column");
    }

    swiper.emitContainerClasses();
  }

  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  extend$2(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  extend$2(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = getWindow();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia("(min-width: " + value + "px)").matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};

function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (typeof item === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device,
      support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': support.pointerEvents && !support.touch
  }, {
    'free-mode': params.freeMode
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'multirow': params.slidesPerColumn > 1
  }, {
    'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }], params.containerModifierClass);
  classNames.push.apply(classNames, suffixes);
  $el.addClass([].concat(classNames).join(' '));
  swiper.emitContainerClasses();
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = getWindow();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var params = swiper.params;
  var wasLocked = swiper.isLocked;
  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked; // events

  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

var checkOverflow$1 = {
  checkOverflow: checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: false,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-container-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }
var prototypes = {
  modular: modular,
  eventsEmitter: eventsEmitter,
  update: update,
  translate: translate,
  transition: transition$1,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};
var extendedDefaults = {};

var Swiper = /*#__PURE__*/function () {
  function Swiper() {
    var el;
    var params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = extend$2({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && $(params.el).length > 1) {
      var swipers = [];
      $(params.el).each(function (containerEl) {
        var newParams = extend$2({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];

    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }

    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];

      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) return;

        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
          params[moduleParamName] = {
            auto: true
          };
        }

        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }

        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }

        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
      }
    }); // Extend defaults with modules params

    var swiperParams = extend$2({}, defaults);
    swiper.useParams(swiperParams); // Extend defaults with passed params

    swiper.params = extend$2({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$2({}, swiper.params);
    swiper.passedParams = extend$2({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = $; // Extend Swiper

    extend$2(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];

        if (swiper.support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }

        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now$1(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }); // Install Modules

    swiper.useModules();
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  var _proto = Swiper.prototype;

  _proto.enable = function enable() {
    var swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  };

  _proto.disable = function disable() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  };

  _proto.setProgress = function setProgress(progress, speed) {
    var swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    var current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  };

  _proto.emitContainerClasses = function emitContainerClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var classes = swiper.el.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', classes.join(' '));
  };

  _proto.getSlideClasses = function getSlideClasses(slideEl) {
    var swiper = this;
    return slideEl.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  };

  _proto.emitSlidesClasses = function emitSlidesClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var updates = [];
    swiper.slides.each(function (slideEl) {
      var classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl: slideEl,
        classNames: classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  };

  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
    var swiper = this;
    var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
    var spv = 1;

    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;

      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
        if (slides[_i] && !breakLoop) {
          slideSize += slides[_i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }

    return spv;
  };

  _proto.update = function update() {
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    var translated;

    if (swiper.params.freeMode) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  };

  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }

    var swiper = this;
    var currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(function (slideEl) {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  };

  _proto.mount = function mount(el) {
    var swiper = this;
    if (swiper.mounted) return true; // Find el

    var $el = $(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    var getWrapperSelector = function getWrapperSelector() {
      return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
    };

    var getWrapper = function getWrapper() {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        var res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = function (options) {
          return $el.children(options);
        };

        return res;
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    var $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      var document = getDocument();
      var wrapper = document.createElement('div');
      $wrapperEl = $(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children("." + swiper.params.slideClass).each(function (slideEl) {
        $wrapperEl.append(slideEl);
      });
    }

    extend$2(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  };

  _proto.init = function init(el) {
    var swiper = this;
    if (swiper.initialized) return swiper;
    var mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  };

  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }

    if (cleanStyles === void 0) {
      cleanStyles = true;
    }

    var swiper = this;
    var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  };

  Swiper.extendDefaults = function extendDefaults(newDefaults) {
    extend$2(extendedDefaults, newDefaults);
  };

  Swiper.installModule = function installModule(module) {
    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now$1();
    Swiper.prototype.modules[name] = module;
  };

  Swiper.use = function use(module) {
    if (Array.isArray(module)) {
      module.forEach(function (m) {
        return Swiper.installModule(m);
      });
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  };

  _createClass$6(Swiper, null, [{
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer$1]);

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = $(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = $(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    extend$2(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
var Navigation$1 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      navigation: _extends$4({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
};

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = $(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = createElementIfNotDefined(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = $(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    extend$2(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }
};
var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      pagination: _extends$5({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
};

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var Fade = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var offset = $slideEl[0].swiperSlideOffset;
      var tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      var ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }

      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl.css({
        opacity: slideOpacity
      }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl;
    slides.transition(duration);

    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      slides.transitionEnd(function () {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};
var EffectFade = {
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      fadeEffect: _extends$6({}, Fade)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (swiper.params.effect !== 'fade') return;
      swiper.classNames.push(swiper.params.containerModifierClass + "fade");
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      extend$2(swiper.params, overwriteParams);
      extend$2(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate(swiper) {
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTransition(duration);
    }
  }
};

function isObject$2(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend$3(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend$3(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }

  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }

  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }

  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }

  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}

/* underscore in name -> watch for changes */
var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

// eslint-disable-next-line

function getParams(obj) {
  if (obj === void 0) {
    obj = {};
  }

  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  extend$3(params, Swiper.defaults);
  extend$3(params, Swiper.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = paramsList.map(function (key) {
    return key.replace(/_/, '');
  });
  Object.keys(obj).forEach(function (key) {
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject$2(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend$3(params[key], obj[key]);
        extend$3(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
}

// eslint-disable-next-line

function initSwiper(swiperParams) {
  return new Swiper(swiperParams);
}

function mountSwiper(_ref, swiperParams) {
  var el = _ref.el,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      paginationEl = _ref.paginationEl,
      scrollbarEl = _ref.scrollbarEl,
      swiper = _ref.swiper;

  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}

function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    var breakpoint = Swiper.prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
}

function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React.cloneElement(child, {
      key: child.key + "-duplicate-" + index + "-" + position,
      className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/React.createElement("div", {
          className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  modifiedSlides.forEach(function (child, index) {
    if (index < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index, 'prepend'));
    }

    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index, 'append'));
    }
  });

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [].concat(prependSlides, modifiedSlides, appendSlides);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren) {
  var keys = [];
  if (!oldParams) return keys;

  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  var oldChildrenKeys = oldChildren.map(function (child) {
    return child.key;
  });
  var childrenKeys = children.map(function (child) {
    return child.key;
  });
  if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
  if (oldChildren.length !== children.length) addKey('children');
  var watchParams = paramsList.filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if (isObject$2(swiperParams[key]) && isObject$2(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

function processChildren(c) {
  var slides = [];
  React.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}

function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}

function updateSwiper(_ref) {
  var swiper = _ref.swiper,
      slides = _ref.slides,
      passedParams = _ref.passedParams,
      changedParams = _ref.changedParams,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      scrollbarEl = _ref.scrollbarEl,
      paginationEl = _ref.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
      pagination = swiper.pagination,
      navigation = swiper.navigation,
      scrollbar = swiper.scrollbar,
      virtual = swiper.virtual,
      thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(function (key) {
    if (isObject$2(currentParams[key]) && isObject$2(passedParams[key])) {
      extend$3(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}

function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
}

function renderVirtual(swiper, slides, virtualData) {
  var _ref;

  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
    top: virtualData.offset + "px"
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}

var _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"];

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Swiper$1 = /*#__PURE__*/forwardRef(function (_temp, externalElRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$wrapperTag = _ref.wrapperTag,
      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
      children = _ref.children,
      onSwiper = _ref.onSwiper,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var eventsAssigned = false;

  var _useState = useState('swiper-container'),
      containerClasses = _useState[0],
      setContainerClasses = _useState[1];

  var _useState2 = useState(null),
      virtualData = _useState2[0],
      setVirtualData = _useState2[1];

  var _useState3 = useState(false),
      breakpointChanged = _useState3[0],
      setBreakpointChanged = _useState3[1];

  var initializedRef = useRef(false);
  var swiperElRef = useRef(null);
  var swiperRef = useRef(null);
  var oldPassedParamsRef = useRef(null);
  var oldSlides = useRef(null);
  var nextElRef = useRef(null);
  var prevElRef = useRef(null);
  var paginationElRef = useRef(null);
  var scrollbarElRef = useRef(null);

  var _getParams = getParams(rest),
      swiperParams = _getParams.params,
      passedParams = _getParams.passedParams,
      restProps = _getParams.rest,
      events = _getParams.events;

  var _getChildren = getChildren(children),
      slides = _getChildren.slides,
      slots = _getChildren.slots;

  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });

  if (!swiperElRef.current) {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = initSwiper(swiperParams);

    swiperRef.current.loopCreate = function () {};

    swiperRef.current.loopDestroy = function () {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend$3(swiperRef.current.params.virtual, extendWith);
      extend$3(swiperRef.current.originalParams.virtual, extendWith);
    }
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  useEffect(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  useEffect(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(function () {
    attachEvents();
    var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return function () {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(function () {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/React.createElement(Tag, _extends$7({
    ref: swiperElRef,
    className: uniqueClasses("" + containerClasses + (className ? " " + className : ''))
  }, restProps), slots['container-start'], needsNavigation(swiperParams) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), /*#__PURE__*/React.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
});
Swiper$1.displayName = 'Swiper';

var _excluded$1 = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SwiperSlide = /*#__PURE__*/forwardRef(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutPropertiesLoose$1(_ref, _excluded$1);

  var slideElRef = useRef(null);

  var _useState = useState('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/React.createElement(Tag, _extends$8({
    ref: slideElRef,
    className: uniqueClasses("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/React.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';

Swiper.use([Navigation$1, Pagination$1, EffectFade]);
var SwiperCarousel = function (props) {
    var auto = 'auto';
    var getNavigation = function () {
        switch (props.section) {
            case 'guide-pair':
                return {
                    prevEl: ".swiper-button-prev-guide-pair",
                    nextEl: ".swiper-button-next-guide-pair",
                };
            case 'guide-auto':
                return {
                    prevEl: ".swiper-button-prev-guide-auto",
                    nextEl: ".swiper-button-next-guide-auto",
                };
            case 'topics-pair':
                return {
                    prevEl: ".swiper-button-prev-topics-pair",
                    nextEl: ".swiper-button-next-topics-pair",
                };
            case 'topics-auto':
                return {
                    prevEl: ".swiper-button-prev-topics-auto",
                    nextEl: ".swiper-button-next-topics-auto",
                };
            case 'research-pair':
                return {
                    prevEl: ".swiper-button-prev-research-pair",
                    nextEl: ".swiper-button-next-research-pair",
                };
            case 'research-auto':
                return {
                    prevEl: ".swiper-button-prev-research-auto",
                    nextEl: ".swiper-button-next-research-auto",
                };
            default:
                return {
                    prevEl: ".swiper-button-prev",
                    nextEl: ".swiper-button-next",
                };
        }
    };
    var getSliderSettings = function () {
        if (props.type === 'hero') {
            return {
                spaceBetween: 16,
                resizeObserver: true,
                watchOverflow: true,
                slidesPerView: 1,
                navigation: __assign({}, getNavigation()),
                effect: 'fade',
                fadeEffect: { crossFade: true },
                speed: 1000,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    type: 'bullets',
                },
                paginationelement: 'button',
            };
        }
        else if (props.type === 'pair') {
            return {
                spaceBetween: 16,
                resizeObserver: true,
                watchOverflow: true,
                slidesPerView: 1,
                navigation: __assign({}, getNavigation()),
                breakpoints: {
                    // when window width is >= 500px
                    '500': {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                },
            };
        }
        else {
            return {
                spaceBetween: 16,
                resizeObserver: true,
                watchOverflow: true,
                slidesPerView: 1,
                navigation: __assign({}, getNavigation()),
                breakpoints: {
                    // when window width is >= 500px
                    '500': {
                        slidesPerView: auto,
                        spaceBetween: 24,
                    },
                },
            };
        }
    };
    var getSwiperClassName = function () {
        if (props.type === 'hero')
            return 'swiper-outter-conatiner--hero';
        return props.type === 'auto' ? 'swiper-slide-auto' : '';
    };
    return (React.createElement("div", { className: "swiper-outter-conatiner " + getSwiperClassName() },
        props.type !== 'hero' && (React.createElement("div", { className: "swiper-button-prev swiper-button-prev-" + props.section },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "40.704", viewBox: "0 0 24 40.704" },
                React.createElement("path", { id: "icon_arrow_right_black", d: "M24,3.639,20.339,0,0,20.352,20.36,40.7,24,37.066,7.28,20.352Z", fill: "currentColor" })))),
        React.createElement(Swiper$1, __assign({}, __assign(__assign({}, getSliderSettings()), { a11y: { enabled: true } })), props.data &&
            props.data.map(function (child, index) {
                return (React.createElement(SwiperSlide, { key: index },
                    React.createElement(props.sliderComponent, __assign({}, child))));
            })),
        props.type !== 'hero' && (React.createElement("div", { className: "swiper-button-next swiper-button-next-" + props.section },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "40.704", viewBox: "0 0 24 40.704" },
                React.createElement("path", { id: "icon_arrow_right_black", d: "M24,3.639,20.339,0,0,20.352,20.36,40.7,24,37.066,7.28,20.352Z", transform: "translate(24 40.704) rotate(180)", fill: "currentColor" }))))));
};

var useStyles$m = makeStyles(function (theme) {
    var _a, _b, _c, _d;
    var lgHeight = 330;
    var mdHeight = 220;
    var xsHeight = 395;
    return createStyles({
        card: (_a = {
                minWidth: '250px',
                //maxWidth: 600,
                height: xsHeight,
                width: '100%',
                cursor: 'pointer',
                borderRadius: 0,
                backgroundColor: theme.palette.secondary.main,
                boxShadow: 'none',
                textAlign: 'left',
                marginRight: '.5rem'
            },
            _a[theme.breakpoints.up('sm')] = {
                height: mdHeight,
            },
            _a[theme.breakpoints.up('lg')] = {
                height: lgHeight,
            },
            _a),
        cardInner: {
            height: '100%',
            position: 'relative',
        },
        cardMedia: (_b = {
                minWidth: '250px',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            },
            _b[theme.breakpoints.only('xs')] = {
                height: xsHeight,
            },
            _b[theme.breakpoints.up('sm')] = {
                height: mdHeight,
            },
            _b[theme.breakpoints.up('lg')] = {
                height: lgHeight,
            },
            _b),
        cardContent: (_c = {
                textAlign: 'left',
                position: 'relative',
                maxHeight: '100%',
                // top: -Math.abs(xsHeight),
                height: xsHeight,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                textDecoration: 'none',
                '&:hover': {
                    '& button span': {
                        textDecoration: 'underline',
                    },
                }
            },
            _c[theme.breakpoints.up('sm')] = {
                height: lgHeight,
            },
            _c[theme.breakpoints.up('lg')] = {
                height: lgHeight,
            },
            _c['& *'] = {
                color: theme.palette.primary.contrastText,
            },
            _c),
        cardHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
        },
        cardTitleArea: (_d = {
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
                width: '100%',
                paddingTop: '15px',
                maxHeight: '100%',
                overflow: 'hidden',
                overflowY: 'scroll'
            },
            _d[theme.breakpoints.up('sm')] = {
                width: '100%',
            },
            _d[theme.breakpoints.up('lg')] = {
                width: '66%',
            },
            _d),
        cardTitleTypo: {
            textTransform: 'uppercase',
        },
        cardSubtitleTypo: {
            paddingTop: '10px',
        },
        cardCountArea: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        },
        cardDiscoverButton: {
            padding: 0,
            paddingLeft: '4px',
            '&:focus-visible': {
                outline: "4px solid #fff !important",
                boxShadow: '0px 0px',
            },
        },
        cardDiscoverButtonTypo: {
            textTransform: 'uppercase',
        },
    });
});

var CollectionCardComponent$1 = function (props) {
    var image = props.image, title = props.title, subtitle = props.subtitle, count = props.count, onClick = props.onClick, _a = props.actionText, actionText = _a === void 0 ? 'Discover' : _a;
    var classes = useStyles$m();
    return (React.createElement(Card, { className: classes.card, onClick: function () { return onClick && onClick(); } },
        React.createElement(CardContent, { tabIndex: -1, className: classes.cardInner },
            React.createElement(CardMedia, { className: classes.cardMedia, image: image }),
            React.createElement(CardContent, { className: classes.cardContent },
                React.createElement("div", { className: classes.cardHeader },
                    React.createElement("div", { className: classes.cardCountArea }, count && (React.createElement(React.Fragment, null,
                        React.createElement(PhotoLibraryOutlinedIcon, null),
                        React.createElement(Typography, { variant: "caption" }, count)))),
                    React.createElement(ButtonBase, { className: classes.cardDiscoverButton, onClick: function () { return onClick && onClick(); } },
                        React.createElement(Typography, { variant: "caption", className: classes.cardDiscoverButtonTypo }, actionText),
                        React.createElement(ArrowRightAltIcon, null))),
                React.createElement("div", { className: classes.cardTitleArea },
                    React.createElement("div", null,
                        React.createElement(Typography, { variant: "h3", className: classes.cardTitleTypo }, title)),
                    React.createElement("div", null,
                        React.createElement(Typography, { variant: "body1", className: classes.cardSubtitleTypo }, subtitle)))))));
};
var CollectionCard$1 = CollectionCardComponent$1;

var useStyles$n = makeStyles(function (theme) {
    return createStyles({
        container: {
            transition: theme.transitions.create(['height'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            // backgroundColor: theme.palette.primary.main,
            backgroundColor: '#feffe4',
        },
        gridContainer: {
            maxWidth: '1312px',
            margin: '0 auto',
            width: '100%',
        },
        titleGridItem: {
            display: 'block',
        },
        titleArrowButton: {
            //color: theme.palette.primary.contrastText,
            color: 'black',
        },
        buttonTitle: {
            '& > span': {
                display: 'block',
            },
        },
        titleButton: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            textAlign: 'left',
            color: 'black',
        },
        titleButtonTypo: {
            //color: theme.palette.primary.contrastText,
            color: 'black',
            fontSize: '1.25rem',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
    });
});

/* eslint-disable react/jsx-key */
// TODO: Probably this implementation is not necessary, CollectionsModule could be used instead.
function CollectionsDiscoverModule(_a) {
    var _b = _a.collectionModuleClasses, collectionModuleClasses = _b === void 0 ? '' : _b, _c = _a.section, section = _c === void 0 ? '' : _c;
    var classes = useStyles$n();
    var t = useTranslation().t;
    var link = new LinkBuilder();
    var handleTopic = function () {
        link.toTopicsHashed('/#topics');
    };
    return (React.createElement(CollectionsContext.Consumer, null, function (collectionsContext) { return (React.createElement("div", { id: 'CollectionsModule', className: clsx(classes.container, collectionModuleClasses) },
        React.createElement(Grid, { container: true, className: classes.gridContainer, spacing: 4, direction: 'row', alignItems: 'center', "data-testid": 'collection-discover-module-wrapper' },
            React.createElement(Grid, { item: true, xs: 12, className: classes.titleGridItem },
                React.createElement(ButtonBase$1, { onClick: handleTopic, className: classes.titleButton },
                    React.createElement(Typography$1, { className: classes.titleButtonTypo }, t('discover other collections')),
                    React.createElement(ArrowRightAltOutlinedIcon, { className: classes.titleArrowButton, fontSize: 'large' }))),
            collectionsContext.collections.map(function (collectionContextData, index) { return (React.createElement(Grid, { item: true, key: index, xs: 12, sm: 6 },
                React.createElement(CollectionCard, { "data-testid": 'collection-discover-module-cards-wrapper', image: collectionContextData.previewImageCard, title: collectionContextData.title, subtitle: collectionContextData.subtitle, section: section, actionText: t('collections module discover button'), href: link.getTopicsHref(collectionContextData.id, collectionContextData.platform) }))); })))); }));
}

var useStyles$o = makeStyles(function (theme) {
    return createStyles({
        contentWrapper: {
            transition: theme.transitions.create(['height'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            maxWidth: '1280px',
            padding: '50px',
            margin: 'auto',
            marginBottom: '3rem',
            backgroundColor: theme.palette.secondary.main,
        },
        contentWrapperHide: {
            height: '0px',
        },
        card: {
            margin: 'auto',
            padding: '12px',
            width: '270px',
            borderRadius: 0,
            backgroundColor: theme.palette.secondary.main,
            boxShadow: 'none',
        },
        cardMediaLink: {
            display: 'block',
            textDecoration: 'none',
            color: theme.palette.primary.dark,
            '&:focus-visible': {
                outline: '4px solid black !important',
                boxShadow: 'none',
            },
            '&:focus, & :focus': {
                outline: 'none',
            },
            '&:hover .MuiCardMedia-root': {
                filter: 'brightness(1.2)',
            },
        },
        cardMedia: {
            height: '270px',
            backgroundSize: 'contain',
            cursor: 'pointer',
        },
        cardContent: {
            padding: '0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& *': {
                color: theme.palette.primary.dark,
            },
        },
        cardTypo: {
            textAlign: 'center',
            cursor: 'pointer',
        },
        titleGridItem: {
            display: 'grid',
            alignItems: 'center',
            justifyContent: 'center',
        },
        buttonTitle: {
            '& > span': {
                display: 'block',
            },
        },
        iconButtonTitleTypo: {
            color: theme.palette.primary.main,
        },
        titleArrowButton: {
            transform: 'rotate(90deg)',
            color: theme.palette.secondary.contrastText,
        },
        endArrowButton: {
            transform: 'rotate(-90deg)',
            color: theme.palette.secondary.contrastText,
        },
    });
});

var CollectionContext$1 = createContext({
    id: 0,
    previewImageSlider: '',
    previewImageCard: '',
    previewImageMediaPlayer: '',
    title: '',
    subtitle: '',
    collectionObjects: [],
    interval: 8000,
});

/* eslint-disable react/jsx-key */
/**
 * CollectionModule displays a collection of images as grid.
 * @param maxImageSize
 * @param title
 * @param bottomTitle
 * @constructor
 */
function CollectionModule(_a) {
    var _b = _a.maxImageSize, maxImageSize = _b === void 0 ? 170 : _b, title = _a.title, bottomTitle = _a.bottomTitle;
    var classes = useStyles$o();
    var config = useConfigLoader().config;
    var contentContainerRef = useState(createRef())[0];
    var buildImageUrl = function (imageId, imageSize) {
        var imageUrlBuilder = new ImageUrlBuilder(config);
        return imageUrlBuilder.buildUrl(imageId, imageSize, imageSize);
    };
    // const collectionContext = useContext<CollectionContextData>(CollectionContext);
    var discoverButtonClicked = function () {
        contentContainerRef.current &&
            window &&
            window.scrollTo({
                left: 0,
                top: contentContainerRef.current.offsetTop,
                behavior: 'smooth',
            });
    };
    var scrollToTop = function () {
        window && window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    };
    // const imageClicked = (index: number): void => {
    //   collectionContext.onCollectionObjectSelected &&
    //     collectionContext.onCollectionObjectSelected(index);
    //   scrollToTop();
    // };
    var createDetailPageLink = function (objectId) {
        return config.RESEARCH_DOMAIN + "/detail/" + objectId;
    };
    var t = useTranslation().t;
    return (React.createElement(CollectionContext$1.Consumer, null, function (collectionContext) { return (React.createElement("div", { className: classes.contentWrapper, ref: contentContainerRef, "data-testid": 'collection-module-content-wrapper' },
        React.createElement(Grid$1, { container: true, spacing: 1, direction: 'row', justifyContent: 'center', alignItems: 'center' },
            title && (React.createElement(Grid$1, { item: true, xs: 12, className: classes.titleGridItem },
                React.createElement(ButtonBase$1, { onClick: discoverButtonClicked, className: classes.buttonTitle },
                    React.createElement("span", null,
                        React.createElement(Typography$1, { variant: 'h3', className: classes.iconButtonTitleTypo }, title),
                        React.createElement(ArrowRightAltOutlinedIcon, { className: classes.titleArrowButton, fontSize: 'large' }))))),
            collectionContext.collectionObjects.map(function (collectionObject, index) { return (React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, lg: 3, key: index },
                React.createElement(Link, { className: classes.cardMediaLink, href: createDetailPageLink(collectionObject.objectId), target: "__blank" },
                    React.createElement(Card, { className: classes.card },
                        React.createElement(LazyLoadImage, { src: buildImageUrl(collectionObject, maxImageSize) },
                            React.createElement(CardMedia$1, { className: classes.cardMedia, image: buildImageUrl(collectionObject, maxImageSize) })),
                        React.createElement(CardContent$1, { className: classes.cardContent },
                            React.createElement(Typography$1, { "aria-label": t('show detail'), variant: 'body1', className: classes.cardTypo }, collectionObject.displayTitle)))))); }),
            bottomTitle && (React.createElement(Grid$1, { item: true, xs: 12, className: classes.titleGridItem },
                React.createElement(ButtonBase$1, { onClick: scrollToTop, className: classes.buttonTitle },
                    React.createElement("span", null,
                        React.createElement(ArrowRightAltOutlinedIcon, { className: classes.endArrowButton, fontSize: 'large' }),
                        React.createElement(Typography$1, { variant: 'h3', className: classes.iconButtonTitleTypo }, bottomTitle)))))))); }));
}

var useStyles$p = makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return createStyles({
        container: {
            display: 'flex',
            justifyContent: 'space-between',
            maxWidth: 1280,
            padding: '30px 0',
            margin: 'auto',
            flexWrap: 'wrap',
        },
        imgContainer: (_a = {
                width: '100%',
                height: '600px',
                maxWidth: '400px'
            },
            _a[theme.breakpoints.down('md')] = {
                height: '600px',
            },
            _a[theme.breakpoints.down('sm')] = {
                height: '350px',
            },
            _a),
        imgPreviewContainer: (_b = {
                display: 'flex',
                alignItems: 'flex-end',
                overflowX: 'scroll',
                maxHeight: 300
            },
            _b[theme.breakpoints.up('md')] = {
                flexDirection: 'column',
                maxWidth: 200,
                overflowX: 'hidden',
                overflowY: 'scroll',
                alignItems: 'flex-end',
            },
            _b),
        imgFlexWrapper: (_c = {
                display: 'flex',
                flexWrap: 'nowrap',
                flexDirection: 'row'
            },
            _c[theme.breakpoints.up('md')] = {
                flexDirection: 'column',
            },
            _c['& > div'] = {
                height: 86,
                width: 86,
                margin: 7,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                cursor: 'pointer',
                opacity: 0.7,
                '&:hover': {
                    opacity: 1,
                },
                '&.active': {
                    opacity: 1,
                },
            },
            _c),
        imgAside: (_d = {
                display: 'flex',
                // 60px based on the 30px padding of parent
                maxWidth: 'calc(100vw - 60px)',
                flexDirection: 'column'
            },
            _d[theme.breakpoints.up('md')] = {
                maxHeight: '55vh',
                width: 200,
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
            },
            _d),
        pictureCredits: {
            display: 'block',
            width: '100%',
            color: theme.palette.secondary.contrastText,
            paddingTop: '1rem',
            textAlign: 'center',
        },
        license: {
            paddingLeft: '6px',
        },
    });
});

var ExhibitPreview = function (props) {
    var attachments = props.attachments, currentAttachment = props.currentAttachment, creditsLabel = props.creditsLabel, onChange = props.onChange;
    var t = useTranslation().t;
    var classes = useStyles$p();
    var _a = currentAttachment !== null && currentAttachment !== void 0 ? currentAttachment : {}, credits = _a.credits, license = _a.license, src = _a.src;
    var renderFallbackImage = function () {
        return (React.createElement(FallbackImage, { text: t('image.notFoundText'), width: "100%", height: "100%" }));
    };
    return (React.createElement(Grid, { className: classes.container, justifyContent: "center", container: true },
        React.createElement(Grid, { item: true, lg: 1, md: 1, sm: 12 }),
        React.createElement(Grid, { item: true, container: true, justifyContent: "center", lg: 8, md: 8, sm: 12, xs: 12 },
            React.createElement("div", { className: classes.imgContainer },
                React.createElement(LazyLoadImage, { Fallback: renderFallbackImage(), width: "100%", height: "100%", src: src })),
            React.createElement(Typography, { variant: "caption", className: classes.pictureCredits },
                credits && creditsLabel + ": " + credits,
                license && license.href && (React.createElement("a", { className: classes.license, href: license.href, target: license.target || '_blank' }, license.text)),
                license && !license.href && (React.createElement("div", { className: classes.license }, license.text)))),
        React.createElement(Grid, { item: true, container: true, alignItems: "flex-end", justifyContent: "flex-end", lg: 1, md: 1, sm: 12 },
            React.createElement("div", { className: classes.imgPreviewContainer },
                React.createElement("div", { className: classes.imgFlexWrapper }, (attachments === null || attachments === void 0 ? void 0 : attachments.length) > 1 &&
                    attachments.map(function (attachment, i) {
                        return (React.createElement("div", { key: i, style: { height: '86px' } },
                            React.createElement(LazyLoadImage, { width: "86px", height: "86px", src: attachment === null || attachment === void 0 ? void 0 : attachment.src, onClick: function () { return onChange && onChange(attachment); } })));
                    }))))));
};

var useStyles$q = makeStyles(function () {
    return createStyles({
        actionsContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
        },
    });
});

var ExhibitActions = function (props) {
    var classNames = props.classNames, _a = props.showImageActions, showImageActions = _a === void 0 ? false : _a, zoomActionLabel = props.zoomActionLabel, downloadActionLabel = props.downloadActionLabel, onZoom = props.onZoom, onDownload = props.onDownload;
    var classes = useStyles$q();
    return (React.createElement("div", { className: clsx(classes.actionsContainer, classNames) },
        showImageActions && (React.createElement(IconButton, { color: "inherit", "aria-label": downloadActionLabel || 'Download', "data-cy": 'object-actions-download', onClick: function () { return onDownload && onDownload(); } },
            React.createElement(SaveAltOutlinedIcon, null))),
        showImageActions && (React.createElement(IconButton, { color: "inherit", "aria-label": zoomActionLabel || 'Zoom', "data-cy": 'object-actions-zoom', onClick: function () { return onZoom && onZoom(); } },
            React.createElement(ZoomInOutlinedIcon, null)))));
};

var EExhibitAsideLinks;
(function (EExhibitAsideLinks) {
    EExhibitAsideLinks[EExhibitAsideLinks["TEXT"] = 0] = "TEXT";
    EExhibitAsideLinks[EExhibitAsideLinks["TOPIC"] = 1] = "TOPIC";
    EExhibitAsideLinks[EExhibitAsideLinks["GUIDE"] = 2] = "GUIDE";
})(EExhibitAsideLinks || (EExhibitAsideLinks = {}));

var useStyles$r = makeStyles(function () {
    return createStyles({
        content: {
            padding: 15,
            margin: '10px 0',
        },
        link: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.75rem',
            '& > svg': {
                marginLeft: 10,
            },
        },
        contentTopic: {
            color: '#f9ff04',
            backgroundColor: '#6f7045',
        },
        contentGuide: {
            color: '#ffffff',
            backgroundColor: '#f25b5b',
        },
        contentText: {
            color: '#000000',
            backgroundColor: '#d3d3d3',
        },
        typoTitle: {
            paddingBottom: 10,
        },
    });
});

var ExhibitAsideLinks = function (_a) {
    var _b, _c, _d;
    var title = _a.title, links = _a.links, type = _a.type;
    var classes = useStyles$r();
    var containerTypeClasses = clsx((_b = {}, _b[classes.contentTopic] = type === EExhibitAsideLinks.TOPIC, _b), (_c = {}, _c[classes.contentGuide] = type === EExhibitAsideLinks.GUIDE, _c), (_d = {}, _d[classes.contentText] = type === EExhibitAsideLinks.TEXT, _d));
    return (React.createElement("div", { className: clsx(classes.content, containerTypeClasses) },
        React.createElement(Typography, { component: "div", variant: "h5", className: clsx(classes.typoTitle, containerTypeClasses) }, title), links === null || links === void 0 ? void 0 :
        links.map(function (link, i) { return (React.createElement(Link$1, { key: i, href: link.href, color: "inherit", className: clsx(classes.link, containerTypeClasses) },
            link.caption,
            React.createElement(ArrowRightAltIcon, null))); })));
};

var useStyles$s = makeStyles(function (theme) {
    return createStyles({
        content: {
            marginTop: 15,
            fontWeight: 'bold',
            color: theme.palette.secondary.contrastText,
        },
        container: {
            color: theme.palette.secondary.contrastText,
        },
    });
});

var ExhibitAsideText = function (_a) {
    var title = _a.title, content = _a.content;
    var classes = useStyles$s();
    return (React.createElement(Typography, { variant: "body1", className: classes.container },
        React.createElement("span", { className: classes.content },
            title,
            " "),
        content));
};

var ExhibitAside = function (props) {
    var infoItems = props.infoItems, containerElements = props.containerElements, creditLine = props.creditLine;
    return (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12 }, infoItems.map(function (infoItem, i) {
            return (React.createElement(ExhibitAsideText, { key: i, title: infoItem.title, content: infoItem.content }));
        })),
        creditLine && (React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12 },
            React.createElement(Typography, null, creditLine))),
        React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12 }, containerElements.map(function (containerElement, i) {
            return (React.createElement(ExhibitAsideLinks, { key: i, type: containerElement.type, links: containerElement.links, title: containerElement.title }));
        }))));
};

var useStyles$t = makeStyles(function (theme) {
    var _a;
    return createStyles({
        container: {
            maxWidth: 1280,
            padding: '30 0',
        },
        separator: {
            height: 3,
            marginBottom: 30,
            backgroundColor: theme.palette.primary.main,
        },
        titleGrid: {
            paddingTop: 24,
        },
        contentGrid: {
            padding: '30px 0',
        },
        title: {
            color: theme.palette.text.secondary,
            whiteSpace: 'break-spaces',
            textTransform: 'none',
            fontWeight: 'bold',
            lineHeight: 1.5,
        },
        actions: (_a = {},
            _a[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _a),
    });
});

var ExhibitDescription = function (props) {
    var titles = props.titles, children = props.children, renderActions = props.renderActions, renderAside = props.renderAside;
    var classes = useStyles$t();
    return (React.createElement("div", { id: "DescriptionModule", className: classes.container },
        React.createElement(Divider, { className: classes.separator }),
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, xs: 12, sm: 12, lg: 10, md: 10 }, titles.map(function (title, i) {
                if (!title) {
                    return null;
                }
                return (React.createElement(Typography, { key: i, variant: "h3", className: classes.title }, title));
            })),
            React.createElement(Grid, { container: true, justifyContent: "flex-end", item: true, xs: 12, sm: 12, lg: 2, md: 2 },
                React.createElement("div", { className: classes.actions }, renderActions())),
            React.createElement(Grid, { container: true, spacing: 0, direction: "row", justifyContent: "space-between", className: classes.contentGrid },
                React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 3 }, renderAside()),
                React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 8 }, children)))));
};

var useStyles$u = makeStyles(function (theme) {
    var _a;
    return createStyles({
        title: {
            fontWeight: 'bold',
            color: theme.palette.text.secondary,
            whiteSpace: 'break-spaces',
        },
        button: {
            color: theme.palette.text.secondary,
            whiteSpace: 'break-spaces',
            wordBreak: 'break-word',
            fontWeight: 400,
            borderRadius: 0,
            textTransform: 'inherit',
            padding: 0,
            fontSize: 'inherit',
        },
        content: {
            color: theme.palette.text.secondary,
            whiteSpace: 'break-spaces',
            wordBreak: 'break-word',
            fontWeight: 400,
            lineHeight: '1.75rem !important',
            '& a': {
                color: theme.palette.text.secondary,
            },
            '& + &': {
                marginTop: '1rem',
            },
            ' a': {
                color: theme.palette.text.secondary,
            },
        },
        contentLink: {
            color: theme.palette.text.secondary,
            whiteSpace: 'break-spaces',
            wordBreak: 'break-word',
            fontWeight: 400,
            textDecoration: 'underline',
            '&:not(:first-of-type)': {
                marginTop: '.5rem',
            },
        },
        cell: (_a = {
                display: 'flex',
                justifyContent: 'space-between',
                whiteSpace: 'break-spaces',
                paddingRight: '1.5rem'
            },
            _a[theme.breakpoints.down(600)] = {
                paddingRight: '0',
            },
            _a),
        cellLink: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'self-start',
            justifyContent: 'center',
            whiteSpace: 'break-spaces',
        },
        row: {
            padding: 12,
        },
    });
});

/* eslint-disable no-console */
/**
 * Component used to render a row in the grid of detail view
 *
 * -----
 * @param title - title of the row (appears in first column)
 * @param content - content of the row (appears in second column)
 * @param permalink - if it's the row with permalink (last row)
 * @constructor
 */
var ExhibitDescriptionGridRow = function (_a) {
    var title = _a.title, content = _a.content, permalink = _a.permalink;
    var classes = useStyles$u();
    var t = useTranslation().t;
    var copyPermalink = function () {
        copyToClipboard(content);
    };
    // todo: use linkBuilder to build the internal links
    return (React.createElement(Grid, { className: classes.row, container: true },
        React.createElement(Grid, { item: true, xs: 12, sm: 4, md: 5, className: classes.cell },
            React.createElement(Typography, { variant: "h6", className: classes.title }, title),
            permalink && (React.createElement(Tooltip, { title: "" + t('details.aside.permalinkCopied'), arrow: true },
                React.createElement(IconButton$1, { color: "inherit", "aria-label": "" + t('details.aside.permalinkCopied'), "data-testid": 'object-actions-permlink', className: "exhibit-actions__btn", onClick: copyPermalink },
                    React.createElement(LinkOutlinedIcon, { color: "primary", fontSize: "large" }))))),
        React.createElement(Grid, { item: true, xs: 12, sm: 8, md: 7, className: classes.cellLink },
            Array.isArray(content) &&
                content.map(function (link, index) {
                    var _a;
                    var data = link;
                    return (React.createElement(React.Fragment, { key: index },
                        React.createElement(SafeEscapedHTML, { htmlString: (_a = data.markup) !== null && _a !== void 0 ? _a : data.formatted, cssClassNames: classes.content })));
                }),
            !Array.isArray(content) && !permalink && (React.createElement(Typography, { component: 'p', variant: "body1", className: classes.content }, content)),
            permalink && (React.createElement(Tooltip, { title: "" + t('details.aside.permalinkCopied'), arrow: true },
                React.createElement(Button, { variant: "text", className: classes.button, onClick: copyPermalink },
                    React.createElement(Typography, { className: classes.content }, shortenPermalink(content))))))));
};

var useStyles$v = makeStyles(function () {
    return createStyles({
        container: {
            '& > :nth-child(odd)': {
                backgroundColor: '#e8e8e8',
            },
        },
    });
});

/* eslint-disable no-console */
var ExhibitDescriptionGrid = function (_a) {
    var items = _a.items, exhibit = _a.exhibit;
    var _b = useState([]), gridItems = _b[0], setGridItems = _b[1];
    var t = useTranslation().t;
    useEffect(function () {
        var permalink = {
            title: t('search.exhibit.attributes.permalink'),
            content: new LinkBuilder().getPermalinkHref(exhibit.id, exhibit.title),
        };
        items.push(permalink);
        setGridItems(items);
    }, [items]);
    var classes = useStyles$v();
    //todo: create internal links
    return (React.createElement(Grid$1, { className: classes.container, container: true }, gridItems &&
        gridItems.map(function (item, i) {
            return (React.createElement(React.Fragment, { key: i }, item.content.length > 0 && (React.createElement(ExhibitDescriptionGridRow, { key: i, permalink: i === gridItems.length - 1, title: item.title, content: item.content }))));
        })));
};

var useStyles$w = makeStyles(function (theme) {
    return createStyles({
        iconclassRow: {
            '& > div': {
                display: 'flex',
                flexDirection: 'row',
                '& a': {
                    color: theme.palette.text.secondary,
                },
                '& [target*="_blank"]': {
                    '&::after ': {
                        content: "url('data:image/svg+xml; utf8, <svg class=\"makeStyles-svg-291\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 195 191\"><g fill=\"000\"><path d=\"M185.818,0.161 L128.778,0.161 C123.807,0.161 119.778,4.19 119.778,9.161 C119.778,14.132 123.807,18.161 128.778,18.161 L164.09,18.161 L77.79,104.461 C74.275,107.976 74.275,113.674 77.79,117.189 C79.548,118.946 81.851,119.825 84.154,119.825 C86.457,119.825 88.76,118.946 90.518,117.189 L176.818,30.889 L176.818,66.202 C176.818,71.173 180.847,75.202 185.818,75.202 C190.789,75.202 194.818,71.173 194.818,66.202 L194.818,9.162 C194.818,4.19 190.789,0.161 185.818,0.161 Z\"></path><path d=\"M149,75.201 C144.029,75.201 140,79.23 140,84.201 L140,172.657 L18,172.657 L18,50.657 L111.778,50.657 C116.749,50.657 120.778,46.628 120.778,41.657 C120.778,36.686 116.749,32.657 111.778,32.657 L9,32.657 C4.029,32.657 0,36.686 0,41.657 L0,181.657 C0,186.628 4.029,190.657 9,190.657 L149,190.657 C153.971,190.657 158,186.628 158,181.657 L158,84.201 C158,79.23 153.971,75.201 149,75.201 Z\"></path></g></svg>')",
                        display: 'inline-block',
                        paddingLeft: '.25rem',
                    },
                },
                '& [data-link-type="internal"]': {
                    display: 'inline-block !important',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '50vw',
                    overflow: 'hidden'
                }
            },
        },
        contrastText: {
            color: theme.palette.text.secondary,
            whiteSpace: 'break-spaces',
        },
        contrastTextHeader: {
            color: theme.palette.text.secondary,
            whiteSpace: 'break-spaces',
        },
        contrastTextTitle: {
            color: theme.palette.text.secondary,
            whiteSpace: 'break-spaces',
        },
        accordionSummary: {
            '&:hover': {
                '& h4': {
                    textDecoration: 'underline',
                },
            },
        },
        accordionSummaryIcon: {
            fontSize: '2rem !important',
        },
        accordionElement: {
            borderTop: 'solid 1px',
            borderColor: theme.palette.primary.main,
            boxShadow: 'none',
            margin: '0 !important',
            color: '#22201E',
            '&:first-child': {
                borderRadius: 0,
                borderTop: 0,
            },
            '&:not(:last-child)': {
                borderBottom: 0,
            },
            '&:before': {
                display: 'none',
            },
            '& .MuiAccordionSummary-root': {
                minHeight: '4rem',
                '&:hover': {
                    textDecoration: 'underline !important',
                    backgroundColor: 'transparent',
                },
            },
        },
        listItemIcon: {
            color: '#000000',
            'min-width': '1rem',
            'align-self': 'flex-start',
            margin: '6px 0px',
        },
        listItemText: {
            whiteSpace: 'pre-wrap',
        },
        listTitle: {
            color: theme.palette.text.secondary,
            whiteSpace: 'break-spaces',
            padding: '1rem 0 1.5rem',
            fontFamily: 'GTWalsheimPro-Bold, Arial',
            lineHeight: 1,
        },
        accordionListRow: {
            display: 'flex',
            flexWrap: 'wrap',
            padding: '0 0 .5rem 0',
            margin: '0',
            '& li': {
                display: 'flex',
                with: 'auto',
                padding: '0 .5rem .25rem 0',
                listStyle: 'none',
                '& a': {
                    textDecoration: 'underline',
                    fontWeight: '400 !important',
                },
                '& p': {
                    fontWeight: '400 !important',
                    marginBottom: '0 !important',
                },
                '& span': {
                    margin: '0 .5rem 0 0',
                    display: 'flex',
                    justifyContent: 'center',
                    '& svg': {
                        fontSize: '0.875rem !important',
                        marginLeft: '.25rem',
                    },
                },
            },
        },
        icon: {
            margin: '0 !important',
        },
        accordionListColumn: {
            display: 'flex',
            flexDirection: 'column',
            padding: '0 0 .5rem 0',
            margin: '0',
            '& li': {
                display: 'flex',
                with: '100%',
                padding: '0 0 1rem 0',
                listStyle: 'none',
                lineHeight: '1.5rem',
                '& a': {
                    textDecoration: 'underline',
                    fontWeight: '400 !important',
                    display: 'flex !important',
                },
                '& p': {
                    fontWeight: '400 !important',
                    display: 'flex !important',
                    marginBottom: '0 !important',
                },
                '& span': {
                    margin: '0 .5rem 0 0',
                    display: 'flex',
                    justifyContent: 'center',
                    '& svg': {
                        fontSize: '0.875rem !important',
                        marginLeft: '.25rem',
                    },
                },
            },
        },
    });
});

/* eslint-disable react/jsx-key */
var ExhibitDescriptionAccordion = function (props) {
    var title = props.title, content = props.content, listTitle = props.listTitle, keywordsList = props.keywordsList, _a = props.expanded, expanded = _a === void 0 ? false : _a;
    var _b = React.useState(expanded), expandedState = _b[0], setExpandedState = _b[1];
    var handleChange = function (_event, isExpanded) {
        setExpandedState(isExpanded);
    };
    var classes = useStyles$w();
    // We need a valid id for the aria-labeledby attribute
    var generateValidId = function (titleString) {
        return titleString.replace(/\W/g, '_');
    };
    var getListClassName = function (value) {
        switch (value) {
            case 'row':
                return classes.accordionListRow;
            case 'column':
            default:
                return classes.accordionListColumn;
        }
    };
    var renderListItem = function (item, _index) {
        return (React.createElement("li", { key: _index },
            React.createElement(SafeEscapedHTML, { htmlString: item.text, cssClassNames: classes.listItemText + " " + classes.iconclassRow, htmlTag: 'p' })));
    };
    return (React.createElement(Accordion, { expanded: expandedState, onChange: handleChange, defaultExpanded: false, className: classes.accordionElement },
        React.createElement(AccordionSummary, { className: classes.accordionSummary, expandIcon: React.createElement(ExpandMoreIcon, { fontSize: "large", className: classes.accordionSummaryIcon }) },
            React.createElement(Typography$1, { variant: "h4", id: generateValidId(title), className: classes.contrastTextHeader },
                React.createElement(SafeEscapedHTML, { htmlString: title }))),
        React.createElement(AccordionDetails, { style: { display: 'inherit' } },
            listTitle && (React.createElement(Typography$1, { variant: "body1", id: generateValidId('listTitle'), className: classes.contrastTextTitle }, listTitle)),
            keywordsList && (keywordsList === null || keywordsList === void 0 ? void 0 : keywordsList.length) > 0 && (React.createElement("div", { "aria-labelledby": listTitle ? generateValidId(listTitle) : generateValidId(title) }, keywordsList.map(function (listItem, _index) {
                var _a;
                return (React.createElement("div", { key: _index },
                    listItem.key !== 'keywords' && (React.createElement(Typography$1, { variant: "h5", id: generateValidId(listItem.title), className: classes.listTitle }, listItem.title)),
                    React.createElement("ul", { className: getListClassName(listItem.layout) }, ((_a = listItem === null || listItem === void 0 ? void 0 : listItem.list) === null || _a === void 0 ? void 0 : _a.length) > 0 && (listItem === null || listItem === void 0 ? void 0 : listItem.list.map(function (item, _index) {
                        return renderListItem(item, _index);
                    })))));
            }))),
            Array.isArray(content) ? (React.createElement(List, { dense: true, disablePadding: true, "aria-labelledby": listTitle ? generateValidId(listTitle) : generateValidId(title) }, content.map(function (listItem, i) {
                return (React.createElement(ListItem, { dense: true, disableGutters: true, key: i },
                    React.createElement(ListItemIcon, { className: classes.listItemIcon }, "\u2022"),
                    React.createElement(ListItemText, { primaryTypographyProps: {
                            gutterBottom: false,
                            variant: 'body2',
                        }, className: classes.listItemText },
                        React.createElement(SafeEscapedHTML, { htmlString: listItem, htmlTag: 'span' }))));
            }))) : (React.createElement(Typography$1, { variant: "body2", className: classes.contrastText },
                React.createElement(SafeEscapedHTML, { htmlString: content, htmlTag: 'span' }))))));
};

var css$c = ".card {\n  max-height: 100%;\n  width: 250px;\n  background: none;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto !important;\n}\n.card:hover {\n  filter: brightness(120%);\n}\n.card:focus-visible {\n  outline: none;\n}\n.card.content:focus-within {\n  outline: 4px solid currentColor;\n}\n.card__text-wrappr {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n}\n.card__text {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  color: currentColor;\n  line-clamp: 1;\n  box-orient: vertical;\n  overflow: hidden;\n  text-align: center;\n  width: 100%;\n  margin-bottom: 0.5rem !important;\n}\n.card__text--small {\n  font-size: 1rem !important;\n}\n.card__text--bold {\n  font-family: GTWalsheimPro-Bold, Arial, sans-serif !important;\n}";
n(css$c,{});

/* eslint-disable no-console */
var CarouselImageCard$1 = function (props) {
    var t = useTranslation().t;
    var _a = props.img, img = _a === void 0 ? '' : _a, _b = props.image, image = _b === void 0 ? '' : _b, _c = props.title, title = _c === void 0 ? '' : _c, _d = props.subTitle, subTitle = _d === void 0 ? '' : _d, _e = props.collection, collection = _e === void 0 ? '' : _e, _f = props.date, date = _f === void 0 ? '' : _f, _g = props.color, color = _g === void 0 ? '#0F0900' : _g, _h = props.link, link = _h === void 0 ? '' : _h, _j = props.maxWidth, maxWidth = _j === void 0 ? 250 : _j, _k = props.maxHeight, maxHeight = _k === void 0 ? 200 : _k;
    var content = [title, subTitle, date, collection];
    var renderFallbackImage = function () {
        return (React.createElement(FallbackImage, { label: title, text: t('image.notFoundText'), width: maxWidth, height: maxHeight }));
    };
    var getContent = function () {
        return content.filter(function (item) { return item; });
    };
    var getContentVariant = function (index) {
        if (index === 0)
            return 'h4';
        else
            return 'body2';
    };
    var getContentClassName = function (index, lastIndex) {
        if (index === 0)
            return 'card__text';
        else if (index === lastIndex)
            return 'card__text card__text--bold';
        else
            return 'card__text card__text--small';
    };
    return (React.createElement(Link, { "data-testid": 'carousel-card', "aria-label": "Link zu " + getContent()[0], href: link, className: "card", style: { color: color } },
        React.createElement("div", { className: "card__image", "aria-label": "Abbildung von " + getContent()[0] },
            React.createElement(LazyLoadImage, { Fallback: renderFallbackImage(), width: maxWidth, height: maxHeight, src: img ? img : image })),
        React.createElement("div", { className: "card__text-wrappr" }, getContent().map(function (item, index) {
            var lastItemIndex = getContent().length - 1;
            return item ? (React.createElement(Typography, { key: "attr-" + index, className: getContentClassName(index, lastItemIndex), variant: getContentVariant(index), color: "inherit" }, item)) : (React.createElement(React.Fragment, null));
        }))));
};

var css$d = ".research-section {\n  color: inherit;\n  padding-top: 3rem;\n}\n.research-section__loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}";
n(css$d,{});

/* eslint-disable react/jsx-key */
function ResearchSection() {
    var highlightsService = new HighlightService();
    var assortmentsService = new AssortmentsService();
    var _a = highlightsService.getHighlightsObjects(), loading = _a.loading, contextData = _a.contextData;
    var _b = assortmentsService.getAssortmentObjects(), assortmentsLoading = _b.assortmentsLoading, assortmentsContextData = _b.assortmentsContextData;
    var config = useConfigLoader().config;
    var t = useTranslation().t;
    // const classes = useStyles();
    var getCardAssortments = function (contextData) {
        return contextData.map(function (assortment) {
            return {
                section: 'research',
                title: assortment.title,
                subtitle: assortment.subtitle,
                href: assortment.link,
                id: assortment.id,
                actionText: t('collections.buttons.research'),
                image: assortment.img,
            };
        });
    };
    var assortments = getCardAssortments(assortmentsContextData);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'research-section' },
            React.createElement(CarouselHeadline, { href: config.RESEARCH_DOMAIN, variant: 'h4', text: t('research.highlights.text'), link: false }, t('research.highlights.title')),
            loading && (React.createElement("div", { className: 'research-section__loader' },
                React.createElement(LoadingSpinner, null))),
            !loading && contextData.length > 0 && (React.createElement(SwiperCarousel, { data: contextData, type: "auto", sliderComponent: CarouselImageCard$1, section: "research-auto" }))),
        !assortmentsLoading && assortments.length > 0 && (React.createElement("div", { className: 'research-section' },
            React.createElement(CarouselHeadline, { href: config.RESEARCH_DOMAIN, variant: 'h4', text: t('research.collection.text'), link: false }, t('research.collection.title')),
            assortmentsLoading && (React.createElement("div", { className: 'research-section__loader' },
                React.createElement(LoadingSpinner, null))),
            React.createElement(SwiperCarousel, { data: assortments, type: "pair", sliderComponent: CollectionCard, section: "research-pair" })))));
}

/* eslint-disable no-console */
var ORG_UNIT_LIST = [
    {
        name: 'Ägyptisches Museum und Papyrussammlung',
        isActive: true,
        value: 'AMP*',
        email: 'mailto:aemp@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/aegyptisches-museum-und-papyrussammlung/home/',
        level: 0,
    },
    {
        name: 'Antikensammlung',
        isActive: true,
        value: 'ANT*',
        email: 'mailto:ant@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/antikensammlung/home/',
        level: 0,
    },
    {
        name: 'Ethnologisches Museum',
        isActive: true,
        value: 'EM*',
        email: 'mailto:em@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/ethnologisches-museum/home/',
        level: 0,
    },
    {
        name: 'Gemäldegalerie',
        isActive: true,
        value: 'GG*',
        email: 'mailto:gg@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/gemaeldegalerie/home/',
        level: 0,
    },
    {
        name: 'Kunstbibliothek',
        isActive: true,
        value: 'KB*',
        email: 'mailto:kb@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/kunstbibliothek/home/',
        level: 0,
    },
    {
        name: 'Kunstgewerbemuseum',
        isActive: true,
        value: 'KGM*',
        email: 'mailto:kgm@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/kunstgewerbemuseum/home/',
        level: 0,
    },
    {
        name: 'Kupferstichkabinett',
        isActive: true,
        value: 'KK*',
        email: 'mailto:kk@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/kupferstichkabinett/home/',
        level: 0,
    },
    {
        name: 'Münzkabinett',
        isActive: true,
        value: 'MK*',
        email: 'mailto:mk@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/muenzkabinett/home/',
        level: 0,
    },
    {
        name: 'Museum Europäischer Kulturen',
        isActive: true,
        value: 'MEK*',
        email: 'mailto:mek@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/museum-europaeischer-kulturen/home/',
        level: 0,
    },
    {
        name: 'Museum für Asiatische Kunst',
        isActive: true,
        value: 'AKu*',
        email: 'mailto:aku@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/museum-fuer-asiatische-kunst/home/',
        level: 0,
    },
    {
        name: 'Museum für Islamische Kunst',
        isActive: true,
        value: 'ISL*',
        email: 'mailto:isl@smb.spk-berlin.de ',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/museum-fuer-islamische-kunst/home/',
        level: 0,
    },
    {
        name: 'Museum für Vor- und Frühgeschichte',
        isActive: true,
        value: 'MVF*',
        email: 'mailto:mvf@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/museum-fuer-vor-und-fruehgeschichte/home/',
        level: 0,
    },
    {
        name: 'Nationalgalerie',
        isActive: true,
        value: 'NG*',
        email: '',
        emailMap: [
            {
                value: 'NGAlteNationalgalerie',
                email: 'mailto:ang@smb.spk-berlin.de',
            },
            {
                value: 'NGHamburgerBahnhofMuseumfurGegenwart',
                email: 'mailto:hbf@smb.spk-berlin.de',
            },
            {
                value: 'NGMuseumBerggruen',
                email: 'mailto:museum-berggruen@smb.spk-berlin.de',
            },
            {
                value: 'NGNeueNationalgalerie',
                email: 'mailto:nng@smb.spk-berlin.de',
            },
            {
                value: 'NGSammlungScharfGerstenberg',
                email: 'mailto:ssg@smb.spk-berlin.de',
            },
        ],
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/nationalgalerie/home/',
        level: 0,
    },
    {
        name: 'Skulpturensammlung und Museum für Byzantinische Kunst',
        isActive: true,
        value: 'MSB* OR SBM* OR SKS*',
        email: 'mailto:sbm@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/skulpturensammlung/home/',
        level: 0,
    },
    {
        name: 'Vorderasiatisches Museum',
        isActive: true,
        value: 'VAM*',
        email: 'mailto:vam-fotoanfragen@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/vorderasiatisches-museum/home/',
        level: 0,
    },
    {
        name: 'Gipsformerei',
        isActive: false,
        value: 'GF*',
        email: '',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/gipsformerei/home/',
        level: 1,
    },
    {
        name: 'Institut für Museumsforschung',
        isActive: true,
        value: 'IFM*',
        email: 'mailto:ifm@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/institut-fuer-museumsforschung/home/',
        level: 1,
    },
    {
        name: 'Rathgen Forschungslabor',
        isActive: false,
        value: 'RaO*',
        email: '',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/rathgen-forschungslabor/home/',
        level: 1,
    },
    {
        name: 'Zentralarchiv',
        isActive: true,
        value: 'ZA*',
        email: 'mailto:za@smb.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.smb.museum/museen-einrichtungen/zentralarchiv/home/',
        level: 1,
    },
    {
        name: 'SIM | Musikinstrumenten-Museum',
        isActive: true,
        value: 'MIM*',
        email: 'mailto:kontakt@sim.spk-berlin.de',
        anfrage: 'mailto:kontakt@bpk-images.de',
        url: 'https://www.simpk.de/museum',
        level: 2,
    },
];
var OrgSublevels = [
    { level: 0, title: 'search.sublevel.title.staatlichenSammlung' },
    { level: 1, title: 'search.sublevel.title.staatlichenInstitute' },
    { level: 2, title: 'search.sublevel.title.musikforschung' },
];
var getOrgUnitURL = function (key, linkAttr) {
    var _a;
    var orgUnit = ORG_UNIT_LIST.find(function (org) {
        return org.value.split('OR').some(function (val) {
            var cleanKey = val.indexOf('*') > -1 ? val.trim().substring(0, val.indexOf('*')) : val.trim();
            return key.startsWith(cleanKey);
        });
    });
    if (orgUnit) {
        if ('email' === linkAttr && orgUnit.emailMap) {
            return (_a = orgUnit.emailMap.find(function (it) { return it.value === key; })) === null || _a === void 0 ? void 0 : _a.email;
        }
        return orgUnit[linkAttr];
    }
};
var getOrgUnitsGrouped = function () {
    var orgObject = OrgSublevels.map(function (group) {
        return {
            title: group.title,
            links: ORG_UNIT_LIST.filter(function (org) { return org.level === group.level; }),
        };
    });
    return orgObject;
};

var css$e = ".intro-section {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding-top: 3rem;\n  color: inherit;\n}\n.intro-section__title {\n  color: #0f0900 !important;\n}\n.intro-section__video {\n  margin-top: 0.75rem !important;\n}\n.intro-section__text {\n  width: 100%;\n  margin-top: 0.75rem !important;\n  font-weight: 500 !important;\n  color: #22201e !important;\n}\n@media (min-width: 800px) {\n  .intro-section__text {\n    max-width: 70%;\n  }\n}\n.intro-section__loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n.intro-section__divider {\n  position: \"relative\";\n  height: 0.25rem;\n  background: #0f0900;\n  margin-bottom: 1.75rem;\n}\n.intro-section__links-wrapper {\n  padding-top: 2rem;\n}\n.intro-section__links-wrapper h5 {\n  font-weight: bold;\n  color: #0f0900 !important;\n}\n.intro-section__links-wrapper:first-of-type {\n  padding-top: 2.5rem;\n}\n.intro-section__links-container {\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: 1rem;\n}\n.intro-section__link {\n  margin: 0;\n  padding: 0.4375rem 1rem 0.3125rem;\n  border: 1px solid #0f0900;\n  font-size: 1rem !important;\n  line-height: 1.375rem !important;\n  margin-right: 0.75rem !important;\n  letter-spacing: 1.28px !important;\n  margin-bottom: 0.75rem !important;\n  background: initial !important;\n}\n.intro-section__link:hover {\n  text-decoration: none !important;\n  opacity: 1;\n  outline: solid 1px;\n}\n.intro-section__link--inactive {\n  border: solid transparent;\n  background: #d3d3d3 !important;\n  opacity: 1;\n  color: #666666 !important;\n}\n.intro-section__link--inactive:hover {\n  text-decoration: none !important;\n  opacity: 1 !important;\n  outline: solid 1px transparent;\n}";
n(css$e,{});

function SearchButtons(_a) {
    var data = _a.data;
    var _b = useState([]), collectionLinks = _b[0], setCollectionLinks = _b[1];
    var lang = LanguageService.getCurrentStrapiLanguage();
    useEffect(function () {
        var groupings = getOrgUnitsGrouped();
        setCollectionLinks(groupings);
    }, []);
    var config = useConfigLoader().config;
    function createMarkup(richText) {
        return { __html: richText };
    }
    var getTextClassVariant = function () {
        return lang === 'de-LS' ? 'text-card__rich-text__leichte-sprache' : '';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'intro-section' },
            React.createElement("div", { className: 'intro-section__divider' }),
            React.createElement(Typography$1, { variant: "h3", component: 'h4', className: 'intro-section__title' }, data.title),
            !data.assets.length && (data === null || data === void 0 ? void 0 : data.text) && (React.createElement(Typography$1, { variant: 'body2', component: 'div', className: "intro-section__text " + getTextClassVariant(), dangerouslySetInnerHTML: createMarkup(data === null || data === void 0 ? void 0 : data.text) })),
            data.assets.length > 0 && (React.createElement("div", { className: "video-card__video-conatiner intro-section__video" }, data.assets.map(function (asset, index) {
                return (React.createElement(ReactPlayer$1, { key: "video-search-buttons-block-" + index, className: 'video-card__player', url: asset.url, controls: true }));
            }))),
            collectionLinks.length > 0 &&
                collectionLinks.map(function (level, levelIdx) {
                    return (data.searchButtonGroupHeadline[levelIdx].title && (React.createElement("div", { key: "level-" + levelIdx, className: 'intro-section__links-wrapper' },
                        React.createElement(Typography$1, { variant: 'h6', component: 'h5' }, "" + data.searchButtonGroupHeadline[levelIdx].title),
                        React.createElement("div", { className: 'intro-section__links-container' }, (level === null || level === void 0 ? void 0 : level.links.length) &&
                            level.links.map(function (link, collectionIdx) { return (React.createElement(React.Fragment, { key: "sammlung_link_" + collectionIdx + "_" + link.value.replace(/(\s|\*)/g, "") }, link.isActive ? (React.createElement(Link$1, { href: config.RESEARCH_DOMAIN + "/?collectionKey=" + link.value, "aria-label": "Suchen in " + link.name.substring(link.name.indexOf('|') + 1), variant: "body2", rel: "noopener noreferrer", className: "intro-section__link" }, link.name)) : (React.createElement("span", { className: "intro-section__link intro-section__link--inactive" }, link.name)))); })))));
                }))));
}

var css$f = ".guide-section {\n  color: inherit;\n  padding-top: 3rem;\n}";
n(css$f,{});

/* eslint-disable react/jsx-key */
function GuideSection() {
    var _a, _b;
    var config = useConfigLoader().config;
    var navigator = new LinkBuilder();
    var t = useTranslation().t;
    var imageUrlBuilder = new ImageUrlBuilder(config);
    var guideService = new GuideService(imageUrlBuilder);
    var _c = guideService.getGuides((_a = config === null || config === void 0 ? void 0 : config.CAROUSEL_CONFIG) === null || _a === void 0 ? void 0 : _a.COLLECTION_CARD_IMAGE_SIZE, (_b = config === null || config === void 0 ? void 0 : config.CAROUSEL_CONFIG) === null || _b === void 0 ? void 0 : _b.TOUR_CAROUSEL_IMAGE_SIZE), loading = _c.loading, contextData = _c.contextData;
    var cardCollection = function (contextData, navigator) {
        return contextData.map(function (tour) {
            return {
                section: 'guide',
                title: tour.title,
                subtitle: tour.subtitle,
                image: tour.previewImageCard,
                actionText: t('collections.buttons.guide'),
                href: navigator.getGuideHref(tour.id, tour.title),
                id: tour.id,
            };
        });
    };
    var collections = cardCollection(contextData, navigator);
    return (React.createElement(React.Fragment, null, !loading && collections.length > 0 && (React.createElement("div", { className: 'guide-section' },
        React.createElement(CarouselHeadline, { href: config.GUIDE_DOMAIN }, t('routes in the collection')),
        React.createElement(SwiperCarousel, { data: collections, type: "pair", sliderComponent: CollectionCard, section: "guide-pair" })))));
}

var css$g = ".pagination {\n  display: flex;\n  padding: 0 0 1.5rem;\n  border-bottom: 4px solid #0f0900;\n  margin-top: 1.5rem;\n  align-items: center;\n  flex-direction: column;\n}\n@media (min-width: 375px) {\n  .pagination {\n    flex-direction: row;\n    max-height: 4rem;\n    align-items: unset;\n  }\n}\n.pagination__content {\n  display: flex;\n  align-items: center;\n}\n.pagination__content button {\n  padding: 0 !important;\n}\n.pagination__count__current {\n  padding: 0 1.5rem;\n}\n@media (min-width: 375px) {\n  .pagination__count__current {\n    padding: 0.5rem;\n  }\n}\n@media (min-width: 400px) {\n  .pagination__count__current {\n    padding: 0 1.5rem;\n  }\n}\n.pagination__count__total {\n  display: flex;\n  align-items: center;\n  margin-top: 1rem !important;\n}\n@media (min-width: 375px) {\n  .pagination__count__total {\n    margin-top: 0 !important;\n    margin-left: 0.75rem !important;\n  }\n}\n@media (min-width: 400px) {\n  .pagination__count__total {\n    margin-left: 1.75rem !important;\n  }\n}";
n(css$g,{});

var Pagination$2 = function (props) {
    var onOffsetChange = props.onOffsetChange, offset = props.offset, limit = props.limit, total = props.total, section = props.section;
    var translate = useTranslation().t;
    var handleNext = function () {
        var newOffset = offset + limit < total ? offset + limit : total - limit;
        onOffsetChange && onOffsetChange(newOffset);
    };
    var handlePrevious = function () {
        var newOffset = offset - limit > 0 ? offset - limit : 0;
        onOffsetChange && onOffsetChange(newOffset);
    };
    var start = offset + 1;
    var end = offset + limit > total ? total : offset + limit;
    return (React.createElement("div", { className: 'pagination' },
        React.createElement("div", { className: 'pagination__content' },
            React.createElement(IconButton, { "aria-label": translate('show previous search results'), color: "inherit", disabled: start === 1, onClick: handlePrevious },
                React.createElement(ArrowBackIosOutlinedIcon, { fontSize: 'large', viewBox: "6 0 24 24" })),
            React.createElement(Typography$1, { component: "div", variant: "h5", className: 'pagination__count__current' },
                start,
                " - ",
                end),
            React.createElement(IconButton, { "aria-label": translate('show next search results'), color: "inherit", disabled: end === total, onClick: handleNext, "data-testid": "next-icon-button" },
                React.createElement(ArrowForwardIosOutlinedIcon, { fontSize: 'large', viewBox: "-6 0 24 24" }))),
        React.createElement(Typography$1, { component: "div", variant: "h5", className: 'pagination__count__total' },
            translate('pagination.from'),
            " ",
            total,
            " ",
            translate("" + section))));
};

var css$h = ".collections-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n.collections-pagination .collectionCard {\n  width: 100%;\n  height: auto;\n  margin-bottom: 1rem;\n}\n@media (min-width: 500px) {\n  .collections-pagination .collectionCard {\n    max-width: calc(50% - 0.5rem);\n  }\n  .collections-pagination .collectionCard:nth-child(odd) {\n    margin-right: 1rem;\n  }\n}";
n(css$h,{});

/* eslint-disable no-console */
function CollectionsPagination(_a) {
    var data = _a.data;
    return (React.createElement(React.Fragment, null, data.length > 0 && (React.createElement("div", { id: 'CollectionsModule', className: 'collections-pagination', "data-testid": 'collection-discover-module-wrapper' }, data.map(function (collectionData, index) { return (React.createElement(CollectionCard, { key: index + "_" + collectionData.id, "data-testid": 'collection-discover-module-cards-wrapper', title: collectionData.title, subtitle: collectionData.subtitle, image: collectionData.image, section: collectionData.section, actionText: collectionData.actionText, href: collectionData.href, target: collectionData.target })); })))));
}

var FetchAllStories = function (platform, hideInOverviewTopicStories) {
    var config = ConfigLoader.CurrentConfig;
    var lang = LanguageService.getCurrentLanguage();
    var fragmentStoriesFields = "stories(locale: \"" + lang + "\", publicationState: LIVE) {\n  data {\n    attributes {\n      title\n      slug\n      displayInHero\n      publishedAt\n      config {\n        author\n        id\n        teaser_text\n        year\n        teaser_image {\n          data {\n            attributes {\n              url\n            }\n          }\n        }\n      }\n    }\n  }\n  }";
    var fragmentSttPlatformsFields;
    if (hideInOverviewTopicStories) {
        fragmentSttPlatformsFields = "smb_stt_platform_config(where: { hide_in_overview: { _eq: false }  }) {\n      platform_key\n      hide_in_overview\n      link_template\n      hero_slider_limit\n    }";
    }
    else {
        fragmentSttPlatformsFields = "smb_stt_platform_config(where: { enable_story_filter: { _eq: true }  }) {\n      platform_key\n      hide_in_overview\n      link_template\n      hero_slider_limit\n    }";
    }
    if (platform === 'all') {
        var query_1 = '';
        for (var key in config.STRAPI_SCHEMA_CONFIG) {
            if (config.STRAPI_SCHEMA_CONFIG[key] !== 'all') {
                query_1 += config.STRAPI_SCHEMA_CONFIG[key] + " {\n          " + fragmentStoriesFields + "\n        }";
            }
        }
        return gql(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["query fetchStories {\n      ", "\n      ", "\n    }"], ["query fetchStories {\n      ", "\n      ", "\n    }"])), query_1, fragmentSttPlatformsFields);
    }
    var query = platform + " {\n    " + fragmentStoriesFields + "\n  }";
    return gql(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["query fetchStories {\n    ", "\n    ", "\n  }"], ["query fetchStories {\n    ", "\n    ", "\n  }"])), query, fragmentSttPlatformsFields);
};
var StoriesRepository = /** @class */ (function () {
    function StoriesRepository() {
    }
    StoriesRepository.prototype.fetchAllStories = function (platform, hideInOverviewTopicStories) {
        var config = ConfigLoader.CurrentConfig;
        var QueryString = FetchAllStories(platform, hideInOverviewTopicStories);
        var _a = useQuery(QueryString), loading = _a.loading, error = _a.error, data = _a.data;
        var resultData = {
            activeFilters: [],
        };
        if (!loading && data && data.smb_stt_platform_config) {
            data.smb_stt_platform_config.forEach(function (platform) {
                var _a, _b, _c, _d;
                var platfrom = platform.platform_key.toLocaleLowerCase();
                var configStrapiPlatform = config.STRAPI_SCHEMA_CONFIG[platfrom];
                resultData.activeFilters = data.smb_stt_platform_config;
                if (!loading &&
                    data &&
                    data[configStrapiPlatform] && ((_b = (_a = data[configStrapiPlatform]) === null || _a === void 0 ? void 0 : _a.stories) === null || _b === void 0 ? void 0 : _b.data.length)) {
                    resultData[platfrom] = (_d = (_c = data[configStrapiPlatform]) === null || _c === void 0 ? void 0 : _c.stories) === null || _d === void 0 ? void 0 : _d.data;
                }
            });
        }
        return { loading: loading, error: error, data: resultData };
    };
    return StoriesRepository;
}());
var templateObject_1$1, templateObject_2$1;

/* eslint no-console: ["error", { allow: ["log"] }] */
var TopicStoriesService = /** @class */ (function () {
    function TopicStoriesService() {
        this.config = ConfigLoader.CurrentConfig;
    }
    TopicStoriesService.prototype.getStoriesData = function (platform, hideInOverviewTopicStories) {
        var _a = this.storiesApiCall(platform, hideInOverviewTopicStories), loading = _a.loading, error = _a.error, data = _a.data;
        var convertedData = {};
        if (!loading && data && !error) {
            convertedData = this.convertStoriesData(data);
        }
        return { loading: loading, error: error, data: convertedData };
    };
    TopicStoriesService.prototype.storiesApiCall = function (platform, hideInOverviewTopicStories) {
        var storiesRepository = new StoriesRepository();
        //Temp fix, untill strapi is on staging, else fetchPlatform = platform
        var fetchPlatform = platform;
        return storiesRepository.fetchAllStories(this.config.STRAPI_SCHEMA_CONFIG[fetchPlatform], hideInOverviewTopicStories);
    };
    TopicStoriesService.prototype.convertStoriesData = function (data) {
        var lang = LanguageService.getCurrentLanguage();
        var getFilters = function () {
            var filters = data.activeFilters.map(function (item) {
                var platform = item.platform_key.toLocaleLowerCase();
                return {
                    title: "stt.filter." + platform,
                    value: platform,
                    id: platform,
                };
            });
            filters.unshift({
                title: "stt.filter.all",
                value: 'all',
                id: 'all',
            });
            return filters;
        };
        var heroConvertedData = [];
        var convertedData = [];
        var filters = {
            label: 'stt.filter.label',
            iconPosition: 'start',
            options: getFilters(),
        };
        var _loop_1 = function (platform) {
            if (platform !== 'activeFilters') {
                var activeFilterData_1 = data.activeFilters.filter(function (item) { return item.platform_key.toLocaleLowerCase() === platform; })[0];
                var PLATFORM_CONFIG_FRONTEND_1 = activeFilterData_1.link_template;
                var PLATFORM_CONFIG_BACKEND_1 = this_1.config.STRAPI_CONFIG.backend[activeFilterData_1.platform_key.toLocaleLowerCase()];
                data[platform].map(function (story, index) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    var imageUrl = "" + PLATFORM_CONFIG_BACKEND_1 + ((_e = (_d = (_c = (_b = (_a = story === null || story === void 0 ? void 0 : story.attributes) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.teaser_image) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.url);
                    var convertedStory = {
                        title: (_f = story === null || story === void 0 ? void 0 : story.attributes) === null || _f === void 0 ? void 0 : _f.title,
                        text: (_h = (_g = story === null || story === void 0 ? void 0 : story.attributes) === null || _g === void 0 ? void 0 : _g.config) === null || _h === void 0 ? void 0 : _h.teaser_text,
                        subtitle: "stt.filter." + platform,
                        href: PLATFORM_CONFIG_FRONTEND_1.replace(':lang', lang).replace(':slug', (_j = story === null || story === void 0 ? void 0 : story.attributes) === null || _j === void 0 ? void 0 : _j.slug),
                        previewImage: imageUrl,
                        platform: platform,
                        publishedAt: story.attributes.publishedAt,
                        id: index,
                        target: '_blank',
                        cta: "stt.cta." + platform,
                    };
                    if (story.attributes.displayInHero &&
                        index < activeFilterData_1.hero_slider_limit) {
                        heroConvertedData.push(convertedStory);
                    }
                    convertedData.push(convertedStory);
                });
            }
        };
        var this_1 = this;
        for (var platform in data) {
            _loop_1(platform);
        }
        return {
            hero: heroConvertedData,
            cards: convertedData,
            filters: filters,
        };
    };
    return TopicStoriesService;
}());

var css$i = ".collections {\n  padding-top: 3rem;\n}";
n(css$i,{});

function getCollections(hideInOverviewTopicStories, slug, cardCta, platform) {
    var config = useConfigLoader().config;
    var t = useTranslation().t;
    var navigator = new LinkBuilder();
    var imageUrlBuilder = new ImageUrlBuilder(config);
    // const getCurrentLocale = () => {
    //   const defaultLang = 'de';
    //   const lang = LanguageService.getCurrentStrapiLanguage();
    //   let currentLocale = '';
    //   if (lang !== defaultLang) {
    //     currentLocale = `/${currentLocale}${lang}`;
    //   }
    //   return currentLocale;
    // };
    var getResearchCollections = function () {
        var assortmentsService = new AssortmentsService();
        var assortmentsContextData = assortmentsService.getAssortmentObjects().assortmentsContextData;
        var collections = {
            cards: [],
            filters: {},
            hero: [],
        };
        collections.cards = assortmentsContextData.map(function (assortment) {
            return {
                id: assortment.id,
                section: 'research',
                title: assortment.title,
                subtitle: assortment.subtitle,
                image: assortment.img,
                href: assortment.link,
                actionText: cardCta,
            };
        });
        return collections;
    };
    var getTopicsCollections = function (platformVal, hideInOverviewTopicStories) {
        var platform = platformVal || '';
        var topicStories = new TopicStoriesService();
        var _a = topicStories.getStoriesData(platform, hideInOverviewTopicStories), loading = _a.loading, contextData = _a.data;
        var collections = {
            cards: [],
            filters: {},
            hero: [],
        };
        if (!loading) {
            collections.filters = __assign({}, contextData.filters);
            if (contextData.cards && contextData.cards.length) {
                collections.cards = __spreadArrays(contextData.cards);
                collections.cards = collections.cards.map(function (story, index) {
                    return {
                        id: "story_" + index,
                        section: 'topics',
                        title: story.title,
                        subtitle: t(story.subtitle),
                        image: story.previewImage,
                        href: story.href,
                        actionText: cardCta || story.cta,
                        target: story.target,
                    };
                });
            }
            return collections;
        }
        return collections;
    };
    var getGuideCollections = function () {
        var _a, _b;
        var guideService = new GuideService(imageUrlBuilder);
        var contextData = guideService.getGuides((_a = config === null || config === void 0 ? void 0 : config.CAROUSEL_CONFIG) === null || _a === void 0 ? void 0 : _a.COLLECTION_CARD_IMAGE_SIZE, (_b = config === null || config === void 0 ? void 0 : config.CAROUSEL_CONFIG) === null || _b === void 0 ? void 0 : _b.TOUR_CAROUSEL_IMAGE_SIZE).contextData;
        var collections = {
            cards: [],
            filters: {},
            hero: [],
        };
        collections.cards = contextData.map(function (tour) {
            return {
                id: tour.id,
                section: 'guide',
                title: tour.title,
                subtitle: tour.subtitle,
                image: tour.previewImageCard,
                href: navigator.getGuideHref(tour.id, tour.title),
                actionText: cardCta,
            };
        });
        return collections;
    };
    switch (slug) {
        case 'RESEARCH':
            return getResearchCollections();
        case 'TOPIC':
            return getTopicsCollections(platform, hideInOverviewTopicStories);
        case 'GUIDE':
            return getGuideCollections();
        case 'INTRO':
        default:
            return [];
    }
}

var css$j = ".filters {\n  color: #0f0900;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  background: transparent;\n  margin-bottom: 2rem;\n  min-width: 300px;\n}\n.filters #standard-basic-label {\n  position: relative;\n  transform: scale(1);\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  width: 100%;\n  padding: 0 0.375rem;\n}\n.filters__dropdown {\n  position: relative;\n  width: 100%;\n}\n.filters__arrow--open {\n  transform: rotate(-180deg);\n  transition: transform 0.3s ease-in-out;\n}\n.filters__arrow--close {\n  transform: rotate(0deg);\n  transition: transform 0.3s ease-in-out;\n}\n.filters__input {\n  width: 100% !important;\n}\n.filters__input input {\n  font-family: ClanOTNarrow, Arial, sans-serif !important;\n  font-size: 1rem;\n  cursor: pointer !important;\n}\n.filters__input__inner {\n  cursor: pointer !important;\n  padding: 0.5rem 0;\n  color: #0f0900 !important;\n  margin-top: 0.25rem !important;\n  border-bottom: 2px solid;\n}\n.filters__list {\n  position: absolute;\n  background: #feffe4;\n  right: 0;\n  left: 0;\n  top: 100%;\n  max-width: 100%;\n  padding: 0;\n  color: inherit;\n  z-index: 7;\n}\n.filters__list li {\n  color: inherit;\n  list-style: none;\n  border-bottom: 1px solid #0f0900;\n}\n.filters__list li label {\n  font-family: ClanOTNarrow, Arial, sans-serif;\n  font-size: 1rem;\n  color: #0f0900 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  width: 100%;\n  padding: 0.5rem;\n  margin-bottom: 0;\n}\n.filters__list li label span {\n  color: #0f0900 !important;\n  padding: 0 !important;\n  margin-left: 0.25rem;\n}";
n(css$j,{});

/* eslint-disable no-console */
function Filters(_a) {
    var filters = _a.filters, onSelect = _a.onSelect, defaultValue = _a.defaultValue;
    var t = useTranslation().t;
    var _b = useState(defaultValue.value), selectedValue = _b[0], setSelectedValue = _b[1];
    var _c = useState(t(defaultValue.title)), selectedLabel = _c[0], setSelectedLabel = _c[1];
    var _d = React.useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var selectedFilter = function (e) {
        e.preventDefault();
        var filterLabel = e.target.ariaLabel;
        var filterValue = e.target.value;
        setSelectedLabel(filterLabel);
        setSelectedValue(filterValue);
        onSelect(filterValue);
        setIsOpen(!isOpen);
    };
    var toggleFilterState = function () {
        setIsOpen(!isOpen);
    };
    var getArrowState = function () {
        return isOpen
            ? 'filters__arrow filters__arrow--open'
            : 'filters__arrow filters__arrow--close';
    };
    var renderOptionItem = function (option) {
        return (React.createElement("li", { className: "filters__list-item", key: "filters-" + option.id },
            React.createElement("label", { htmlFor: option.id },
                t(option.title),
                React.createElement(Checkbox, { id: option.id, checked: selectedValue === option.value, value: option.value, size: "small", onChange: selectedFilter, inputProps: {
                        'aria-label': t(option.title),
                    } }))));
    };
    var renderOptions = function () {
        return (React.createElement("ul", { className: "filters__list" }, filters.options.map(function (option) {
            return renderOptionItem(option);
        })));
    };
    var getIconPosition = function () {
        if (filters.iconPosition === 'end' && window.innerWidth >= 678)
            return 'end';
        return 'start';
    };
    return (React.createElement("div", { className: "filters" },
        React.createElement("div", { className: "filters__dropdown" },
            React.createElement(TextField, { type: "text", className: "filters__input", id: "standard-basic", label: t(filters.label), defaultValue: selectedLabel, onClick: toggleFilterState, InputProps: {
                    disableUnderline: true,
                    readOnly: true,
                    className: 'filters__input__inner',
                    value: selectedLabel,
                    startAdornment: (React.createElement(InputAdornment, { position: getIconPosition(), className: "filters__icon" },
                        React.createElement(ExpandMoreIcon, { className: getArrowState(), fontSize: 'large' }))),
                } }),
            isOpen && filters.options.length > 0 && renderOptions())));
}

var css$k = ".dropdown-filters {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n}\n@media (min-width: 678px) {\n  .dropdown-filters {\n    flex-direction: row;\n  }\n  .dropdown-filters .filters + .filters {\n    align-items: flex-end;\n    min-width: 200px;\n  }\n  .dropdown-filters .filters + .filters #standard-basic-label {\n    text-align: right;\n  }\n  .dropdown-filters .filters + .filters .filters__input input {\n    text-align: right;\n  }\n  .dropdown-filters .filters + .filters .filters__icon {\n    order: 2;\n  }\n}";
n(css$k,{});

function DropdownFilters(_a) {
    var data = _a.data, onFilterSelect = _a.onFilterSelect, onSortingSelect = _a.onSortingSelect;
    var filters = data.filters, sorting = data.sorting;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "dropdown-filters", id: "filters-section" },
            React.createElement(Filters, { filters: filters, onSelect: function (val) { return onFilterSelect(val); }, defaultValue: filters.options[filters.default] }),
            React.createElement(Filters, { filters: sorting, onSelect: function (val) { return onSortingSelect(val); }, defaultValue: sorting.options[sorting.default] }))));
}

function Collections(_a) {
    var pagination = _a.pagination, hideInOverviewTopicStories = _a.hideInOverviewTopicStories, paginationData = _a.paginationData, data = _a.data;
    var _b = useState(0), offset = _b[0], setOffset = _b[1];
    var _c = useState('all'), storiesPlatform = _c[0], setStoriesPlatform = _c[1];
    var _d = useState('last'), sorting = _d[0], setSorting = _d[1];
    var t = useTranslation().t;
    var config = useConfigLoader().config;
    var collections = getCollections(hideInOverviewTopicStories, data === null || data === void 0 ? void 0 : data.slug, data === null || data === void 0 ? void 0 : data.cta, storiesPlatform);
    var paginationLimit = paginationData && (paginationData === null || paginationData === void 0 ? void 0 : paginationData.limit) ? paginationData === null || paginationData === void 0 ? void 0 : paginationData.limit : 8;
    var getTitleHref = function () {
        switch (data.slug) {
            case 'INTRO':
                return config.INTRO_DOMAIN;
            case 'RESEARCH':
                return config.RESEARCH_DOMAIN;
            case 'TOPIC':
                return config.TOPICS_DOMAIN;
            case 'GUIDE':
                return config.GUIDE_DOMAIN;
            default:
                return '';
        }
    };
    var getSectionSlug = function () {
        switch (data.slug) {
            case 'RESEARCH':
                return 'research-pair';
            case 'TOPIC':
                return 'topics-pair';
            case 'GUIDE':
                return 'guide-pair';
            case 'INTRO':
            default:
                return '';
        }
    };
    var onChange = function (value) {
        var _a;
        setOffset(value);
        var bodyRect = document.body.getBoundingClientRect();
        var elRect = (_a = document
            .querySelector('#filters-section')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (elRect && bodyRect) {
            window.scrollTo({
                top: elRect.top - bodyRect.top - 32,
                behavior: 'smooth',
            });
        }
    };
    var getPaginatedCollections = function (sorting) {
        var paginatedCollections = collections.cards
            ? __spreadArrays(collections.cards) : [];
        switch (sorting) {
            case 'last':
                paginatedCollections.sort(function (a, b) {
                    if (a.publishedAt > b.publishedAt) {
                        return -1;
                    }
                    if (a.publishedAt < b.publishedAt) {
                        return 1;
                    }
                    return -1;
                });
                break;
            case 'desc':
                paginatedCollections.sort(function (a, b) {
                    if (a.title > b.title) {
                        return -1;
                    }
                    if (a.title < b.title) {
                        return 1;
                    }
                    return -1;
                });
                break;
            case 'asc':
                paginatedCollections.sort(function (a, b) {
                    if (a.title > b.title) {
                        return 1;
                    }
                    if (a.title < b.title) {
                        return -1;
                    }
                    return 1;
                });
                break;
        }
        return paginatedCollections.slice(offset, offset + paginationLimit);
    };
    var getFilters = function () {
        var SORTING_FILTERS = {
            label: t('stt.sorting.label'),
            iconPosition: 'end',
            options: [
                {
                    title: t('stt.sorting.latest'),
                    value: 'last',
                    id: 'last',
                },
                {
                    title: t('stt.sorting.asc'),
                    value: 'asc',
                    id: 'asc',
                },
                {
                    title: t('stt.sorting.desc'),
                    value: 'desc',
                    id: 'desc',
                },
            ],
        };
        if (collections && (collections === null || collections === void 0 ? void 0 : collections.filters)) {
            return {
                filters: __assign(__assign({}, collections === null || collections === void 0 ? void 0 : collections.filters), { default: 0 }),
                sorting: __assign(__assign({}, SORTING_FILTERS), { default: 0 }),
            };
        }
    };
    var onFilterSelect = function (val) {
        setStoriesPlatform(val);
    };
    var onSortingSelect = function (val) {
        setSorting(val);
    };
    var renderSection = function (pagination) {
        var _a;
        if (pagination) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "collections" },
                    React.createElement(CarouselHeadline, { assets: data.assets, href: getTitleHref(), text: data.text, link: false }, data.title),
                    Object.keys(collections === null || collections === void 0 ? void 0 : collections.filters).length > 0 &&
                        ((_a = collections === null || collections === void 0 ? void 0 : collections.filters) === null || _a === void 0 ? void 0 : _a.options.length) > 1 && (React.createElement(React.Fragment, null,
                        React.createElement(DropdownFilters, { data: getFilters(), onFilterSelect: onFilterSelect, onSortingSelect: onSortingSelect }),
                        sorting && collections.cards.length > 0 && (React.createElement(CollectionsPagination, { data: getPaginatedCollections(sorting) })),
                        React.createElement(Pagination$2, { limit: paginationLimit, total: collections.cards.length, offset: offset, section: 'pagination.section', onOffsetChange: function (offset) {
                                onChange(offset);
                            } }))))));
        }
        return (React.createElement(React.Fragment, null, collections.cards && collections.cards.length > 0 && (React.createElement("div", { className: "collections" },
            React.createElement(CarouselHeadline, { assets: data.assets, href: getTitleHref(), text: data.text, link: false }, data.title),
            React.createElement(SwiperCarousel, { data: collections.cards, type: "pair", sliderComponent: CollectionCard, section: getSectionSlug() })))));
    };
    return React.createElement(React.Fragment, null, renderSection(pagination));
}

var css$l = ".section {\n  padding-top: 5rem;\n  padding-bottom: 5rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n@media (min-width: 500px) {\n  .section {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n@media (min-width: 678px) {\n  .section {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n@media (min-width: 1024px) {\n  .section {\n    padding-left: 3rem;\n    padding-right: 3rem;\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n}\n@media (min-width: 1280px) {\n  .section {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n}\n.section--secondary {\n  background: #ebf2ff;\n}\n.section--tertiary {\n  background: #feffe4;\n}\n.section--quaternary {\n  background: #fbe7e7;\n}\n.section--quinary {\n  background: #d8d8d8;\n}\n.section--default {\n  background: #ffffff;\n}\n.section--X {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n@media (min-width: 500px) {\n  .section--X {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n@media (min-width: 678px) {\n  .section--X {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n@media (min-width: 1024px) {\n  .section--X {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n}\n@media (min-width: 1280px) {\n  .section--X {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n}\n.section--top-0 {\n  padding-top: 0;\n}\n@media (min-width: 1024px) {\n  .section--top-0 {\n    padding-top: 0;\n  }\n}\n.section__content-container {\n  max-width: 1280px;\n  margin: 0 auto;\n}";
n(css$l,{});

/* eslint-disable no-console */
function SectionFactory(_a) {
    var textSectionData = _a.textSectionData, _b = _a.pagination, pagination = _b === void 0 ? false : _b, _c = _a.hideInOverviewTopicStories, hideInOverviewTopicStories = _c === void 0 ? false : _c, hasSvg = _a.hasSvg, isFooter = _a.isFooter;
    var getSectionTheme = function () {
        var theme = '';
        switch (textSectionData.moduleType) {
            case TextModuleType.RESEARCH:
                theme = 'section--secondary';
                break;
            case TextModuleType.TOPIC:
                theme = 'section--tertiary';
                break;
            case TextModuleType.GUIDE:
                theme = 'section--quaternary';
                break;
            case TextModuleType.TEXT:
                theme = 'section--quinary';
                break;
            case TextModuleType.INTRO:
                theme = hasSvg ? "section--top-0 section--default" : 'section--default';
                break;
            default:
                theme = 'section--default';
                break;
        }
        return theme;
    };
    var getPaddingSettings = function (hasSwiperBlock) {
        return !hasSwiperBlock;
    };
    var getTextSectionBlock = function (textBlockData, index) {
        return (React.createElement(TextSection, { key: "text-section-" + index, textSectionData: textBlockData, noPadding: getPaddingSettings(textSectionData.hasSwiperBlock), isFooter: isFooter, target: pagination ? '' : '_blank' }));
    };
    var getSearchButtonsSectionBlock = function (searchBlockData, index) {
        return (React.createElement(SearchButtons, { key: "search-buttons-section-" + index, data: searchBlockData }));
    };
    var getHighlightsBlock = function (highlightsBlockData, index) {
        return (React.createElement(Highlights, { key: "highlights-section-" + index, data: highlightsBlockData }));
    };
    var getCollectionsBlock = function (collectionsBlockData, index) {
        return (React.createElement(Collections, { key: "collections-section-" + index, data: collectionsBlockData, pagination: pagination, hideInOverviewTopicStories: hideInOverviewTopicStories }));
    };
    var getVideoSectionBlock = function (videoBlockData, index) {
        return (React.createElement(VideoSection, { key: "video-section-" + index, data: videoBlockData, noPadding: getPaddingSettings(textSectionData.hasSwiperBlock), target: pagination ? '' : '_blank' }));
    };
    return (React.createElement(MuiThemeProvider, { theme: CommonTheme },
        React.createElement("section", { className: "section " + getSectionTheme() },
            React.createElement("div", { className: "section__content-container" }, (textSectionData === null || textSectionData === void 0 ? void 0 : textSectionData.sections) && (textSectionData === null || textSectionData === void 0 ? void 0 : textSectionData.sections.map(function (blockData, index) {
                switch (blockData.type) {
                    case 'VideoBlock':
                        return getVideoSectionBlock(blockData, index);
                    case 'TextBlock':
                        return getTextSectionBlock(blockData, index);
                    case 'SearchButtonBlock':
                        return getSearchButtonsSectionBlock(blockData, index);
                    case 'HighlightsBlock':
                        return getHighlightsBlock(blockData, index);
                    case 'CollectionsBlock':
                        return getCollectionsBlock(blockData, index);
                    default:
                        return (React.createElement(React.Fragment, { key: "text-section-" + index }));
                }
            }))))));
}

/* eslint-disable no-console */
function Sections(_a) {
    var sections = _a.sections, allowedSectionTypes = _a.allowedSectionTypes, pagination = _a.pagination, _b = _a.hideInOverviewTopicStories, hideInOverviewTopicStories = _b === void 0 ? false : _b, _c = _a.id, id = _c === void 0 ? 'TextSectionBoxModule' : _c, hasSvg = _a.hasSvg, isFooter = _a.isFooter;
    return (React.createElement("div", { id: id, "data-testid": 'page-text-box-links-module-wrapper' }, sections
        .filter(function (value) {
        return (allowedSectionTypes == undefined ||
            allowedSectionTypes.indexOf(value.moduleType) >= 0);
    })
        .map(function (value, index) { return (React.createElement(SectionFactory, { key: index, textSectionData: value, pagination: pagination, hideInOverviewTopicStories: hideInOverviewTopicStories, hasSvg: hasSvg, isFooter: isFooter })); })));
}

var useStyles$x = makeStyles(function (theme) {
    return createStyles({
        progress: {
            height: '4px',
        },
        bar: {
            transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.sharp,
                duration: '0.03s',
            }),
        },
    });
});

function Progressbar(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.maxValue, maxValue = _c === void 0 ? 1000 : _c, _d = _a.styleClasses, styleClasses = _d === void 0 ? '' : _d;
    var classes = useStyles$x();
    var progressValue = Math.min((100 * value) / maxValue);
    return (React.createElement(LinearProgress, { className: clsx(classes.progress, styleClasses), classes: { bar: classes.bar }, value: progressValue, variant: 'determinate' }));
}

var key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var webkit = [
    'webkitFullscreenEnabled',
    'webkitFullscreenElement',
    'webkitRequestFullscreen',
    'webkitExitFullscreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
    '-webkit-full-screen',
];
var moz = [
    'mozFullScreenEnabled',
    'mozFullScreenElement',
    'mozRequestFullScreen',
    'mozCancelFullScreen',
    'mozfullscreenchange',
    'mozfullscreenerror',
    '-moz-full-screen',
];
var ms = [
    'msFullscreenEnabled',
    'msFullscreenElement',
    'msRequestFullscreen',
    'msExitFullscreen',
    'MSFullscreenChange',
    'MSFullscreenError',
    '-ms-fullscreen',
];
// so it doesn't throw if no window or document
var document$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
var vendor = (('fullscreenEnabled' in document$1 && Object.keys(key)) ||
    (webkit[0] in document$1 && webkit) ||
    (moz[0] in document$1 && moz) ||
    (ms[0] in document$1 && ms) ||
    []);
var fscreen = {
    requestFullscreen: function (element) { return element[vendor[key.requestFullscreen]](); },
    requestFullscreenFunction: function (element) { return element[vendor[key.requestFullscreen]]; },
    get exitFullscreen() { return document$1[vendor[key.exitFullscreen]].bind(document$1); },
    get fullscreenPseudoClass() { return ":" + vendor[key.fullscreen]; },
    addEventListener: function (type, handler, options) { return document$1.addEventListener(vendor[key[type]], handler, options); },
    removeEventListener: function (type, handler, options) { return document$1.removeEventListener(vendor[key[type]], handler, options); },
    get fullscreenEnabled() { return Boolean(document$1[vendor[key.fullscreenEnabled]]); },
    set fullscreenEnabled(val) { },
    get fullscreenElement() { return document$1[vendor[key.fullscreenElement]]; },
    set fullscreenElement(val) { },
    get onfullscreenchange() { return document$1[("on" + vendor[key.fullscreenchange]).toLowerCase()]; },
    set onfullscreenchange(handler) { return document$1[("on" + vendor[key.fullscreenchange]).toLowerCase()] = handler; },
    get onfullscreenerror() { return document$1[("on" + vendor[key.fullscreenerror]).toLowerCase()]; },
    set onfullscreenerror(handler) { return document$1[("on" + vendor[key.fullscreenerror]).toLowerCase()] = handler; },
};

var dist = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _fscreen2 = _interopRequireDefault(fscreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullScreen = function (_Component) {
  _inherits(FullScreen, _Component);

  function FullScreen(props) {
    _classCallCheck(this, FullScreen);

    var _this = _possibleConstructorReturn(this, (FullScreen.__proto__ || Object.getPrototypeOf(FullScreen)).call(this, props));

    _this.fullScreenElement = null;
    _this.detectFullScreen = _this.detectFullScreen.bind(_this);
    return _this;
  }

  _createClass(FullScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _fscreen2.default.addEventListener("fullscreenchange", this.detectFullScreen);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _fscreen2.default.removeEventListener("fullscreenchange", this.detectFullScreen);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleProps(this.props);
    }
  }, {
    key: "handleProps",
    value: function handleProps(props) {
      var enabled = _fscreen2.default.fullscreenElement === this.node;
      if (enabled && !props.enabled) {
        this.leaveFullScreen();
      } else if (!enabled && props.enabled) {
        this.enterFullScreen();
      }
    }
  }, {
    key: "detectFullScreen",
    value: function detectFullScreen() {
      if (_fscreen2.default.fullscreenElement === this.node) {
        this.fullScreenElement = _fscreen2.default.fullscreenElement;
        this.props.onChange(true);
      } else if (!_fscreen2.default.fullscreenElement && this.fullScreenElement) {
        this.fullScreenElement = null;
        this.props.onChange(false);
      }
    }
  }, {
    key: "enterFullScreen",
    value: function enterFullScreen() {
      if (_fscreen2.default.fullscreenEnabled) {
        _fscreen2.default.requestFullscreen(this.node);
      }
    }
  }, {
    key: "leaveFullScreen",
    value: function leaveFullScreen() {
      if (_fscreen2.default.fullscreenEnabled) {
        _fscreen2.default.exitFullscreen();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = ["fullscreen"];
      if (this.props.enabled) {
        className.push("fullscreen-enabled");
      }

      return _react2.default.createElement(
        "div",
        {
          className: className.join(" "),
          ref: function ref(node) {
            return _this2.node = node;
          },
          style: this.props.enabled ? { height: "100%", width: "100%" } : undefined
        },
        this.props.children
      );
    }
  }]);

  return FullScreen;
}(React.Component);

FullScreen.propTypes = {
  children: _propTypes2.default.node.isRequired,
  enabled: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func
};
FullScreen.defaultProps = {
  enabled: false,
  onChange: function onChange() {
    return void 0;
  }
};
exports.default = FullScreen;
});

var Fullscreen = unwrapExports(dist);

var useStyles$y = makeStyles(function (theme) {
    var _a;
    return createStyles({
        modal: {
            backgroundColor: theme.palette.primary.dark,
            backgroundImage: 'linear-gradient(0deg, rgba(102,102,102,0.2) 0%, rgba(0,0,0,1) 30%, rgba(0,0,0,1) 70%, rgba(102,102,102,0.2) 100%)',
        },
        childWrapper: {
            display: 'inherit',
            width: 'inherit',
            height: 'inherit',
            justifyContent: 'inherit',
            alignItems: 'inherit',
            flexDirection: 'inherit',
            backgroundColor: 'inherit',
        },
        backButton: {
            position: 'absolute',
            cursor: 'pointer',
            zIndex: 999,
        },
        imageZoomButton: {
            position: 'absolute',
            cursor: 'pointer',
            zIndex: 999,
            right: 0,
        },
        slider: {},
        sliderFullscreen: {
            minHeight: '100vh',
        },
        slide: {
            backgroundSize: 'contain',
            backgroundColor: theme.palette.primary.main,
        },
        slideFullscreen: {
            minHeight: '100vh',
        },
        titleWrapper: {
            position: 'relative',
        },
        titleElements: (_a = {
                position: 'absolute',
                bottom: 150,
                right: 15,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'flex-end'
            },
            _a[theme.breakpoints.up('md')] = {
                bottom: 250,
            },
            _a),
        title: {
            maxWidth: 350,
            marginBottom: 25,
            color: theme.palette.text.hint,
            textAlign: 'right',
            transition: theme.transitions.create(['opacity'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        titleToObject: {
            textTransform: 'uppercase',
        },
        titleHide: {
            opacity: '0',
        },
        progressbar: {
            width: '100vw',
        },
        mediaPlayerControlsWrapper: {
            width: '100vw',
            position: 'relative',
            bottom: '150px',
            transition: theme.transitions.create(['bottom'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        mediaPlayerControlsWrapperHide: {
            bottom: 4,
        },
    });
});

function generateImageUrls(collectionObjects, maxPreviewImageSize) {
    return collectionObjects.map(function (value) {
        return value.imageUrlBuilder
            .buildUrl(value.imageId, maxPreviewImageSize, maxPreviewImageSize)
            .toString();
    });
}
/**
 * media for images.
 * This Player uses a slider element to display a slideshow of images.
 * @param maxImageSize
 * @param maxPreviewImageSize
 * @param children
 * @param sliderClasses
 * @param slideClasses
 * @param hideTitleInterval
 * @param zoom
 * @constructor
 */
function MediaPlayer(_a) {
    var _b = _a.maxImageSize, maxImageSize = _b === void 0 ? 2500 : _b, _c = _a.maxPreviewImageSize, maxPreviewImageSize = _c === void 0 ? 160 : _c, children = _a.children, _d = _a.sliderClasses, sliderClasses = _d === void 0 ? '' : _d, _e = _a.slideClasses, slideClasses = _e === void 0 ? '' : _e, _f = _a.hideTitleInterval, hideTitleInterval = _f === void 0 ? 4000 : _f, _g = _a.zoom, zoom = _g === void 0 ? false : _g;
    var classes = useStyles$y();
    var _h = useState(0), progressbarValue = _h[0], setProgressbarValue = _h[1];
    var _j = useState([]), previewImages = _j[0], setPreviewImages = _j[1];
    var mediaPlayerContextData = useContext(MediaPlayerContext);
    var _k = useState(true), showTitle = _k[0], setShowTitle = _k[1];
    var autoHideRef = useRef();
    var _l = useState(false), zoomOpened = _l[0], setZoomOpened = _l[1];
    var _m = useState(''), currentImageUrl = _m[0], setCurrentImageUrl = _m[1];
    var t = useTranslation().t;
    useEffect(function () {
        if (hideTitleInterval && showTitle) {
            autoHideRef.current = function () {
                setShowTitle(false);
            };
        }
    }, [showTitle, hideTitleInterval]);
    useEffect(function () {
        if (!mediaPlayerContextData.showControls) {
            return;
        }
        setShowTitle(true);
    }, [mediaPlayerContextData.showControls]);
    useEffect(function () {
        setShowTitle(true);
    }, [mediaPlayerContextData.activeIndex]);
    useEffect(function () {
        if (!showTitle) {
            return;
        }
        var hideTitle = function () {
            autoHideRef.current && autoHideRef.current();
        };
        setTimeout(hideTitle, hideTitleInterval);
    }, [hideTitleInterval, showTitle]);
    useEffect(function () {
        setPreviewImages(generateImageUrls(mediaPlayerContextData.collectionObjects, maxPreviewImageSize));
    }, [maxPreviewImageSize, mediaPlayerContextData.collectionObjects]);
    useEffect(function () {
        var collectionObject = mediaPlayerContextData.collectionObjects[mediaPlayerContextData.activeIndex];
        if (!collectionObject) {
            return;
        }
        var imageUrl = collectionObject.imageUrlBuilder
            .buildUrl(collectionObject.imageId, maxImageSize, maxImageSize)
            .toString();
        setCurrentImageUrl(imageUrl);
    }, [
        mediaPlayerContextData.activeIndex,
        mediaPlayerContextData.collectionObjects,
        maxImageSize,
    ]);
    var onUpdateProgress = function (progressValue) {
        setProgressbarValue(progressValue);
    };
    var togglePlayer = function (event, fullscreen) {
        mediaPlayerContextData.toggleFullscreen &&
            mediaPlayerContextData.toggleFullscreen(fullscreen);
        mediaPlayerContextData.togglePlayerOpen &&
            mediaPlayerContextData.togglePlayerOpen(event);
        mediaPlayerContextData.togglePlayerPlaying &&
            mediaPlayerContextData.togglePlayerPlaying(event);
    };
    var toggleZoom = function (event) {
        setZoomOpened(!zoomOpened);
        if (mediaPlayerContextData.playing) {
            mediaPlayerContextData.togglePlayerPlaying &&
                mediaPlayerContextData.togglePlayerPlaying(event);
        }
    };
    // Preloading the first image, so image will be cached by the browser. This will only get called on
    // post-construct.
    useLazyLoadImage(generateImageUrls(mediaPlayerContextData.collectionObjects, maxImageSize)[0]);
    return (React.createElement(MediaPlayerContext.Consumer, null, function (mediaPlayerContext) {
        var _a, _b, _c;
        return (React.createElement("div", { className: classes.childWrapper },
            !mediaPlayerContext.open && children,
            !mediaPlayerContext.open && (React.createElement("div", null,
                React.createElement(Progressbar, { styleClasses: classes.progressbar, value: progressbarValue, maxValue: mediaPlayerContext.interval }),
                React.createElement(MediaPlayerControls, { "data-testid": 'media-player-button-wrapper', playing: false, onPlayPauseButtonClick: function (event) {
                        togglePlayer(event, false);
                    }, show: true, autoHide: false, images: previewImages }))),
            mediaPlayerContext.open && (React.createElement(Fullscreen, { enabled: mediaPlayerContext.fullscreen, onChange: function (isFullscreen) {
                    if (!isFullscreen && mediaPlayerContext.fullscreen) {
                        mediaPlayerContext.toggleFullscreen &&
                            mediaPlayerContext.toggleFullscreen();
                    }
                } },
                mediaPlayerContext.showControls && (React.createElement(IconButton, { "data-testid": 'media-player-back-button', className: classes.backButton, color: "inherit", onClick: function (event) {
                        togglePlayer(event, false);
                    } },
                    React.createElement(ArrowBackIosIcon, null))),
                zoom &&
                    !mediaPlayerContext.fullscreen &&
                    mediaPlayerContext.showControls && (React.createElement(IconButton, { className: classes.imageZoomButton, color: "inherit", onClick: function (event) { return toggleZoom(event); } },
                    React.createElement(ZoomInOutlinedIcon, null))),
                React.createElement(SliderModule, { interval: mediaPlayerContext.interval, playing: mediaPlayerContext.playing, arrows: false, dots: false, sliderClasses: clsx(classes.slider, sliderClasses, (_a = {},
                        _a[classes.sliderFullscreen] = mediaPlayerContext.fullscreen,
                        _a)), onProgressUpdate: onUpdateProgress, activeIndex: mediaPlayerContext.activeIndex, setActiveIndex: mediaPlayerContext.setActiveIndex, onSlide: mediaPlayerContext.setActiveIndex }, mediaPlayerContext.collectionObjects.map(function (collectionObject, index) {
                    var _a;
                    return (React.createElement(Slide, { key: index, image: collectionObject.imageUrlBuilder
                            .buildUrl(collectionObject.imageId, maxImageSize, maxImageSize)
                            .toString(), slideClasses: clsx(classes.slide, slideClasses, (_a = {},
                            _a[classes.slideFullscreen] = mediaPlayerContext.fullscreen,
                            _a)), onClick: function () {
                            return mediaPlayerContext.toggleControls &&
                                mediaPlayerContext.toggleControls();
                        }, onMouseMove: function () {
                            return mediaPlayerContext.toggleControls &&
                                mediaPlayerContext.toggleControls(true);
                        } }));
                })),
                mediaPlayerContext.collectionObjects.length > 0 && (React.createElement("div", { className: classes.titleWrapper },
                    React.createElement("div", { className: clsx(classes.titleElements, (_b = {},
                            _b[classes.titleHide] = !showTitle,
                            _b)) },
                        React.createElement(Typography, { component: "div", variant: 'h4', className: clsx(classes.title) }, mediaPlayerContext.collectionObjects[mediaPlayerContext.activeIndex].title),
                        React.createElement(ButtonBase$1, { onClick: function () {
                                mediaPlayerContext.onInfoClick(mediaPlayerContext.collectionObjects[mediaPlayerContext.activeIndex].objectId);
                            } },
                            React.createElement(Typography, { className: classes.titleToObject }, t('go to object details')),
                            React.createElement(ArrowRightAltOutlinedIcon, null))))),
                React.createElement("div", { className: clsx(classes.mediaPlayerControlsWrapper, (_c = {},
                        _c[classes.mediaPlayerControlsWrapperHide] = !mediaPlayerContext.showControls,
                        _c)) },
                    React.createElement(Progressbar, { styleClasses: classes.progressbar, value: progressbarValue, maxValue: mediaPlayerContext.interval }),
                    React.createElement(MediaPlayerControls, { playing: mediaPlayerContext.playing, onPlayPauseButtonClick: mediaPlayerContext.togglePlayerPlaying, show: mediaPlayerContext.showControls, hideControlsInterval: mediaPlayerContext.hideControlsInterval, toggleShowControls: mediaPlayerContext.toggleControls, images: previewImages, imageIndex: mediaPlayerContext.activeIndex, fullscreen: mediaPlayerContext.fullscreen, onImageClick: mediaPlayerContext.setActiveIndex, onFullscreenClick: function () {
                            return mediaPlayerContext.toggleFullscreen &&
                                mediaPlayerContext.toggleFullscreen();
                        } })),
                React.createElement(ImageZoomModal, { open: zoomOpened, src: currentImageUrl, onClose: function () { return setZoomOpened(!zoomOpened); } })))));
    }));
}

var MediaPlayerContext = createContext({
    collectionObjects: [],
    interval: 8000,
    open: false,
    playing: false,
    showControls: true,
    activeIndex: 0,
    fullscreen: false,
    hideControlsInterval: 4000,
    setActiveIndex: function () {
        throw Error('You have to override the setter!');
    },
    onInfoClick: function () {
        throw Error('You have to override the setter!');
    },
});

var useStyles$z = makeStyles(function (theme) {
    var _a, _b, _c;
    return createStyles({
        wrapper: {
            transition: theme.transitions.create(['height'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            backgroundColor: theme.palette.primary.main,
            height: '150px',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            color: theme.palette.primary.dark,
            '& *': {
                transition: theme.transitions.create(['opacity'], {
                    easing: theme.transitions.easing.easeInOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
        wrapperHide: {
            height: '0px',
            '& *': {
                opacity: '0',
            },
        },
        maximizeButton: {
            width: '25vw',
        },
        countingArea: (_a = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            _a[theme.breakpoints.down('sm')] = {
                width: '25vw',
                alignItems: 'flex-end',
            },
            _a[theme.breakpoints.up('md')] = {
                alignItems: 'center',
                position: 'absolute',
                margin: '15px',
                bottom: '150px',
                right: '0',
            },
            _a),
        hide: {
            display: 'none',
        },
        images: (_b = {
                display: 'flex',
                width: '25vw',
                maxWidth: '25vw',
                overflowY: 'hidden',
                overflowX: 'scroll',
                scrollBehavior: 'smooth'
            },
            _b[theme.breakpoints.down('sm')] = {
                maxWidth: '95vw',
                width: '95vw',
            },
            _b['&::-webkit-scrollbar'] = {
                width: 0,
                background: 'transparent',
            },
            _b),
        imagesSlider: {
            display: 'flex',
            transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            '&:before': (_c = {
                    pointerEvents: 'none',
                    content: 'no-open-quote',
                    position: 'absolute',
                    zIndex: 999,
                    width: '25vw',
                    height: '86px',
                    background: 'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 33%, rgba(0,0,0,0) 67%, rgba(0,0,0,1) 100%)'
                },
                _c[theme.breakpoints.down('sm')] = {
                    maxWidth: '95vw',
                    width: '95vw',
                },
                _c),
        },
        image: {
            transition: theme.transitions.create(['border-width'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            height: 86,
            width: 86,
            marginRight: '7px',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
        },
        activeImage: {
            border: 'solid 3px '.concat(theme.palette.text.hint),
        },
    });
});

function calcScrollX(scrollWidth, imageIndex, imageCount) {
    return (scrollWidth / imageCount) * imageIndex;
}
var MediaPlayerControlsPreviewImagesId = 'MediaPlayerControlsPreviewImages';
/**
 * MediaPlayerControls with Play-Pause-Button, Maximize-Button and Preview-Images.
 *
 * @param playing
 * @param onPlayPauseButtonClick
 * @param show
 * @param autoHide Hide controls after Controls were shown for the first time.
 * @param hideControlsInterval
 * @param toggleShowControls
 * @param images
 * @param imageIndex
 * @param fullscreen
 * @param onImageClick
 * @param onFullscreenClick
 * @constructor
 */
function MediaPlayerControls(_a) {
    var _b, _c, _d;
    var playing = _a.playing, onPlayPauseButtonClick = _a.onPlayPauseButtonClick, _e = _a.show, show = _e === void 0 ? true : _e, _f = _a.autoHide, autoHide = _f === void 0 ? true : _f, _g = _a.hideControlsInterval, hideControlsInterval = _g === void 0 ? 4000 : _g, toggleShowControls = _a.toggleShowControls, images = _a.images, imageIndex = _a.imageIndex, _h = _a.fullscreen, fullscreen = _h === void 0 ? false : _h, onImageClick = _a.onImageClick, onFullscreenClick = _a.onFullscreenClick;
    var classes = useStyles$z();
    var _j = useState(imageIndex), scrolledIndex = _j[0], setScrolledIndex = _j[1];
    var imageContainerRef = useState(createRef())[0];
    var _k = useState(0), autoHideProgress = _k[0], setAutoHideProgress = _k[1];
    var _l = useState(false), showOnMouseOver = _l[0], setShowOnMouseOver = _l[1];
    var autoHideRef = useRef();
    var autoHideUpdateInterval = 100;
    var updateAutoHide = function () {
        if (!autoHide || !toggleShowControls || showOnMouseOver) {
            return;
        }
        var newAutoHideProgress = autoHideProgress + autoHideUpdateInterval;
        if (autoHideProgress >= hideControlsInterval) {
            toggleShowControls(false);
            newAutoHideProgress = 0;
        }
        setAutoHideProgress(newAutoHideProgress);
    };
    useEffect(function () {
        if (autoHide && toggleShowControls) {
            autoHideRef.current = updateAutoHide;
        }
    });
    useEffect(function () {
        var hideControls = function () {
            autoHideRef.current && autoHideRef.current();
        };
        var autoHideInterval = setInterval(hideControls, autoHideUpdateInterval);
        return function () { return clearInterval(autoHideInterval); };
    }, [show]);
    // Wheel-Event has to be registered as active event, so we have to add the event the old way.
    useLayoutEffect(function () {
        if (!document) {
            return;
        }
        var element = document.getElementById(MediaPlayerControlsPreviewImagesId);
        if (!element) {
            return;
        }
        var scrollHorizontal = function (event) {
            if (!imageContainerRef.current) {
                return;
            }
            event.preventDefault();
            var leftScrollPosition = imageContainerRef.current.scrollLeft + event.deltaY;
            imageContainerRef.current.scrollTo({
                left: leftScrollPosition,
                top: 0,
            });
        };
        element.addEventListener('wheel', function (ev) { return scrollHorizontal(ev); });
    }, [imageContainerRef]);
    // if imageIndex and scrolledIndex are not equal, the slider is in different state and die preview should scroll.
    // Scrolling only make sense if window is present, which mean we are not rendering on server-side.
    if (images &&
        imageIndex !== undefined &&
        imageIndex !== scrolledIndex &&
        imageContainerRef.current &&
        imageContainerRef.current.scrollTo &&
        window !== undefined) {
        imageContainerRef.current.scrollTo({
            left: calcScrollX(imageContainerRef.current.scrollWidth, imageIndex - 1, images.length),
        });
        setScrolledIndex(imageIndex);
    }
    return (React.createElement("div", { "data-testid": 'media-player-button-wrapper', id: 'MediaPlayerControls', className: clsx(classes.wrapper, (_b = {}, _b[classes.wrapperHide] = !show, _b)), onMouseOver: function () { return setShowOnMouseOver(true); }, onMouseLeave: function () { return setShowOnMouseOver(false); }, onTouchStart: function () { return setShowOnMouseOver(true); }, onTouchEnd: function () { return setShowOnMouseOver(false); } },
        onFullscreenClick && (React.createElement("div", { className: classes.maximizeButton },
            React.createElement(IconButton, { color: 'inherit', onClick: onFullscreenClick },
                React.createElement(FullscreenOutlinedIcon, { className: clsx((_c = {}, _c[classes.hide] = fullscreen, _c)) }),
                React.createElement(FullscreenExitOutlinedIcon, { className: clsx((_d = {}, _d[classes.hide] = !fullscreen, _d)) })))),
        React.createElement(IconButton, { color: 'inherit', onClick: onPlayPauseButtonClick },
            playing && React.createElement(PauseIcon, null),
            !playing && React.createElement(PlayArrowIcon, null)),
        images && imageIndex !== undefined && (React.createElement("div", { className: classes.countingArea },
            React.createElement("div", null, imageIndex + 1 + " | " + images.length))),
        images && (React.createElement("div", { id: MediaPlayerControlsPreviewImagesId, ref: imageContainerRef, className: classes.images },
            React.createElement("div", { className: classes.imagesSlider }, images.map(function (value, index) {
                var _a;
                return (React.createElement(LazyLoadImage, { key: index, src: value },
                    React.createElement("div", { className: clsx(classes.image, (_a = {},
                            _a[classes.activeImage] = imageIndex === index,
                            _a)), key: index, style: {
                            backgroundImage: "url(" + value + ")",
                        }, onClick: function () { return onImageClick && onImageClick(index); } })));
            }))))));
}

var useStyles$A = makeStyles(function (theme) {
    return createStyles({
        modal: {
            backgroundColor: theme.palette.primary.dark,
            backgroundImage: 'linear-gradient(0deg, rgba(102,102,102,0.2) 0%, rgba(0,0,0,1) 30%, rgba(0,0,0,1) 70%, rgba(102,102,102,0.2) 100%)',
        },
        slider: {
            height: '100vh',
        },
        slide: {
            backgroundSize: 'contain',
        },
        progressbar: {
            width: '100vw',
        },
        mediaPlayerControlsWrapper: {
            width: '100vw',
            position: 'absolute',
            bottom: '0',
        },
    });
});

function MediaPlayerOverlay(_a) {
    var children = _a.children;
    var classes = useStyles$A();
    return (React.createElement(MediaPlayerContext.Consumer, null, function (mediaPlayerContext) { return (React.createElement(Modal, { className: classes.modal, open: mediaPlayerContext.open !== undefined
            ? mediaPlayerContext.open
            : true, onClose: mediaPlayerContext.togglePlayerPlaying },
        React.createElement("div", null, children))); }));
}

var useStyles$B = makeStyles(function (theme) {
    var _a;
    return createStyles({
        card: {
            margin: 'auto',
            minWidth: 250,
            height: 250,
            padding: 16,
            borderRadius: 0,
            backgroundColor: theme.palette.secondary.main,
            boxShadow: 'none',
            cursor: 'pointer',
            '&:hover': {
                '& h3': {
                    textDecoration: 'underline',
                },
                '& svg': {
                    fill: theme.palette.secondary.main,
                },
            },
        },
        cardContent: {},
        cardTitleArea: {
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
        },
        cardTitleWrapper: {
            display: 'flex',
            flexGrow: 2,
            justifyContent: 'space-between',
            alignItems: 'center',
            '& :focus-visible': {
                outline: '4px solid',
                boxShadow: 'none',
            },
        },
        cardTitleTypo: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                fontSize: '1.7rem',
            },
            _a['&:hover, & :hover'] = {
                textDecoration: 'undeline',
            },
            _a),
        cardSubtitleTypo: {
            paddingTop: 10,
        },
    });
});

function LinkTextCard(_a) {
    var title = _a.title, subtitle = _a.subtitle, 
    // tintColor,
    _b = _a.textColor, 
    // tintColor,
    textColor = _b === void 0 ? 'white' : _b, _c = _a.textAreaColor, textAreaColor = _c === void 0 ? 'black' : _c, onClick = _a.onClick, cardClasses = _a.cardClasses, titleTypoClasses = _a.titleTypoClasses, subtitleTypoClasses = _a.subtitleTypoClasses, ariaLabel = _a.ariaLabel;
    var classes = useStyles$B();
    return (React.createElement(Card$1, { style: { backgroundColor: textAreaColor }, className: clsx(classes.card, cardClasses), onClick: onClick },
        React.createElement(CardContent$1, { className: clsx(classes.cardContent), style: { backgroundColor: textAreaColor } },
            React.createElement(Grid, { container: true, direction: 'column', className: classes.cardTitleArea },
                React.createElement(Grid, { justifyContent: 'space-between', style: { width: '100%' }, className: classes.cardTitleWrapper },
                    React.createElement(Typography$1, { variant: 'h3', style: { color: textColor }, className: clsx(classes.cardTitleTypo, titleTypoClasses) }, title),
                    React.createElement(IconButton, { "aria-label": ariaLabel, style: { color: textColor } },
                        React.createElement(ArrowRightAltIcon, { fontSize: 'large', color: 'inherit' }))),
                React.createElement(Grid, null,
                    React.createElement(Typography$1, { variant: 'body1', style: { color: textColor, textOverflow: 'ellipsis' }, className: clsx(classes.cardSubtitleTypo, subtitleTypoClasses) }, subtitle))))));
}

var css$m = ".collection-card-wrapper {\n  width: 100%;\n  margin-bottom: 1rem !important;\n}\n@media (min-width: 600px) {\n  .collection-card-wrapper {\n    width: calc(50% - 0.5rem);\n  }\n  .collection-card-wrapper:nth-child(2n) {\n    margin-left: 1rem;\n  }\n}\n\n.collection-card-max-width {\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n}";
n(css$m,{});

/* eslint-disable react/jsx-key */
function CollectionsDiscoverModuleNew(_a) {
    var _b = _a.section, section = _b === void 0 ? '' : _b;
    var t = useTranslation().t;
    var link = new LinkBuilder();
    return (React.createElement(CollectionsContext.Consumer, null, function (collectionsContext) { return (React.createElement("div", { id: 'CollectionsModule', className: 'collection-card-max-width' },
        React.createElement(Grid, { container: true, direction: 'row', alignItems: 'center', "data-testid": 'collection-discover-module-wrapper' }, collectionsContext.collections.map(function (collectionContextData, index) { return (React.createElement(Grid, { item: true, key: index, className: 'collection-card-wrapper' },
            React.createElement(CollectionCard, { "data-testid": 'collection-discover-module-cards-wrapper', image: collectionContextData.previewImageCard, title: collectionContextData.title, subtitle: collectionContextData.subtitle, section: section, actionText: t('collections module discover button'), href: link.getTopicsHref(collectionContextData.id, collectionContextData.platform) }))); })))); }));
}

/* global setTimeout, clearTimeout */

var dist$1 = function debounce(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var lastCallAt = void 0;
  var deferred = void 0;
  var timer = void 0;
  var pendingArgs = [];
  return function debounced() {
    var currentWait = getWait(wait);
    var currentTime = new Date().getTime();

    var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;

    lastCallAt = currentTime;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isCold && options.leading) {
      return options.accumulate ? Promise.resolve(fn.call(this, [args])).then(function (result) {
        return result[0];
      }) : Promise.resolve(fn.call.apply(fn, [this].concat(args)));
    }

    if (deferred) {
      clearTimeout(timer);
    } else {
      deferred = defer();
    }

    pendingArgs.push(args);
    timer = setTimeout(flush.bind(this), currentWait);

    if (options.accumulate) {
      var argsIndex = pendingArgs.length - 1;
      return deferred.promise.then(function (results) {
        return results[argsIndex];
      });
    }

    return deferred.promise;
  };

  function flush() {
    var thisDeferred = deferred;
    clearTimeout(timer);

    Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);

    pendingArgs = [];
    deferred = null;
  }
};

function getWait(wait) {
  return typeof wait === 'function' ? wait() : wait;
}

function defer() {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}

function createImperativePromise(promiseArg) {
    var resolve = null;
    var reject = null;
    var wrappedPromise = new Promise(function (_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
    });
    promiseArg && promiseArg.then(function (val) {
        resolve && resolve(val);
    }, function (error) {
        reject && reject(error);
    });
    return {
        promise: wrappedPromise,
        resolve: function (value) {
            resolve && resolve(value);
        },
        reject: function (reason) {
            reject && reject(reason);
        },
        cancel: function () {
            resolve = null;
            reject = null;
        }
    };
}

// see https://stackoverflow.com/a/54825370/82609
function onlyResolvesLast(asyncFunction) {
    var cancelPrevious = null;
    var wrappedFunction = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        cancelPrevious && cancelPrevious();
        var initialPromise = asyncFunction.apply(void 0, args);
        var _a = createImperativePromise(initialPromise), promise = _a.promise, cancel = _a.cancel;
        cancelPrevious = cancel;
        return promise;
    };
    return wrappedFunction; // TODO fix TS
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

var DefaultOptions = {
    // One distinct debounced function is created per key and added to an internal cache
    // By default, the key is null, which means that all the calls
    // will share the same debounced function
    key: function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
        return null;
    },
    // By default, a debounced function will only resolve
    // the last promise it returned
    // Former calls will stay unresolved, so that you don't have
    // to handle concurrency issues in your code
    // Setting this to false means all returned promises will resolve to the last result
    onlyResolvesLast: true,
};
// We create a debouncing function cache, because when wrapping the original function,
// we may actually want to route the function call to different debounced functions depending function paameters
var DebounceCache = /** @class */ (function () {
    function DebounceCache(config) {
        this.config = config;
        this.debounceSingleton = null;
        this.debounceCache = {}; // when key feature is used
    }
    DebounceCache.prototype._createDebouncedFunction = function () {
        var debouncedFunc = dist$1(this.config.func, this.config.wait, this.config.options); // TODO TS
        if (this.config.options.onlyResolvesLast) {
            debouncedFunc = onlyResolvesLast(debouncedFunc);
        }
        return {
            func: debouncedFunc,
        };
    };
    DebounceCache.prototype.getDebouncedFunction = function (args) {
        var _a;
        var key = (_a = this.config.options).key.apply(_a, args);
        if (key === null || typeof key === 'undefined') {
            if (!this.debounceSingleton) {
                this.debounceSingleton = this._createDebouncedFunction();
            }
            return this.debounceSingleton;
        }
        else {
            if (!this.debounceCache[key]) {
                this.debounceCache[key] = this._createDebouncedFunction();
            }
            return this.debounceCache[key];
        }
    };
    return DebounceCache;
}());
function AwesomeDebouncePromise(func, wait, options) {
    var finalOptions = __assign$1({}, DefaultOptions, options);
    var debounceCache = new DebounceCache({
        func: func,
        wait: wait,
        options: finalOptions,
    });
    var AwesomeDebouncePromiseWrapper = (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var debouncedFn = debounceCache.getDebouncedFunction(args).func;
        return debouncedFn.apply(void 0, args);
    }); // TODO fix TS
    /*
    AwesomeDebouncePromiseWrapper.cancel = (key?: string) => {
  
    };
    */
    return AwesomeDebouncePromiseWrapper;
}

var useStyles$C = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return createStyles({
        contentWrapper: (_a = {
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'space-between'
            },
            _a[theme.breakpoints.up('sm')] = {
                alignItems: 'center',
            },
            _a),
        content: (_b = {
                display: 'block',
                justifyContent: 'space-evenly',
                alignItems: 'center',
                maxWidth: 1280,
                width: '100%',
                height: '100%'
            },
            _b[theme.breakpoints.up('sm')] = {
                position: 'relative',
                display: 'flex',
            },
            _b['&:after'] = {
                clear: 'both',
            },
            _b),
        backToTopicsButtonArea: (_c = {
                position: 'relative',
                top: 0,
                left: 0,
                color: 'white'
            },
            _c[theme.breakpoints.up('sm')] = {
                position: 'absolute',
            },
            _c),
        backToTopicsTypo: {
            textTransform: 'uppercase',
        },
        descriptionArea: (_d = {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                padding: 15,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '100%'
            },
            _d[theme.breakpoints.up('sm')] = {
                height: 'auto',
                background: 'none !important',
                maxWidth: 470,
            },
            _d[theme.breakpoints.down('sm') + " and (orientation: landscape)"] = {
                paddingTop: 48,
            },
            _d),
        title: {},
        imageContainer: (_e = {
                display: 'none',
                alignItems: 'center',
                justifyContent: 'center'
            },
            _e[theme.breakpoints.up('sm')] = {
                display: 'flex',
            },
            _e),
        image: (_f = {
                maxHeight: 'calc(80vh - 150px)',
                maxWidth: '45vw'
            },
            _f[theme.breakpoints.up('lg')] = {
                maxWidth: 750,
            },
            _f),
        playButton: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 35,
            width: 205,
            height: 58,
            margin: '25px 25px 25px 0px',
            cursor: 'pointer',
            backgroundColor: theme.palette.text.hint,
        },
        playButtonTypo: {
            color: theme.palette.text.secondary,
            textTransform: 'uppercase',
        },
    });
});

function CollectionPlayerModule(_a) {
    var _b;
    var interval = _a.interval, _c = _a.wrapperClasses, wrapperClasses = _c === void 0 ? '' : _c, _d = _a.previewWrapperClasses, previewWrapperClasses = _d === void 0 ? '' : _d, _e = _a.mediaPlayerClasses, mediaPlayerClasses = _e === void 0 ? '' : _e;
    var classes = useStyles$C();
    var _f = useState(false), playerOpen = _f[0], setPlayerOpen = _f[1];
    var _g = useState(false), playerPlaying = _g[0], setPlayerPlaying = _g[1];
    var _h = useState(true), showControls = _h[0], setShowControls = _h[1];
    var _j = useState(false), fullscreen = _j[0], setFullscreen = _j[1];
    var _k = useState(0), activeIndex = _k[0], setActiveIndex = _k[1];
    var collectionContext = useContext(CollectionContext$1);
    var t = useTranslation().t;
    var config = useConfigLoader().config;
    var history = useHistory();
    // activeCollectionIndex will be used to handle changes from outside, because normaly changes of selectedObjectIndex will
    // be handled by this component itself.
    var _l = useState(collectionContext.selectedObjectIndex), activeCollectionIndex = _l[0], setActiveCollectionIndex = _l[1];
    var debounceToggleControls = AwesomeDebouncePromise(setShowControls, 70, {
        key: function (show) { return show; },
    });
    var mediaPlayerContextData = {
        collectionObjects: collectionContext.collectionObjects,
        open: playerOpen,
        interval: interval,
        playing: playerPlaying,
        showControls: showControls,
        activeIndex: activeIndex,
        fullscreen: fullscreen,
        togglePlayerOpen: function () { return setPlayerOpen(!playerOpen); },
        togglePlayerPlaying: function () { return setPlayerPlaying(!playerPlaying); },
        toggleControls: function (show) {
            if (show === void 0) { show = !showControls; }
            return debounceToggleControls(show);
        },
        toggleFullscreen: function (enable) {
            if (enable === void 0) { enable = !fullscreen; }
            return setFullscreen(enable);
        },
        setActiveIndex: function (index) { return setActiveIndex(index); },
        onInfoClick: function (objectId) {
            var _a;
            var url = config.RESEARCH_DOMAIN + "/detail/" + objectId;
            (_a = window === null || window === void 0 ? void 0 : window.open(url, '_blank')) === null || _a === void 0 ? void 0 : _a.focus();
        },
    };
    // TODO: history usage should be removed from component and implemented in page
    var backToTopics = function () {
        history.push("/");
    };
    // if the selectedObjectIndex from collectionContext has changed, it is necessary to set the active index.
    useEffect(function () {
        if (activeCollectionIndex === collectionContext.selectedObjectIndex ||
            collectionContext.selectedObjectIndex === undefined) {
            return;
        }
        setActiveCollectionIndex(collectionContext.selectedObjectIndex);
        setActiveIndex(collectionContext.selectedObjectIndex);
        setPlayerPlaying(false);
        if (!playerOpen) {
            setPlayerOpen(true);
        }
    }, [
        activeIndex,
        activeCollectionIndex,
        playerOpen,
        playerPlaying,
        collectionContext.selectedObjectIndex,
    ]);
    return (React.createElement("div", { className: clsx(classes.contentWrapper, wrapperClasses, (_b = {},
            _b[previewWrapperClasses] = !playerOpen,
            _b)) },
        React.createElement(MediaPlayerContext.Provider, { value: mediaPlayerContextData },
            React.createElement(MediaPlayer, { sliderClasses: mediaPlayerClasses, slideClasses: mediaPlayerClasses, zoom: true },
                React.createElement("div", { className: classes.content, "data-testid": "collection-player-module-wrapper" },
                    React.createElement("div", { className: classes.backToTopicsButtonArea },
                        React.createElement(IconButton, { tabIndex: 0, color: 'inherit', onClick: backToTopics },
                            React.createElement(ArrowBackIosIcon, null),
                            React.createElement(Typography, { className: classes.backToTopicsTypo }, t('go to topics overview')))),
                    React.createElement("div", { "data-testid": "collection-player-module-details", className: classes.descriptionArea, style: {
                            backgroundImage: "url(" + collectionContext.previewImageSlider + ")",
                        } },
                        React.createElement(Typography, { variant: 'h2', className: classes.title }, collectionContext.title),
                        React.createElement(Typography, { component: "div", variant: 'h5' }, collectionContext.subtitle),
                        React.createElement(HighlightButton, { caption: t('play button'), onClick: function (event) {
                                mediaPlayerContextData.togglePlayerOpen &&
                                    mediaPlayerContextData.togglePlayerOpen(event);
                                mediaPlayerContextData.togglePlayerPlaying &&
                                    mediaPlayerContextData.togglePlayerPlaying(event);
                            } },
                            React.createElement(PlayArrowIcon, { color: 'primary' }))),
                    React.createElement("div", { className: classes.imageContainer, "data-testid": "collection-player-module-image-wrapper" },
                        React.createElement(CollectionContext$1.Consumer, null, function (collectionContext) { return (React.createElement(LazyLoadImage, { src: collectionContext.previewImageSlider },
                            React.createElement("img", { className: classes.image, src: collectionContext.previewImageSlider, alt: '' }))); })))))));
}



var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CollectionPlayerModule: CollectionPlayerModule,
  CollectionModule: CollectionModule,
  CollectionsDiscoverModule: CollectionsDiscoverModule,
  CollectionsDiscoverModuleNew: CollectionsDiscoverModuleNew,
  CollectionCardComponent: CollectionCardComponent$1,
  CollectionCard: CollectionCard$1,
  CollectionsModule: CollectionsModule,
  CollectionContext: CollectionContext$1
});

function Image$1(_a) {
    var alt = _a.alt, fallback = _a.fallback, height = _a.height, width = _a.width, caption = _a.caption, onClick = _a.onClick, src = _a.src;
    var _fallback = fallback ? fallback : React.createElement(FallbackImage, { text: '' });
    var _img = src === '' ? (_fallback) : (React.createElement(build_1, { alt: alt, height: height, src: src, width: width }));
    return (React.createElement("div", { style: {
            cursor: !onClick ? 'default' : 'pointer',
        }, onClick: onClick },
        _img,
        React.createElement("span", null, caption)));
}

var css$n = ".hero-slide {\n  width: 100%;\n  max-width: 1280px;\n  height: 100%;\n  box-sizing: border-box;\n  margin: 0 auto;\n}\n.hero-slide.section--X {\n  padding-top: 1rem;\n}\n@media (min-width: 500px) {\n  .hero-slide.section--X {\n    padding-top: 1.5rem;\n  }\n}\n@media (min-width: 678px) {\n  .hero-slide.section--X {\n    padding-top: 2rem;\n  }\n}\n@media (min-width: 1350px) {\n  .hero-slide.section--X {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n.hero-slide__image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: -1;\n}\n.hero-slide__content {\n  background: #0f0900;\n  padding: 0.5rem;\n  max-width: 470px;\n}\n@media (min-width: 375px) {\n  .hero-slide__content {\n    padding: 1rem;\n  }\n}\n.hero-slide__content--topics-hero {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  z-index: 1;\n  background: #f9ff4b;\n  color: #0f0900;\n}\n.hero-slide__content--topics-hero a {\n  color: inherit;\n  margin-top: 1.5rem;\n  text-transform: uppercase;\n  text-decoration: none;\n}\n.hero-slide__content--topics-hero a p {\n  font-size: 1.5rem;\n  font-family: \"GTWalsheimPro-Bold\", sans-serif;\n}\n.hero-slide__content--topics-hero a:hover .link-animation {\n  width: 100%;\n}\n.hero-slide__content--guide-hero {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  z-index: 1;\n  background: #0f0900;\n  color: #f84040;\n}\n.hero-slide__content--guide-hero a {\n  color: inherit;\n  margin-top: 1.5rem;\n  text-transform: uppercase;\n  text-decoration: none;\n}\n.hero-slide__content--guide-hero a p {\n  font-size: 1.5rem;\n  font-family: \"GTWalsheimPro-Bold\", sans-serif;\n}\n.hero-slide__content--guide-hero a:hover .link-animation {\n  width: 100%;\n}\n.hero-slide__content__text {\n  margin-top: 1rem !important;\n  font-size: 1.125rem !important;\n  font-weight: bold !important;\n  font-stretch: normal !important;\n  font-style: normal !important;\n  line-height: 1.875rem !important;\n  letter-spacing: 1.15px !important;\n}\n.hero-slide__content__subtitle {\n  margin-bottom: 0.5rem !important;\n}\n.hero-slide__bar {\n  position: absolute;\n  background: #0f0900;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  padding-top: 0.4375rem;\n  padding-bottom: 0.4375rem;\n}\n.hero-slide__bar__inner {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n}\n.hero-slide__bar__link {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  color: white !important;\n}\n.hero-slide__bar__link:hover {\n  text-decoration: underline;\n}\n.hero-slide__bar__link__arrow {\n  margin-right: 1rem;\n}\n.hero-slide__slide-buttons {\n  position: absolute;\n  max-width: 1280px;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0 auto;\n}";
n(css$n,{});

/* eslint-disable no-console */
var HeroSilde = function (props) {
    var title = props.title, id = props.id, text = props.text, image = props.image, href = props.href, caption = props.caption, section = props.section, actionText = props.actionText, actionHref = props.actionHref, target = props.target, subtitle = props.subtitle;
    return (React.createElement("div", { className: "hero-slide section--X", id: id, tabIndex: 0 },
        React.createElement("div", { className: "hero-slide__content hero-slide__content--" + section },
            subtitle && (React.createElement(Typography, { variant: "subtitle1", className: "hero-slide__content__subtitle" }, subtitle)),
            React.createElement(Typography, { variant: "h2", component: "h2" }, title),
            text && (React.createElement(Typography, { variant: "body1", className: "hero-slide__content__text" }, text)),
            actionHref && actionText && (React.createElement(React.Fragment, null,
                React.createElement("a", { href: actionHref, target: target, rel: "noreferrer", "aria-label": "" + ((actionText && ': ' && subtitle) || actionText) },
                    React.createElement(Typography, { variant: "body1" }, actionText),
                    React.createElement("span", { className: "link-animation" }))))),
        React.createElement("div", { className: "hero-slide__slide-buttons" },
            React.createElement("div", { className: "swiper-button-prev swiper-button-prev-intro-hero" },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "40.704", viewBox: "0 0 24 40.704" },
                    React.createElement("path", { id: "icon_arrow_right_black", d: "M24,3.639,20.339,0,0,20.352,20.36,40.7,24,37.066,7.28,20.352Z", fill: "currentColor" }))),
            React.createElement("div", { className: "swiper-button-next swiper-button-next-intro-hero" },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "40.704", viewBox: "0 0 24 40.704" },
                    React.createElement("path", { id: "icon_arrow_right_black", d: "M24,3.639,20.339,0,0,20.352,20.36,40.7,24,37.066,7.28,20.352Z", transform: "translate(24 40.704) rotate(180)", fill: "currentColor" })))),
        caption && (React.createElement("div", { className: "hero-slide__bar section--X" },
            React.createElement("div", { className: "hero-slide__bar__inner" },
                React.createElement(Link, { className: 'hero-slide__bar__link', href: href, "aria-label": "Link zu " + caption, target: '_blank', variant: "subtitle1" },
                    React.createElement(SvgIcon, { viewBox: "0 0 30 23.075", className: 'hero-slide__bar__link__arrow' },
                        React.createElement("path", { id: "icon_arrow_link", d: "M22.519,8.653H0v5.769H22.519v8.653L30,11.538,22.519,0V8.653Z", fill: "#fff" })),
                    caption)))),
        React.createElement("img", { className: "hero-slide__image", src: image, alt: "Current Slide Image" })));
};

var css$o = ".hero-swiper {\n  display: flex;\n  align-items: inherit;\n  position: relative;\n  width: 100%;\n  height: calc(95vh - 94px);\n  margin: 0;\n  background: #8b8b8b;\n}\n@media (min-width: 375px) {\n  .hero-swiper {\n    height: calc(95vh - 108px);\n  }\n}\n@media (min-width: 600px) {\n  .hero-swiper {\n    height: calc(95vh - 132px);\n  }\n}\n@media (min-width: 678px) {\n  .hero-swiper {\n    height: calc(95vh - 148px);\n  }\n}\n@media (min-width: 900px) {\n  .hero-swiper {\n    height: calc(95vh - 106px);\n  }\n}\n.hero-swiper .swiper-pagination {\n  display: flex !important;\n  justify-content: center !important;\n  width: 100% !important;\n  bottom: 3rem;\n  left: 0;\n}\n@media (min-width: 1024px) {\n  .hero-swiper .swiper-pagination {\n    bottom: 5rem;\n  }\n}\n.hero-swiper .swiper-pagination-bullet {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 0.25rem;\n  width: 2rem;\n  height: 2rem;\n  background: transparent;\n  opacity: 1;\n}\n.hero-swiper .swiper-pagination-bullet-active {\n  background: #ffffff91;\n}\n.hero-swiper .swiper-pagination-bullet::before {\n  content: \"\";\n  display: flex;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 50%;\n  background: white !important;\n}";
n(css$o,{});

/* eslint-disable react/jsx-key */
var HeroSwiper = function (props) {
    var data = props.data, section = props.section;
    var heroCardsCollection = function (contextData) {
        return contextData.map(function (slide, index) {
            var _a, _b;
            return {
                title: slide === null || slide === void 0 ? void 0 : slide.title,
                caption: slide === null || slide === void 0 ? void 0 : slide.caption,
                text: slide === null || slide === void 0 ? void 0 : slide.text,
                image: slide === null || slide === void 0 ? void 0 : slide.image,
                href: slide === null || slide === void 0 ? void 0 : slide.href,
                actionText: slide === null || slide === void 0 ? void 0 : slide.actionText,
                actionHref: slide === null || slide === void 0 ? void 0 : slide.actionHref,
                subtitle: (_a = slide.subtitle) !== null && _a !== void 0 ? _a : '',
                section: section,
                target: (_b = slide.target) !== null && _b !== void 0 ? _b : '_blank',
                id: "hero-slide_" + index + "_" + slide.id,
            };
        });
    };
    var collections = heroCardsCollection(data);
    return (React.createElement(MuiThemeProvider, { theme: CommonTheme },
        React.createElement("div", { className: "hero-swiper" },
            React.createElement(SwiperCarousel, { data: collections, type: "hero", section: section, sliderComponent: HeroSilde }),
            React.createElement("div", { className: "swiper-pagination" }))));
};

var css$p = ".static-pages {\n  display: flex;\n  justify-content: center;\n  min-height: calc(100vh - 100px);\n  padding-top: 6.25rem;\n  padding-bottom: 6.25rem;\n  color: #0f0900;\n}\n.static-pages__content {\n  padding-right: 1rem;\n  padding-left: 1rem;\n  min-height: 100vh;\n  max-width: 960px;\n  width: 100%;\n}\n.static-pages__innerContent {\n  margin-bottom: 0.25rem;\n}\n.static-pages__header {\n  font-family: \"GTWalsheimPro-Black\", Arial, sans-serif;\n  font-size: 2rem;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 3.25rem;\n  letter-spacing: 0.0675em;\n  color: inherit;\n  margin-bottom: 1rem;\n  word-wrap: break-word;\n}\n.static-pages__rich-text h2,\n.static-pages__rich-text h3,\n.static-pages__rich-text h4,\n.static-pages__rich-text h5,\n.static-pages__rich-text h6 {\n  font-family: \"GTWalsheimPro-Bold\", Arial, sans-serif;\n}\n.static-pages__rich-text h2 {\n  font-size: 1.75rem;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2.25rem;\n  letter-spacing: 0.065em;\n  color: inherit;\n  margin-top: 2rem;\n  margin-bottom: 0.25rem;\n}\n.static-pages__rich-text h3 {\n  font-size: 1.5rem;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.75rem;\n  letter-spacing: 0.065em;\n  color: inherit;\n  margin-top: 2rem;\n  margin-bottom: 0.25rem;\n}\n.static-pages__rich-text h4 {\n  font-size: 1.313rem;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2rem;\n  letter-spacing: 0.07875em;\n  color: inherit;\n  margin-top: 2rem;\n  margin-bottom: 0.25rem;\n}\n.static-pages__rich-text p {\n  font-size: 1.125rem;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.875rem;\n  letter-spacing: 0.075em;\n  color: inherit;\n  margin-bottom: 0.5rem;\n}\n.static-pages__rich-text ul,\n.static-pages__rich-text ol {\n  margin: 1rem 0;\n}\n.static-pages__rich-text li {\n  margin: 0.5rem 0;\n  line-height: 1.875rem;\n  letter-spacing: 0.075em;\n}\n.static-pages__rich-text a {\n  color: #0f0900;\n  font-weight: normal;\n  word-break: break-word;\n}\n.static-pages__rich-text svg {\n  margin-left: 0.25rem;\n}\n.static-pages__asset {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n.static-pages__asset img + img {\n  margin-left: 1rem;\n}\n.static-pages__iframe {\n  margin-top: 2rem;\n  border: 0;\n  height: 200px;\n  width: 100%;\n  overflow: scroll;\n}";
n(css$p,{});

var EXTERNAL_LINKS = {
    KEYWORDS_ICONCLASSES_LINK: 'https://iconclass.org/rkd/',
};
var CAROUSEL_CONFIG = {
    COLLECTION_CARD_IMAGE_SIZE: 400,
    MEDIA_PLAYER_PREVIEW_IMAGE_SIZE: 750,
    DETAILPAGE_IMAGE_SIZE: 2500,
    PREVIEW_IMAGE_SIZE: 86,
    SLIDER_IMAGE_SIZE: 2500,
    TOUR_CAROUSEL_IMAGE_SIZE: 200,
    HIGHLIGHT_CAROUSEL_IMAGE_SIZE: 200,
    CAROUSEL_HIGHLIGHTS_COUNT: 50,
};
var STRAPI_SCHEMA_CONFIG = {
    all: 'all',
    smb: 'strapi_smb',
    kgm: 'strapi_kgm',
    hbf: 'strapi_hbf',
    isl: 'strapi_isl',
};
var AppStage;
(function (AppStage) {
    AppStage["LOCAL"] = "local";
    AppStage["DEV"] = "dev";
    AppStage["STAGE"] = "stage";
    AppStage["PRODUCTION"] = "production";
})(AppStage || (AppStage = {}));
var DEV = __assign({ stage: AppStage.DEV, PRODUCTION_READY: false, IMAGE_PROVIDER_ENDPOINT: 'https://smb-research.xailabs.dev/images', GRAPHQL_ENDPOINT: 'https://smb-api.xailabs.dev/v1/graphql', GUIDE_ORIENT_API_ENDPOINT: 'https://smb-api-guide.xailabs.dev', ELASTIC_API_URL: 'https://smb-api.xailabs.dev/search', INTRO_DOMAIN: 'https://smb-landingpage.xailabs.dev', TOPICS_DOMAIN: 'https://smb-topics.xailabs.dev', RESEARCH_DOMAIN: 'https://smb-research.xailabs.dev', GUIDE_DOMAIN: 'https://smb-guide.xailabs.dev', MATOMO_URL: 'https://smb-matomo.xailabs.dev', CAROUSEL_CONFIG: CAROUSEL_CONFIG, STRAPI_SCHEMA_CONFIG: STRAPI_SCHEMA_CONFIG, STRAPI_CONFIG: {
        backend: {
            isl: 'https://stt-isl.xaidev.net/strapi',
            smb: 'https://stt-smb.xaidev.net/strapi',
            kgm: 'https://stt-kgm.xaidev.net/strapi',
            hbf: 'https://stt-hbf.xaidev.net/strapi',
        },
    } }, EXTERNAL_LINKS);
var STAGE = __assign({ stage: AppStage.STAGE, PRODUCTION_READY: true, IMAGE_PROVIDER_ENDPOINT: 'https://smb-research.xaidev.net/images', GRAPHQL_ENDPOINT: 'https://smb-api.xaidev.net/v1/graphql', GUIDE_ORIENT_API_ENDPOINT: 'https://smb-api.xaidev.net/guide', ELASTIC_API_URL: 'https://smb-api.xaidev.net/search', INTRO_DOMAIN: 'https://smb-landingpage.xaidev.net', TOPICS_DOMAIN: 'https://smb-topics.xaidev.net', RESEARCH_DOMAIN: 'https://smb-research.xaidev.net', GUIDE_DOMAIN: 'https://smb-guide.xaidev.net', MATOMO_URL: 'https://smb-admin.xaidev.net/matomo/', CAROUSEL_CONFIG: CAROUSEL_CONFIG, STRAPI_SCHEMA_CONFIG: STRAPI_SCHEMA_CONFIG, STRAPI_CONFIG: {
        backend: {
            isl: 'https://stt-isl.xaidev.net/strapi',
            smb: 'https://stt-smb.xaidev.net/strapi',
            kgm: 'https://stt-kgm.xaidev.net/strapi',
            hbf: 'https://stt-hbf.xaidev.net/strapi',
        },
    } }, EXTERNAL_LINKS);
var PRODUCTION = __assign({ stage: AppStage.PRODUCTION, PRODUCTION_READY: true, IMAGE_PROVIDER_ENDPOINT: 'https://recherche.smb.museum/images', GRAPHQL_ENDPOINT: 'https://api.smb.museum/v1/graphql', GUIDE_ORIENT_API_ENDPOINT: 'https://api.smb.museum/guide', ELASTIC_API_URL: 'https://api.smb.museum/search', INTRO_DOMAIN: 'https://sammlung.smb.museum', TOPICS_DOMAIN: 'https://themen.smb.museum', RESEARCH_DOMAIN: 'https://recherche.smb.museum', GUIDE_DOMAIN: 'https://touren.smb.museum', MATOMO_URL: 'https://admin.smb.museum/matomo/index.php', CAROUSEL_CONFIG: CAROUSEL_CONFIG, STRAPI_SCHEMA_CONFIG: STRAPI_SCHEMA_CONFIG, STRAPI_CONFIG: {
        backend: {
            isl: 'https://islamic-art.smb.museum/cms',
            smb: 'https://admin.smb.museum/smb',
            kgm: 'https://admin.smb.museum/kgm',
            hbf: 'https://admin.smb.museum/hbf',
        },
    } }, EXTERNAL_LINKS);
var LOCAL = __assign(__assign({}, STAGE), { stage: AppStage.LOCAL, PRODUCTION_READY: false, INTRO_DOMAIN: 'http://localhost:3000', TOPICS_DOMAIN: 'http://localhost:3001', GUIDE_DOMAIN: 'http://localhost:3002', RESEARCH_DOMAIN: 'http://localhost:3003' });
var loadConfig = function (environment) {
    switch (environment) {
        case AppStage.DEV:
            return DEV;
        case AppStage.STAGE:
            return STAGE;
        case AppStage.PRODUCTION:
            return PRODUCTION;
        default:
            return LOCAL;
    }
};

var EGraphqlTranslationAttributesFields;
(function (EGraphqlTranslationAttributesFields) {
    EGraphqlTranslationAttributesFields["title"] = "ObjObjectTitleGrp.TitleTxt";
    EGraphqlTranslationAttributesFields["technicalTerm"] = "ObjTechnicalTermClb";
    EGraphqlTranslationAttributesFields["findSpot"] = "ObjGeograficGrp.PlaceVoc";
    EGraphqlTranslationAttributesFields["dating"] = "ObjDateGrp.DateTxt";
    EGraphqlTranslationAttributesFields["identNumber"] = "ObjObjectNumberGrp.NumberVrt";
    EGraphqlTranslationAttributesFields["collectionKey"] = "__orgUnit";
    EGraphqlTranslationAttributesFields["collection"] = "ObjOwnerRef";
    EGraphqlTranslationAttributesFields["location"] = "ObjCurrentLocationGrpVrt";
    EGraphqlTranslationAttributesFields["involvedParties"] = "ObjPerAssociationMainParticipantVrt";
    EGraphqlTranslationAttributesFields["description"] = "ObjTextOnlineGrp.TextClb";
    EGraphqlTranslationAttributesFields["geographicalReferences"] = "ObjGeograficGrp.PlaceVoc";
    EGraphqlTranslationAttributesFields["culturalReferences"] = "ObjCulturalContextGrp.NameVoc";
    EGraphqlTranslationAttributesFields["materialAndTechnique"] = "ObjMaterialTechniqueGrp.ExportClb";
    EGraphqlTranslationAttributesFields["dimensionsAndWeight"] = "ObjDimAllGrp.PreviewVrt";
})(EGraphqlTranslationAttributesFields || (EGraphqlTranslationAttributesFields = {}));

/* eslint-disable no-console */
var TRANSLATION_DE = {
    accessibility: 'Barrierefreiheit',
    back: 'Zurück',
    'button play': 'Objekte des Themas abspielen',
    breadcrumb: {
        main: 'Sammlungen Online > ',
        noTitle: 'Ohne Titel',
        research: 'Recherche',
    },
    carousel: {
        nextTopic: 'Nächstes Thema',
        nextTour: 'Nächste Tour',
        previousTopic: 'Vorheriges Thema',
        previousTour: 'Vorherige Tour',
    },
    'collections module discover button': 'Entdecken',
    'collections module show all button': 'Alle ansehen',
    collections: {
        buttons: {
            guide: 'Einblick',
            research: 'Anschauen',
        },
    },
    'discover other collections': 'Andere Kollektionen entdecken',
    'download image': 'Bild herunterladen',
    duration: 'Dauer',
    details: {
        aside: {
            'contact and feedback': 'Kontakt und Feedback',
            'image request': 'Bildanfrage stellen',
            permalinkCopied: 'Permalink kopieren',
            topic: 'Themen',
            topicTestData: 'Verlinkung zum Themen',
            tours: 'Touren',
            toursTestData: 'Verlinkung zum Touren',
        },
        attachment: {
            pictureCredits: 'Credit',
            missingImageReasons: {
                '5802648': 'Ohne Abbildungen LINEBREAK aus ethischen Gründen',
                '6545994': 'Ohne Abbildungen LINEBREAK - Kriegsverlust -',
                '6548841': 'Ohne Abbildungen LINEBREAK aus lizenzrechtlichen Gründen',
            },
        },
        externalSearch: 'Link zu {{value}} auf {{domain}}',
        internalSearch: 'Interne Suche nach {{field}} {{value}}',
        referencesToOtherExhibits: 'Weitere Objekte aus den Sammlungen',
    },
    end: 'Ende',
    footer: {
        blog: 'Blog',
        staatliche: 'Staatliche Museen zu Berlin',
        newsletter: 'Newsletter',
        webshop: 'Webshop',
    },
    'go to object details': 'Zum Objekt',
    'go to topic': 'Zum Thema',
    'go to topics overview': 'Themenübersicht',
    header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz',
    },
    image: {
        notFoundText: 'Ohne Abbildungen',
    },
    notFoundPage: {
        title: 'SEITE NICHT GEFUNDEN',
        description: 'Leider existiert die angeforderte Seite nicht.',
        toMainPage: 'Zur Hauptseite',
    },
    object: 'Objekt',
    objects: 'Objekte',
    'object desc no data available': 'Keine Daten vorhanden.',
    'play button': 'Abspielen',
    place: 'Ort',
    'routes in the collection': 'Touren aus den Sammlungen',
    start: 'Start',
    search: {
        sublevel: {
            title: {
                musikforschung: 'Sammlung des Staatlichen Instituts für Musikforschung',
                staatlichenInstitute: 'Institute der Staatlichen Museen zu Berlin',
                staatlichenSammlung: 'Sammlungen der Staatlichen Museen zu Berlin',
            },
        },
        exhibit: {
            attributes: {
                acquisition: 'Erwerbung',
                archiveContent: 'Enthält',
                collection: 'Sammlung',
                dating: 'Datierung',
                datingFromTo: 'Datierung von/bis',
                description: 'Objektbeschreibung',
                dimensionsAndWeight: 'Abmessungen',
                exhibitions: 'Ausstellungen',
                findSpot: 'Fundort',
                geographicalReferences: 'Geografische Bezüge',
                culturalReferences: 'Kulturelle Bezüge',
                iconclasses: 'Iconclass',
                iconography: 'Ikonografie',
                identNumber: 'Ident. Nr.',
                inscriptions: 'Aufschriften',
                involvedParties: 'Beteiligte',
                keywords: 'Schlagwörter',
                literature: 'Literatur',
                location: 'Standort',
                materialAndTechnique: 'Material / Technik',
                noData: 'Keine Daten vorhanden.',
                permalink: 'Permalink',
                provenance: 'Provenienz',
                provenanceEvaluation: 'Provenienz',
                signatures: 'Signaturen und Inschriften',
                technicalTerm: 'Objektbezeichnung',
                title: 'Titel',
                titles: 'Weitere Titel',
            },
            collection: 'Sammlung',
            compilation: 'Bestand',
            location: 'Standort',
            notExhibited: 'Nicht ausgestellt',
        },
        guide: {
            title: 'Touren aus den Sammlungen',
        },
        results: {
            count: 'von {{searchResultsCount}} Objekten',
            empty: 'Die Suche lieferte keine Ergebnisse.',
            next: 'Nächstes Objekt',
            previous: 'Vorheriges Objekt',
            title: 'Suchergebnisse',
            backTo: 'Zurück zu Suchergebnisse',
        },
        topics: {
            title: 'Themen aus den Sammlungen',
        },
    },
    searchForm: {
        advancedSearch: 'Erweiterte Suche',
        labels: {
            search: 'Suchen',
            searchLong: 'Suchen Sie nach Personen oder Begriffen',
            noFiltersSelected: 'alle',
            filtersSelected: 'Filter aktiv',
        },
        actions: {
            clear: 'Löschen',
            addCondition: 'Suche verfeinern',
            search: 'Suche auslösen',
        },
        sorting: {
            label: 'Sortieren nach',
            relevance: 'Relevanz',
            lastUpdate: 'Zuletzt aktualisiert',
            identNumber: 'Ident. Nr.',
            titleAsc: 'Titel (A-Z, ÄÖÜ)',
            titleDesc: 'Titel (ÜÖÄ, Z-A)',
            dateAsc: 'Datierung (Älteste zuerst)',
            dateDesc: 'Datierung (Neueste zuerst)',
            termAsc: 'Objektbezeichnung (A-Z, ÄÖÜ)',
            termDesc: 'Objektbezeichnung (ÜÖÄ, Z-A)',
        },
        filters: {
            location: 'Standort',
            collection: 'Sammlungen und Institute',
            assortments: 'Kollektionen',
            compilation: 'Bestand',
            toggles: {
                attachment: 'Nur mit Abbildungen',
                exhibited: 'Ausgestellt',
                highlight: 'Highlights',
            },
            attributes: {
                attachments: 'Abbildungen',
                acquisition: 'Erwerbung',
                archiveContent: 'Enthält',
                collection: 'Sammlung',
                collectionKey: 'Sammlung',
                compilation: 'Bestand',
                creditLine: 'Beschaffung',
                dating: 'Datierung',
                datingFrom: 'Datierung von',
                datingFromTo: 'Datierung von/bis',
                datingTo: 'Datierung bis',
                dateRange: 'Datum',
                dimensionsAndWeight: 'Abmessungen',
                exhibit: 'Ausgestellt',
                exhibitions: 'Ausstellungen',
                exhibitionSpace: 'Standort',
                findSpot: 'Fundort',
                fulltext: 'Volltext',
                geographicalReferences: 'Geografische Bezüge',
                culturalReferences: 'Kulturelle Bezüge',
                id: 'Id',
                identNumber: 'Ident. Nr.',
                involvedParties: 'Beteiligte',
                literature: 'Literatur',
                location: 'Standort',
                longDescription: 'Beschreibung',
                highlight: 'Highlight',
                materialAndTechnique: 'Material / Technik',
                provenance: 'Provenienz',
                provenanceEvaluation: 'Provenienz',
                signatures: 'Signaturen und Inschriften',
                technicalTerm: 'Objektbezeichnung',
                titles: 'Titel',
                title: 'Titel',
                iconclasses: 'Iconclass',
                iconography: 'Ikonografie',
                keywords: 'Schlagwörter',
            },
            operators: {
                and: 'und',
                not: 'nicht',
                or: 'oder',
            },
        },
    },
    'search field': 'Feld zur Eintragung des Suchbegriffs',
    sharebuttons: {
        title: 'Teilen:',
    },
    'show less': 'Weniger Anzeigen',
    'show more': 'Mehr Anzeigen',
    'show detail': 'Detaillierte Objektbeschreibung anzeigen',
    'show next search results': 'Nächste Suchergebnisse anzeigen',
    'show previous search results': 'Vorherige Suchergebnisse anzeigen',
    'start search': 'Suche auslösen',
    stt: {
        filter: {
            label: 'Publiziert von',
            all: 'Alle',
            hbf: 'Hamburger Bahnhof',
            isl: 'Museum für Islamische Kunst',
            kgm: 'Kunstgewerbemuseum',
            smb: 'Sammlungen Online',
        },
        cta: {
            hbf: 'Anschauen',
            isl: 'Entdecken',
            kgm: 'Anschauen',
            smb: 'Entdecken',
        },
        sorting: {
            label: 'Sortieren nach',
            latest: 'zuletzt hinzugefügt',
            asc: 'A-Z',
            desc: 'Z-A',
        },
        topics: {
            carousel: {
                title: 'Themen aus den Sammlungen',
            },
        },
    },
    'zoom in': 'Hineinzoomen',
    language: {
        de: {
            label: 'Deutsch',
            hrefLang: 'Deutsch',
            ariaLabel: 'Auswahl: Sprache Deutsch',
        },
        en: {
            label: 'English',
            hrefLang: 'English',
            ariaLabel: 'Selection: English language',
        },
        'de-ls': {
            hrefLang: 'Leichte Sprache',
            ariaLabel: 'Auswahl: Leichte Sprache Deutsch',
        },
        'de-dgs': {
            hrefLang: 'Deutsche Gebärdensprache',
            ariaLabel: 'Auswahl: Gebärdensprache Deutsch',
        },
        'en-sl': {
            hrefLang: 'Simple language',
            ariaLabel: 'Selection: Simple language English',
        },
        'en-asl': {
            hrefLang: 'English Sign Language',
            ariaLabel: 'Selection: Sign language English',
        },
    },
    pagination: {
        from: 'von',
        section: 'Themen',
    },
};

var TRANSLATION_GUIDE_DE = __assign(__assign({}, TRANSLATION_DE), { cookieBanner: 'Diese Website benutzt Cookies. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.', header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz - Startseite Touren',
    } });

var TRANSLATION_RESEARCH_DE = __assign(__assign({}, TRANSLATION_DE), { cookieBanner: {
        content: 'Diese Website benutzt Cookies. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.',
    }, header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz - Startseite Recherche',
    } });

var TRANSLATION_TOPICS_DE = __assign(__assign({}, TRANSLATION_DE), { cookieBanner: {
        content: 'Diese Website benutzt Cookies. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.',
    }, header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz - Startseite Themen',
    } });

var TRANSLATION_INTRO_DE = __assign(__assign({}, TRANSLATION_DE), { cookieBanner: 'Diese Website benutzt Cookies. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.', header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz - Startseite',
    } });

/* eslint-disable no-console */
var TRANSLATION_EN = {
    accessibility: 'Accessibility',
    back: 'Back',
    'button play': 'Play',
    breadcrumb: {
        main: 'Sammlungen Online > ',
        noTitle: 'No title',
        research: 'Research',
    },
    carousel: {
        nextTopic: 'Next Topic',
        nextTour: 'Next Tour',
        previousTopic: 'Previous Topic',
        previousTour: 'Next Tour',
    },
    'collections module discover button': 'Discover',
    'collections module show all button': 'Show all',
    collections: {
        buttons: {
            guide: 'Insight',
            research: 'View',
        },
    },
    'discover other collections': 'Discover More Collections',
    'download image': 'Download Image',
    duration: 'Duration',
    details: {
        aside: {
            'contact and feedback': 'Contact and Feedback',
            'image request': 'Submit Image Request',
            permalinkCopied: 'Copy Permalink',
            topic: 'Topics',
            topicTestData: 'TEST-Topic',
            tours: 'Tours',
            toursTestData: 'TEST-Tour',
        },
        attachment: {
            pictureCredits: 'Credit',
            missingImageReasons: {
                '5802648': 'Without Image LINEBREAK due to ethical reasons',
                '6545994': 'Without Image LINEBREAK - martial loss -',
                '6548841': 'Without Image LINEBREAK due to legal reasons',
            },
        },
        externalSearch: 'Link to {{value}} at {{domain}}',
        internalSearch: 'Internal search for {{field}} {{value}}',
        referencesToOtherExhibits: 'More Objects from the Online Collection',
    },
    end: 'End',
    footer: {
        blog: 'Blog',
        staatliche: 'Staatliche Museen zu Berlin',
        newsletter: 'Newsletter',
        webshop: 'Webshop',
    },
    'go to object details': 'Go to Object',
    'go to topic': 'Go to Topic',
    'go to topics overview': 'Topics Overview',
    header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz',
    },
    image: {
        notFoundText: 'No image available',
    },
    notFoundPage: {
        title: 'PAGE NOT FOUND',
        description: 'The requested page does not exist.',
        toMainPage: 'Go to Main Page',
    },
    object: 'Object',
    objects: 'Objects',
    'object desc no data available': 'No data available.',
    'play button': 'Play',
    place: 'Place',
    'routes in the collection': 'Tours through the Collection',
    start: 'Start',
    search: {
        sublevel: {
            title: {
                musikforschung: 'Collection of the Staatliches Institut für Musikforschung',
                staatlichenInstitute: 'Institutes of Staatliche Museen zu Berlin',
                staatlichenSammlung: 'Collections of Staatliche Museen zu Berlin',
            },
        },
        exhibit: {
            attributes: {
                archiveContent: 'Contains',
                acquisition: 'Acquisition',
                collection: 'Collection',
                dating: 'Dating',
                datingFromTo: 'Dating from/to',
                description: 'Description',
                dimensionsAndWeight: 'Dimensions',
                exhibitions: 'Exhibitions',
                findSpot: 'Find Spot',
                geographicalReferences: 'Geographical References',
                culturalReferences: 'Cultural References',
                iconclasses: 'Icon Classes',
                iconography: 'Iconography',
                identNumber: 'Ident Number',
                inscriptions: 'Inscriptions',
                involvedParties: 'Involved Parties',
                keywords: 'Keywords',
                literature: 'Literature',
                location: 'Location',
                materialAndTechnique: 'Material / Technique',
                noData: 'No data available',
                permalink: 'Permalink',
                provenance: 'Provenance',
                provenanceEvaluation: 'Provenance',
                signatures: 'Signatures',
                technicalTerm: 'Technical Term',
                title: 'Title',
                titles: 'Titles',
            },
            collection: 'Collection',
            compilation: 'Compilation',
            location: 'Current Location',
            notExhibited: 'Not exhibited',
        },
        guide: {
            title: 'Tours through the Collection',
        },
        results: {
            count: 'of {{searchResultsCount}} Obejcts',
            empty: 'There are no search results.',
            next: 'Next Object',
            previous: 'Previous Object',
            title: 'Search Results',
            backTo: 'Back to Search Results',
        },
        topics: {
            title: 'Topics from the Collections',
        },
    },
    searchForm: {
        advancedSearch: 'Advanced search',
        labels: {
            search: 'Search',
            searchLong: 'Search for people or terms',
            noFiltersSelected: 'all',
            filtersSelected: 'Active filters',
        },
        actions: {
            clear: 'Remove',
            addCondition: 'Refine search',
            search: 'Start search',
        },
        sorting: {
            label: 'Sort by',
            relevance: 'Relevance',
            lastUpdate: 'Last updated',
            identNumber: 'Ident Number',
            titleAsc: 'Title (A-Z, ÄÖÜ)',
            titleDesc: 'Title (ÜÖÄ, Z-A)',
            dateAsc: 'Dating (oldest first)',
            dateDesc: 'Dating (newest first)',
            termAsc: 'Technical Term (A-Z, ÄÖÜ)',
            termDesc: 'Technical Term (ÜÖÄ, Z-A)',
        },
        filters: {
            location: 'Locations',
            collection: 'Collections',
            assortments: 'Assortments',
            compilation: 'Stocks',
            toggles: {
                attachment: 'With Attachments',
                exhibited: 'Exhibited',
                highlight: 'Highlights',
            },
            attributes: {
                attachments: 'Attachments',
                acquisition: 'Acquisition',
                archiveContent: 'Contains',
                collection: 'Collection',
                collectionKey: 'Collection',
                compilation: 'Stock',
                creditLine: 'Provisioning',
                dating: 'Dating',
                datingFrom: 'Dating from',
                datingFromTo: 'Dating from/to',
                datingTo: 'Dating to',
                dateRange: 'Date Stamping',
                dimensionsAndWeight: 'Dimensions',
                exhibit: 'Exhibited',
                exhibitions: 'Exhibition',
                exhibitionSpace: 'Exhibition Space',
                findSpot: 'Find Spot',
                fulltext: 'Full text',
                geographicalReferences: 'Geographical Reference',
                culturalReferences: 'Cultural References',
                id: 'ID',
                identNumber: 'Ident Number',
                involvedParties: 'Involved Party',
                literature: 'Literature',
                location: 'Location',
                longDescription: 'Description',
                highlight: 'Highlight',
                materialAndTechnique: 'Material / Technique',
                provenance: 'Provenance',
                provenanceEvaluation: 'Provenance',
                signatures: 'Signature',
                technicalTerm: 'Technical Term',
                titles: 'Titles',
                title: 'Title',
                iconclasses: 'Icon Class',
                iconography: 'Iconography',
                keywords: '',
            },
            operators: {
                and: 'and',
                not: 'not',
                or: 'or',
            },
        },
    },
    'search field': 'Search Input Field',
    sharebuttons: {
        title: 'Share:',
    },
    'show less': 'Show Less',
    'show more': 'Show More',
    'show detail': 'Open Object Details',
    'show next search results': 'Show Next Search Results',
    'show previous search results': 'Show Previous Search Results',
    'start search': 'Execute Search',
    stt: {
        filter: {
            label: 'Published by',
            all: 'All',
            hbf: 'Hamburger Bahnhof',
            isl: 'Museum für Islamische Kunst',
            kgm: 'Kunstgewerbemuseum',
            smb: 'Sammlungen Online',
        },
        cta: {
            hbf: 'Go to Story',
            isl: 'Discover Story',
            kgm: 'Go to Story',
            smb: 'Discover Story',
        },
        sorting: {
            label: 'Sort by',
            latest: 'Publication Date',
            asc: 'A-Z',
            desc: 'Z-A',
        },
        topics: {
            carousel: {
                title: 'Topics from the Collections',
            },
        },
    },
    'zoom in': 'Zoom in',
    language: {
        de: {
            label: 'Deutsch',
            hrefLang: 'Deutsch',
            ariaLabel: 'Auswahl: Sprache Deutsch',
        },
        en: {
            label: 'English',
            hrefLang: 'English',
            ariaLabel: 'Selection: English Language',
        },
        'de-ls': {
            hrefLang: 'Leichte Sprache',
            ariaLabel: 'Auswahl: Leichte Sprache Deutsch',
        },
        'de-dgs': {
            hrefLang: 'Deutsche Gebärdensprache',
            ariaLabel: 'Auswahl: Gebärdensprache Deutsch',
        },
        'en-sl': {
            hrefLang: 'Simple Language',
            ariaLabel: 'Selection: Simple Language English',
        },
        'en-asl': {
            hrefLang: 'English Sign Language',
            ariaLabel: 'Selection: Sign Language English',
        },
    },
    pagination: {
        from: 'from',
        section: 'Topics',
    },
};

var TRANSLATION_GUIDE_EN = __assign(__assign({}, TRANSLATION_EN), { cookieBanner: 'Diese Website benutzt Cookies. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.', header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz - Startseite Touren',
    } });

var TRANSLATION_RESEARCH_EN = __assign(__assign({}, TRANSLATION_EN), { cookieBanner: {
        content: 'Diese Website benutzt Cookies. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.',
    }, header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz - Startseite Recherche',
    } });

var TRANSLATION_TOPICS_EN = __assign(__assign({}, TRANSLATION_EN), { cookieBanner: {
        content: 'Diese Website benutzt Cookies. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.',
    }, header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz - Startseite Themen',
    } });

var TRANSLATION_INTRO_EN = __assign(__assign({}, TRANSLATION_EN), { cookieBanner: 'Diese Website benutzt Cookies. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.', header: {
        logo: 'Die Staatlichen Museen zu Berlin Preußischer Kulturbesitz - Startseite',
    } });

/* eslint-disable @typescript-eslint/no-explicit-any */
function StaticPages(_a) {
    var _b;
    var content = _a.content;
    function createMarkup(value) {
        var externSvg = "<svg\n  className={classes.svg}\n  xmlns=\"http://www.w3.org/2000/svg\"\n  width=\"14\"\n  height=\"14\"\n  viewBox=\"0 0 195 191\"\n>\n  <g fill=\"#000\">\n    <path d=\"M185.818,0.161 L128.778,0.161 C123.807,0.161 119.778,4.19 119.778,9.161 C119.778,14.132 123.807,18.161 128.778,18.161 L164.09,18.161 L77.79,104.461 C74.275,107.976 74.275,113.674 77.79,117.189 C79.548,118.946 81.851,119.825 84.154,119.825 C86.457,119.825 88.76,118.946 90.518,117.189 L176.818,30.889 L176.818,66.202 C176.818,71.173 180.847,75.202 185.818,75.202 C190.789,75.202 194.818,71.173 194.818,66.202 L194.818,9.162 C194.818,4.19 190.789,0.161 185.818,0.161 Z\" />\n    <path d=\"M149,75.201 C144.029,75.201 140,79.23 140,84.201 L140,172.657 L18,172.657 L18,50.657 L111.778,50.657 C116.749,50.657 120.778,46.628 120.778,41.657 C120.778,36.686 116.749,32.657 111.778,32.657 L9,32.657 C4.029,32.657 0,36.686 0,41.657 L0,181.657 C0,186.628 4.029,190.657 9,190.657 L149,190.657 C153.971,190.657 158,186.628 158,181.657 L158,84.201 C158,79.23 153.971,75.201 149,75.201 Z\" />\n  </g>\n</svg></a> ";
        var regex = /<\/a>/g;
        var formattedText = value.replace(regex, "" + externSvg);
        return { __html: formattedText };
    }
    var matomoLang = LanguageService.getDefaultLanguage();
    var currentLang = LanguageService.getCurrentStrapiLanguage();
    var config = loadConfig((_b = process.env.REACT_APP_STAGE) !== null && _b !== void 0 ? _b : null);
    var matomoParams = "?module=CoreAdminHome&action=optOut&language=" + matomoLang + "&backgroundColor=&fontColor=&fontSize=16px&fontFamily=Arial";
    return (React.createElement("section", { className: 'static-pages', "data-testid": 'page-privacy-wrapper' },
        React.createElement("div", { className: 'static-pages__content' },
            React.createElement("h1", { className: "static-pages__header" }, content.title),
            content.block.length > 0 && (React.createElement(React.Fragment, null, content.block.map(function (row, index) {
                return (React.createElement("div", { className: "static-pages__innerContent", key: "page-block-" + index + "-" + row.id },
                    currentLang === 'de-DGS' && row.videoAssets.length > 0 && (React.createElement("div", { className: 'static-pages__asset' }, row.videoAssets.map(function (asset, index) { return (React.createElement(ReactPlayer$1, { key: "video-" + index, className: 'video-card__player', url: "" + row.assetBaseUrl + asset.attributes.url, controls: true })); }))),
                    React.createElement("div", { key: "page-block-" + index + "-" + row.id, className: "static-pages__rich-text", dangerouslySetInnerHTML: createMarkup(row.text) }),
                    row.assets.length > 0 && (React.createElement("div", { className: 'static-pages__asset' }, row.assets.map(function (asset, index) { return (React.createElement("img", { key: "image_" + index, src: "" + row.assetBaseUrl + asset.attributes.url, alt: asset.attributes.alternativeText, width: "243" })); })))));
            }))),
            content.matomo && (React.createElement("iframe", { className: 'static-pages__iframe', src: "" + config.MATOMO_URL + matomoParams })))));
}

var css$q = ".highlights-block {\n  padding-top: 3rem;\n}\n.highlights-block__loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}";
n(css$q,{});

/* eslint-disable no-console */
function Highlights(_a) {
    var data = _a.data, highlightsCollections = _a.highlightsCollections;
    var config = useConfigLoader().config;
    var getTitleHref = function () {
        switch (data.slug) {
            case 'INTRO':
                return config.INTRO_DOMAIN;
            case 'RESEARCH':
                return config.RESEARCH_DOMAIN;
            case 'TOPIC':
                return config.TOPICS_DOMAIN;
            case 'GUIDE':
                return config.GUIDE_DOMAIN;
            default:
                return '';
        }
    };
    var getHighlightsCollections = function () {
        if (highlightsCollections && (highlightsCollections === null || highlightsCollections === void 0 ? void 0 : highlightsCollections.length) > 0) {
            return highlightsCollections;
        }
        else {
            var highlightsService = new HighlightService();
            var _a = highlightsService.getHighlightsObjects(), loading = _a.loading, contextData = _a.contextData;
            if (!loading && contextData.length > 0)
                return contextData;
            else
                return [];
        }
    };
    var highlights = getHighlightsCollections();
    return (React.createElement(React.Fragment, null, highlights && (React.createElement("div", { className: 'highlights-block' },
        React.createElement(CarouselHeadline, { href: getTitleHref(), variant: 'h4', text: data.text, link: false, assets: data.assets }, data.title),
        highlights && (highlights === null || highlights === void 0 ? void 0 : highlights.length) <= 0 && (React.createElement("div", { className: 'highlights-block__loader' },
            React.createElement(LoadingSpinner, null))),
        highlights && (highlights === null || highlights === void 0 ? void 0 : highlights.length) > 0 && (React.createElement(SwiperCarousel, { data: highlights, type: "auto", sliderComponent: CarouselImageCard$1, section: "research-auto" }))))));
}

var useStyles$D = makeStyles(function () {
    return createStyles({
        content: {
            padding: 15,
            marginTop: 10,
        },
        link: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.75rem',
            '&> svg': {
                marginLeft: 10,
            },
        },
        contentTopic: {
            backgroundColor: '#6f7045',
        },
        contentGuide: {
            backgroundColor: '#f25b5b',
        },
        contentText: {
            backgroundColor: '#d3d3d3',
        },
        typoTitle: {
            paddingBottom: 10,
        },
        typoTopic: {
            color: '#f9ff04',
        },
        typoGuide: {
            color: '#ffffff',
        },
        typoText: {
            color: '#000000',
        },
    });
});

var TextContainerType;
(function (TextContainerType) {
    TextContainerType[TextContainerType["TEXT"] = 0] = "TEXT";
    TextContainerType[TextContainerType["TOPIC"] = 1] = "TOPIC";
    TextContainerType[TextContainerType["GUIDE"] = 2] = "GUIDE";
})(TextContainerType || (TextContainerType = {}));
function TextContainer(_a) {
    var _b, _c, _d, _e, _f, _g;
    var containerType = _a.containerType, title = _a.title, elements = _a.elements;
    var classes = useStyles$D();
    return (React.createElement("div", { className: clsx(classes.content, (_b = {}, _b[classes.contentTopic] = containerType === TextContainerType.TOPIC, _b), (_c = {}, _c[classes.contentGuide] = containerType === TextContainerType.GUIDE, _c), (_d = {}, _d[classes.contentText] = containerType === TextContainerType.TEXT, _d)) },
        React.createElement(Typography, { component: "div", variant: 'h5', className: clsx(classes.typoTitle, (_e = {}, _e[classes.typoTopic] = containerType === TextContainerType.TOPIC, _e), (_f = {}, _f[classes.typoGuide] = containerType === TextContainerType.GUIDE, _f), (_g = {}, _g[classes.typoText] = containerType === TextContainerType.TEXT, _g)) }, title),
        elements.map(function (elem, index) {
            var _a, _b, _c;
            return (React.createElement(Link$1, { key: index, href: elem.href, color: 'inherit', className: clsx(classes.link, (_a = {}, _a[classes.typoTopic] = containerType === TextContainerType.TOPIC, _a), (_b = {}, _b[classes.typoGuide] = containerType === TextContainerType.GUIDE, _b), (_c = {}, _c[classes.typoText] = containerType === TextContainerType.TEXT, _c)) },
                elem.caption,
                React.createElement(ArrowRightAltIcon, null)));
        })));
}

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

function getDefaultWhiteList () {
  // 白名单值说明：
  // true: 允许该属性
  // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
  // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
  // 除上面列出的值外均表示不允许
  var whiteList = {};

  whiteList['align-content'] = false; // default: auto
  whiteList['align-items'] = false; // default: auto
  whiteList['align-self'] = false; // default: auto
  whiteList['alignment-adjust'] = false; // default: auto
  whiteList['alignment-baseline'] = false; // default: baseline
  whiteList['all'] = false; // default: depending on individual properties
  whiteList['anchor-point'] = false; // default: none
  whiteList['animation'] = false; // default: depending on individual properties
  whiteList['animation-delay'] = false; // default: 0
  whiteList['animation-direction'] = false; // default: normal
  whiteList['animation-duration'] = false; // default: 0
  whiteList['animation-fill-mode'] = false; // default: none
  whiteList['animation-iteration-count'] = false; // default: 1
  whiteList['animation-name'] = false; // default: none
  whiteList['animation-play-state'] = false; // default: running
  whiteList['animation-timing-function'] = false; // default: ease
  whiteList['azimuth'] = false; // default: center
  whiteList['backface-visibility'] = false; // default: visible
  whiteList['background'] = true; // default: depending on individual properties
  whiteList['background-attachment'] = true; // default: scroll
  whiteList['background-clip'] = true; // default: border-box
  whiteList['background-color'] = true; // default: transparent
  whiteList['background-image'] = true; // default: none
  whiteList['background-origin'] = true; // default: padding-box
  whiteList['background-position'] = true; // default: 0% 0%
  whiteList['background-repeat'] = true; // default: repeat
  whiteList['background-size'] = true; // default: auto
  whiteList['baseline-shift'] = false; // default: baseline
  whiteList['binding'] = false; // default: none
  whiteList['bleed'] = false; // default: 6pt
  whiteList['bookmark-label'] = false; // default: content()
  whiteList['bookmark-level'] = false; // default: none
  whiteList['bookmark-state'] = false; // default: open
  whiteList['border'] = true; // default: depending on individual properties
  whiteList['border-bottom'] = true; // default: depending on individual properties
  whiteList['border-bottom-color'] = true; // default: current color
  whiteList['border-bottom-left-radius'] = true; // default: 0
  whiteList['border-bottom-right-radius'] = true; // default: 0
  whiteList['border-bottom-style'] = true; // default: none
  whiteList['border-bottom-width'] = true; // default: medium
  whiteList['border-collapse'] = true; // default: separate
  whiteList['border-color'] = true; // default: depending on individual properties
  whiteList['border-image'] = true; // default: none
  whiteList['border-image-outset'] = true; // default: 0
  whiteList['border-image-repeat'] = true; // default: stretch
  whiteList['border-image-slice'] = true; // default: 100%
  whiteList['border-image-source'] = true; // default: none
  whiteList['border-image-width'] = true; // default: 1
  whiteList['border-left'] = true; // default: depending on individual properties
  whiteList['border-left-color'] = true; // default: current color
  whiteList['border-left-style'] = true; // default: none
  whiteList['border-left-width'] = true; // default: medium
  whiteList['border-radius'] = true; // default: 0
  whiteList['border-right'] = true; // default: depending on individual properties
  whiteList['border-right-color'] = true; // default: current color
  whiteList['border-right-style'] = true; // default: none
  whiteList['border-right-width'] = true; // default: medium
  whiteList['border-spacing'] = true; // default: 0
  whiteList['border-style'] = true; // default: depending on individual properties
  whiteList['border-top'] = true; // default: depending on individual properties
  whiteList['border-top-color'] = true; // default: current color
  whiteList['border-top-left-radius'] = true; // default: 0
  whiteList['border-top-right-radius'] = true; // default: 0
  whiteList['border-top-style'] = true; // default: none
  whiteList['border-top-width'] = true; // default: medium
  whiteList['border-width'] = true; // default: depending on individual properties
  whiteList['bottom'] = false; // default: auto
  whiteList['box-decoration-break'] = true; // default: slice
  whiteList['box-shadow'] = true; // default: none
  whiteList['box-sizing'] = true; // default: content-box
  whiteList['box-snap'] = true; // default: none
  whiteList['box-suppress'] = true; // default: show
  whiteList['break-after'] = true; // default: auto
  whiteList['break-before'] = true; // default: auto
  whiteList['break-inside'] = true; // default: auto
  whiteList['caption-side'] = false; // default: top
  whiteList['chains'] = false; // default: none
  whiteList['clear'] = true; // default: none
  whiteList['clip'] = false; // default: auto
  whiteList['clip-path'] = false; // default: none
  whiteList['clip-rule'] = false; // default: nonzero
  whiteList['color'] = true; // default: implementation dependent
  whiteList['color-interpolation-filters'] = true; // default: auto
  whiteList['column-count'] = false; // default: auto
  whiteList['column-fill'] = false; // default: balance
  whiteList['column-gap'] = false; // default: normal
  whiteList['column-rule'] = false; // default: depending on individual properties
  whiteList['column-rule-color'] = false; // default: current color
  whiteList['column-rule-style'] = false; // default: medium
  whiteList['column-rule-width'] = false; // default: medium
  whiteList['column-span'] = false; // default: none
  whiteList['column-width'] = false; // default: auto
  whiteList['columns'] = false; // default: depending on individual properties
  whiteList['contain'] = false; // default: none
  whiteList['content'] = false; // default: normal
  whiteList['counter-increment'] = false; // default: none
  whiteList['counter-reset'] = false; // default: none
  whiteList['counter-set'] = false; // default: none
  whiteList['crop'] = false; // default: auto
  whiteList['cue'] = false; // default: depending on individual properties
  whiteList['cue-after'] = false; // default: none
  whiteList['cue-before'] = false; // default: none
  whiteList['cursor'] = false; // default: auto
  whiteList['direction'] = false; // default: ltr
  whiteList['display'] = true; // default: depending on individual properties
  whiteList['display-inside'] = true; // default: auto
  whiteList['display-list'] = true; // default: none
  whiteList['display-outside'] = true; // default: inline-level
  whiteList['dominant-baseline'] = false; // default: auto
  whiteList['elevation'] = false; // default: level
  whiteList['empty-cells'] = false; // default: show
  whiteList['filter'] = false; // default: none
  whiteList['flex'] = false; // default: depending on individual properties
  whiteList['flex-basis'] = false; // default: auto
  whiteList['flex-direction'] = false; // default: row
  whiteList['flex-flow'] = false; // default: depending on individual properties
  whiteList['flex-grow'] = false; // default: 0
  whiteList['flex-shrink'] = false; // default: 1
  whiteList['flex-wrap'] = false; // default: nowrap
  whiteList['float'] = false; // default: none
  whiteList['float-offset'] = false; // default: 0 0
  whiteList['flood-color'] = false; // default: black
  whiteList['flood-opacity'] = false; // default: 1
  whiteList['flow-from'] = false; // default: none
  whiteList['flow-into'] = false; // default: none
  whiteList['font'] = true; // default: depending on individual properties
  whiteList['font-family'] = true; // default: implementation dependent
  whiteList['font-feature-settings'] = true; // default: normal
  whiteList['font-kerning'] = true; // default: auto
  whiteList['font-language-override'] = true; // default: normal
  whiteList['font-size'] = true; // default: medium
  whiteList['font-size-adjust'] = true; // default: none
  whiteList['font-stretch'] = true; // default: normal
  whiteList['font-style'] = true; // default: normal
  whiteList['font-synthesis'] = true; // default: weight style
  whiteList['font-variant'] = true; // default: normal
  whiteList['font-variant-alternates'] = true; // default: normal
  whiteList['font-variant-caps'] = true; // default: normal
  whiteList['font-variant-east-asian'] = true; // default: normal
  whiteList['font-variant-ligatures'] = true; // default: normal
  whiteList['font-variant-numeric'] = true; // default: normal
  whiteList['font-variant-position'] = true; // default: normal
  whiteList['font-weight'] = true; // default: normal
  whiteList['grid'] = false; // default: depending on individual properties
  whiteList['grid-area'] = false; // default: depending on individual properties
  whiteList['grid-auto-columns'] = false; // default: auto
  whiteList['grid-auto-flow'] = false; // default: none
  whiteList['grid-auto-rows'] = false; // default: auto
  whiteList['grid-column'] = false; // default: depending on individual properties
  whiteList['grid-column-end'] = false; // default: auto
  whiteList['grid-column-start'] = false; // default: auto
  whiteList['grid-row'] = false; // default: depending on individual properties
  whiteList['grid-row-end'] = false; // default: auto
  whiteList['grid-row-start'] = false; // default: auto
  whiteList['grid-template'] = false; // default: depending on individual properties
  whiteList['grid-template-areas'] = false; // default: none
  whiteList['grid-template-columns'] = false; // default: none
  whiteList['grid-template-rows'] = false; // default: none
  whiteList['hanging-punctuation'] = false; // default: none
  whiteList['height'] = true; // default: auto
  whiteList['hyphens'] = false; // default: manual
  whiteList['icon'] = false; // default: auto
  whiteList['image-orientation'] = false; // default: auto
  whiteList['image-resolution'] = false; // default: normal
  whiteList['ime-mode'] = false; // default: auto
  whiteList['initial-letters'] = false; // default: normal
  whiteList['inline-box-align'] = false; // default: last
  whiteList['justify-content'] = false; // default: auto
  whiteList['justify-items'] = false; // default: auto
  whiteList['justify-self'] = false; // default: auto
  whiteList['left'] = false; // default: auto
  whiteList['letter-spacing'] = true; // default: normal
  whiteList['lighting-color'] = true; // default: white
  whiteList['line-box-contain'] = false; // default: block inline replaced
  whiteList['line-break'] = false; // default: auto
  whiteList['line-grid'] = false; // default: match-parent
  whiteList['line-height'] = false; // default: normal
  whiteList['line-snap'] = false; // default: none
  whiteList['line-stacking'] = false; // default: depending on individual properties
  whiteList['line-stacking-ruby'] = false; // default: exclude-ruby
  whiteList['line-stacking-shift'] = false; // default: consider-shifts
  whiteList['line-stacking-strategy'] = false; // default: inline-line-height
  whiteList['list-style'] = true; // default: depending on individual properties
  whiteList['list-style-image'] = true; // default: none
  whiteList['list-style-position'] = true; // default: outside
  whiteList['list-style-type'] = true; // default: disc
  whiteList['margin'] = true; // default: depending on individual properties
  whiteList['margin-bottom'] = true; // default: 0
  whiteList['margin-left'] = true; // default: 0
  whiteList['margin-right'] = true; // default: 0
  whiteList['margin-top'] = true; // default: 0
  whiteList['marker-offset'] = false; // default: auto
  whiteList['marker-side'] = false; // default: list-item
  whiteList['marks'] = false; // default: none
  whiteList['mask'] = false; // default: border-box
  whiteList['mask-box'] = false; // default: see individual properties
  whiteList['mask-box-outset'] = false; // default: 0
  whiteList['mask-box-repeat'] = false; // default: stretch
  whiteList['mask-box-slice'] = false; // default: 0 fill
  whiteList['mask-box-source'] = false; // default: none
  whiteList['mask-box-width'] = false; // default: auto
  whiteList['mask-clip'] = false; // default: border-box
  whiteList['mask-image'] = false; // default: none
  whiteList['mask-origin'] = false; // default: border-box
  whiteList['mask-position'] = false; // default: center
  whiteList['mask-repeat'] = false; // default: no-repeat
  whiteList['mask-size'] = false; // default: border-box
  whiteList['mask-source-type'] = false; // default: auto
  whiteList['mask-type'] = false; // default: luminance
  whiteList['max-height'] = true; // default: none
  whiteList['max-lines'] = false; // default: none
  whiteList['max-width'] = true; // default: none
  whiteList['min-height'] = true; // default: 0
  whiteList['min-width'] = true; // default: 0
  whiteList['move-to'] = false; // default: normal
  whiteList['nav-down'] = false; // default: auto
  whiteList['nav-index'] = false; // default: auto
  whiteList['nav-left'] = false; // default: auto
  whiteList['nav-right'] = false; // default: auto
  whiteList['nav-up'] = false; // default: auto
  whiteList['object-fit'] = false; // default: fill
  whiteList['object-position'] = false; // default: 50% 50%
  whiteList['opacity'] = false; // default: 1
  whiteList['order'] = false; // default: 0
  whiteList['orphans'] = false; // default: 2
  whiteList['outline'] = false; // default: depending on individual properties
  whiteList['outline-color'] = false; // default: invert
  whiteList['outline-offset'] = false; // default: 0
  whiteList['outline-style'] = false; // default: none
  whiteList['outline-width'] = false; // default: medium
  whiteList['overflow'] = false; // default: depending on individual properties
  whiteList['overflow-wrap'] = false; // default: normal
  whiteList['overflow-x'] = false; // default: visible
  whiteList['overflow-y'] = false; // default: visible
  whiteList['padding'] = true; // default: depending on individual properties
  whiteList['padding-bottom'] = true; // default: 0
  whiteList['padding-left'] = true; // default: 0
  whiteList['padding-right'] = true; // default: 0
  whiteList['padding-top'] = true; // default: 0
  whiteList['page'] = false; // default: auto
  whiteList['page-break-after'] = false; // default: auto
  whiteList['page-break-before'] = false; // default: auto
  whiteList['page-break-inside'] = false; // default: auto
  whiteList['page-policy'] = false; // default: start
  whiteList['pause'] = false; // default: implementation dependent
  whiteList['pause-after'] = false; // default: implementation dependent
  whiteList['pause-before'] = false; // default: implementation dependent
  whiteList['perspective'] = false; // default: none
  whiteList['perspective-origin'] = false; // default: 50% 50%
  whiteList['pitch'] = false; // default: medium
  whiteList['pitch-range'] = false; // default: 50
  whiteList['play-during'] = false; // default: auto
  whiteList['position'] = false; // default: static
  whiteList['presentation-level'] = false; // default: 0
  whiteList['quotes'] = false; // default: text
  whiteList['region-fragment'] = false; // default: auto
  whiteList['resize'] = false; // default: none
  whiteList['rest'] = false; // default: depending on individual properties
  whiteList['rest-after'] = false; // default: none
  whiteList['rest-before'] = false; // default: none
  whiteList['richness'] = false; // default: 50
  whiteList['right'] = false; // default: auto
  whiteList['rotation'] = false; // default: 0
  whiteList['rotation-point'] = false; // default: 50% 50%
  whiteList['ruby-align'] = false; // default: auto
  whiteList['ruby-merge'] = false; // default: separate
  whiteList['ruby-position'] = false; // default: before
  whiteList['shape-image-threshold'] = false; // default: 0.0
  whiteList['shape-outside'] = false; // default: none
  whiteList['shape-margin'] = false; // default: 0
  whiteList['size'] = false; // default: auto
  whiteList['speak'] = false; // default: auto
  whiteList['speak-as'] = false; // default: normal
  whiteList['speak-header'] = false; // default: once
  whiteList['speak-numeral'] = false; // default: continuous
  whiteList['speak-punctuation'] = false; // default: none
  whiteList['speech-rate'] = false; // default: medium
  whiteList['stress'] = false; // default: 50
  whiteList['string-set'] = false; // default: none
  whiteList['tab-size'] = false; // default: 8
  whiteList['table-layout'] = false; // default: auto
  whiteList['text-align'] = true; // default: start
  whiteList['text-align-last'] = true; // default: auto
  whiteList['text-combine-upright'] = true; // default: none
  whiteList['text-decoration'] = true; // default: none
  whiteList['text-decoration-color'] = true; // default: currentColor
  whiteList['text-decoration-line'] = true; // default: none
  whiteList['text-decoration-skip'] = true; // default: objects
  whiteList['text-decoration-style'] = true; // default: solid
  whiteList['text-emphasis'] = true; // default: depending on individual properties
  whiteList['text-emphasis-color'] = true; // default: currentColor
  whiteList['text-emphasis-position'] = true; // default: over right
  whiteList['text-emphasis-style'] = true; // default: none
  whiteList['text-height'] = true; // default: auto
  whiteList['text-indent'] = true; // default: 0
  whiteList['text-justify'] = true; // default: auto
  whiteList['text-orientation'] = true; // default: mixed
  whiteList['text-overflow'] = true; // default: clip
  whiteList['text-shadow'] = true; // default: none
  whiteList['text-space-collapse'] = true; // default: collapse
  whiteList['text-transform'] = true; // default: none
  whiteList['text-underline-position'] = true; // default: auto
  whiteList['text-wrap'] = true; // default: normal
  whiteList['top'] = false; // default: auto
  whiteList['transform'] = false; // default: none
  whiteList['transform-origin'] = false; // default: 50% 50% 0
  whiteList['transform-style'] = false; // default: flat
  whiteList['transition'] = false; // default: depending on individual properties
  whiteList['transition-delay'] = false; // default: 0s
  whiteList['transition-duration'] = false; // default: 0s
  whiteList['transition-property'] = false; // default: all
  whiteList['transition-timing-function'] = false; // default: ease
  whiteList['unicode-bidi'] = false; // default: normal
  whiteList['vertical-align'] = false; // default: baseline
  whiteList['visibility'] = false; // default: visible
  whiteList['voice-balance'] = false; // default: center
  whiteList['voice-duration'] = false; // default: auto
  whiteList['voice-family'] = false; // default: implementation dependent
  whiteList['voice-pitch'] = false; // default: medium
  whiteList['voice-range'] = false; // default: medium
  whiteList['voice-rate'] = false; // default: normal
  whiteList['voice-stress'] = false; // default: normal
  whiteList['voice-volume'] = false; // default: medium
  whiteList['volume'] = false; // default: medium
  whiteList['white-space'] = false; // default: normal
  whiteList['widows'] = false; // default: 2
  whiteList['width'] = true; // default: auto
  whiteList['will-change'] = false; // default: auto
  whiteList['word-break'] = true; // default: normal
  whiteList['word-spacing'] = true; // default: normal
  whiteList['word-wrap'] = true; // default: normal
  whiteList['wrap-flow'] = false; // default: auto
  whiteList['wrap-through'] = false; // default: wrap
  whiteList['writing-mode'] = false; // default: horizontal-tb
  whiteList['z-index'] = false; // default: auto

  return whiteList;
}


/**
 * 匹配到白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onAttr (name, value, options) {
  // do nothing
}

/**
 * 匹配到不在白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onIgnoreAttr (name, value, options) {
  // do nothing
}

var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;

/**
 * 过滤属性值
 *
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function safeAttrValue(name, value) {
  if (REGEXP_URL_JAVASCRIPT.test(value)) return '';
  return value;
}


var whiteList = getDefaultWhiteList();
var getDefaultWhiteList_1 = getDefaultWhiteList;
var onAttr_1 = onAttr;
var onIgnoreAttr_1 = onIgnoreAttr;
var safeAttrValue_1 = safeAttrValue;

var _default = {
	whiteList: whiteList,
	getDefaultWhiteList: getDefaultWhiteList_1,
	onAttr: onAttr_1,
	onIgnoreAttr: onIgnoreAttr_1,
	safeAttrValue: safeAttrValue_1
};

var util$1 = {
  indexOf: function (arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function (arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function (str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, '');
  },
  trimRight: function (str) {
    if (String.prototype.trimRight) {
      return str.trimRight();
    }
    return str.replace(/(\s*$)/g, '');
  }
};

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */




/**
 * 解析style
 *
 * @param {String} css
 * @param {Function} onAttr 处理属性的函数
 *   参数格式： function (sourcePosition, position, name, value, source)
 * @return {String}
 */
function parseStyle (css, onAttr) {
  css = util$1.trimRight(css);
  if (css[css.length - 1] !== ';') css += ';';
  var cssLength = css.length;
  var isParenthesisOpen = false;
  var lastPos = 0;
  var i = 0;
  var retCSS = '';

  function addNewAttr () {
    // 如果没有正常的闭合圆括号，则直接忽略当前属性
    if (!isParenthesisOpen) {
      var source = util$1.trim(css.slice(lastPos, i));
      var j = source.indexOf(':');
      if (j !== -1) {
        var name = util$1.trim(source.slice(0, j));
        var value = util$1.trim(source.slice(j + 1));
        // 必须有属性名称
        if (name) {
          var ret = onAttr(lastPos, retCSS.length, name, value, source);
          if (ret) retCSS += ret + '; ';
        }
      }
    }
    lastPos = i + 1;
  }

  for (; i < cssLength; i++) {
    var c = css[i];
    if (c === '/' && css[i + 1] === '*') {
      // 备注开始
      var j = css.indexOf('*/', i + 2);
      // 如果没有正常的备注结束，则后面的部分全部跳过
      if (j === -1) break;
      // 直接将当前位置调到备注结尾，并且初始化状态
      i = j + 1;
      lastPos = i + 1;
      isParenthesisOpen = false;
    } else if (c === '(') {
      isParenthesisOpen = true;
    } else if (c === ')') {
      isParenthesisOpen = false;
    } else if (c === ';') {
      if (isParenthesisOpen) ; else {
        addNewAttr();
      }
    } else if (c === '\n') {
      addNewAttr();
    }
  }

  return util$1.trim(retCSS);
}

var parser = parseStyle;

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */






/**
 * 返回值是否为空
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull (obj) {
  return (obj === undefined || obj === null);
}

/**
 * 浅拷贝对象
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject (obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

/**
 * 创建CSS过滤器
 *
 * @param {Object} options
 *   - {Object} whiteList
 *   - {Function} onAttr
 *   - {Function} onIgnoreAttr
 *   - {Function} safeAttrValue
 */
function FilterCSS (options) {
  options = shallowCopyObject(options || {});
  options.whiteList = options.whiteList || _default.whiteList;
  options.onAttr = options.onAttr || _default.onAttr;
  options.onIgnoreAttr = options.onIgnoreAttr || _default.onIgnoreAttr;
  options.safeAttrValue = options.safeAttrValue || _default.safeAttrValue;
  this.options = options;
}

FilterCSS.prototype.process = function (css) {
  // 兼容各种奇葩输入
  css = css || '';
  css = css.toString();
  if (!css) return '';

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onAttr = options.onAttr;
  var onIgnoreAttr = options.onIgnoreAttr;
  var safeAttrValue = options.safeAttrValue;

  var retCSS = parser(css, function (sourcePosition, position, name, value, source) {

    var check = whiteList[name];
    var isWhite = false;
    if (check === true) isWhite = check;
    else if (typeof check === 'function') isWhite = check(value);
    else if (check instanceof RegExp) isWhite = check.test(value);
    if (isWhite !== true) isWhite = false;

    // 如果过滤后 value 为空则直接忽略
    value = safeAttrValue(name, value);
    if (!value) return;

    var opts = {
      position: position,
      sourcePosition: sourcePosition,
      source: source,
      isWhite: isWhite
    };

    if (isWhite) {

      var ret = onAttr(name, value, opts);
      if (isNull(ret)) {
        return name + ':' + value;
      } else {
        return ret;
      }

    } else {

      var ret = onIgnoreAttr(name, value, opts);
      if (!isNull(ret)) {
        return ret;
      }

    }
  });

  return retCSS;
};


var css$r = FilterCSS;

var lib$1 = createCommonjsModule(function (module, exports) {
/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */





/**
 * XSS过滤
 *
 * @param {String} css 要过滤的CSS代码
 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
 * @return {String}
 */
function filterCSS (html, options) {
  var xss = new css$r(options);
  return xss.process(html);
}


// 输出
exports = module.exports = filterCSS;
exports.FilterCSS = css$r;
for (var i in _default) exports[i] = _default[i];

// 在浏览器端使用
if (typeof window !== 'undefined') {
  window.filterCSS = module.exports;
}
});
var lib_1 = lib$1.FilterCSS;

var util$2 = {
  indexOf: function (arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function (arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function (str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function (str) {
    var reg = /\s|\n|\t/;
    var match = reg.exec(str);
    return match ? match.index : -1;
  },
};

/**
 * default settings
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS$1 = lib$1.FilterCSS;
var getDefaultCSSWhiteList = lib$1.getDefaultWhiteList;


function getDefaultWhiteList$1() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "preload",
      "src",
    ],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    figcaption: [],
    figure: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height"],
    ins: ["datetime"],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    summary: [],
    sup: [],
    strong: [],
    strike: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "playsinline",
      "poster",
      "preload",
      "src",
      "height",
      "width",
    ],
  };
}

var defaultCSSFilter = new FilterCSS$1();

/**
 * default onTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onTag(tag, html, options) {
  // do nothing
}

/**
 * default onIgnoreTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onIgnoreTag(tag, html, options) {
  // do nothing
}

/**
 * default onTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default onIgnoreTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onIgnoreTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default escapeHtml function
 *
 * @param {String} html
 */
function escapeHtml(html) {
  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
}

/**
 * default safeAttrValue function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @param {Object} cssFilter
 * @return {String}
 */
function safeAttrValue$1(tag, name, value, cssFilter) {
  // unescape attribute value firstly
  value = friendlyAttrValue(value);

  if (name === "href" || name === "src") {
    // filter `href` and `src` attribute
    // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
    value = util$2.trim(value);
    if (value === "#") return "#";
    if (
      !(
        value.substr(0, 7) === "http://" ||
        value.substr(0, 8) === "https://" ||
        value.substr(0, 7) === "mailto:" ||
        value.substr(0, 4) === "tel:" ||
        value.substr(0, 11) === "data:image/" ||
        value.substr(0, 6) === "ftp://" ||
        value.substr(0, 2) === "./" ||
        value.substr(0, 3) === "../" ||
        value[0] === "#" ||
        value[0] === "/"
      )
    ) {
      return "";
    }
  } else if (name === "background") {
    // filter `background` attribute (maybe no use)
    // `javascript:`
    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
      return "";
    }
  } else if (name === "style") {
    // `expression()`
    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
      return "";
    }
    // `url()`
    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
        return "";
      }
    }
    if (cssFilter !== false) {
      cssFilter = cssFilter || defaultCSSFilter;
      value = cssFilter.process(value);
    }
  }

  // escape `<>"` before returns
  value = escapeAttrValue(value);
  return value;
}

// RegExp list
var REGEXP_LT = /</g;
var REGEXP_GT = />/g;
var REGEXP_QUOTE = /"/g;
var REGEXP_QUOTE_2 = /&quot;/g;
var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
// var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
var REGEXP_DEFAULT_ON_TAG_ATTR_4 =
  /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_7 =
  /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;

/**
 * escape double quote
 *
 * @param {String} str
 * @return {String} str
 */
function escapeQuote(str) {
  return str.replace(REGEXP_QUOTE, "&quot;");
}

/**
 * unescape double quote
 *
 * @param {String} str
 * @return {String} str
 */
function unescapeQuote(str) {
  return str.replace(REGEXP_QUOTE_2, '"');
}

/**
 * escape html entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeHtmlEntities(str) {
  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
    return code[0] === "x" || code[0] === "X"
      ? String.fromCharCode(parseInt(code.substr(1), 16))
      : String.fromCharCode(parseInt(code, 10));
  });
}

/**
 * escape html5 new danger entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeDangerHtml5Entities(str) {
  return str
    .replace(REGEXP_ATTR_VALUE_COLON, ":")
    .replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
}

/**
 * clear nonprintable characters
 *
 * @param {String} str
 * @return {String}
 */
function clearNonPrintableCharacter(str) {
  var str2 = "";
  for (var i = 0, len = str.length; i < len; i++) {
    str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
  }
  return util$2.trim(str2);
}

/**
 * get friendly attribute value
 *
 * @param {String} str
 * @return {String}
 */
function friendlyAttrValue(str) {
  str = unescapeQuote(str);
  str = escapeHtmlEntities(str);
  str = escapeDangerHtml5Entities(str);
  str = clearNonPrintableCharacter(str);
  return str;
}

/**
 * unescape attribute value
 *
 * @param {String} str
 * @return {String}
 */
function escapeAttrValue(str) {
  str = escapeQuote(str);
  str = escapeHtml(str);
  return str;
}

/**
 * `onIgnoreTag` function for removing all the tags that are not in whitelist
 */
function onIgnoreTagStripAll() {
  return "";
}

/**
 * remove tag body
 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
 *
 * @param {array} tags
 * @param {function} next
 */
function StripTagBody(tags, next) {
  if (typeof next !== "function") {
    next = function () {};
  }

  var isRemoveAllTag = !Array.isArray(tags);
  function isRemoveTag(tag) {
    if (isRemoveAllTag) return true;
    return util$2.indexOf(tags, tag) !== -1;
  }

  var removeList = [];
  var posStart = false;

  return {
    onIgnoreTag: function (tag, html, options) {
      if (isRemoveTag(tag)) {
        if (options.isClosing) {
          var ret = "[/removed]";
          var end = options.position + ret.length;
          removeList.push([
            posStart !== false ? posStart : options.position,
            end,
          ]);
          posStart = false;
          return ret;
        } else {
          if (!posStart) {
            posStart = options.position;
          }
          return "[removed]";
        }
      } else {
        return next(tag, html, options);
      }
    },
    remove: function (html) {
      var rethtml = "";
      var lastPos = 0;
      util$2.forEach(removeList, function (pos) {
        rethtml += html.slice(lastPos, pos[0]);
        lastPos = pos[1];
      });
      rethtml += html.slice(lastPos);
      return rethtml;
    },
  };
}

/**
 * remove html comments
 *
 * @param {String} html
 * @return {String}
 */
function stripCommentTag(html) {
  var retHtml = "";
  var lastPos = 0;
  while (lastPos < html.length) {
    var i = html.indexOf("<!--", lastPos);
    if (i === -1) {
      retHtml += html.slice(lastPos);
      break;
    }
    retHtml += html.slice(lastPos, i);
    var j = html.indexOf("-->", i);
    if (j === -1) {
      break;
    }
    lastPos = j + 3;
  }
  return retHtml;
}

/**
 * remove invisible characters
 *
 * @param {String} html
 * @return {String}
 */
function stripBlankChar(html) {
  var chars = html.split("");
  chars = chars.filter(function (char) {
    var c = char.charCodeAt(0);
    if (c === 127) return false;
    if (c <= 31) {
      if (c === 10 || c === 13) return true;
      return false;
    }
    return true;
  });
  return chars.join("");
}

var whiteList$1 = getDefaultWhiteList$1();
var getDefaultWhiteList_1$1 = getDefaultWhiteList$1;
var onTag_1 = onTag;
var onIgnoreTag_1 = onIgnoreTag;
var onTagAttr_1 = onTagAttr;
var onIgnoreTagAttr_1 = onIgnoreTagAttr;
var safeAttrValue_1$1 = safeAttrValue$1;
var escapeHtml_1 = escapeHtml;
var escapeQuote_1 = escapeQuote;
var unescapeQuote_1 = unescapeQuote;
var escapeHtmlEntities_1 = escapeHtmlEntities;
var escapeDangerHtml5Entities_1 = escapeDangerHtml5Entities;
var clearNonPrintableCharacter_1 = clearNonPrintableCharacter;
var friendlyAttrValue_1 = friendlyAttrValue;
var escapeAttrValue_1 = escapeAttrValue;
var onIgnoreTagStripAll_1 = onIgnoreTagStripAll;
var StripTagBody_1 = StripTagBody;
var stripCommentTag_1 = stripCommentTag;
var stripBlankChar_1 = stripBlankChar;
var cssFilter = defaultCSSFilter;
var getDefaultCSSWhiteList_1 = getDefaultCSSWhiteList;

var _default$1 = {
	whiteList: whiteList$1,
	getDefaultWhiteList: getDefaultWhiteList_1$1,
	onTag: onTag_1,
	onIgnoreTag: onIgnoreTag_1,
	onTagAttr: onTagAttr_1,
	onIgnoreTagAttr: onIgnoreTagAttr_1,
	safeAttrValue: safeAttrValue_1$1,
	escapeHtml: escapeHtml_1,
	escapeQuote: escapeQuote_1,
	unescapeQuote: unescapeQuote_1,
	escapeHtmlEntities: escapeHtmlEntities_1,
	escapeDangerHtml5Entities: escapeDangerHtml5Entities_1,
	clearNonPrintableCharacter: clearNonPrintableCharacter_1,
	friendlyAttrValue: friendlyAttrValue_1,
	escapeAttrValue: escapeAttrValue_1,
	onIgnoreTagStripAll: onIgnoreTagStripAll_1,
	StripTagBody: StripTagBody_1,
	stripCommentTag: stripCommentTag_1,
	stripBlankChar: stripBlankChar_1,
	cssFilter: cssFilter,
	getDefaultCSSWhiteList: getDefaultCSSWhiteList_1
};

/**
 * Simple HTML Parser
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */



/**
 * get tag name
 *
 * @param {String} html e.g. '<a hef="#">'
 * @return {String}
 */
function getTagName(html) {
  var i = util$2.spaceIndex(html);
  var tagName;
  if (i === -1) {
    tagName = html.slice(1, -1);
  } else {
    tagName = html.slice(1, i + 1);
  }
  tagName = util$2.trim(tagName).toLowerCase();
  if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
  if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
  return tagName;
}

/**
 * is close tag?
 *
 * @param {String} html 如：'<a hef="#">'
 * @return {Boolean}
 */
function isClosing(html) {
  return html.slice(0, 2) === "</";
}

/**
 * parse input html and returns processed html
 *
 * @param {String} html
 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
 * @param {Function} escapeHtml
 * @return {String}
 */
function parseTag(html, onTag, escapeHtml) {

  var rethtml = "";
  var lastPos = 0;
  var tagStart = false;
  var quoteStart = false;
  var currentPos = 0;
  var len = html.length;
  var currentTagName = "";
  var currentHtml = "";

  chariterator: for (currentPos = 0; currentPos < len; currentPos++) {
    var c = html.charAt(currentPos);
    if (tagStart === false) {
      if (c === "<") {
        tagStart = currentPos;
        continue;
      }
    } else {
      if (quoteStart === false) {
        if (c === "<") {
          rethtml += escapeHtml(html.slice(lastPos, currentPos));
          tagStart = currentPos;
          lastPos = currentPos;
          continue;
        }
        if (c === ">" || currentPos === len - 1) {
          rethtml += escapeHtml(html.slice(lastPos, tagStart));
          currentHtml = html.slice(tagStart, currentPos + 1);
          currentTagName = getTagName(currentHtml);
          rethtml += onTag(
            tagStart,
            rethtml.length,
            currentTagName,
            currentHtml,
            isClosing(currentHtml)
          );
          lastPos = currentPos + 1;
          tagStart = false;
          continue;
        }
        if (c === '"' || c === "'") {
          var i = 1;
          var ic = html.charAt(currentPos - i);

          while (ic.trim() === "" || ic === "=") {
            if (ic === "=") {
              quoteStart = c;
              continue chariterator;
            }
            ic = html.charAt(currentPos - ++i);
          }
        }
      } else {
        if (c === quoteStart) {
          quoteStart = false;
          continue;
        }
      }
    }
  }
  if (lastPos < len) {
    rethtml += escapeHtml(html.substr(lastPos));
  }

  return rethtml;
}

var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9\\_:.-]/gim;

/**
 * parse input attributes and returns processed attributes
 *
 * @param {String} html e.g. `href="#" target="_blank"`
 * @param {Function} onAttr e.g. `function (name, value)`
 * @return {String}
 */
function parseAttr(html, onAttr) {

  var lastPos = 0;
  var lastMarkPos = 0;
  var retAttrs = [];
  var tmpName = false;
  var len = html.length;

  function addAttr(name, value) {
    name = util$2.trim(name);
    name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
    if (name.length < 1) return;
    var ret = onAttr(name, value || "");
    if (ret) retAttrs.push(ret);
  }

  // 逐个分析字符
  for (var i = 0; i < len; i++) {
    var c = html.charAt(i);
    var v, j;
    if (tmpName === false && c === "=") {
      tmpName = html.slice(lastPos, i);
      lastPos = i + 1;
      lastMarkPos = html.charAt(lastPos) === '"' || html.charAt(lastPos) === "'" ? lastPos : findNextQuotationMark(html, i + 1);
      continue;
    }
    if (tmpName !== false) {
      if (
        i === lastMarkPos
      ) {
        j = html.indexOf(c, i + 1);
        if (j === -1) {
          break;
        } else {
          v = util$2.trim(html.slice(lastMarkPos + 1, j));
          addAttr(tmpName, v);
          tmpName = false;
          i = j;
          lastPos = i + 1;
          continue;
        }
      }
    }
    if (/\s|\n|\t/.test(c)) {
      html = html.replace(/\s|\n|\t/g, " ");
      if (tmpName === false) {
        j = findNextEqual(html, i);
        if (j === -1) {
          v = util$2.trim(html.slice(lastPos, i));
          addAttr(v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          i = j - 1;
          continue;
        }
      } else {
        j = findBeforeEqual(html, i - 1);
        if (j === -1) {
          v = util$2.trim(html.slice(lastPos, i));
          v = stripQuoteWrap(v);
          addAttr(tmpName, v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          continue;
        }
      }
    }
  }

  if (lastPos < html.length) {
    if (tmpName === false) {
      addAttr(html.slice(lastPos));
    } else {
      addAttr(tmpName, stripQuoteWrap(util$2.trim(html.slice(lastPos))));
    }
  }

  return util$2.trim(retAttrs.join(" "));
}

function findNextEqual(str, i) {
  for (; i < str.length; i++) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function findNextQuotationMark(str, i) {
  for (; i < str.length; i++) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "'" || c === '"') return i;
    return -1;
  }
}

function findBeforeEqual(str, i) {
  for (; i > 0; i--) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function isQuoteWrapString(text) {
  if (
    (text[0] === '"' && text[text.length - 1] === '"') ||
    (text[0] === "'" && text[text.length - 1] === "'")
  ) {
    return true;
  } else {
    return false;
  }
}

function stripQuoteWrap(text) {
  if (isQuoteWrapString(text)) {
    return text.substr(1, text.length - 2);
  } else {
    return text;
  }
}

var parseTag_1 = parseTag;
var parseAttr_1 = parseAttr;

var parser$1 = {
	parseTag: parseTag_1,
	parseAttr: parseAttr_1
};

/**
 * filter xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS$2 = lib$1.FilterCSS;


var parseTag$1 = parser$1.parseTag;
var parseAttr$1 = parser$1.parseAttr;


/**
 * returns `true` if the input value is `undefined` or `null`
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull$1(obj) {
  return obj === undefined || obj === null;
}

/**
 * get attributes for a tag
 *
 * @param {String} html
 * @return {Object}
 *   - {String} html
 *   - {Boolean} closing
 */
function getAttrs(html) {
  var i = util$2.spaceIndex(html);
  if (i === -1) {
    return {
      html: "",
      closing: html[html.length - 2] === "/",
    };
  }
  html = util$2.trim(html.slice(i + 1, -1));
  var isClosing = html[html.length - 1] === "/";
  if (isClosing) html = util$2.trim(html.slice(0, -1));
  return {
    html: html,
    closing: isClosing,
  };
}

/**
 * shallow copy
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject$1(obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

function keysToLowerCase(obj) {
  var ret = {};
  for (var i in obj) {
    if (Array.isArray(obj[i])) {
      ret[i.toLowerCase()] = obj[i].map(function (item) {
        return item.toLowerCase();
      });
    } else {
      ret[i.toLowerCase()] = obj[i];
    }
  }
  return ret;
}

/**
 * FilterXSS class
 *
 * @param {Object} options
 *        whiteList (or allowList), onTag, onTagAttr, onIgnoreTag,
 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
 */
function FilterXSS(options) {
  options = shallowCopyObject$1(options || {});

  if (options.stripIgnoreTag) {
    if (options.onIgnoreTag) {
      console.error(
        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
      );
    }
    options.onIgnoreTag = _default$1.onIgnoreTagStripAll;
  }
  if (options.whiteList || options.allowList) {
    options.whiteList = keysToLowerCase(options.whiteList || options.allowList);
  } else {
    options.whiteList = _default$1.whiteList;
  }

  options.onTag = options.onTag || _default$1.onTag;
  options.onTagAttr = options.onTagAttr || _default$1.onTagAttr;
  options.onIgnoreTag = options.onIgnoreTag || _default$1.onIgnoreTag;
  options.onIgnoreTagAttr = options.onIgnoreTagAttr || _default$1.onIgnoreTagAttr;
  options.safeAttrValue = options.safeAttrValue || _default$1.safeAttrValue;
  options.escapeHtml = options.escapeHtml || _default$1.escapeHtml;
  this.options = options;

  if (options.css === false) {
    this.cssFilter = false;
  } else {
    options.css = options.css || {};
    this.cssFilter = new FilterCSS$2(options.css);
  }
}

/**
 * start process and returns result
 *
 * @param {String} html
 * @return {String}
 */
FilterXSS.prototype.process = function (html) {
  // compatible with the input
  html = html || "";
  html = html.toString();
  if (!html) return "";

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onTag = options.onTag;
  var onIgnoreTag = options.onIgnoreTag;
  var onTagAttr = options.onTagAttr;
  var onIgnoreTagAttr = options.onIgnoreTagAttr;
  var safeAttrValue = options.safeAttrValue;
  var escapeHtml = options.escapeHtml;
  var cssFilter = me.cssFilter;

  // remove invisible characters
  if (options.stripBlankChar) {
    html = _default$1.stripBlankChar(html);
  }

  // remove html comments
  if (!options.allowCommentTag) {
    html = _default$1.stripCommentTag(html);
  }

  // if enable stripIgnoreTagBody
  var stripIgnoreTagBody = false;
  if (options.stripIgnoreTagBody) {
    stripIgnoreTagBody = _default$1.StripTagBody(
      options.stripIgnoreTagBody,
      onIgnoreTag
    );
    onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
  }

  var retHtml = parseTag$1(
    html,
    function (sourcePosition, position, tag, html, isClosing) {
      var info = {
        sourcePosition: sourcePosition,
        position: position,
        isClosing: isClosing,
        isWhite: Object.prototype.hasOwnProperty.call(whiteList, tag),
      };

      // call `onTag()`
      var ret = onTag(tag, html, info);
      if (!isNull$1(ret)) return ret;

      if (info.isWhite) {
        if (info.isClosing) {
          return "</" + tag + ">";
        }

        var attrs = getAttrs(html);
        var whiteAttrList = whiteList[tag];
        var attrsHtml = parseAttr$1(attrs.html, function (name, value) {
          // call `onTagAttr()`
          var isWhiteAttr = util$2.indexOf(whiteAttrList, name) !== -1;
          var ret = onTagAttr(tag, name, value, isWhiteAttr);
          if (!isNull$1(ret)) return ret;

          if (isWhiteAttr) {
            // call `safeAttrValue()`
            value = safeAttrValue(tag, name, value, cssFilter);
            if (value) {
              return name + '="' + value + '"';
            } else {
              return name;
            }
          } else {
            // call `onIgnoreTagAttr()`
            ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
            if (!isNull$1(ret)) return ret;
            return;
          }
        });

        // build new tag html
        html = "<" + tag;
        if (attrsHtml) html += " " + attrsHtml;
        if (attrs.closing) html += " /";
        html += ">";
        return html;
      } else {
        // call `onIgnoreTag()`
        ret = onIgnoreTag(tag, html, info);
        if (!isNull$1(ret)) return ret;
        return escapeHtml(html);
      }
    },
    escapeHtml
  );

  // if enable stripIgnoreTagBody
  if (stripIgnoreTagBody) {
    retHtml = stripIgnoreTagBody.remove(retHtml);
  }

  return retHtml;
};

var xss = FilterXSS;

var lib$2 = createCommonjsModule(function (module, exports) {
/**
 * xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */





/**
 * filter xss function
 *
 * @param {String} html
 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
 * @return {String}
 */
function filterXSS(html, options) {
  var xss$1 = new xss(options);
  return xss$1.process(html);
}

exports = module.exports = filterXSS;
exports.filterXSS = filterXSS;
exports.FilterXSS = xss;

(function () {
  for (var i in _default$1) {
    exports[i] = _default$1[i];
  }
  for (var j in parser$1) {
    exports[j] = parser$1[j];
  }
})();

// using `xss` on the browser, output `filterXSS` to the globals
if (typeof window !== "undefined") {
  window.filterXSS = module.exports;
}

// using `xss` on the WebWorker, output `filterXSS` to the globals
function isWorkerEnv() {
  return (
    typeof self !== "undefined" &&
    typeof DedicatedWorkerGlobalScope !== "undefined" &&
    self instanceof DedicatedWorkerGlobalScope
  );
}
if (isWorkerEnv()) {
  self.filterXSS = module.exports;
}
});
var lib_1$1 = lib$2.filterXSS;
var lib_2 = lib$2.FilterXSS;

var defaultXssFilteringOptions = {
    whiteList: {
        a: ["target", "href", "title", "data-link-type", "aria-label"],
        abbr: ["title"],
        address: [],
        area: ["shape", "coords", "href", "alt"],
        article: [],
        aside: [],
        audio: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "preload",
            "src",
        ],
        b: [],
        bdi: ["dir"],
        bdo: ["dir"],
        big: [],
        blockquote: ["cite"],
        br: [],
        caption: [],
        center: [],
        cite: [],
        code: [],
        col: ["align", "valign", "span", "width"],
        colgroup: ["align", "valign", "span", "width"],
        dd: [],
        del: ["datetime"],
        details: ["open"],
        div: [],
        dl: [],
        dt: [],
        em: [],
        figcaption: [],
        figure: [],
        font: ["color", "size", "face"],
        footer: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        header: [],
        hr: [],
        i: [],
        img: ["src", "alt", "title", "width", "height", "loading"],
        ins: ["datetime"],
        li: [],
        mark: [],
        nav: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        section: [],
        small: [],
        span: [],
        sub: [],
        summary: [],
        sup: [],
        strong: [],
        strike: [],
        table: ["width", "border", "align", "valign"],
        tbody: ["align", "valign"],
        td: ["width", "rowspan", "colspan", "align", "valign"],
        tfoot: ["align", "valign"],
        th: ["width", "rowspan", "colspan", "align", "valign"],
        thead: ["align", "valign"],
        tr: ["rowspan", "align", "valign"],
        tt: [],
        u: [],
        ul: [],
        video: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "playsinline",
            "poster",
            "preload",
            "src",
            "height",
            "width",
        ],
    }
};

/**
 * Safely escapes HTML and displays it inside a customizable div element.
 * Can be styled by adding css classes divided by space as a string in the
 * cssClassNames prop
 * @param props
 * @constructor
 */
var SafeEscapedHTML = function (props) {
    var _a;
    var htmlString = props.htmlString, _b = props.filteringOptions, filteringOptions = _b === void 0 ? defaultXssFilteringOptions : _b, htmlTag = props.htmlTag, cssClassNames = props.cssClassNames;
    var safeHTML = lib_1$1(htmlString, filteringOptions);
    switch (htmlTag) {
        case 'p':
            return (React.createElement("p", { dangerouslySetInnerHTML: { __html: safeHTML }, className: cssClassNames !== null && cssClassNames !== void 0 ? cssClassNames : '' }));
        case 'span':
            return (React.createElement("span", { dangerouslySetInnerHTML: { __html: safeHTML }, className: cssClassNames !== null && cssClassNames !== void 0 ? cssClassNames : '' }));
        case 'h1':
            return (React.createElement("h1", { dangerouslySetInnerHTML: { __html: safeHTML }, className: cssClassNames !== null && cssClassNames !== void 0 ? cssClassNames : '' }));
        case 'h2':
            return (React.createElement("h2", { dangerouslySetInnerHTML: { __html: safeHTML }, className: cssClassNames !== null && cssClassNames !== void 0 ? cssClassNames : '' }));
        case 'h3':
            return (React.createElement("h3", { dangerouslySetInnerHTML: { __html: safeHTML }, className: cssClassNames !== null && cssClassNames !== void 0 ? cssClassNames : '' }));
        case 'h4':
            return (React.createElement("h4", { dangerouslySetInnerHTML: { __html: safeHTML }, className: cssClassNames !== null && cssClassNames !== void 0 ? cssClassNames : '' }));
        case 'h5':
            return (React.createElement("h5", { dangerouslySetInnerHTML: { __html: safeHTML }, className: cssClassNames !== null && cssClassNames !== void 0 ? cssClassNames : '' }));
        case 'h6':
            return (React.createElement("h6", { dangerouslySetInnerHTML: { __html: safeHTML }, className: cssClassNames !== null && cssClassNames !== void 0 ? cssClassNames : '' }));
        default:
            return (React.createElement("div", { dangerouslySetInnerHTML: { __html: safeHTML }, className: (_a = props.cssClassNames) !== null && _a !== void 0 ? _a : '' }));
    }
};

var css$s = ".arrow-up {\n  position: fixed;\n  bottom: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  right: 0;\n  width: 3.75rem;\n  height: 3.75rem;\n  background: #0f0900;\n  outline: none;\n  border: none;\n  z-index: 100;\n}\n.arrow-up:hover {\n  cursor: pointer;\n}";
n(css$s,{});

function ArrowUpSvg() {
    var handleClick = function () {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "arrow-up", onClick: handleClick },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40.704", height: "24", viewBox: "0 0 40.704 24" },
                React.createElement("path", { id: "icon_arrow_right_black", d: "M24,3.639,20.339,0,0,20.352,20.36,40.7,24,37.066,7.28,20.352Z", transform: "translate(40.704) rotate(90)", fill: "#fff" })))));
}

// import useStyles from './focusObject.jss';
function FocusObject() {
    // const classes = useStyles();
    return React.createElement("div", null);
}

var useStyles$E = makeStyles(function (theme) {
    return createStyles({
        container: {
            position: 'relative',
            width: '100%',
            margin: '0 auto',
            padding: '0 70px',
            paddingTop: '52px',
            overflow: 'hidden',
            // TODO: use Theme color
            backgroundColor: '#e8fffa',
        },
        title: theme.typography.h2,
    });
});

function FocusObjectModule(_a) {
    var title = _a.title, children = _a.children;
    var classes = useStyles$E();
    return (React.createElement("div", { className: classes.container },
        React.createElement("h2", { className: classes.title }, title),
        React.createElement("div", null, children)));
}

/* eslint-disable */
var ObjectContext = createContext({
    previewClicked: function () {
        console.log('previewClicked');
    },
    emailButtonPressed: function () {
        console.log('emailButtonPressed');
    },
    downloadButtonPressed: function () {
        console.log('downloadButtonPressed');
    },
    shareButtonPressed: function () {
        console.log('shareButtonPressed');
    },
    zoomButtonPressed: function () {
        console.log('zoomButtonPressed');
    },
    driveFileButtonPressed: function () {
        console.log('driveFileButtonPressed');
    },
});

var useStyles$F = makeStyles(function () {
    return createStyles({
        actionsContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
    });
});

function ObjectActions(_a) {
    var classNames = _a.classNames, showImageActions = _a.showImageActions;
    var classes = useStyles$F();
    var objectContextData = useContext(ObjectContext);
    var t = useTranslation().t;
    return (React.createElement("div", { className: clsx(classes.actionsContainer, classNames) },
        showImageActions && (React.createElement(IconButton, { "aria-label": t('download image'), "data-cy": 'object-actions-download', color: 'inherit', onClick: objectContextData.downloadButtonPressed },
            React.createElement(SaveAltOutlinedIcon, null))),
        showImageActions && (React.createElement(IconButton, { "aria-label": t('zoom in'), "data-cy": 'object-actions-zoom', color: 'inherit', onClick: objectContextData.zoomButtonPressed },
            React.createElement(ZoomInOutlinedIcon, null)))));
}

var useStyles$G = makeStyles(function () {
    return createStyles({
        spacingTop: {
            marginTop: 50,
        },
        accordionWrapper: {
            borderTop: 'solid 3px',
            borderBottom: 'solid 3px',
        },
    });
});

var useStyles$H = makeStyles(function (theme) {
    return createStyles({
        contrastText: {
            color: theme.palette.text.secondary,
        },
        spacingTop: {
            marginTop: 15,
        },
        accordionElement: {
            borderTop: 'solid 1px',
            borderColor: theme.palette.primary.main,
            boxShadow: 'none',
            '&:first-child': {
                borderRadius: 0,
                borderTop: 0,
            },
            '&:not(:last-child)': {
                borderBottom: 0,
            },
            '&:before': {
                display: 'none',
            },
        },
    });
});

function ObjectDescriptionAccordionRow(_a) {
    var title = _a.title, content = _a.content, _b = _a.initialExpandState, initialExpandState = _b === void 0 ? false : _b;
    var classes = useStyles$H();
    var _c = useState(initialExpandState), expanded = _c[0], setExpanded = _c[1];
    return (React.createElement(Accordion, { className: classes.accordionElement, expanded: expanded, onChange: function (_event, accordionExpanded) {
            setExpanded(accordionExpanded);
        } },
        React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, { fontSize: 'large' }) },
            React.createElement(Typography$1, { variant: 'h6', className: clsx(classes.contrastText) }, title)),
        React.createElement(AccordionDetails, { style: { display: 'inherit' } }, content.split('\n').map(function (line, index) { return (React.createElement(Typography$1, { key: index, variant: 'body1', className: clsx(classes.contrastText, classes.spacingTop) }, line.trim())); }))));
}

var useStyles$I = makeStyles(function (theme) {
    var _a;
    return createStyles({
        asideContainer: {
            '& > :nth-child(3)': (_a = {},
                _a[theme.breakpoints.down('md')] = {
                    marginBottom: 10,
                },
                _a),
        },
        spacer: {
            paddingBottom: 15,
        },
        txtBold: {
            fontWeight: 'bold',
            color: theme.palette.secondary.contrastText,
        },
        contrastText: {
            color: theme.palette.secondary.contrastText,
        },
        txtElement: {
            marginTop: 15,
        },
        outboundLinks: {
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
        },
    });
});

function ObjectDescriptionAside() {
    var _a, _b, _c, _d, _e, _f;
    var classes = useStyles$I();
    var t = useTranslation().t;
    var objectContextData = useContext(ObjectContext);
    var noDataAvailableText = t('object attribute fallback - no data available');
    var TypoBoldElement = function (_a) {
        var children = _a.children;
        return (React.createElement("span", { className: clsx(classes.txtBold, classes.txtElement) }, children));
    };
    var TypoElement = function (_a) {
        var title = _a.title, content = _a.content;
        return (React.createElement(Typography, { variant: 'body1', className: clsx(classes.contrastText) },
            React.createElement(TypoBoldElement, null, title + " "),
            content));
    };
    return (React.createElement("div", { className: classes.asideContainer },
        React.createElement("div", { className: clsx(classes.spacer) },
            React.createElement(TypoElement, { title: t('object attribute identNr'), content: ((_a = objectContextData.objectData) === null || _a === void 0 ? void 0 : _a.identNr) ? (_b = objectContextData.objectData) === null || _b === void 0 ? void 0 : _b.identNr : noDataAvailableText }),
            React.createElement(TypoElement, { title: t('object attribute collection'), content: ((_c = objectContextData.objectData) === null || _c === void 0 ? void 0 : _c.collection) ? (_d = objectContextData.objectData) === null || _d === void 0 ? void 0 : _d.collection : noDataAvailableText }),
            React.createElement(TypoElement, { title: t('object attribute location'), content: ((_e = objectContextData.objectData) === null || _e === void 0 ? void 0 : _e.location) ? (_f = objectContextData.objectData) === null || _f === void 0 ? void 0 : _f.location : noDataAvailableText })),
        objectContextData.asideTextContainerElements &&
            objectContextData.asideTextContainerElements.map(function (value, index) { return (React.createElement(TextContainer, { key: index, containerType: value.type, title: value.title, elements: value.elements })); })));
}

var useStyles$J = makeStyles(function (theme) {
    return createStyles({
        contrastText: {
            color: theme.palette.text.secondary,
        },
        boldText: {
            fontWeight: 'bold',
        },
        rowColored: {
            backgroundColor: '#e8e8e8',
        },
        cell: {
            padding: 12,
        },
    });
});

function ObjectDescriptionGridRow(_a) {
    var _b;
    var title = _a.title, content = _a.content, _c = _a.colored, colored = _c === void 0 ? true : _c;
    var classes = useStyles$J();
    return (React.createElement(Grid$1, { item: true, xs: 12, sm: 12, md: 12, className: clsx((_b = {}, _b[classes.rowColored] = colored, _b)) },
        React.createElement(Grid$1, { container: true },
            React.createElement(Grid$1, { item: true, xs: 12, sm: 4, md: 5, className: clsx(classes.cell) },
                React.createElement(Typography$1, { variant: 'h6', className: clsx(classes.boldText, classes.contrastText) }, title)),
            React.createElement(Grid$1, { item: true, xs: 12, sm: 8, md: 7, className: clsx(classes.cell) }, content.split('\n').map(function (line, index) { return (React.createElement(Typography$1, { key: index, className: clsx(classes.contrastText) }, line.trim())); })))));
}

function isEmpty(candidate) {
    if (!candidate)
        return true;
    return Array.isArray(candidate)
        ? candidate.length === 0
        : candidate.trim().length === 0;
}
function defaultIfEmpty(candidate, defaultValue) {
    if (isEmpty(candidate))
        return defaultValue;
    return Array.isArray(candidate) ? candidate.join('\n') : candidate;
}
function ObjectDescriptionGrid(_a) {
    var config = _a.config;
    var object = useContext(ObjectContext).objectData;
    var t = useTranslation().t;
    var noDataAvailableText = t('object attribute fallback - no data available');
    var colored = false;
    var renderRow = function (cfg) {
        // Disable ts here, it cannot handle dynamic properties syntax.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var value = object && object[cfg.key];
        if (cfg.visibility === Visibility.VISIBLE || !isEmpty(value)) {
            colored = !colored;
            return (React.createElement(ObjectDescriptionGridRow, { key: cfg.key, title: t("object attribute " + cfg.key), content: defaultIfEmpty(value, noDataAvailableText), colored: colored }));
        }
        return null;
    };
    return React.createElement(Grid$1, { container: true }, config.map(function (f) { return renderRow(f); }));
}

var useStyles$K = makeStyles(function (theme) {
    var _a;
    return createStyles({
        container: {
            maxWidth: 1280,
            padding: 30,
            margin: 'auto',
        },
        separator: {
            height: 3,
            backgroundColor: theme.palette.primary.main,
        },
        titleGrid: {
            paddingTop: 24,
        },
        contentGrid: {
            paddingTop: 24,
        },
        largeText: {
            lineHeight: 1.5,
        },
        objectActions: (_a = {},
            _a[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _a),
        contrastText: {
            color: theme.palette.text.secondary,
            textTransform: 'none',
        },
        boldText: {
            fontWeight: 'bold',
        },
    });
});

var Visibility;
(function (Visibility) {
    Visibility[Visibility["VISIBLE"] = 0] = "VISIBLE";
    Visibility[Visibility["VISIBLE_IF_AVAILABLE"] = 1] = "VISIBLE_IF_AVAILABLE";
})(Visibility || (Visibility = {}));
function filterUniqueValues() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values
        .filter(function (v) { return v !== ''; })
        .filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
}
function ObjectDescriptionModule(_a) {
    var _b, _c, _d, _e, _f;
    var gridConfig = _a.gridConfig, accordionConfig = _a.accordionConfig;
    var classes = useStyles$K();
    var objectContextData = useContext(ObjectContext);
    var title = (((_b = objectContextData.objectData) === null || _b === void 0 ? void 0 : _b.objectTitles) &&
        objectContextData.objectData.objectTitles[0]) ||
        '';
    var term = ((_c = objectContextData.objectData) === null || _c === void 0 ? void 0 : _c.technicalTerm) || '';
    var date = (((_d = objectContextData.objectData) === null || _d === void 0 ? void 0 : _d.dating) && ((_e = objectContextData.objectData) === null || _e === void 0 ? void 0 : _e.dating[0])) ||
        '';
    var mainTitles = filterUniqueValues(title, term, date);
    var renderTitles = function () {
        var _a;
        return mainTitles.length > 0
            ? mainTitles.map(function (mainTitle, index) { return (React.createElement(Typography$1, { key: index, variant: 'h3', className: clsx(classes.contrastText, classes.largeText, classes.boldText) }, mainTitle)); })
            : (_a = objectContextData.objectData) === null || _a === void 0 ? void 0 : _a.displayTitle;
    };
    return (React.createElement("div", { id: 'DescriptionModule', className: classes.container },
        React.createElement("div", { className: classes.separator }),
        React.createElement(Grid$1, { container: true, spacing: 0, direction: 'row', justifyContent: 'space-between', className: classes.titleGrid },
            React.createElement(Grid$1, { item: true, xs: 12, sm: 12, lg: 11, md: 10 }, renderTitles()),
            React.createElement(Grid$1, { item: true, xs: 12, sm: 12, lg: 1, md: 2 },
                React.createElement(ObjectActions, { showImageActions: ((_f = objectContextData === null || objectContextData === void 0 ? void 0 : objectContextData.objectData) === null || _f === void 0 ? void 0 : _f.hasPrimaryImage) || false, classNames: classes.objectActions }))),
        React.createElement(Grid$1, { container: true, spacing: 0, direction: 'row', justifyContent: 'space-between', className: classes.contentGrid },
            React.createElement(Grid$1, { item: true, xs: 12, sm: 12, md: 3 },
                React.createElement(ObjectDescriptionAside, null)),
            React.createElement(Grid$1, { item: true, xs: 12, sm: 12, md: 8 },
                React.createElement(ObjectDescriptionGrid, { config: gridConfig }),
                React.createElement(ObjectDescriptionAccordion, { config: accordionConfig })))));
}

function isEmpty$1(candidate) {
    if (!candidate)
        return true;
    return Array.isArray(candidate)
        ? candidate.length === 0
        : candidate.trim().length === 0;
}
function defaultIfEmpty$1(candidate, defaultValue) {
    if (isEmpty$1(candidate))
        return defaultValue;
    return Array.isArray(candidate) ? candidate.join('; ') : candidate;
}
function ObjectDescriptionAccordion(_a) {
    var config = _a.config;
    var classes = useStyles$G();
    var t = useTranslation().t;
    var object = useContext(ObjectContext).objectData;
    var noDataAvailableText = t('object desc no data available');
    var renderRow = function (cfg) {
        // Disable ts here, it cannot handle dynamic properties syntax.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var value = object && object[cfg.key];
        if (cfg.visibility === Visibility.VISIBLE || !isEmpty$1(value)) {
            return (React.createElement(ObjectDescriptionAccordionRow, { key: cfg.key, title: t("object attribute " + cfg.key), content: defaultIfEmpty$1(value, noDataAvailableText), initialExpandState: !isEmpty$1(value) }));
        }
        return null;
    };
    return (React.createElement("div", { className: clsx(classes.spacingTop, classes.accordionWrapper) }, config.map(function (f) { return renderRow(f); })));
}

var useStyles$L = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g;
    return createStyles({
        container: (_a = {
                maxWidth: 1280,
                padding: 30,
                margin: 'auto',
                display: 'flex',
                width: '100vw',
                flexWrap: 'wrap'
            },
            _a[theme.breakpoints.up('md')] = {
                justifyContent: 'flex-end',
            },
            _a),
        imgContainer: (_b = {
                width: '100%',
                height: '55vh'
            },
            _b[theme.breakpoints.up('md')] = {
                flex: 1,
            },
            _b),
        imgFrame: (_c = {
                width: '100%',
                height: '100%',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            },
            _c[theme.breakpoints.up('md')] = {
                flex: 1,
            },
            _c),
        imgPreviewContainer: (_d = {
                display: 'flex',
                overflowX: 'scroll'
            },
            _d[theme.breakpoints.up('md')] = {
                flexDirection: 'column',
                maxHeight: '45vh',
                maxWidth: 200,
                overflowX: 'hidden',
                overflowY: 'scroll',
                alignItems: 'flex-end',
            },
            _d),
        imgFlexWrapper: (_e = {
                display: 'flex',
                flexWrap: 'nowrap',
                flexDirection: 'row'
            },
            _e[theme.breakpoints.up('md')] = {
                flexDirection: 'column',
            },
            _e),
        imgPreview: {
            height: 86,
            width: 86,
            margin: 7,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            cursor: 'pointer',
            opacity: 0.7,
            '&:hover': {
                opacity: 1,
            },
        },
        imgAside: (_f = {
                display: 'flex',
                // 60px based on the 30px padding of parent
                maxWidth: 'calc(100vw - 60px)',
                flexDirection: 'column'
            },
            _f[theme.breakpoints.up('md')] = {
                maxHeight: '55vh',
                width: 200,
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
            },
            _f),
        pictureCredits: (_g = {
                color: theme.palette.secondary.contrastText
            },
            _g[theme.breakpoints.up('lg')] = {
                paddingTop: 10,
            },
            _g.textAlign = 'center',
            _g.width = '100%',
            _g.display = 'block',
            _g),
        license: {
            paddingLeft: '6px',
        },
    });
});

var hasMultipleAttachments = function (obj) {
    var _a;
    var attachments = (_a = obj === null || obj === void 0 ? void 0 : obj.objectData) === null || _a === void 0 ? void 0 : _a.attachments;
    return attachments && attachments.length > 1;
};
var previewStyle = function (image, cropped) {
    return {
        backgroundImage: "url(" + image + ")",
        backgroundSize: cropped ? 'cover' : 'contain',
    };
};
var previewSize = function (attachment) {
    // TODO use size from config
    return attachment.resize(86, 86);
};
function ObjectImageModule(_a) {
    var _b;
    var currentAttachment = _a.currentAttachment, _c = _a.cropped, cropped = _c === void 0 ? true : _c;
    var classes = useStyles$L();
    var t = useTranslation().t;
    var objectContextData = useContext(ObjectContext);
    if (!currentAttachment) {
        return (React.createElement("div", { className: classes.container, "data-testid": '' },
            React.createElement(LoadingSpinner, null)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.imgAside }),
            React.createElement("div", { className: classes.imgContainer },
                React.createElement("div", { className: classes.imgFrame, style: {
                        display: 'flex',
                        alignContent: 'center',
                        backgroundImage: "url(" + currentAttachment.src + ")",
                    } }),
                React.createElement("div", { style: {
                        alignSelf: 'flex-end',
                        alignContent: 'center',
                    } },
                    React.createElement(Typography$1, { variant: 'caption', className: clsx(classes.pictureCredits) },
                        t('details.attachment.pictureCredits'),
                        ":",
                        ' ',
                        currentAttachment.credits || 'Staatliche Museen zu Berlin',
                        currentAttachment.license && (React.createElement("a", { className: clsx(classes.license), href: currentAttachment.license.href, target: currentAttachment.license.target || '_blank' }, currentAttachment.license.text))))),
            React.createElement("div", { className: classes.imgAside }, hasMultipleAttachments(objectContextData) && (React.createElement("div", null,
                React.createElement("div", { className: classes.imgPreviewContainer },
                    React.createElement("div", { className: classes.imgFlexWrapper }, (_b = objectContextData.objectData.attachments) === null || _b === void 0 ? void 0 : _b.map(function (attachment, index) { return (React.createElement(build_2, { key: index },
                        React.createElement("div", { className: classes.imgPreview, key: index, style: previewStyle(previewSize(attachment), cropped), onClick: function () {
                                return objectContextData.previewClicked(attachment);
                            } }))); })))))))));
}

var FetchResearchModal = gql(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  query fetchResearchModal($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbResearchpage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            header\n            modalDialog {\n              downloadSection {\n                buttonText\n                header\n                id\n                text\n              }\n              webSection {\n                buttonLink\n                buttonText\n                header\n                id\n                text\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query fetchResearchModal($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbResearchpage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            header\n            modalDialog {\n              downloadSection {\n                buttonText\n                header\n                id\n                text\n              }\n              webSection {\n                buttonLink\n                buttonText\n                header\n                id\n                text\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
var FetchMaintenanceModal = gql(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  query FetchMaintenanceModal($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbResearchpage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            show_maintenance_popup,\n            maintenance_text,\n            maintenance_text_long\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query FetchMaintenanceModal($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbResearchpage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            show_maintenance_popup,\n            maintenance_text,\n            maintenance_text_long\n          }\n        }\n      }\n    }\n  }\n"])));
var ResearchRepository = /** @class */ (function () {
    function ResearchRepository() {
    }
    ResearchRepository.prototype.fetchResearchModal = function (lang) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var _o = useQuery(FetchResearchModal, {
            variables: {
                lang: lang,
            },
        }), loading = _o.loading, error = _o.error, data = _o.data;
        var resultData = null;
        var resultDataTitle = '';
        if (!loading &&
            data &&
            data.strapi_smb && ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.strapi_smb.smbResearchpage) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.modalDialog)) {
            resultData = (_f = (_e = (_d = data.strapi_smb.smbResearchpage) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f.modalDialog;
        }
        if (!loading &&
            data &&
            data.strapi_smb && ((_j = (_h = (_g = data.strapi_smb.smbResearchpage) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.attributes) === null || _j === void 0 ? void 0 : _j.header)) {
            resultDataTitle = (_m = (_l = (_k = data.strapi_smb.smbResearchpage) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.attributes) === null || _m === void 0 ? void 0 : _m.header;
        }
        return { loading: loading, error: error, data: resultData, title: resultDataTitle };
    };
    ResearchRepository.prototype.fetchMaintenanceModal = function (lang) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var _u = useQuery(FetchMaintenanceModal, {
            variables: {
                lang: lang,
            },
        }), loading = _u.loading, error = _u.error, data = _u.data;
        var resultData = {};
        if (!loading && data && data.strapi_smb) {
            if ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.strapi_smb.smbResearchpage) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.show_maintenance_popup) {
                resultData['showMaintenancePopup'] = (_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.strapi_smb.smbResearchpage) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f.show_maintenance_popup;
            }
            if ((_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.strapi_smb.smbResearchpage) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.attributes) === null || _j === void 0 ? void 0 : _j.maintenance_text) {
                resultData['maintenanceText'] = (_m = (_l = (_k = data === null || data === void 0 ? void 0 : data.strapi_smb.smbResearchpage) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.attributes) === null || _m === void 0 ? void 0 : _m.maintenance_text;
            }
            if ((_q = (_p = (_o = data === null || data === void 0 ? void 0 : data.strapi_smb.smbResearchpage) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.attributes) === null || _q === void 0 ? void 0 : _q.maintenance_text_long) {
                resultData['maintenanceTextLong'] = (_t = (_s = (_r = data === null || data === void 0 ? void 0 : data.strapi_smb.smbResearchpage) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.attributes) === null || _t === void 0 ? void 0 : _t.maintenance_text_long;
            }
        }
        return { loading: loading, error: error, data: resultData };
    };
    return ResearchRepository;
}());
var templateObject_1$2, templateObject_2$2;

/* eslint-disable no-console */
var ResearchService = /** @class */ (function () {
    function ResearchService() {
    }
    ResearchService.prototype.getResearchModalData = function () {
        var lang = LanguageService.getDefaultLanguage();
        var researchRepository = new ResearchRepository();
        var _a = researchRepository.fetchResearchModal(lang), loading = _a.loading, error = _a.error, data = _a.data, title = _a.title;
        var convertedSectionsData;
        if (!loading && data) {
            convertedSectionsData = this.convertModuleData(data, title);
        }
        return { loading: loading, error: error, data: convertedSectionsData };
    };
    ResearchService.prototype.getMaintenanceModalData = function () {
        var lang = LanguageService.getDefaultLanguage();
        var researchRepository = new ResearchRepository();
        var _a = researchRepository.fetchMaintenanceModal(lang), loading = _a.loading, error = _a.error, data = _a.data;
        var convertedSectionsData;
        if (!loading && data) {
            convertedSectionsData = data;
        }
        return { loading: loading, error: error, data: convertedSectionsData };
    };
    ResearchService.prototype.convertModuleData = function (items, title) {
        return {
            title: title,
            download: items.downloadSection ? items.downloadSection : null,
            web: (items === null || items === void 0 ? void 0 : items.webSection) ? items === null || items === void 0 ? void 0 : items.webSection : null,
        };
    };
    return ResearchService;
}());

var useStyles$M = makeStyles(function (theme) {
    var _a, _b;
    return createStyles({
        container: {
            backgroundColor: theme.palette.grey[300],
            padding: '0 !important',
        },
        contentWrapper: {
            display: 'flex',
            flexWrap: 'wrap',
            padding: '1.5rem !important',
        },
        innerContent: (_a = {
                display: 'flex',
                flexDirection: 'column'
            },
            _a[theme.breakpoints.up(960)] = {
                paddingRight: '1rem',
            },
            _a['& + &'] = (_b = {
                    marginTop: '1.5rem !important'
                },
                _b[theme.breakpoints.up(960)] = {
                    marginTop: '0 !important',
                    paddingLeft: '1rem',
                    borderLeft: 'solid 2px',
                    paddingRight: '0',
                },
                _b),
            _a),
        header: {
            display: 'flex',
            padding: '1.5rem',
        },
        title: {
            color: theme.palette.secondary.contrastText,
            textAlign: 'center',
            flex: '1',
        },
        closeButton: {
            padding: '0 !important',
            marginLeft: '.75rem',
        },
        sectionTitle: { textTransform: 'capitalize' },
        sectionRichText: {
            color: theme.palette.secondary.contrastText,
            padding: '1rem 0',
            minHeight: '4rem',
            fontFamily: 'ClanOTNarrow-News, Arial',
            height: '100%',
            '& p': {
                marginBottom: '.75rem',
            },
            '& b': {
                fontWeight: 'bold',
            },
            '& a': {
                color: theme.palette.secondary.contrastText,
                textDecoration: 'underline',
                fontWeight: 400,
                '&:hover': {
                    textDecoration: 'underline',
                },
                '& svg': {
                    marginLeft: '.25rem',
                },
            },
        },
        sectionButton: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '.5rem',
        },
        sectionButtonLink: {
            color: theme.palette.secondary.contrastText,
        },
    });
});

/* eslint-disable no-console */
var licenseCodePlaceholderText = '(licenseCode)';
var externalLinkIcon = "\n <svg className={classes.svg} xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 195 191\">\n  <g fill=\"#000\">\n   <path d=\"M185.818,0.161 L128.778,0.161 C123.807,0.161 119.778,4.19 119.778,9.161 C119.778,14.132 123.807,18.161 128.778,18.161 L164.09,18.161 L77.79,104.461 C74.275,107.976 74.275,113.674 77.79,117.189 C79.548,118.946 81.851,119.825 84.154,119.825 C86.457,119.825 88.76,118.946 90.518,117.189 L176.818,30.889 L176.818,66.202 C176.818,71.173 180.847,75.202 185.818,75.202 C190.789,75.202 194.818,71.173 194.818,66.202 L194.818,9.162 C194.818,4.19 190.789,0.161 185.818,0.161 Z\" />\n   <path d=\"M149,75.201 C144.029,75.201 140,79.23 140,84.201 L140,172.657 L18,172.657 L18,50.657 L111.778,50.657 C116.749,50.657 120.778,46.628 120.778,41.657 C120.778,36.686 116.749,32.657 111.778,32.657 L9,32.657 C4.029,32.657 0,36.686 0,41.657 L0,181.657 C0,186.628 4.029,190.657 9,190.657 L149,190.657 C153.971,190.657 158,186.628 158,181.657 L158,84.201 C158,79.23 153.971,75.201 149,75.201 Z\" />\n  </g>\n </svg>\n";
function ObjectImageDownloadDialog(_a) {
    var filename = _a.filename, isOpen = _a.isOpen, image = _a.image, license = _a.license, onClose = _a.onClose;
    var classes = useStyles$M();
    var researchService = new ResearchService();
    var _b = researchService.getResearchModalData(), loading = _b.loading, data = _b.data;
    var formatText = function (text) {
        var formattedText = (text || '')
            .replace(/<\/a>/g, externalLinkIcon + "</a>")
            .replace("" + licenseCodePlaceholderText, "<a href=\"" + license.href + "\" aria-label=\"Link zu: " + license.text + "\" target=\"" + (license.target || '_blank') + "\">" + license.text + externalLinkIcon + "</a>");
        return formattedText;
    };
    var getDialogVariant = function () {
        if ((data === null || data === void 0 ? void 0 : data.download) && (data === null || data === void 0 ? void 0 : data.web))
            return 'md';
        return 'xs';
    };
    var getDialogContentVariant = function () {
        if ((data === null || data === void 0 ? void 0 : data.download) && (data === null || data === void 0 ? void 0 : data.web))
            return 6;
        return 12;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { style: { zIndex: 1400 }, fullWidth: true, maxWidth: getDialogVariant(), open: isOpen, onClose: onClose }, !loading && data && (React.createElement(React.Fragment, null,
            React.createElement(DialogTitle, { className: classes.container, disableTypography: true },
                React.createElement("div", { className: classes.header },
                    React.createElement(Typography, { variant: 'h3', className: classes.title }, data.title),
                    React.createElement(IconButton$1, { "data-cy": "dialog-close", onClick: onClose, className: classes.closeButton },
                        React.createElement(CloseIcon, { fontSize: "large" })))),
            React.createElement(DialogContent, { className: classes.container },
                React.createElement("div", { className: classes.contentWrapper },
                    data.download && (React.createElement(Grid, { item: true, className: classes.innerContent, md: getDialogContentVariant() },
                        data.download.header && (React.createElement(Typography, { className: classes.sectionTitle, "xs-align": "left", "sm-align": "center", variant: "h4" }, data.download.header)),
                        data.download.text && (React.createElement(Typography, { className: classes.sectionRichText, component: 'div', variant: "body1", dangerouslySetInnerHTML: {
                                __html: "" + formatText(data.download.text),
                            } })),
                        data.download.buttonText && (React.createElement(Link, { href: image, className: classes.sectionButton, download: filename, target: '_blank', "data-cy": "download-dialog-download" },
                            React.createElement(Typography, { component: "div", variant: 'h4', className: classes.sectionButtonLink }, data.download.buttonText),
                            React.createElement(SaveAltOutlinedIcon, { fontSize: 'large' }))))),
                    data.web && (React.createElement(Grid, { item: true, className: classes.innerContent, md: getDialogContentVariant() },
                        data.web.header && (React.createElement(Typography, { className: classes.sectionTitle, "xs-align": "left", "sm-align": "center", variant: "h4" }, data.web.header)),
                        data.web.text && (React.createElement(Typography, { className: classes.sectionRichText, component: 'div', variant: "body1", dangerouslySetInnerHTML: {
                                __html: "" + formatText(data.web.text),
                            } })),
                        data.web.buttonLink && (React.createElement(Link, { href: data.web.buttonLink, className: classes.sectionButton, target: '_blank' },
                            React.createElement(Typography, { component: "div", variant: 'h4', className: classes.sectionButtonLink }, data.web.buttonText),
                            React.createElement(LanguageOutlined, { fontSize: 'large' }))))))))))));
}

function MaintenanceDialog() {
    var classes = useStyles$M();
    var researchService = new ResearchService();
    var _a = researchService.getMaintenanceModalData(), loading = _a.loading, data = _a.data;
    var _b = useState(true), isOpen = _b[0], setIsOpen = _b[1];
    var getDialogVariant = function () {
        if ((data === null || data === void 0 ? void 0 : data.showMaintenancePopup) && (data === null || data === void 0 ? void 0 : data.maintenanceText) && (data === null || data === void 0 ? void 0 : data.maintenanceTextLong))
            return 'md';
        return 'xs';
    };
    var getDialogContentVariant = function () {
        if ((data === null || data === void 0 ? void 0 : data.showMaintenancePopup) && (data === null || data === void 0 ? void 0 : data.maintenanceText) && (data === null || data === void 0 ? void 0 : data.maintenanceTextLong))
            return 6;
        return 12;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { style: { zIndex: 1400 }, fullWidth: true, maxWidth: getDialogVariant(), open: isOpen && !loading && data && (data === null || data === void 0 ? void 0 : data.showMaintenancePopup), onClose: function () { setIsOpen(false); } }, isOpen && !loading && data && (data === null || data === void 0 ? void 0 : data.showMaintenancePopup) && (React.createElement(React.Fragment, null,
            React.createElement(DialogTitle, { className: classes.container, disableTypography: true },
                React.createElement("div", { className: classes.header },
                    React.createElement(Typography, { variant: 'h3', className: classes.title }, data.maintenanceText),
                    React.createElement(IconButton$1, { "data-cy": "dialog-close", onClick: function () { setIsOpen(false); }, className: classes.closeButton },
                        React.createElement(CloseIcon, { fontSize: "large" })))),
            React.createElement(DialogContent, { className: classes.container },
                React.createElement("div", { className: classes.contentWrapper }, data.maintenanceTextLong && (React.createElement(Grid, { item: true, className: classes.innerContent, md: getDialogContentVariant() },
                    React.createElement(Typography, { className: classes.sectionRichText, component: 'div', variant: 'body1', dangerouslySetInnerHTML: {
                            __html: data.maintenanceTextLong
                        } }))))))))));
}

var HeaderPlatformType;
(function (HeaderPlatformType) {
    HeaderPlatformType["INTRO"] = "INTRO";
    HeaderPlatformType["RESEARCH"] = "RESEARCH";
    HeaderPlatformType["TOPIC"] = "TOPIC";
    HeaderPlatformType["GUIDE"] = "GUIDE";
})(HeaderPlatformType || (HeaderPlatformType = {}));

var DEFAULT_IMAGE_TYPESUFFIX = 'jpg';
var ImageUrlBuilderService = /** @class */ (function () {
    function ImageUrlBuilderService(_config) {
        this._config = _config;
    }
    ImageUrlBuilderService.prototype.createUrlFromTemplate = function (template, width, height) {
        var w = width.toString();
        var h = height.toString();
        return template.replace('{width}', w).replace('{height}', h);
    };
    ImageUrlBuilderService.prototype.createTemplateImageUrl = function (imageName) {
        var _a = this.splitImageIdAndType(imageName), baseName = _a[0], type = _a[1];
        return this._config.IMAGE_PROVIDER_ENDPOINT + "/" + baseName + "_{width}x{height}." + type;
    };
    ImageUrlBuilderService.prototype.splitImageIdAndType = function (filename, fallbackType) {
        if (fallbackType === void 0) { fallbackType = DEFAULT_IMAGE_TYPESUFFIX; }
        var parts = filename.split(/\.([^\\.]{3,})$/);
        // expect len=3 because there is an empty string at the end -> ['name', 'suffix', '']
        if (parts.length !== 3) {
            return [parts.join('.'), fallbackType];
        }
        return [parts[0], parts[1]];
    };
    ImageUrlBuilderService.prototype.buildUrl = function (filename, width, height) {
        var _a = this.splitImageIdAndType(filename), name = _a[0], type = _a[1];
        return new URL(this._config.IMAGE_PROVIDER_ENDPOINT + "/" + name + "_" + width + "x" + height + "." + type).toString();
    };
    return ImageUrlBuilderService;
}());

var FetchExhibitAttachments = gql$1(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  query FetchObjectAttachments($object_id: bigint!, $language: String) {\n    smb_objects_by_pk(id: $object_id) {\n      attachments(\n        order_by: [{ primary: desc }, { attachment: asc }]\n        limit: 10\n      ) {\n        id\n        attachment\n        name\n        primary\n        credits\n        license {\n          key\n          link\n          i18n(where: { language: { lang: { _eq: $language } } }) {\n            content\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query FetchObjectAttachments($object_id: bigint!, $language: String) {\n    smb_objects_by_pk(id: $object_id) {\n      attachments(\n        order_by: [{ primary: desc }, { attachment: asc }]\n        limit: 10\n      ) {\n        id\n        attachment\n        name\n        primary\n        credits\n        license {\n          key\n          link\n          i18n(where: { language: { lang: { _eq: $language } } }) {\n            content\n          }\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$3;

var AttachmentRepository = /** @class */ (function () {
    function AttachmentRepository() {
    }
    AttachmentRepository.prototype.fetchExhibitAttachments = function (id, lang) {
        var _a;
        var _b = useQuery(FetchExhibitAttachments, {
            variables: {
                object_id: id,
                language: lang,
            },
        }), loading = _b.loading, error = _b.error, data = _b.data;
        var attachments = ((_a = data === null || data === void 0 ? void 0 : data.smb_objects_by_pk) === null || _a === void 0 ? void 0 : _a.attachments) || (data === null || data === void 0 ? void 0 : data.smb_attachments);
        return { loading: loading, error: error, data: attachments !== null && attachments !== void 0 ? attachments : [] };
    };
    return AttachmentRepository;
}());

var AttachmentService = /** @class */ (function () {
    function AttachmentService(_config) {
        this._imageUrlBuilder = new ImageUrlBuilderService(_config);
        this._attachmentRepository = new AttachmentRepository();
    }
    AttachmentService.prototype.findOneByExhibitId = function (id) {
        var _a;
        var language = LanguageService$1.getCurrentLanguage();
        var _b = this._attachmentRepository.fetchExhibitAttachments(id, language), loading = _b.loading, error = _b.error, rawAttachments = _b.data;
        var attachments = (_a = rawAttachments === null || rawAttachments === void 0 ? void 0 : rawAttachments.map(this._mapToAttachment.bind(this))) !== null && _a !== void 0 ? _a : [];
        return { loading: loading, error: error, data: attachments };
    };
    AttachmentService.prototype._mapToAttachment = function (attachmentDto) {
        var _a, _b;
        var filename = attachmentDto.attachment, downloadFilename = attachmentDto.name, credits = attachmentDto.credits, license = attachmentDto.license, isPrimary = attachmentDto.primary;
        var src = this._imageUrlBuilder.buildUrl(filename, 300, 300);
        return {
            id: attachmentDto.id,
            src: src,
            filename: filename,
            downloadFilename: downloadFilename || filename.substring(filename.lastIndexOf('/') + 1),
            credits: credits || '',
            primary: !!isPrimary,
            license: {
                text: ((_a = license === null || license === void 0 ? void 0 : license.i18n[0]) === null || _a === void 0 ? void 0 : _a.content) || (license === null || license === void 0 ? void 0 : license.key),
                href: (_b = license === null || license === void 0 ? void 0 : license.link) !== null && _b !== void 0 ? _b : undefined,
                target: '_blank',
            },
        };
    };
    return AttachmentService;
}());

var FetchExhibitById = gql$1(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  query FetchObjectById(\n    $object_id: bigint!\n    $attributes: [String!]\n    $lang: String!\n  ) {\n    smb_objects(\n      where: {\n        id: { _eq: $object_id }\n        attributes: {\n          attribute_key: { _in: $attributes }\n          language: { lang: { _eq: $lang } }\n        }\n      }\n    ) {\n      id\n      attachments(\n        order_by: [{ primary: desc }, { attachment: asc }]\n        limit: 1\n      ) {\n        attachment\n        primary\n        credits\n      }\n      attributes(\n        where: {\n          attribute_key: { _in: $attributes }\n          language: { lang: { _eq: $lang } }\n        }\n      ) {\n        attribute_key\n        value\n      }\n    }\n  }\n"], ["\n  query FetchObjectById(\n    $object_id: bigint!\n    $attributes: [String!]\n    $lang: String!\n  ) {\n    smb_objects(\n      where: {\n        id: { _eq: $object_id }\n        attributes: {\n          attribute_key: { _in: $attributes }\n          language: { lang: { _eq: $lang } }\n        }\n      }\n    ) {\n      id\n      attachments(\n        order_by: [{ primary: desc }, { attachment: asc }]\n        limit: 1\n      ) {\n        attachment\n        primary\n        credits\n      }\n      attributes(\n        where: {\n          attribute_key: { _in: $attributes }\n          language: { lang: { _eq: $lang } }\n        }\n      ) {\n        attribute_key\n        value\n      }\n    }\n  }\n"])));
var FetchManyExhibitsById = gql$1(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  query FetchPrimaryAttachmentsForObjects($object_ids: [bigint!]!) {\n    smb_objects(where: { id: { _in: $object_ids } }) {\n      id\n      attachments(\n        order_by: [{ primary: desc }, { attachment: asc }]\n        limit: 1\n      ) {\n        attachment\n      }\n    }\n  }\n"], ["\n  query FetchPrimaryAttachmentsForObjects($object_ids: [bigint!]!) {\n    smb_objects(where: { id: { _in: $object_ids } }) {\n      id\n      attachments(\n        order_by: [{ primary: desc }, { attachment: asc }]\n        limit: 1\n      ) {\n        attachment\n      }\n    }\n  }\n"])));
var templateObject_1$4, templateObject_2$3;

/**
 * Service used to get Exhibits from the search API
 * todo: too much use of the any keyword - makes typing useless
 */
var ExhibitService = /** @class */ (function () {
    function ExhibitService(_config, _graphqlService, _imageUrlBuilderService) {
        this._config = _config;
        this._graphqlService = _graphqlService;
        this._imageUrlBuilderService = _imageUrlBuilderService;
    }
    /**
     * Gets one exhibit from the search API by ID and converts it to corresponding model. Uses `?projection=full`.
     *
     * -----
     * TODO: model conversion should be based on projection (full|flat|id)
     *    currently there is only full projection (hardcoded in url bellow)
     *    used but it should be provided as param
     * @param id object id
     * @returns error or ExhibitModelFull
     */
    ExhibitService.prototype.findOne = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, language, exhibitFromGraphql, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, axios.get(this._config.ELASTIC_API_URL + "/" + id + "/?projection=full")];
                    case 1:
                        data = (_a.sent()).data;
                        if (!!data) return [3 /*break*/, 3];
                        language = LanguageService$1.getCurrentLanguage();
                        return [4 /*yield*/, this._graphqlService.query(FetchExhibitById, {
                                lang: language,
                                id: id,
                            })];
                    case 2:
                        exhibitFromGraphql = (_a.sent()).smb_objects;
                        return [2 /*return*/, this.mapTranslatesToExhibit(exhibitFromGraphql[0])];
                    case 3: return [2 /*return*/, this.mapToExhibitModel(data)];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        //fixme: should let error bubble up on a higher level in a try-catch
                        // bad design to have multiple possible types in same variable
                        return [2 /*return*/, new Error(error_1)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ExhibitService.prototype.findMany = function (ids) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var exhibitsWithAttachmentOnly;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this._graphqlService.query(FetchManyExhibitsById, {
                            object_ids: ids,
                        })];
                    case 1:
                        exhibitsWithAttachmentOnly = _c.sent();
                        return [2 /*return*/, ((_b = (_a = exhibitsWithAttachmentOnly.smb_objects) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
                                var _b;
                                var id = _a.id, attachments = _a.attachments;
                                var filename = (_b = attachments[0]) === null || _b === void 0 ? void 0 : _b.attachment;
                                var src = filename && _this._imageUrlBuilderService.buildUrl(filename, 300, 300);
                                return {
                                    id: id,
                                    src: src !== null && src !== void 0 ? src : '',
                                };
                            })) !== null && _b !== void 0 ? _b : [])];
                }
            });
        });
    };
    // todo: needs documenting - difficult to understand o
    ExhibitService.prototype.mapTranslatesToExhibit = function (object) {
        var dto = { id: object.id };
        for (var _i = 0, _a = object.attributes; _i < _a.length; _i++) {
            var _b = _a[_i], value = _b.value, attribute_key = _b.attribute_key, attribute = _b.attribute;
            var key = attribute_key || attribute.key;
            if (Array.isArray(dto[key])) {
                dto[key].push(value);
            }
            else if (dto[key]) {
                dto[key] = [dto[key], value];
            }
            else {
                dto[key] = value;
            }
        }
        var graphqlExhibitModel = this.mapToGraphqlExhibitModel(dto);
        return this.mapToExhibitModel(graphqlExhibitModel);
    };
    ExhibitService.prototype.mapToGraphqlExhibitModel = function (dto) {
        return {
            id: dto.id,
            title: dto[EGraphqlTranslationAttributesFields.title],
            technicalTerm: dto[EGraphqlTranslationAttributesFields.technicalTerm],
            dating: dto[EGraphqlTranslationAttributesFields.dating],
            identNumber: dto[EGraphqlTranslationAttributesFields.identNumber],
            collectionKey: dto[EGraphqlTranslationAttributesFields.collectionKey],
            location: dto[EGraphqlTranslationAttributesFields.location],
            findSpot: dto[EGraphqlTranslationAttributesFields.findSpot],
            involvedParties: dto[EGraphqlTranslationAttributesFields.involvedParties],
            description: dto[EGraphqlTranslationAttributesFields.description],
            geographicalReferences: dto[EGraphqlTranslationAttributesFields.geographicalReferences],
            culturalReferences: dto[EGraphqlTranslationAttributesFields.culturalReferences],
            materialAndTechnique: dto[EGraphqlTranslationAttributesFields.materialAndTechnique],
            dimensionsAndWeight: dto[EGraphqlTranslationAttributesFields.dimensionsAndWeight],
        };
    };
    /**
     * Converts a GraphqlExhibitModel to ExhibitModel
     * @param dto
     */
    ExhibitService.prototype.mapToExhibitModel = function (dto) {
        var _a, _b;
        var getTitle = function () {
            var _a;
            // Prio1: title
            if (dto.title) {
                return dto.title;
            }
            // Prio2: first of titles
            if ((_a = dto.titles) === null || _a === void 0 ? void 0 : _a.length) {
                return (typeof dto.titles[0] === 'string') ? dto.titles[0] : dto.titles[0].formatted;
            }
            // Prio3: technical term
            if (dto.technicalTerm) {
                return (typeof dto.technicalTerm === 'string') ? dto.technicalTerm : dto.technicalTerm.formatted;
            }
            // Prio4: ident number
            // else: [Ohne Titel]
            return dto.identNumber || '[Ohne Titel]';
        };
        return {
            acquisition: dto.acquisition,
            archiveContent: dto.archiveContent,
            attachments: dto.attachments,
            collection: dto.collection,
            collectionKey: (_a = dto.collectionKey) !== null && _a !== void 0 ? _a : 'default',
            compilation: dto.compilation,
            creditLine: dto.creditLine,
            culturalReferences: dto.culturalReferences,
            dating: dto.dating,
            description: dto.description,
            dimensionsAndWeight: dto.dimensionsAndWeight,
            exhibit: dto.exhibit || dto.exhibited,
            exhibited: dto.exhibit || dto.exhibited,
            exhibitions: dto.exhibitions,
            exhibitionSpace: dto.exhibitionSpace,
            geographicalReferences: dto.geographicalReferences,
            highlight: dto.highlight,
            iconclasses: dto.iconclasses,
            iconography: dto.iconography,
            id: dto.id,
            identNumber: dto.identNumber,
            inscriptions: dto.inscriptions,
            involvedParties: dto.involvedParties,
            keywords: (_b = dto.keywords) !== null && _b !== void 0 ? _b : [],
            literature: dto.literature,
            location: dto.location,
            materialAndTechnique: dto.materialAndTechnique,
            provenance: dto.provenance,
            provenanceEvaluation: dto.provenanceEvaluation,
            signatures: dto.signatures,
            src: dto.src,
            technicalTerm: dto.technicalTerm,
            title: getTitle(),
            titles: dto.titles,
        };
    };
    /**
     * Converts GraphqlExhibitModel to ExhibitModelFlat.
     * Should only be used on data fetched from a flat projection endpoint
     * @param dto
     */
    ExhibitService.prototype.mapFlat = function (dto) {
        return {
            id: dto.id,
            assets: dto.assets,
            archiveContent: dto.archiveContent,
            attachments: dto.attachments,
            assortments: dto.assortments,
            collection: dto.collection,
            collectionKey: dto.collectionKey,
            compilation: dto.compilation,
            creditLine: dto.creditLine,
            culturalReferences: dto.culturalReferences,
            dateRange: dto.dateRange,
            dating: dto.dating,
            description: dto.description,
            dimensionsAndWeight: dto.dimensionsAndWeight,
            exhibit: dto.exhibit,
            exhibitionSpace: dto.exhibitionSpace,
            exhibitions: dto.exhibitions,
            findSpot: dto.findSpot,
            geographicalReferences: dto.geographicalReferences,
            highlight: dto.highlight,
            iconclasses: dto.iconclasses,
            iconography: dto.iconography,
            identNumber: dto.identNumber,
            inscriptions: dto.inscriptions,
            involvedParties: dto.involvedParties,
            keywords: dto.keywords,
            literature: dto.literature,
            location: dto.location,
            materialAndTechnique: dto.materialAndTechnique,
            permalink: dto.permalink,
            provenance: dto.provenance,
            provenanceEvaluation: dto.provenanceEvaluation,
            signatures: dto.signatures,
            technicalTerm: dto.technicalTerm,
            title: dto.title,
            titles: dto.titles,
        };
    };
    /**
     * Converts GraphqlExhibitModel to ExhibitModelFull.
     * Should only be used on data fetched from a full projection endpoint
     * @param dto
     */
    ExhibitService.prototype.mapFull = function (dto) {
        return {
            id: dto.id,
            acquisition: dto.acquisition,
            archiveContent: dto.archiveContent,
            assets: dto.assets,
            attachments: dto.attachments,
            assortments: dto.assortments,
            collection: dto.collection,
            collectionKey: dto.collectionKey,
            compilation: dto.compilation,
            creditLine: dto.creditLine,
            culturalReferences: dto.culturalReferences,
            dateRange: dto.dateRange,
            dating: dto.dating,
            description: dto.description,
            dimensionsAndWeight: dto.dimensionsAndWeight,
            exhibit: dto.exhibit,
            exhibitionSpace: dto.exhibitionSpace,
            exhibitions: dto.exhibitions,
            findSpot: dto.findSpot,
            geographicalReferences: dto.geographicalReferences,
            highlight: dto.highlight,
            iconclasses: dto.iconclasses,
            iconography: dto.iconography,
            identNumber: dto.identNumber,
            inscriptions: dto.inscriptions,
            involvedParties: dto.involvedParties,
            keywords: dto.keywords,
            literature: dto.literature,
            location: dto.location,
            materialAndTechnique: dto.materialAndTechnique,
            permalink: dto.permalink,
            provenance: dto.provenance,
            provenanceEvaluation: dto.provenanceEvaluation,
            signatures: dto.signatures,
            technicalTerm: dto.technicalTerm,
            title: dto.title,
            titles: dto.titles,
        };
    };
    return ExhibitService;
}());

var GraphqlService = /** @class */ (function () {
    function GraphqlService(endpoint) {
        this._client = new GraphQLClient(endpoint);
    }
    GraphqlService.prototype.query = function (query, variables) {
        return this._client.request(query, variables);
    };
    return GraphqlService;
}());

var useRemoveFocusWhenNotTab = function () {
    var handleFirstTab = useCallback(function (event) {
        if (event.keyCode === 9) {
            document.body.classList.add('user-is-tabbing');
        }
    }, []);
    var handleMouseDown = useCallback(function () {
        document.body.classList.remove('user-is-tabbing');
    }, []);
    useEffect(function () {
        window.addEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDown);
        return function () {
            window.removeEventListener('keydown', handleFirstTab);
            window.removeEventListener('mousedown', handleMouseDown);
        };
    });
};

var EBreakpoints;
(function (EBreakpoints) {
    EBreakpoints["xs"] = "xs";
    EBreakpoints["sm"] = "sm";
    EBreakpoints["md"] = "md";
    EBreakpoints["lg"] = "lg";
    EBreakpoints["xl"] = "xl";
})(EBreakpoints || (EBreakpoints = {}));
var useWidth = function () {
    var theme = useTheme();
    var isXs = useMediaQuery(theme.breakpoints.down(EBreakpoints.xs));
    var isSm = useMediaQuery(theme.breakpoints.down(EBreakpoints.sm));
    var isMd = useMediaQuery(theme.breakpoints.down(EBreakpoints.md));
    var isLg = useMediaQuery(theme.breakpoints.down(EBreakpoints.lg));
    if (isXs) {
        return EBreakpoints.xs;
    }
    else if (isSm) {
        return EBreakpoints.sm;
    }
    else if (isMd) {
        return EBreakpoints.md;
    }
    else if (isLg) {
        return EBreakpoints.lg;
    }
    return EBreakpoints.xl;
};

var FetchHighlights = gql(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  query FetchHighlights(\n    $offset: Int!\n    $limit: Int!\n    $lang: String!\n    $attributes: [String!]!\n  ) {\n    smb_highlights(\n      order_by: { object_id: asc }\n      offset: $offset\n      limit: $limit\n      distinct_on: object_id\n    ) {\n      object {\n        id\n        attachments(\n          order_by: [{ primary: desc }, { attachment: asc }]\n          limit: 1\n        ) {\n          attachment\n          primary\n        }\n        attributes(\n          where: {\n            attribute_key: { _in: $attributes }\n            language: { lang: { _eq: $lang } }\n          }\n        ) {\n          attribute_key\n          value\n        }\n      }\n    }\n    smb_highlights_aggregate {\n      aggregate {\n        count\n      }\n    }\n  }\n"], ["\n  query FetchHighlights(\n    $offset: Int!\n    $limit: Int!\n    $lang: String!\n    $attributes: [String!]!\n  ) {\n    smb_highlights(\n      order_by: { object_id: asc }\n      offset: $offset\n      limit: $limit\n      distinct_on: object_id\n    ) {\n      object {\n        id\n        attachments(\n          order_by: [{ primary: desc }, { attachment: asc }]\n          limit: 1\n        ) {\n          attachment\n          primary\n        }\n        attributes(\n          where: {\n            attribute_key: { _in: $attributes }\n            language: { lang: { _eq: $lang } }\n          }\n        ) {\n          attribute_key\n          value\n        }\n      }\n    }\n    smb_highlights_aggregate {\n      aggregate {\n        count\n      }\n    }\n  }\n"])));
var HighlightRepository = /** @class */ (function () {
    function HighlightRepository() {
        this.config = ConfigLoader.CurrentConfig;
    }
    HighlightRepository.prototype.fetchHighlightObjects = function (offset, limit, lang) {
        var _a;
        if (offset === void 0) { offset = 0; }
        if (limit === void 0) { limit = this.config.CAROUSEL_CONFIG.CAROUSEL_HIGHLIGHTS_COUNT; }
        var _b = useQuery(FetchHighlights, {
            variables: {
                offset: offset,
                limit: limit,
                lang: lang,
                attributes: [
                    EGraphqlTranslationAttributesFields.title,
                    EGraphqlTranslationAttributesFields.technicalTerm,
                    EGraphqlTranslationAttributesFields.collection,
                ],
            },
        }), loading = _b.loading, error = _b.error, data = _b.data;
        var resultData = null;
        var resultCount = 0;
        if (!loading && data) {
            resultData = data.smb_highlights.map(function (highlight) { return highlight.object; });
            if ((_a = data.smb_highlights_aggregate.aggregate) === null || _a === void 0 ? void 0 : _a.count) {
                resultCount = data.smb_highlights_aggregate.aggregate.count;
            }
        }
        return {
            loading: loading,
            error: error,
            data: resultData,
            resultCount: resultCount,
        };
    };
    return HighlightRepository;
}());
var templateObject_1$5;

var ValueExtractor = /** @class */ (function () {
    function ValueExtractor(object) {
        this.object = object;
    }
    ValueExtractor.prototype.getValues = function (key) {
        return key && key !== '' ? this.getValuesByKey(key) : [];
    };
    ValueExtractor.prototype.getValuesByKey = function (key) {
        var _a;
        var values = [];
        for (var _i = 0, _b = this.object.attributes; _i < _b.length; _i++) {
            var attr = _b[_i];
            if (attr.attribute_key === key || ((_a = attr.attribute) === null || _a === void 0 ? void 0 : _a.key) === key) {
                if (attr.value && attr.value.trim() !== '') {
                    values.push(attr.value);
                }
            }
        }
        return values;
    };
    ValueExtractor.prototype.getValue = function (key) {
        if (key && key !== '') {
            return this.getValueByKey(key);
        }
    };
    ValueExtractor.prototype.getValueByKey = function (key) {
        var _a, _b;
        var filter = function (t) {
            var _a, _b;
            // find attribute with key...
            if (t.attribute_key === key || ((_a = t.attribute) === null || _a === void 0 ? void 0 : _a.key) === key) {
                // ... in case there are multiple attribues with the same key, use the first non-empty
                return ((_b = t.value) === null || _b === void 0 ? void 0 : _b.trim()) !== '';
            }
            return false;
        };
        return (_b = (_a = this.object.attributes) === null || _a === void 0 ? void 0 : _a.find(filter)) === null || _b === void 0 ? void 0 : _b.value;
    };
    ValueExtractor.prototype.getFirstValueByKey = function (attr) {
        var alternatives = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            alternatives[_i - 1] = arguments[_i];
        }
        var value = this.getValueByKey(attr);
        if (value) {
            return value;
        }
        if (alternatives && alternatives.length) {
            var next = alternatives.shift();
            if (next) {
                return this.getFirstValueByKey.apply(this, __spreadArrays([next], alternatives));
            }
        }
    };
    return ValueExtractor;
}());

var HighlightService = /** @class */ (function () {
    function HighlightService() {
        this.highlightsRepository = new HighlightRepository();
        this.config = ConfigLoader.CurrentConfig;
    }
    HighlightService.prototype.getHighlightsObjects = function () {
        var _a = this.highlightsRepository.fetchHighlightObjects(0, this.config.CAROUSEL_CONFIG.CAROUSEL_HIGHLIGHTS_COUNT, 'de'), loading = _a.loading, error = _a.error, data = _a.data;
        var contextData = !loading && data
            ? this.convertCarouselData(data, this.config)
            : new Array();
        return { loading: loading, error: error, rawData: data, contextData: contextData };
    };
    HighlightService.prototype.convertCarouselData = function (hightlights, config) {
        var cards = [];
        for (var _i = 0, hightlights_1 = hightlights; _i < hightlights_1.length; _i++) {
            var hightlight = hightlights_1[_i];
            cards.push(this.convertToCardData(hightlight, config));
        }
        return cards;
    };
    HighlightService.prototype.convertToCardData = function (object, config) {
        var valueExtractor = new ValueExtractor(object);
        var titleAtributeCandidates = [
            EGraphqlTranslationAttributesFields.title,
            EGraphqlTranslationAttributesFields.technicalTerm,
        ];
        var extractTitle = function () {
            return (valueExtractor.getFirstValueByKey.apply(valueExtractor, __spreadArrays([
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                titleAtributeCandidates.shift()], titleAtributeCandidates)) || '');
        };
        var extractCollection = function () {
            var collection = valueExtractor.getValueByKey(EGraphqlTranslationAttributesFields.collection) || '';
            if (collection.includes(',')) {
                collection = collection.split(',')[0];
            }
            return collection;
        };
        var buildImageUrl = function () {
            var _a;
            if ((_a = object.attachments[0]) === null || _a === void 0 ? void 0 : _a.attachment) {
                var image = object.attachments[0].attachment;
                var dim = config.CAROUSEL_CONFIG.HIGHLIGHT_CAROUSEL_IMAGE_SIZE;
                return new ImageUrlBuilder(config).buildUrl(image, dim, dim);
            }
            return '';
        };
        var title = extractTitle();
        var buildTargetUri = function () {
            return new LinkBuilder().getDetailsLink(object.id, title, true);
        };
        return {
            id: object.id,
            title: title,
            collection: extractCollection(),
            image: buildImageUrl(),
            link: buildTargetUri(),
        };
    };
    return HighlightService;
}());

var FetchAssortments = gql(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  query FetchAssortments($language: String) {\n    smb_assortments(order_by: { key: asc }) {\n      key\n      preview_image\n      i18n(where: { language: { lang: { _eq: $language } } }) {\n        abstract\n        description\n        subtitle\n        title\n      }\n    }\n  }\n"], ["\n  query FetchAssortments($language: String) {\n    smb_assortments(order_by: { key: asc }) {\n      key\n      preview_image\n      i18n(where: { language: { lang: { _eq: $language } } }) {\n        abstract\n        description\n        subtitle\n        title\n      }\n    }\n  }\n"])));
var AssortmentsRepository = /** @class */ (function () {
    function AssortmentsRepository() {
    }
    AssortmentsRepository.prototype.fetchAssortmentObjects = function (lang) {
        var _a = useQuery(FetchAssortments, {
            variables: {
                language: lang,
            },
        }), loading = _a.loading, error = _a.error, data = _a.data;
        var resultData = null;
        var resultCount = 0;
        if (!loading && data && data.smb_assortments.length) {
            resultData = data.smb_assortments;
            resultCount = data.smb_assortments.length;
        }
        return {
            loading: loading,
            error: error,
            data: resultData,
            resultCount: resultCount,
        };
    };
    return AssortmentsRepository;
}());
var templateObject_1$6;

var AssortmentsService = /** @class */ (function () {
    function AssortmentsService() {
        this.assortmentsRepository = new AssortmentsRepository();
        this.config = ConfigLoader.CurrentConfig;
    }
    AssortmentsService.prototype.getAssortmentObjects = function () {
        var _a = this.assortmentsRepository.fetchAssortmentObjects(LanguageService.getCurrentLanguage()), loading = _a.loading, error = _a.error, data = _a.data;
        var contextData = !loading && data
            ? this.convertToCards(data, this.config)
            : new Array();
        var assortmentsLoading = loading;
        var assortmentsContextData = contextData;
        return { assortmentsLoading: assortmentsLoading, error: error, rawData: data, assortmentsContextData: assortmentsContextData };
    };
    AssortmentsService.prototype.convertToCards = function (assortments, config) {
        var cards = [];
        for (var _i = 0, assortments_1 = assortments; _i < assortments_1.length; _i++) {
            var assortment = assortments_1[_i];
            cards.push(this.convertToCardData(assortment, config));
        }
        return cards;
    };
    AssortmentsService.prototype.convertToCardData = function (assortment, config) {
        var _this = this;
        var _a, _b;
        var buildImageUrl = function () {
            if (assortment.preview_image) {
                var dim = config.CAROUSEL_CONFIG.COLLECTION_CARD_IMAGE_SIZE;
                return new ImageUrlBuilder(config).buildUrl(assortment.preview_image, dim, dim);
            }
            return '';
        };
        var buildTargetUri = function () {
            return _this.config.RESEARCH_DOMAIN + "/?assortments=" + assortment.key;
        };
        return {
            id: assortment.key,
            title: ((_a = assortment === null || assortment === void 0 ? void 0 : assortment.i18n[0]) === null || _a === void 0 ? void 0 : _a.title) || '',
            subtitle: ((_b = assortment === null || assortment === void 0 ? void 0 : assortment.i18n[0]) === null || _b === void 0 ? void 0 : _b.subtitle) || '',
            img: buildImageUrl(),
            link: buildTargetUri(),
        };
    };
    return AssortmentsService;
}());

var ExhibitModel = /** @class */ (function () {
    function ExhibitModel() {
        this.src = '';
        this.title = '[Ohne Titel]';
        this.collectionKey = 'default';
    }
    return ExhibitModel;
}());

var GuideService = /** @class */ (function () {
    // private ImageUrlBuilder: IImageUrlBuilder;
    // private readonly config: Config;
    function GuideService(_imageUrlBuilder) {
        // this.ImageUrlBuilder = imageUrlBuilder;
        // this.config = ConfigLoader.CurrentConfig;
    }
    GuideService.prototype.getGuide = function (id, _imageCardSize, _imageSliderSize) {
        // eslint-disable-next-line no-console
        console.log('getGuide', id);
        return {
            tourLoading: true,
            tourError: undefined,
            tourData: null,
            objectLoading: false,
            objectError: undefined,
            objectsData: [],
        };
    };
    GuideService.prototype.getGuides = function (_imageCardSize, _ImageSliderSize) {
        // eslint-disable-next-line no-console
        console.log('getGuides');
        return { loading: true, error: undefined, rawData: null, contextData: [] };
    };
    return GuideService;
}());

var TopicService = /** @class */ (function () {
    function TopicService() {
    }
    //  private readonly config: IConfiguration;
    // constructor() {
    //   this.config = ConfigLoader.CurrentConfig;
    // }
    TopicService.prototype.getTopics = function () {
        // eslint-disable-next-line no-console
        console.log('getTopics');
        return {
            loading: true,
            error: undefined,
            rawData: null,
            contextData: [],
        };
    };
    TopicService.prototype.findTopicsInfoByExhibitId = function (exhibitId) {
        // eslint-disable-next-line no-console
        console.log('findTopicsInfoByExhibitId', exhibitId);
        return { loading: true, error: undefined, data: [] };
    };
    return TopicService;
}());

// Query all categories.
var FetchLandingpage = gql(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  query fetchLandingpage($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbLandingpage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            createdAt\n            publishedAt\n            updatedAt\n            heroSwiperItems {\n              id\n              title\n              href\n              caption\n              image {\n                data {\n                  id\n                  attributes {\n                    url\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query fetchLandingpage($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbLandingpage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            createdAt\n            publishedAt\n            updatedAt\n            heroSwiperItems {\n              id\n              title\n              href\n              caption\n              image {\n                data {\n                  id\n                  attributes {\n                    url\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
// Query all categories.
var FetchLandingpageSections = gql(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  query fetchLandingpageSections($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbLandingpage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            module {\n              ... on ComponentComponentsSmbSection {\n                id\n                Type\n                CollectionsBlock {\n                  headline\n                  text\n                  type\n                  cardCtaText\n                  assets {\n                    data {\n                      attributes {\n                        alternativeText\n                        caption\n                        url\n                      }\n                    }\n                  }\n                }\n                HighlightsBlock {\n                  type\n                  text\n                  headline\n                  assets {\n                    data {\n                      attributes {\n                        alternativeText\n                        caption\n                        url\n                      }\n                    }\n                  }\n                }\n                SearchButtonBlock {\n                  headline\n                  text\n                  searchButtonGroupHeadline1\n                  searchButtonGroupHeadline2\n                  searchButtonGroupHeadline3\n                  assets {\n                    data {\n                      attributes {\n                        alternativeText\n                        caption\n                        url\n                      }\n                    }\n                  }\n                }\n                TextBlock {\n                  headline\n                  subHeadline\n                  text\n                  linkText\n                  linkUrl\n                }\n                VideoBlock {\n                  assets {\n                    data {\n                      attributes {\n                        alternativeText\n                        caption\n                        url\n                      }\n                    }\n                  }\n                  headline\n                  subHeadline\n                  linkUrl\n                  linkText\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query fetchLandingpageSections($lang: I18NLocaleCode) {\n    strapi_smb {\n      smbLandingpage(locale: $lang, publicationState: LIVE) {\n        data {\n          attributes {\n            module {\n              ... on ComponentComponentsSmbSection {\n                id\n                Type\n                CollectionsBlock {\n                  headline\n                  text\n                  type\n                  cardCtaText\n                  assets {\n                    data {\n                      attributes {\n                        alternativeText\n                        caption\n                        url\n                      }\n                    }\n                  }\n                }\n                HighlightsBlock {\n                  type\n                  text\n                  headline\n                  assets {\n                    data {\n                      attributes {\n                        alternativeText\n                        caption\n                        url\n                      }\n                    }\n                  }\n                }\n                SearchButtonBlock {\n                  headline\n                  text\n                  searchButtonGroupHeadline1\n                  searchButtonGroupHeadline2\n                  searchButtonGroupHeadline3\n                  assets {\n                    data {\n                      attributes {\n                        alternativeText\n                        caption\n                        url\n                      }\n                    }\n                  }\n                }\n                TextBlock {\n                  headline\n                  subHeadline\n                  text\n                  linkText\n                  linkUrl\n                }\n                VideoBlock {\n                  assets {\n                    data {\n                      attributes {\n                        alternativeText\n                        caption\n                        url\n                      }\n                    }\n                  }\n                  headline\n                  subHeadline\n                  linkUrl\n                  linkText\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
var LandingpageRepository = /** @class */ (function () {
    function LandingpageRepository() {
    }
    LandingpageRepository.prototype.fetchLandingpageData = function (lang) {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = useQuery(FetchLandingpage, {
            variables: {
                lang: lang,
            },
        }), loading = _h.loading, error = _h.error, data = _h.data;
        var resultData = null;
        if (!loading &&
            data &&
            data.strapi_smb && ((_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.strapi_smb.smbLandingpage) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.heroSwiperItems) === null || _d === void 0 ? void 0 : _d.length)) {
            resultData = (_g = (_f = (_e = data.strapi_smb) === null || _e === void 0 ? void 0 : _e.smbLandingpage) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.attributes;
        }
        return { loading: loading, error: error, data: resultData };
    };
    LandingpageRepository.prototype.fetchLandingpageSections = function (lang) {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = useQuery(FetchLandingpageSections, {
            variables: {
                lang: lang,
            },
        }), loading = _h.loading, error = _h.error, data = _h.data;
        var resultData = null;
        if (!loading &&
            data &&
            data.strapi_smb && ((_d = (_c = (_b = (_a = data.strapi_smb.smbLandingpage) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.module) === null || _d === void 0 ? void 0 : _d.length)) {
            resultData = (_g = (_f = (_e = data.strapi_smb.smbLandingpage) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.attributes) === null || _g === void 0 ? void 0 : _g.module;
        }
        return { loading: loading, error: error, data: resultData };
    };
    return LandingpageRepository;
}());
var templateObject_1$7, templateObject_2$4;

/* eslint no-console: ["error", { allow: ["log"] }] */
var LandingpageService = /** @class */ (function () {
    function LandingpageService() {
        this.config = ConfigLoader.CurrentConfig;
    }
    LandingpageService.prototype.getHeroSwiperData = function () {
        var _a;
        var lang = LanguageService.getCurrentStrapiLanguage();
        var landingpageRepository = new LandingpageRepository();
        var _b = landingpageRepository.fetchLandingpageData(lang), loading = _b.loading, error = _b.error, data = _b.data;
        var convertedData;
        if (!loading && ((_a = data === null || data === void 0 ? void 0 : data.heroSwiperItems) === null || _a === void 0 ? void 0 : _a.length)) {
            convertedData = this.convertSwiperData(data.heroSwiperItems);
        }
        return { loading: loading, error: error, data: convertedData };
    };
    LandingpageService.prototype.getLandingpageSections = function () {
        var lang = LanguageService.getCurrentStrapiLanguage();
        var landingpageRepository = new LandingpageRepository();
        var _a = landingpageRepository.fetchLandingpageSections(lang), loading = _a.loading, error = _a.error, data = _a.data;
        var convertedSectionsData;
        if (!loading && data && (data === null || data === void 0 ? void 0 : data.length)) {
            convertedSectionsData = this.convertSectionsData(data, lang);
        }
        return { loading: loading, error: error, data: convertedSectionsData };
    };
    LandingpageService.prototype.convertSwiperData = function (items) {
        var _this = this;
        return {
            section: 'test',
            data: items === null || items === void 0 ? void 0 : items.map(function (item) {
                var _a, _b;
                return {
                    title: item === null || item === void 0 ? void 0 : item.title,
                    image: _this.config.STRAPI_CONFIG.backend.smb + ((_b = (_a = item === null || item === void 0 ? void 0 : item.image.data) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.url),
                    caption: item === null || item === void 0 ? void 0 : item.caption,
                    href: item === null || item === void 0 ? void 0 : item.href,
                    id: item === null || item === void 0 ? void 0 : item.id,
                };
            }),
        };
    };
    LandingpageService.prototype.convertSectionsData = function (items, lang) {
        var _this = this;
        //module is passed as param
        return items === null || items === void 0 ? void 0 : items.map(function (item) {
            var _a;
            if (item === null || item === void 0 ? void 0 : item.__typename) {
                item = item;
                var TextBlock = item.TextBlock, SearchButtonBlock = item.SearchButtonBlock, HighlightsBlock = item.HighlightsBlock, CollectionsBlock = item.CollectionsBlock, VideoBlock = item.VideoBlock;
                var hasSwiperBlock = HighlightsBlock || CollectionsBlock ? true : false;
                var sections = [];
                var getBlockAssets = function (block) {
                    var _a, _b;
                    if (lang === 'de-DGS' && block && ((_a = block.assets) === null || _a === void 0 ? void 0 : _a.data.length)) {
                        return (_b = block.assets) === null || _b === void 0 ? void 0 : _b.data.map(function (asset) {
                            var _a;
                            return {
                                url: "" + _this.config.STRAPI_CONFIG.backend.smb + ((_a = asset === null || asset === void 0 ? void 0 : asset.attributes) === null || _a === void 0 ? void 0 : _a.url),
                            };
                        });
                    }
                    return [];
                };
                if (TextBlock) {
                    sections.push({
                        type: 'TextBlock',
                        link: {
                            caption: TextBlock.linkText,
                            href: TextBlock.linkUrl,
                        },
                        title: TextBlock.headline,
                        subtitle: TextBlock.subHeadline,
                        text: TextBlock.text,
                        // not needed or used props
                        moduleBackgroundColor: '',
                        textAreaColor: '',
                        textColor: '',
                        titleColor: '',
                        moduleType: 4,
                    });
                }
                if (SearchButtonBlock) {
                    sections.push({
                        type: 'SearchButtonBlock',
                        title: SearchButtonBlock.headline,
                        text: SearchButtonBlock.text,
                        assets: getBlockAssets(SearchButtonBlock),
                        searchButtonGroupHeadline: {
                            '0': {
                                title: SearchButtonBlock.searchButtonGroupHeadline1,
                            },
                            '1': {
                                title: SearchButtonBlock.searchButtonGroupHeadline2,
                            },
                            '2': {
                                title: SearchButtonBlock.searchButtonGroupHeadline3,
                            },
                        },
                    });
                }
                if (HighlightsBlock) {
                    sections.push({
                        type: 'HighlightsBlock',
                        title: HighlightsBlock.headline,
                        text: HighlightsBlock.text,
                        slug: HighlightsBlock.type,
                        assets: getBlockAssets(HighlightsBlock),
                    });
                }
                if (CollectionsBlock) {
                    sections.push({
                        type: 'CollectionsBlock',
                        title: CollectionsBlock.headline,
                        text: CollectionsBlock.text,
                        slug: CollectionsBlock.type,
                        cta: (_a = CollectionsBlock.cardCtaText) === null || _a === void 0 ? void 0 : _a.trim(),
                        assets: getBlockAssets(CollectionsBlock),
                    });
                }
                if (VideoBlock && lang === 'de-DGS') {
                    var videoData = {
                        type: 'VideoBlock',
                        title: VideoBlock.headline,
                        subtitle: VideoBlock.subHeadline,
                        assets: getBlockAssets(VideoBlock),
                        link: {
                            caption: VideoBlock.linkText,
                            href: VideoBlock.linkUrl,
                        },
                    };
                    if (TextBlock) {
                        sections.splice(0, 1, videoData);
                    }
                    else {
                        sections.unshift(videoData);
                    }
                }
                return {
                    id: item.id,
                    moduleType: item.Type ? TextModuleType[item.Type] : '',
                    hasSwiperBlock: hasSwiperBlock,
                    sections: sections,
                };
            }
        }).filter(function (item) { return item !== undefined; });
    };
    return LandingpageService;
}());

var useStyles$N = makeStyles(function () {
    return createStyles({
        accordionWrapper: {
            marginTop: 50,
            borderTop: 'solid 3px',
            borderBottom: 'solid 3px',
            '& p:last-child': {
                marginBottom: 20,
            },
        },
    });
});

var ExhibitDescriptionAccordionList = function (_a) {
    var items = _a.items;
    var classes = useStyles$N();
    return (React.createElement(MuiThemeProvider, { theme: CommonTheme },
        React.createElement("div", { className: classes.accordionWrapper }, items.map(function (item, i) {
            return (React.createElement(ExhibitDescriptionAccordion, { expanded: item.expanded === true, key: i, title: item.title, content: item.content, keywordsList: item.keywordsList, listTitle: item.listTitle }));
        }))));
};

export { AppStage, ArrowUpSvg, AssortmentsRepository, AssortmentsService, AttachmentService, Carousel$1 as Carousel, CarouselHeadline, CarouselImageCard, CollectionCard$1 as CollectionCard, CollectionCard as CollectionCardNew, CollectionContext, CollectionModule, CollectionPlayerModule, CollectionsContext, CollectionsDiscoverModule, CollectionsModule, CommonTheme, ConfigLoader, CustomCssBaseline$1 as CustomCssBaseline, Dots, DropdownFilters, EBreakpoints, EExhibitAsideLinks, EFooterLinkType, EGraphqlTranslationAttributesFields, ExhibitActions, ExhibitAside, ExhibitAsideLinks, ExhibitAsideText, ExhibitDescription, ExhibitDescriptionAccordion, ExhibitDescriptionAccordionList, ExhibitDescriptionGrid, ExhibitModel, ExhibitPreview, ExhibitService, FallbackImage, FetchExhibitAttachments, FocusObject, FocusObjectModule, Footer, FooterGrid, GraphqlService, GuideSection, GuideService, Header, HeaderPlatformType, HeroSwiper, HighlightButton, HighlightRepository, HighlightService, Highlights, Image$1 as Image, ImageUrlBuilder, ImageUrlBuilderService, ImageZoomModal, LandingpageRepository, LandingpageService, LanguageService, LazyLoadImage, LinkBuilder, LinkTextCard, LoadingSpinner, MaintenanceDialog, MediaPlayer, MediaPlayerContext, MediaPlayerControls, MediaPlayerOverlay, NoDataPage, NotFoundPage, ORG_UNIT_LIST, ObjectActions, ObjectContext, ObjectDescriptionAccordion, ObjectDescriptionAccordionRow, ObjectDescriptionAside, ObjectDescriptionGrid, ObjectDescriptionGridRow, ObjectDescriptionModule, ObjectImageDownloadDialog, ObjectImageModule, Progressbar, ResearchSection, SafeEscapedHTML, SearchButtons, Sections, SiteConfigRepository, SiteConfigService, Slide, Slider, SliderContent, SliderModule, Spinner, StaticPages, SwiperCarousel, TRANSLATION_GUIDE_DE, TRANSLATION_GUIDE_EN, TRANSLATION_INTRO_DE, TRANSLATION_INTRO_EN, TRANSLATION_RESEARCH_DE, TRANSLATION_RESEARCH_EN, TRANSLATION_TOPICS_DE, TRANSLATION_TOPICS_EN, TextModuleType, TextSection, TextSectionContext, TopicService, TopicStoriesService, VideoSection, WrappedSpinner, areEqual, index$1 as collection, copyToClipboard, getLanguageOptionIcon, getOrgUnitURL, loadConfig, navHeight, shortenPermalink, useConfigLoader, useGraphQlClient, useLazyImageLoader, useLazyImagesLoader, useRemoveFocusWhenNotTab, useWidth, useWindowDimensions };
//# sourceMappingURL=index.es.js.map
